!function(t) {
    var e = {};
    function n(r) {
        if (e[r])
            return e[r].exports;
        var i = e[r] = {
            i: r,
            l: !1,
            exports: {}
        };
        return t[r].call(i.exports, i, i.exports, n),
        i.l = !0,
        i.exports
    }
    n.m = t,
    n.c = e,
    n.d = function(t, e, r) {
        n.o(t, e) || Object.defineProperty(t, e, {
            enumerable: !0,
            get: r
        })
    }
    ,
    n.r = function(t) {
        "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
            value: "Module"
        }),
        Object.defineProperty(t, "__esModule", {
            value: !0
        })
    }
    ,
    n.t = function(t, e) {
        if (1 & e && (t = n(t)),
        8 & e)
            return t;
        if (4 & e && "object" == typeof t && t && t.__esModule)
            return t;
        var r = Object.create(null);
        if (n.r(r),
        Object.defineProperty(r, "default", {
            enumerable: !0,
            value: t
        }),
        2 & e && "string" != typeof t)
            for (var i in t)
                n.d(r, i, function(e) {
                    return t[e]
                }
                .bind(null, i));
        return r
    }
    ,
    n.n = function(t) {
        var e = t && t.__esModule ? function() {
            return t.default
        }
        : function() {
            return t
        }
        ;
        return n.d(e, "a", e),
        e
    }
    ,
    n.o = function(t, e) {
        return Object.prototype.hasOwnProperty.call(t, e)
    }
    ,
    n.p = "",
    n(n.s = 24)
}([function(t, e, n) {
    "use strict";
    function r(t) {
        if (void 0 === t)
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return t
    }
    function i(t, e) {
        t.prototype = Object.create(e.prototype),
        t.prototype.constructor = t,
        t.__proto__ = e
    }
    /*!
 * GSAP 3.6.0
 * https://greensock.com
 *
 * @license Copyright 2008-2021, GreenSock. All rights reserved.
 * Subject to the terms at https://greensock.com/standard-license or for
 * Club GreenSock members, the agreement issued with that membership.
 * @author: Jack Doyle, jack@greensock.com
*/
    var o, s, a, u, l, c, f, h, d, p, g, v, m, y, x, b, w, _, T, k, C, E, S, P, A, O, D, M, L = {
        autoSleep: 120,
        force3D: "auto",
        nullTargetWarn: 1,
        units: {
            lineHeight: ""
        }
    }, q = {
        duration: .5,
        overwrite: !1,
        delay: 0
    }, N = 1e8, j = 2 * Math.PI, R = j / 4, I = 0, F = Math.sqrt, B = Math.cos, H = Math.sin, X = function(t) {
        return "string" == typeof t
    }, z = function(t) {
        return "function" == typeof t
    }, Y = function(t) {
        return "number" == typeof t
    }, W = function(t) {
        return void 0 === t
    }, U = function(t) {
        return "object" == typeof t
    }, $ = function(t) {
        return !1 !== t
    }, V = function() {
        return "undefined" != typeof window
    }, G = function(t) {
        return z(t) || X(t)
    }, K = "function" == typeof ArrayBuffer && ArrayBuffer.isView || function() {}
    , Q = Array.isArray, J = /(?:-?\.?\d|\.)+/gi, Z = /[-+=.]*\d+[.e\-+]*\d*[e\-+]*\d*/g, tt = /[-+=.]*\d+[.e-]*\d*[a-z%]*/g, et = /[-+=.]*\d+\.?\d*(?:e-|e\+)?\d*/gi, nt = /[+-]=-?[.\d]+/, rt = /[#\-+.]*\b[a-z\d-=+%.]+/gi, it = /[\d.+\-=]+(?:e[-+]\d*)*/i, ot = {}, st = {}, at = function(t) {
        return (st = Lt(t, ot)) && vn
    }, ut = function(t, e) {
        return console.warn("Invalid property", t, "set to", e, "Missing plugin? gsap.registerPlugin()")
    }, lt = function(t, e) {
        return !e && console.warn(t)
    }, ct = function(t, e) {
        return t && (ot[t] = e) && st && (st[t] = e) || ot
    }, ft = function() {
        return 0
    }, ht = {}, dt = [], pt = {}, gt = {}, vt = {}, mt = 30, yt = [], xt = "", bt = function(t) {
        var e, n, r = t[0];
        if (U(r) || z(r) || (t = [t]),
        !(e = (r._gsap || {}).harness)) {
            for (n = yt.length; n-- && !yt[n].targetTest(r); )
                ;
            e = yt[n]
        }
        for (n = t.length; n--; )
            t[n] && (t[n]._gsap || (t[n]._gsap = new Be(t[n],e))) || t.splice(n, 1);
        return t
    }, wt = function(t) {
        return t._gsap || bt(se(t))[0]._gsap
    }, _t = function(t, e, n) {
        return (n = t[e]) && z(n) ? t[e]() : W(n) && t.getAttribute && t.getAttribute(e) || n
    }, Tt = function(t, e) {
        return (t = t.split(",")).forEach(e) || t
    }, kt = function(t) {
        return Math.round(1e5 * t) / 1e5 || 0
    }, Ct = function(t, e) {
        for (var n = e.length, r = 0; t.indexOf(e[r]) < 0 && ++r < n; )
            ;
        return r < n
    }, Et = function(t, e, n) {
        var r, i = Y(t[1]), o = (i ? 2 : 1) + (e < 2 ? 0 : 1), s = t[o];
        if (i && (s.duration = t[1]),
        s.parent = n,
        e) {
            for (r = s; n && !("immediateRender"in r); )
                r = n.vars.defaults || {},
                n = $(n.vars.inherit) && n.parent;
            s.immediateRender = $(r.immediateRender),
            e < 2 ? s.runBackwards = 1 : s.startAt = t[o - 1]
        }
        return s
    }, St = function() {
        var t, e, n = dt.length, r = dt.slice(0);
        for (pt = {},
        dt.length = 0,
        t = 0; t < n; t++)
            (e = r[t]) && e._lazy && (e.render(e._lazy[0], e._lazy[1], !0)._lazy = 0)
    }, Pt = function(t, e, n, r) {
        dt.length && St(),
        t.render(e, n, r),
        dt.length && St()
    }, At = function(t) {
        var e = parseFloat(t);
        return (e || 0 === e) && (t + "").match(rt).length < 2 ? e : X(t) ? t.trim() : t
    }, Ot = function(t) {
        return t
    }, Dt = function(t, e) {
        for (var n in e)
            n in t || (t[n] = e[n]);
        return t
    }, Mt = function(t, e) {
        for (var n in e)
            n in t || "duration" === n || "ease" === n || (t[n] = e[n])
    }, Lt = function(t, e) {
        for (var n in e)
            t[n] = e[n];
        return t
    }, qt = function t(e, n) {
        for (var r in n)
            "__proto__" !== r && "constructor" !== r && "prototype" !== r && (e[r] = U(n[r]) ? t(e[r] || (e[r] = {}), n[r]) : n[r]);
        return e
    }, Nt = function(t, e) {
        var n, r = {};
        for (n in t)
            n in e || (r[n] = t[n]);
        return r
    }, jt = function(t) {
        var e = t.parent || s
          , n = t.keyframes ? Mt : Dt;
        if ($(t.inherit))
            for (; e; )
                n(t, e.vars.defaults),
                e = e.parent || e._dp;
        return t
    }, Rt = function(t, e, n, r) {
        void 0 === n && (n = "_first"),
        void 0 === r && (r = "_last");
        var i = e._prev
          , o = e._next;
        i ? i._next = o : t[n] === e && (t[n] = o),
        o ? o._prev = i : t[r] === e && (t[r] = i),
        e._next = e._prev = e.parent = null
    }, It = function(t, e) {
        t.parent && (!e || t.parent.autoRemoveChildren) && t.parent.remove(t),
        t._act = 0
    }, Ft = function(t, e) {
        if (t && (!e || e._end > t._dur || e._start < 0))
            for (var n = t; n; )
                n._dirty = 1,
                n = n.parent;
        return t
    }, Bt = function(t) {
        for (var e = t.parent; e && e.parent; )
            e._dirty = 1,
            e.totalDuration(),
            e = e.parent;
        return t
    }, Ht = function(t) {
        return t._repeat ? Xt(t._tTime, t = t.duration() + t._rDelay) * t : 0
    }, Xt = function(t, e) {
        var n = Math.floor(t /= e);
        return t && n === t ? n - 1 : n
    }, zt = function(t, e) {
        return (t - e._start) * e._ts + (e._ts >= 0 ? 0 : e._dirty ? e.totalDuration() : e._tDur)
    }, Yt = function(t) {
        return t._end = kt(t._start + (t._tDur / Math.abs(t._ts || t._rts || 1e-8) || 0))
    }, Wt = function(t, e) {
        var n = t._dp;
        return n && n.smoothChildTiming && t._ts && (t._start = kt(n._time - (t._ts > 0 ? e / t._ts : ((t._dirty ? t.totalDuration() : t._tDur) - e) / -t._ts)),
        Yt(t),
        n._dirty || Ft(n, t)),
        t
    }, Ut = function(t, e) {
        var n;
        if ((e._time || e._initted && !e._dur) && (n = zt(t.rawTime(), e),
        (!e._dur || ee(0, e.totalDuration(), n) - e._tTime > 1e-8) && e.render(n, !0)),
        Ft(t, e)._dp && t._initted && t._time >= t._dur && t._ts) {
            if (t._dur < t.duration())
                for (n = t; n._dp; )
                    n.rawTime() >= 0 && n.totalTime(n._tTime),
                    n = n._dp;
            t._zTime = -1e-8
        }
    }, $t = function(t, e, n, r) {
        return e.parent && It(e),
        e._start = kt(n + e._delay),
        e._end = kt(e._start + (e.totalDuration() / Math.abs(e.timeScale()) || 0)),
        function(t, e, n, r, i) {
            void 0 === n && (n = "_first"),
            void 0 === r && (r = "_last");
            var o, s = t[r];
            if (i)
                for (o = e[i]; s && s[i] > o; )
                    s = s._prev;
            s ? (e._next = s._next,
            s._next = e) : (e._next = t[n],
            t[n] = e),
            e._next ? e._next._prev = e : t[r] = e,
            e._prev = s,
            e.parent = e._dp = t
        }(t, e, "_first", "_last", t._sort ? "_start" : 0),
        t._recent = e,
        r || Ut(t, e),
        t
    }, Vt = function(t, e) {
        return (ot.ScrollTrigger || ut("scrollTrigger", e)) && ot.ScrollTrigger.create(e, t)
    }, Gt = function(t, e, n, r) {
        return $e(t, e),
        t._initted ? !n && t._pt && (t._dur && !1 !== t.vars.lazy || !t._dur && t.vars.lazy) && f !== Se.frame ? (dt.push(t),
        t._lazy = [e, r],
        1) : void 0 : 1
    }, Kt = function(t, e, n, r) {
        var i = t._repeat
          , o = kt(e) || 0
          , s = t._tTime / t._tDur;
        return s && !r && (t._time *= o / t._dur),
        t._dur = o,
        t._tDur = i ? i < 0 ? 1e10 : kt(o * (i + 1) + t._rDelay * i) : o,
        s && !r ? Wt(t, t._tTime = t._tDur * s) : t.parent && Yt(t),
        n || Ft(t.parent, t),
        t
    }, Qt = function(t) {
        return t instanceof Xe ? Ft(t) : Kt(t, t._dur)
    }, Jt = {
        _start: 0,
        endTime: ft
    }, Zt = function t(e, n) {
        var r, i, o = e.labels, s = e._recent || Jt, a = e.duration() >= N ? s.endTime(!1) : e._dur;
        return X(n) && (isNaN(n) || n in o) ? "<" === (r = n.charAt(0)) || ">" === r ? ("<" === r ? s._start : s.endTime(s._repeat >= 0)) + (parseFloat(n.substr(1)) || 0) : (r = n.indexOf("=")) < 0 ? (n in o || (o[n] = a),
        o[n]) : (i = +(n.charAt(r - 1) + n.substr(r + 1)),
        r > 1 ? t(e, n.substr(0, r - 1)) + i : a + i) : null == n ? a : +n
    }, te = function(t, e) {
        return t || 0 === t ? e(t) : e
    }, ee = function(t, e, n) {
        return n < t ? t : n > e ? e : n
    }, ne = function(t) {
        if ("string" != typeof t)
            return "";
        var e = it.exec(t);
        return e ? t.substr(e.index + e[0].length) : ""
    }, re = [].slice, ie = function(t, e) {
        return t && U(t) && "length"in t && (!e && !t.length || t.length - 1 in t && U(t[0])) && !t.nodeType && t !== a
    }, oe = function(t, e, n) {
        return void 0 === n && (n = []),
        t.forEach((function(t) {
            var r;
            return X(t) && !e || ie(t, 1) ? (r = n).push.apply(r, se(t)) : n.push(t)
        }
        )) || n
    }, se = function(t, e) {
        return !X(t) || e || !u && Pe() ? Q(t) ? oe(t, e) : ie(t) ? re.call(t, 0) : t ? [t] : [] : re.call(l.querySelectorAll(t), 0)
    }, ae = function(t) {
        return t.sort((function() {
            return .5 - Math.random()
        }
        ))
    }, ue = function(t) {
        if (z(t))
            return t;
        var e = U(t) ? t : {
            each: t
        }
          , n = Ne(e.ease)
          , r = e.from || 0
          , i = parseFloat(e.base) || 0
          , o = {}
          , s = r > 0 && r < 1
          , a = isNaN(r) || s
          , u = e.axis
          , l = r
          , c = r;
        return X(r) ? l = c = {
            center: .5,
            edges: .5,
            end: 1
        }[r] || 0 : !s && a && (l = r[0],
        c = r[1]),
        function(t, s, f) {
            var h, d, p, g, v, m, y, x, b, w = (f || e).length, _ = o[w];
            if (!_) {
                if (!(b = "auto" === e.grid ? 0 : (e.grid || [1, N])[1])) {
                    for (y = -N; y < (y = f[b++].getBoundingClientRect().left) && b < w; )
                        ;
                    b--
                }
                for (_ = o[w] = [],
                h = a ? Math.min(b, w) * l - .5 : r % b,
                d = a ? w * c / b - .5 : r / b | 0,
                y = 0,
                x = N,
                m = 0; m < w; m++)
                    p = m % b - h,
                    g = d - (m / b | 0),
                    _[m] = v = u ? Math.abs("y" === u ? g : p) : F(p * p + g * g),
                    v > y && (y = v),
                    v < x && (x = v);
                "random" === r && ae(_),
                _.max = y - x,
                _.min = x,
                _.v = w = (parseFloat(e.amount) || parseFloat(e.each) * (b > w ? w - 1 : u ? "y" === u ? w / b : b : Math.max(b, w / b)) || 0) * ("edges" === r ? -1 : 1),
                _.b = w < 0 ? i - w : i,
                _.u = ne(e.amount || e.each) || 0,
                n = n && w < 0 ? Le(n) : n
            }
            return w = (_[t] - _.min) / _.max || 0,
            kt(_.b + (n ? n(w) : w) * _.v) + _.u
        }
    }, le = function(t) {
        var e = t < 1 ? Math.pow(10, (t + "").length - 2) : 1;
        return function(n) {
            var r = Math.round(parseFloat(n) / t) * t * e;
            return (r - r % 1) / e + (Y(n) ? 0 : ne(n))
        }
    }, ce = function(t, e) {
        var n, r, i = Q(t);
        return !i && U(t) && (n = i = t.radius || N,
        t.values ? (t = se(t.values),
        (r = !Y(t[0])) && (n *= n)) : t = le(t.increment)),
        te(e, i ? z(t) ? function(e) {
            return r = t(e),
            Math.abs(r - e) <= n ? r : e
        }
        : function(e) {
            for (var i, o, s = parseFloat(r ? e.x : e), a = parseFloat(r ? e.y : 0), u = N, l = 0, c = t.length; c--; )
                (i = r ? (i = t[c].x - s) * i + (o = t[c].y - a) * o : Math.abs(t[c] - s)) < u && (u = i,
                l = c);
            return l = !n || u <= n ? t[l] : e,
            r || l === e || Y(e) ? l : l + ne(e)
        }
        : le(t))
    }, fe = function(t, e, n, r) {
        return te(Q(t) ? !e : !0 === n ? !!(n = 0) : !r, (function() {
            return Q(t) ? t[~~(Math.random() * t.length)] : (n = n || 1e-5) && (r = n < 1 ? Math.pow(10, (n + "").length - 2) : 1) && Math.floor(Math.round((t - n / 2 + Math.random() * (e - t + .99 * n)) / n) * n * r) / r
        }
        ))
    }, he = function(t, e, n) {
        return te(n, (function(n) {
            return t[~~e(n)]
        }
        ))
    }, de = function(t) {
        for (var e, n, r, i, o = 0, s = ""; ~(e = t.indexOf("random(", o)); )
            r = t.indexOf(")", e),
            i = "[" === t.charAt(e + 7),
            n = t.substr(e + 7, r - e - 7).match(i ? rt : J),
            s += t.substr(o, e - o) + fe(i ? n : +n[0], i ? 0 : +n[1], +n[2] || 1e-5),
            o = r + 1;
        return s + t.substr(o, t.length - o)
    }, pe = function(t, e, n, r, i) {
        var o = e - t
          , s = r - n;
        return te(i, (function(e) {
            return n + ((e - t) / o * s || 0)
        }
        ))
    }, ge = function(t, e, n) {
        var r, i, o, s = t.labels, a = N;
        for (r in s)
            (i = s[r] - e) < 0 == !!n && i && a > (i = Math.abs(i)) && (o = r,
            a = i);
        return o
    }, ve = function(t, e, n) {
        var r, i, o = t.vars, s = o[e];
        if (s)
            return r = o[e + "Params"],
            i = o.callbackScope || t,
            n && dt.length && St(),
            r ? s.apply(i, r) : s.call(i)
    }, me = function(t) {
        return It(t),
        t.progress() < 1 && ve(t, "onInterrupt"),
        t
    }, ye = function(t) {
        var e = (t = !t.name && t.default || t).name
          , n = z(t)
          , r = e && !n && t.init ? function() {
            this._props = []
        }
        : t
          , i = {
            init: ft,
            render: an,
            add: We,
            kill: ln,
            modifier: un,
            rawVars: 0
        }
          , o = {
            targetTest: 0,
            get: 0,
            getSetter: nn,
            aliases: {},
            register: 0
        };
        if (Pe(),
        t !== r) {
            if (gt[e])
                return;
            Dt(r, Dt(Nt(t, i), o)),
            Lt(r.prototype, Lt(i, Nt(t, o))),
            gt[r.prop = e] = r,
            t.targetTest && (yt.push(r),
            ht[e] = 1),
            e = ("css" === e ? "CSS" : e.charAt(0).toUpperCase() + e.substr(1)) + "Plugin"
        }
        ct(e, r),
        t.register && t.register(vn, r, hn)
    }, xe = {
        aqua: [0, 255, 255],
        lime: [0, 255, 0],
        silver: [192, 192, 192],
        black: [0, 0, 0],
        maroon: [128, 0, 0],
        teal: [0, 128, 128],
        blue: [0, 0, 255],
        navy: [0, 0, 128],
        white: [255, 255, 255],
        olive: [128, 128, 0],
        yellow: [255, 255, 0],
        orange: [255, 165, 0],
        gray: [128, 128, 128],
        purple: [128, 0, 128],
        green: [0, 128, 0],
        red: [255, 0, 0],
        pink: [255, 192, 203],
        cyan: [0, 255, 255],
        transparent: [255, 255, 255, 0]
    }, be = function(t, e, n) {
        return 255 * (6 * (t = t < 0 ? t + 1 : t > 1 ? t - 1 : t) < 1 ? e + (n - e) * t * 6 : t < .5 ? n : 3 * t < 2 ? e + (n - e) * (2 / 3 - t) * 6 : e) + .5 | 0
    }, we = function(t, e, n) {
        var r, i, o, s, a, u, l, c, f, h, d = t ? Y(t) ? [t >> 16, t >> 8 & 255, 255 & t] : 0 : xe.black;
        if (!d) {
            if ("," === t.substr(-1) && (t = t.substr(0, t.length - 1)),
            xe[t])
                d = xe[t];
            else if ("#" === t.charAt(0)) {
                if (t.length < 6 && (r = t.charAt(1),
                i = t.charAt(2),
                o = t.charAt(3),
                t = "#" + r + r + i + i + o + o + (5 === t.length ? t.charAt(4) + t.charAt(4) : "")),
                9 === t.length)
                    return [(d = parseInt(t.substr(1, 6), 16)) >> 16, d >> 8 & 255, 255 & d, parseInt(t.substr(7), 16) / 255];
                d = [(t = parseInt(t.substr(1), 16)) >> 16, t >> 8 & 255, 255 & t]
            } else if ("hsl" === t.substr(0, 3))
                if (d = h = t.match(J),
                e) {
                    if (~t.indexOf("="))
                        return d = t.match(Z),
                        n && d.length < 4 && (d[3] = 1),
                        d
                } else
                    s = +d[0] % 360 / 360,
                    a = +d[1] / 100,
                    r = 2 * (u = +d[2] / 100) - (i = u <= .5 ? u * (a + 1) : u + a - u * a),
                    d.length > 3 && (d[3] *= 1),
                    d[0] = be(s + 1 / 3, r, i),
                    d[1] = be(s, r, i),
                    d[2] = be(s - 1 / 3, r, i);
            else
                d = t.match(J) || xe.transparent;
            d = d.map(Number)
        }
        return e && !h && (r = d[0] / 255,
        i = d[1] / 255,
        o = d[2] / 255,
        u = ((l = Math.max(r, i, o)) + (c = Math.min(r, i, o))) / 2,
        l === c ? s = a = 0 : (f = l - c,
        a = u > .5 ? f / (2 - l - c) : f / (l + c),
        s = l === r ? (i - o) / f + (i < o ? 6 : 0) : l === i ? (o - r) / f + 2 : (r - i) / f + 4,
        s *= 60),
        d[0] = ~~(s + .5),
        d[1] = ~~(100 * a + .5),
        d[2] = ~~(100 * u + .5)),
        n && d.length < 4 && (d[3] = 1),
        d
    }, _e = function(t) {
        var e = []
          , n = []
          , r = -1;
        return t.split(ke).forEach((function(t) {
            var i = t.match(tt) || [];
            e.push.apply(e, i),
            n.push(r += i.length + 1)
        }
        )),
        e.c = n,
        e
    }, Te = function(t, e, n) {
        var r, i, o, s, a = "", u = (t + a).match(ke), l = e ? "hsla(" : "rgba(", c = 0;
        if (!u)
            return t;
        if (u = u.map((function(t) {
            return (t = we(t, e, 1)) && l + (e ? t[0] + "," + t[1] + "%," + t[2] + "%," + t[3] : t.join(",")) + ")"
        }
        )),
        n && (o = _e(t),
        (r = n.c).join(a) !== o.c.join(a)))
            for (s = (i = t.replace(ke, "1").split(tt)).length - 1; c < s; c++)
                a += i[c] + (~r.indexOf(c) ? u.shift() || l + "0,0,0,0)" : (o.length ? o : u.length ? u : n).shift());
        if (!i)
            for (s = (i = t.split(ke)).length - 1; c < s; c++)
                a += i[c] + u[c];
        return a + i[s]
    }, ke = function() {
        var t, e = "(?:\\b(?:(?:rgb|rgba|hsl|hsla)\\(.+?\\))|\\B#(?:[0-9a-f]{3,4}){1,2}\\b";
        for (t in xe)
            e += "|" + t + "\\b";
        return new RegExp(e + ")","gi")
    }(), Ce = /hsl[a]?\(/, Ee = function(t) {
        var e, n = t.join(" ");
        if (ke.lastIndex = 0,
        ke.test(n))
            return e = Ce.test(n),
            t[1] = Te(t[1], e),
            t[0] = Te(t[0], e, _e(t[1])),
            !0
    }, Se = (b = Date.now,
    w = 500,
    _ = 33,
    T = b(),
    k = T,
    E = C = 1e3 / 240,
    P = function t(e) {
        var n, r, i, o, s = b() - k, a = !0 === e;
        if (s > w && (T += s - _),
        ((n = (i = (k += s) - T) - E) > 0 || a) && (o = ++m.frame,
        y = i - 1e3 * m.time,
        m.time = i /= 1e3,
        E += n + (n >= C ? 4 : C - n),
        r = 1),
        a || (p = g(t)),
        r)
            for (x = 0; x < S.length; x++)
                S[x](i, y, o, e)
    }
    ,
    m = {
        time: 0,
        frame: 0,
        tick: function() {
            P(!0)
        },
        deltaRatio: function(t) {
            return y / (1e3 / (t || 60))
        },
        wake: function() {
            c && (!u && V() && (a = u = window,
            l = a.document || {},
            ot.gsap = vn,
            (a.gsapVersions || (a.gsapVersions = [])).push(vn.version),
            at(st || a.GreenSockGlobals || !a.gsap && a || {}),
            v = a.requestAnimationFrame),
            p && m.sleep(),
            g = v || function(t) {
                return setTimeout(t, E - 1e3 * m.time + 1 | 0)
            }
            ,
            d = 1,
            P(2))
        },
        sleep: function() {
            (v ? a.cancelAnimationFrame : clearTimeout)(p),
            d = 0,
            g = ft
        },
        lagSmoothing: function(t, e) {
            w = t || 1 / 1e-8,
            _ = Math.min(e, w, 0)
        },
        fps: function(t) {
            C = 1e3 / (t || 240),
            E = 1e3 * m.time + C
        },
        add: function(t) {
            S.indexOf(t) < 0 && S.push(t),
            Pe()
        },
        remove: function(t) {
            var e;
            ~(e = S.indexOf(t)) && S.splice(e, 1) && x >= e && x--
        },
        _listeners: S = []
    }), Pe = function() {
        return !d && Se.wake()
    }, Ae = {}, Oe = /^[\d.\-M][\d.\-,\s]/, De = /["']/g, Me = function(t) {
        for (var e, n, r, i = {}, o = t.substr(1, t.length - 3).split(":"), s = o[0], a = 1, u = o.length; a < u; a++)
            n = o[a],
            e = a !== u - 1 ? n.lastIndexOf(",") : n.length,
            r = n.substr(0, e),
            i[s] = isNaN(r) ? r.replace(De, "").trim() : +r,
            s = n.substr(e + 1).trim();
        return i
    }, Le = function(t) {
        return function(e) {
            return 1 - t(1 - e)
        }
    }, qe = function t(e, n) {
        for (var r, i = e._first; i; )
            i instanceof Xe ? t(i, n) : !i.vars.yoyoEase || i._yoyo && i._repeat || i._yoyo === n || (i.timeline ? t(i.timeline, n) : (r = i._ease,
            i._ease = i._yEase,
            i._yEase = r,
            i._yoyo = n)),
            i = i._next
    }, Ne = function(t, e) {
        return t && (z(t) ? t : Ae[t] || function(t) {
            var e, n, r, i, o = (t + "").split("("), s = Ae[o[0]];
            return s && o.length > 1 && s.config ? s.config.apply(null, ~t.indexOf("{") ? [Me(o[1])] : (e = t,
            n = e.indexOf("(") + 1,
            r = e.indexOf(")"),
            i = e.indexOf("(", n),
            e.substring(n, ~i && i < r ? e.indexOf(")", r + 1) : r)).split(",").map(At)) : Ae._CE && Oe.test(t) ? Ae._CE("", t) : s
        }(t)) || e
    }, je = function(t, e, n, r) {
        void 0 === n && (n = function(t) {
            return 1 - e(1 - t)
        }
        ),
        void 0 === r && (r = function(t) {
            return t < .5 ? e(2 * t) / 2 : 1 - e(2 * (1 - t)) / 2
        }
        );
        var i, o = {
            easeIn: e,
            easeOut: n,
            easeInOut: r
        };
        return Tt(t, (function(t) {
            for (var e in Ae[t] = ot[t] = o,
            Ae[i = t.toLowerCase()] = n,
            o)
                Ae[i + ("easeIn" === e ? ".in" : "easeOut" === e ? ".out" : ".inOut")] = Ae[t + "." + e] = o[e]
        }
        )),
        o
    }, Re = function(t) {
        return function(e) {
            return e < .5 ? (1 - t(1 - 2 * e)) / 2 : .5 + t(2 * (e - .5)) / 2
        }
    }, Ie = function t(e, n, r) {
        var i = n >= 1 ? n : 1
          , o = (r || (e ? .3 : .45)) / (n < 1 ? n : 1)
          , s = o / j * (Math.asin(1 / i) || 0)
          , a = function(t) {
            return 1 === t ? 1 : i * Math.pow(2, -10 * t) * H((t - s) * o) + 1
        }
          , u = "out" === e ? a : "in" === e ? function(t) {
            return 1 - a(1 - t)
        }
        : Re(a);
        return o = j / o,
        u.config = function(n, r) {
            return t(e, n, r)
        }
        ,
        u
    }, Fe = function t(e, n) {
        void 0 === n && (n = 1.70158);
        var r = function(t) {
            return t ? --t * t * ((n + 1) * t + n) + 1 : 0
        }
          , i = "out" === e ? r : "in" === e ? function(t) {
            return 1 - r(1 - t)
        }
        : Re(r);
        return i.config = function(n) {
            return t(e, n)
        }
        ,
        i
    };
    Tt("Linear,Quad,Cubic,Quart,Quint,Strong", (function(t, e) {
        var n = e < 5 ? e + 1 : e;
        je(t + ",Power" + (n - 1), e ? function(t) {
            return Math.pow(t, n)
        }
        : function(t) {
            return t
        }
        , (function(t) {
            return 1 - Math.pow(1 - t, n)
        }
        ), (function(t) {
            return t < .5 ? Math.pow(2 * t, n) / 2 : 1 - Math.pow(2 * (1 - t), n) / 2
        }
        ))
    }
    )),
    Ae.Linear.easeNone = Ae.none = Ae.Linear.easeIn,
    je("Elastic", Ie("in"), Ie("out"), Ie()),
    A = 7.5625,
    D = 1 / (O = 2.75),
    je("Bounce", (function(t) {
        return 1 - M(1 - t)
    }
    ), M = function(t) {
        return t < D ? A * t * t : t < .7272727272727273 ? A * Math.pow(t - 1.5 / O, 2) + .75 : t < .9090909090909092 ? A * (t -= 2.25 / O) * t + .9375 : A * Math.pow(t - 2.625 / O, 2) + .984375
    }
    ),
    je("Expo", (function(t) {
        return t ? Math.pow(2, 10 * (t - 1)) : 0
    }
    )),
    je("Circ", (function(t) {
        return -(F(1 - t * t) - 1)
    }
    )),
    je("Sine", (function(t) {
        return 1 === t ? 1 : 1 - B(t * R)
    }
    )),
    je("Back", Fe("in"), Fe("out"), Fe()),
    Ae.SteppedEase = Ae.steps = ot.SteppedEase = {
        config: function(t, e) {
            void 0 === t && (t = 1);
            var n = 1 / t
              , r = t + (e ? 0 : 1)
              , i = e ? 1 : 0;
            return function(t) {
                return ((r * ee(0, 1 - 1e-8, t) | 0) + i) * n
            }
        }
    },
    q.ease = Ae["quad.out"],
    Tt("onComplete,onUpdate,onStart,onRepeat,onReverseComplete,onInterrupt", (function(t) {
        return xt += t + "," + t + "Params,"
    }
    ));
    var Be = function(t, e) {
        this.id = I++,
        t._gsap = this,
        this.target = t,
        this.harness = e,
        this.get = e ? e.get : _t,
        this.set = e ? e.getSetter : nn
    }
      , He = function() {
        function t(t, e) {
            var n = t.parent || s;
            this.vars = t,
            this._delay = +t.delay || 0,
            (this._repeat = t.repeat === 1 / 0 ? -2 : t.repeat || 0) && (this._rDelay = t.repeatDelay || 0,
            this._yoyo = !!t.yoyo || !!t.yoyoEase),
            this._ts = 1,
            Kt(this, +t.duration, 1, 1),
            this.data = t.data,
            d || Se.wake(),
            n && $t(n, this, e || 0 === e ? e : n._time, 1),
            t.reversed && this.reverse(),
            t.paused && this.paused(!0)
        }
        var e = t.prototype;
        return e.delay = function(t) {
            return t || 0 === t ? (this.parent && this.parent.smoothChildTiming && this.startTime(this._start + t - this._delay),
            this._delay = t,
            this) : this._delay
        }
        ,
        e.duration = function(t) {
            return arguments.length ? this.totalDuration(this._repeat > 0 ? t + (t + this._rDelay) * this._repeat : t) : this.totalDuration() && this._dur
        }
        ,
        e.totalDuration = function(t) {
            return arguments.length ? (this._dirty = 0,
            Kt(this, this._repeat < 0 ? t : (t - this._repeat * this._rDelay) / (this._repeat + 1))) : this._tDur
        }
        ,
        e.totalTime = function(t, e) {
            if (Pe(),
            !arguments.length)
                return this._tTime;
            var n = this._dp;
            if (n && n.smoothChildTiming && this._ts) {
                for (Wt(this, t),
                !n._dp || n.parent || Ut(n, this); n.parent; )
                    n.parent._time !== n._start + (n._ts >= 0 ? n._tTime / n._ts : (n.totalDuration() - n._tTime) / -n._ts) && n.totalTime(n._tTime, !0),
                    n = n.parent;
                !this.parent && this._dp.autoRemoveChildren && (this._ts > 0 && t < this._tDur || this._ts < 0 && t > 0 || !this._tDur && !t) && $t(this._dp, this, this._start - this._delay)
            }
            return (this._tTime !== t || !this._dur && !e || this._initted && 1e-8 === Math.abs(this._zTime) || !t && !this._initted && (this.add || this._ptLookup)) && (this._ts || (this._pTime = t),
            Pt(this, t, e)),
            this
        }
        ,
        e.time = function(t, e) {
            return arguments.length ? this.totalTime(Math.min(this.totalDuration(), t + Ht(this)) % this._dur || (t ? this._dur : 0), e) : this._time
        }
        ,
        e.totalProgress = function(t, e) {
            return arguments.length ? this.totalTime(this.totalDuration() * t, e) : this.totalDuration() ? Math.min(1, this._tTime / this._tDur) : this.ratio
        }
        ,
        e.progress = function(t, e) {
            return arguments.length ? this.totalTime(this.duration() * (!this._yoyo || 1 & this.iteration() ? t : 1 - t) + Ht(this), e) : this.duration() ? Math.min(1, this._time / this._dur) : this.ratio
        }
        ,
        e.iteration = function(t, e) {
            var n = this.duration() + this._rDelay;
            return arguments.length ? this.totalTime(this._time + (t - 1) * n, e) : this._repeat ? Xt(this._tTime, n) + 1 : 1
        }
        ,
        e.timeScale = function(t) {
            if (!arguments.length)
                return -1e-8 === this._rts ? 0 : this._rts;
            if (this._rts === t)
                return this;
            var e = this.parent && this._ts ? zt(this.parent._time, this) : this._tTime;
            return this._rts = +t || 0,
            this._ts = this._ps || -1e-8 === t ? 0 : this._rts,
            Bt(this.totalTime(ee(-this._delay, this._tDur, e), !0))
        }
        ,
        e.paused = function(t) {
            return arguments.length ? (this._ps !== t && (this._ps = t,
            t ? (this._pTime = this._tTime || Math.max(-this._delay, this.rawTime()),
            this._ts = this._act = 0) : (Pe(),
            this._ts = this._rts,
            this.totalTime(this.parent && !this.parent.smoothChildTiming ? this.rawTime() : this._tTime || this._pTime, 1 === this.progress() && (this._tTime -= 1e-8) && 1e-8 !== Math.abs(this._zTime)))),
            this) : this._ps
        }
        ,
        e.startTime = function(t) {
            if (arguments.length) {
                this._start = t;
                var e = this.parent || this._dp;
                return e && (e._sort || !this.parent) && $t(e, this, t - this._delay),
                this
            }
            return this._start
        }
        ,
        e.endTime = function(t) {
            return this._start + ($(t) ? this.totalDuration() : this.duration()) / Math.abs(this._ts)
        }
        ,
        e.rawTime = function(t) {
            var e = this.parent || this._dp;
            return e ? t && (!this._ts || this._repeat && this._time && this.totalProgress() < 1) ? this._tTime % (this._dur + this._rDelay) : this._ts ? zt(e.rawTime(t), this) : this._tTime : this._tTime
        }
        ,
        e.globalTime = function(t) {
            for (var e = this, n = arguments.length ? t : e.rawTime(); e; )
                n = e._start + n / (e._ts || 1),
                e = e._dp;
            return n
        }
        ,
        e.repeat = function(t) {
            return arguments.length ? (this._repeat = t === 1 / 0 ? -2 : t,
            Qt(this)) : -2 === this._repeat ? 1 / 0 : this._repeat
        }
        ,
        e.repeatDelay = function(t) {
            return arguments.length ? (this._rDelay = t,
            Qt(this)) : this._rDelay
        }
        ,
        e.yoyo = function(t) {
            return arguments.length ? (this._yoyo = t,
            this) : this._yoyo
        }
        ,
        e.seek = function(t, e) {
            return this.totalTime(Zt(this, t), $(e))
        }
        ,
        e.restart = function(t, e) {
            return this.play().totalTime(t ? -this._delay : 0, $(e))
        }
        ,
        e.play = function(t, e) {
            return null != t && this.seek(t, e),
            this.reversed(!1).paused(!1)
        }
        ,
        e.reverse = function(t, e) {
            return null != t && this.seek(t || this.totalDuration(), e),
            this.reversed(!0).paused(!1)
        }
        ,
        e.pause = function(t, e) {
            return null != t && this.seek(t, e),
            this.paused(!0)
        }
        ,
        e.resume = function() {
            return this.paused(!1)
        }
        ,
        e.reversed = function(t) {
            return arguments.length ? (!!t !== this.reversed() && this.timeScale(-this._rts || (t ? -1e-8 : 0)),
            this) : this._rts < 0
        }
        ,
        e.invalidate = function() {
            return this._initted = this._act = 0,
            this._zTime = -1e-8,
            this
        }
        ,
        e.isActive = function() {
            var t, e = this.parent || this._dp, n = this._start;
            return !(e && !(this._ts && this._initted && e.isActive() && (t = e.rawTime(!0)) >= n && t < this.endTime(!0) - 1e-8))
        }
        ,
        e.eventCallback = function(t, e, n) {
            var r = this.vars;
            return arguments.length > 1 ? (e ? (r[t] = e,
            n && (r[t + "Params"] = n),
            "onUpdate" === t && (this._onUpdate = e)) : delete r[t],
            this) : r[t]
        }
        ,
        e.then = function(t) {
            var e = this;
            return new Promise((function(n) {
                var r = z(t) ? t : Ot
                  , i = function() {
                    var t = e.then;
                    e.then = null,
                    z(r) && (r = r(e)) && (r.then || r === e) && (e.then = t),
                    n(r),
                    e.then = t
                };
                e._initted && 1 === e.totalProgress() && e._ts >= 0 || !e._tTime && e._ts < 0 ? i() : e._prom = i
            }
            ))
        }
        ,
        e.kill = function() {
            me(this)
        }
        ,
        t
    }();
    Dt(He.prototype, {
        _time: 0,
        _start: 0,
        _end: 0,
        _tTime: 0,
        _tDur: 0,
        _dirty: 0,
        _repeat: 0,
        _yoyo: !1,
        parent: null,
        _initted: !1,
        _rDelay: 0,
        _ts: 1,
        _dp: 0,
        ratio: 0,
        _zTime: -1e-8,
        _prom: 0,
        _ps: !1,
        _rts: 1
    });
    var Xe = function(t) {
        function e(e, n) {
            var i;
            return void 0 === e && (e = {}),
            (i = t.call(this, e, n) || this).labels = {},
            i.smoothChildTiming = !!e.smoothChildTiming,
            i.autoRemoveChildren = !!e.autoRemoveChildren,
            i._sort = $(e.sortChildren),
            i.parent && Ut(i.parent, r(i)),
            e.scrollTrigger && Vt(r(i), e.scrollTrigger),
            i
        }
        i(e, t);
        var n = e.prototype;
        return n.to = function(t, e, n) {
            return new Qe(t,Et(arguments, 0, this),Zt(this, Y(e) ? arguments[3] : n)),
            this
        }
        ,
        n.from = function(t, e, n) {
            return new Qe(t,Et(arguments, 1, this),Zt(this, Y(e) ? arguments[3] : n)),
            this
        }
        ,
        n.fromTo = function(t, e, n, r) {
            return new Qe(t,Et(arguments, 2, this),Zt(this, Y(e) ? arguments[4] : r)),
            this
        }
        ,
        n.set = function(t, e, n) {
            return e.duration = 0,
            e.parent = this,
            jt(e).repeatDelay || (e.repeat = 0),
            e.immediateRender = !!e.immediateRender,
            new Qe(t,e,Zt(this, n),1),
            this
        }
        ,
        n.call = function(t, e, n) {
            return $t(this, Qe.delayedCall(0, t, e), Zt(this, n))
        }
        ,
        n.staggerTo = function(t, e, n, r, i, o, s) {
            return n.duration = e,
            n.stagger = n.stagger || r,
            n.onComplete = o,
            n.onCompleteParams = s,
            n.parent = this,
            new Qe(t,n,Zt(this, i)),
            this
        }
        ,
        n.staggerFrom = function(t, e, n, r, i, o, s) {
            return n.runBackwards = 1,
            jt(n).immediateRender = $(n.immediateRender),
            this.staggerTo(t, e, n, r, i, o, s)
        }
        ,
        n.staggerFromTo = function(t, e, n, r, i, o, s, a) {
            return r.startAt = n,
            jt(r).immediateRender = $(r.immediateRender),
            this.staggerTo(t, e, r, i, o, s, a)
        }
        ,
        n.render = function(t, e, n) {
            var r, i, o, a, u, l, c, f, h, d, p, g, v = this._time, m = this._dirty ? this.totalDuration() : this._tDur, y = this._dur, x = this !== s && t > m - 1e-8 && t >= 0 ? m : t < 1e-8 ? 0 : t, b = this._zTime < 0 != t < 0 && (this._initted || !y);
            if (x !== this._tTime || n || b) {
                if (v !== this._time && y && (x += this._time - v,
                t += this._time - v),
                r = x,
                h = this._start,
                l = !(f = this._ts),
                b && (y || (v = this._zTime),
                (t || !e) && (this._zTime = t)),
                this._repeat) {
                    if (p = this._yoyo,
                    u = y + this._rDelay,
                    this._repeat < -1 && t < 0)
                        return this.totalTime(100 * u + t, e, n);
                    if (r = kt(x % u),
                    x === m ? (a = this._repeat,
                    r = y) : ((a = ~~(x / u)) && a === x / u && (r = y,
                    a--),
                    r > y && (r = y)),
                    d = Xt(this._tTime, u),
                    !v && this._tTime && d !== a && (d = a),
                    p && 1 & a && (r = y - r,
                    g = 1),
                    a !== d && !this._lock) {
                        var w = p && 1 & d
                          , _ = w === (p && 1 & a);
                        if (a < d && (w = !w),
                        v = w ? 0 : y,
                        this._lock = 1,
                        this.render(v || (g ? 0 : kt(a * u)), e, !y)._lock = 0,
                        !e && this.parent && ve(this, "onRepeat"),
                        this.vars.repeatRefresh && !g && (this.invalidate()._lock = 1),
                        v !== this._time || l !== !this._ts)
                            return this;
                        if (y = this._dur,
                        m = this._tDur,
                        _ && (this._lock = 2,
                        v = w ? y : -1e-4,
                        this.render(v, !0),
                        this.vars.repeatRefresh && !g && this.invalidate()),
                        this._lock = 0,
                        !this._ts && !l)
                            return this;
                        qe(this, g)
                    }
                }
                if (this._hasPause && !this._forcing && this._lock < 2 && (c = function(t, e, n) {
                    var r;
                    if (n > e)
                        for (r = t._first; r && r._start <= n; ) {
                            if (!r._dur && "isPause" === r.data && r._start > e)
                                return r;
                            r = r._next
                        }
                    else
                        for (r = t._last; r && r._start >= n; ) {
                            if (!r._dur && "isPause" === r.data && r._start < e)
                                return r;
                            r = r._prev
                        }
                }(this, kt(v), kt(r))) && (x -= r - (r = c._start)),
                this._tTime = x,
                this._time = r,
                this._act = !f,
                this._initted || (this._onUpdate = this.vars.onUpdate,
                this._initted = 1,
                this._zTime = t,
                v = 0),
                !v && (r || !y && t >= 0) && !e && ve(this, "onStart"),
                r >= v && t >= 0)
                    for (i = this._first; i; ) {
                        if (o = i._next,
                        (i._act || r >= i._start) && i._ts && c !== i) {
                            if (i.parent !== this)
                                return this.render(t, e, n);
                            if (i.render(i._ts > 0 ? (r - i._start) * i._ts : (i._dirty ? i.totalDuration() : i._tDur) + (r - i._start) * i._ts, e, n),
                            r !== this._time || !this._ts && !l) {
                                c = 0,
                                o && (x += this._zTime = -1e-8);
                                break
                            }
                        }
                        i = o
                    }
                else {
                    i = this._last;
                    for (var T = t < 0 ? t : r; i; ) {
                        if (o = i._prev,
                        (i._act || T <= i._end) && i._ts && c !== i) {
                            if (i.parent !== this)
                                return this.render(t, e, n);
                            if (i.render(i._ts > 0 ? (T - i._start) * i._ts : (i._dirty ? i.totalDuration() : i._tDur) + (T - i._start) * i._ts, e, n),
                            r !== this._time || !this._ts && !l) {
                                c = 0,
                                o && (x += this._zTime = T ? -1e-8 : 1e-8);
                                break
                            }
                        }
                        i = o
                    }
                }
                if (c && !e && (this.pause(),
                c.render(r >= v ? 0 : -1e-8)._zTime = r >= v ? 1 : -1,
                this._ts))
                    return this._start = h,
                    Yt(this),
                    this.render(t, e, n);
                this._onUpdate && !e && ve(this, "onUpdate", !0),
                (x === m && m >= this.totalDuration() || !x && v) && (h !== this._start && Math.abs(f) === Math.abs(this._ts) || this._lock || ((t || !y) && (x === m && this._ts > 0 || !x && this._ts < 0) && It(this, 1),
                e || t < 0 && !v || !x && !v || (ve(this, x === m ? "onComplete" : "onReverseComplete", !0),
                this._prom && !(x < m && this.timeScale() > 0) && this._prom())))
            }
            return this
        }
        ,
        n.add = function(t, e) {
            var n = this;
            if (Y(e) || (e = Zt(this, e)),
            !(t instanceof He)) {
                if (Q(t))
                    return t.forEach((function(t) {
                        return n.add(t, e)
                    }
                    )),
                    this;
                if (X(t))
                    return this.addLabel(t, e);
                if (!z(t))
                    return this;
                t = Qe.delayedCall(0, t)
            }
            return this !== t ? $t(this, t, e) : this
        }
        ,
        n.getChildren = function(t, e, n, r) {
            void 0 === t && (t = !0),
            void 0 === e && (e = !0),
            void 0 === n && (n = !0),
            void 0 === r && (r = -N);
            for (var i = [], o = this._first; o; )
                o._start >= r && (o instanceof Qe ? e && i.push(o) : (n && i.push(o),
                t && i.push.apply(i, o.getChildren(!0, e, n)))),
                o = o._next;
            return i
        }
        ,
        n.getById = function(t) {
            for (var e = this.getChildren(1, 1, 1), n = e.length; n--; )
                if (e[n].vars.id === t)
                    return e[n]
        }
        ,
        n.remove = function(t) {
            return X(t) ? this.removeLabel(t) : z(t) ? this.killTweensOf(t) : (Rt(this, t),
            t === this._recent && (this._recent = this._last),
            Ft(this))
        }
        ,
        n.totalTime = function(e, n) {
            return arguments.length ? (this._forcing = 1,
            !this._dp && this._ts && (this._start = kt(Se.time - (this._ts > 0 ? e / this._ts : (this.totalDuration() - e) / -this._ts))),
            t.prototype.totalTime.call(this, e, n),
            this._forcing = 0,
            this) : this._tTime
        }
        ,
        n.addLabel = function(t, e) {
            return this.labels[t] = Zt(this, e),
            this
        }
        ,
        n.removeLabel = function(t) {
            return delete this.labels[t],
            this
        }
        ,
        n.addPause = function(t, e, n) {
            var r = Qe.delayedCall(0, e || ft, n);
            return r.data = "isPause",
            this._hasPause = 1,
            $t(this, r, Zt(this, t))
        }
        ,
        n.removePause = function(t) {
            var e = this._first;
            for (t = Zt(this, t); e; )
                e._start === t && "isPause" === e.data && It(e),
                e = e._next
        }
        ,
        n.killTweensOf = function(t, e, n) {
            for (var r = this.getTweensOf(t, n), i = r.length; i--; )
                ze !== r[i] && r[i].kill(t, e);
            return this
        }
        ,
        n.getTweensOf = function(t, e) {
            for (var n, r = [], i = se(t), o = this._first, s = Y(e); o; )
                o instanceof Qe ? Ct(o._targets, i) && (s ? (!ze || o._initted && o._ts) && o.globalTime(0) <= e && o.globalTime(o.totalDuration()) > e : !e || o.isActive()) && r.push(o) : (n = o.getTweensOf(i, e)).length && r.push.apply(r, n),
                o = o._next;
            return r
        }
        ,
        n.tweenTo = function(t, e) {
            e = e || {};
            var n = this
              , r = Zt(n, t)
              , i = e
              , o = i.startAt
              , s = i.onStart
              , a = i.onStartParams
              , u = i.immediateRender
              , l = Qe.to(n, Dt({
                ease: "none",
                lazy: !1,
                immediateRender: !1,
                time: r,
                overwrite: "auto",
                duration: e.duration || Math.abs((r - (o && "time"in o ? o.time : n._time)) / n.timeScale()) || 1e-8,
                onStart: function() {
                    n.pause();
                    var t = e.duration || Math.abs((r - n._time) / n.timeScale());
                    l._dur !== t && Kt(l, t, 0, 1).render(l._time, !0, !0),
                    s && s.apply(l, a || [])
                }
            }, e));
            return u ? l.render(0) : l
        }
        ,
        n.tweenFromTo = function(t, e, n) {
            return this.tweenTo(e, Dt({
                startAt: {
                    time: Zt(this, t)
                }
            }, n))
        }
        ,
        n.recent = function() {
            return this._recent
        }
        ,
        n.nextLabel = function(t) {
            return void 0 === t && (t = this._time),
            ge(this, Zt(this, t))
        }
        ,
        n.previousLabel = function(t) {
            return void 0 === t && (t = this._time),
            ge(this, Zt(this, t), 1)
        }
        ,
        n.currentLabel = function(t) {
            return arguments.length ? this.seek(t, !0) : this.previousLabel(this._time + 1e-8)
        }
        ,
        n.shiftChildren = function(t, e, n) {
            void 0 === n && (n = 0);
            for (var r, i = this._first, o = this.labels; i; )
                i._start >= n && (i._start += t,
                i._end += t),
                i = i._next;
            if (e)
                for (r in o)
                    o[r] >= n && (o[r] += t);
            return Ft(this)
        }
        ,
        n.invalidate = function() {
            var e = this._first;
            for (this._lock = 0; e; )
                e.invalidate(),
                e = e._next;
            return t.prototype.invalidate.call(this)
        }
        ,
        n.clear = function(t) {
            void 0 === t && (t = !0);
            for (var e, n = this._first; n; )
                e = n._next,
                this.remove(n),
                n = e;
            return this._dp && (this._time = this._tTime = this._pTime = 0),
            t && (this.labels = {}),
            Ft(this)
        }
        ,
        n.totalDuration = function(t) {
            var e, n, r, i = 0, o = this, a = o._last, u = N;
            if (arguments.length)
                return o.timeScale((o._repeat < 0 ? o.duration() : o.totalDuration()) / (o.reversed() ? -t : t));
            if (o._dirty) {
                for (r = o.parent; a; )
                    e = a._prev,
                    a._dirty && a.totalDuration(),
                    (n = a._start) > u && o._sort && a._ts && !o._lock ? (o._lock = 1,
                    $t(o, a, n - a._delay, 1)._lock = 0) : u = n,
                    n < 0 && a._ts && (i -= n,
                    (!r && !o._dp || r && r.smoothChildTiming) && (o._start += n / o._ts,
                    o._time -= n,
                    o._tTime -= n),
                    o.shiftChildren(-n, !1, -Infinity),
                    u = 0),
                    a._end > i && a._ts && (i = a._end),
                    a = e;
                Kt(o, o === s && o._time > i ? o._time : i, 1, 1),
                o._dirty = 0
            }
            return o._tDur
        }
        ,
        e.updateRoot = function(t) {
            if (s._ts && (Pt(s, zt(t, s)),
            f = Se.frame),
            Se.frame >= mt) {
                mt += L.autoSleep || 120;
                var e = s._first;
                if ((!e || !e._ts) && L.autoSleep && Se._listeners.length < 2) {
                    for (; e && !e._ts; )
                        e = e._next;
                    e || Se.sleep()
                }
            }
        }
        ,
        e
    }(He);
    Dt(Xe.prototype, {
        _lock: 0,
        _hasPause: 0,
        _forcing: 0
    });
    var ze, Ye = function(t, e, n, r, i, o, s) {
        var a, u, l, c, f, h, d, p, g = new hn(this._pt,t,e,0,1,sn,null,i), v = 0, m = 0;
        for (g.b = n,
        g.e = r,
        n += "",
        (d = ~(r += "").indexOf("random(")) && (r = de(r)),
        o && (o(p = [n, r], t, e),
        n = p[0],
        r = p[1]),
        u = n.match(et) || []; a = et.exec(r); )
            c = a[0],
            f = r.substring(v, a.index),
            l ? l = (l + 1) % 5 : "rgba(" === f.substr(-5) && (l = 1),
            c !== u[m++] && (h = parseFloat(u[m - 1]) || 0,
            g._pt = {
                _next: g._pt,
                p: f || 1 === m ? f : ",",
                s: h,
                c: "=" === c.charAt(1) ? parseFloat(c.substr(2)) * ("-" === c.charAt(0) ? -1 : 1) : parseFloat(c) - h,
                m: l && l < 4 ? Math.round : 0
            },
            v = et.lastIndex);
        return g.c = v < r.length ? r.substring(v, r.length) : "",
        g.fp = s,
        (nt.test(r) || d) && (g.e = 0),
        this._pt = g,
        g
    }, We = function(t, e, n, r, i, o, s, a, u) {
        z(r) && (r = r(i || 0, t, o));
        var l, c = t[e], f = "get" !== n ? n : z(c) ? u ? t[e.indexOf("set") || !z(t["get" + e.substr(3)]) ? e : "get" + e.substr(3)](u) : t[e]() : c, h = z(c) ? u ? tn : Ze : Je;
        if (X(r) && (~r.indexOf("random(") && (r = de(r)),
        "=" === r.charAt(1) && (r = parseFloat(f) + parseFloat(r.substr(2)) * ("-" === r.charAt(0) ? -1 : 1) + (ne(f) || 0))),
        f !== r)
            return isNaN(f * r) ? (!c && !(e in t) && ut(e, r),
            Ye.call(this, t, e, f, r, h, a || L.stringFilter, u)) : (l = new hn(this._pt,t,e,+f || 0,r - (f || 0),"boolean" == typeof c ? on : rn,0,h),
            u && (l.fp = u),
            s && l.modifier(s, this, t),
            this._pt = l)
    }, Ue = function(t, e, n, r, i, o) {
        var s, a, u, l;
        if (gt[t] && !1 !== (s = new gt[t]).init(i, s.rawVars ? e[t] : function(t, e, n, r, i) {
            if (z(t) && (t = Ve(t, i, e, n, r)),
            !U(t) || t.style && t.nodeType || Q(t) || K(t))
                return X(t) ? Ve(t, i, e, n, r) : t;
            var o, s = {};
            for (o in t)
                s[o] = Ve(t[o], i, e, n, r);
            return s
        }(e[t], r, i, o, n), n, r, o) && (n._pt = a = new hn(n._pt,i,t,0,1,s.render,s,0,s.priority),
        n !== h))
            for (u = n._ptLookup[n._targets.indexOf(i)],
            l = s._props.length; l--; )
                u[s._props[l]] = a;
        return s
    }, $e = function t(e, n) {
        var r, i, a, u, l, c, f, h, d, p, g, v, m, y = e.vars, x = y.ease, b = y.startAt, w = y.immediateRender, _ = y.lazy, T = y.onUpdate, k = y.onUpdateParams, C = y.callbackScope, E = y.runBackwards, S = y.yoyoEase, P = y.keyframes, A = y.autoRevert, O = e._dur, D = e._startAt, M = e._targets, L = e.parent, N = L && "nested" === L.data ? L.parent._targets : M, j = "auto" === e._overwrite && !o, R = e.timeline;
        if (R && (!P || !x) && (x = "none"),
        e._ease = Ne(x, q.ease),
        e._yEase = S ? Le(Ne(!0 === S ? x : S, q.ease)) : 0,
        S && e._yoyo && !e._repeat && (S = e._yEase,
        e._yEase = e._ease,
        e._ease = S),
        !R) {
            if (v = (h = M[0] ? wt(M[0]).harness : 0) && y[h.prop],
            r = Nt(y, ht),
            D && D.render(-1, !0).kill(),
            b) {
                if (It(e._startAt = Qe.set(M, Dt({
                    data: "isStart",
                    overwrite: !1,
                    parent: L,
                    immediateRender: !0,
                    lazy: $(_),
                    startAt: null,
                    delay: 0,
                    onUpdate: T,
                    onUpdateParams: k,
                    callbackScope: C,
                    stagger: 0
                }, b))),
                w)
                    if (n > 0)
                        A || (e._startAt = 0);
                    else if (O && !(n < 0 && D))
                        return void (n && (e._zTime = n))
            } else if (E && O)
                if (D)
                    !A && (e._startAt = 0);
                else if (n && (w = !1),
                a = Dt({
                    overwrite: !1,
                    data: "isFromStart",
                    lazy: w && $(_),
                    immediateRender: w,
                    stagger: 0,
                    parent: L
                }, r),
                v && (a[h.prop] = v),
                It(e._startAt = Qe.set(M, a)),
                w) {
                    if (!n)
                        return
                } else
                    t(e._startAt, 1e-8);
            for (e._pt = 0,
            _ = O && $(_) || _ && !O,
            i = 0; i < M.length; i++) {
                if (f = (l = M[i])._gsap || bt(M)[i]._gsap,
                e._ptLookup[i] = p = {},
                pt[f.id] && dt.length && St(),
                g = N === M ? i : N.indexOf(l),
                h && !1 !== (d = new h).init(l, v || r, e, g, N) && (e._pt = u = new hn(e._pt,l,d.name,0,1,d.render,d,0,d.priority),
                d._props.forEach((function(t) {
                    p[t] = u
                }
                )),
                d.priority && (c = 1)),
                !h || v)
                    for (a in r)
                        gt[a] && (d = Ue(a, r, e, g, l, N)) ? d.priority && (c = 1) : p[a] = u = We.call(e, l, a, "get", r[a], g, N, 0, y.stringFilter);
                e._op && e._op[i] && e.kill(l, e._op[i]),
                j && e._pt && (ze = e,
                s.killTweensOf(l, p, e.globalTime(0)),
                m = !e.parent,
                ze = 0),
                e._pt && _ && (pt[f.id] = 1)
            }
            c && fn(e),
            e._onInit && e._onInit(e)
        }
        e._from = !R && !!y.runBackwards,
        e._onUpdate = T,
        e._initted = (!e._op || e._pt) && !m
    }, Ve = function(t, e, n, r, i) {
        return z(t) ? t.call(e, n, r, i) : X(t) && ~t.indexOf("random(") ? de(t) : t
    }, Ge = xt + "repeat,repeatDelay,yoyo,repeatRefresh,yoyoEase", Ke = (Ge + ",id,stagger,delay,duration,paused,scrollTrigger").split(","), Qe = function(t) {
        function e(e, n, i, a) {
            var u;
            "number" == typeof n && (i.duration = n,
            n = i,
            i = null);
            var l, c, f, h, d, p, g, v, m = (u = t.call(this, a ? n : jt(n), i) || this).vars, y = m.duration, x = m.delay, b = m.immediateRender, w = m.stagger, _ = m.overwrite, T = m.keyframes, k = m.defaults, C = m.scrollTrigger, E = m.yoyoEase, S = u.parent, P = (Q(e) || K(e) ? Y(e[0]) : "length"in n) ? [e] : se(e);
            if (u._targets = P.length ? bt(P) : lt("GSAP target " + e + " not found. https://greensock.com", !L.nullTargetWarn) || [],
            u._ptLookup = [],
            u._overwrite = _,
            T || w || G(y) || G(x)) {
                if (n = u.vars,
                (l = u.timeline = new Xe({
                    data: "nested",
                    defaults: k || {}
                })).kill(),
                l.parent = l._dp = r(u),
                l._start = 0,
                T)
                    Dt(l.vars.defaults, {
                        ease: "none"
                    }),
                    T.forEach((function(t) {
                        return l.to(P, t, ">")
                    }
                    ));
                else {
                    if (h = P.length,
                    g = w ? ue(w) : ft,
                    U(w))
                        for (d in w)
                            ~Ge.indexOf(d) && (v || (v = {}),
                            v[d] = w[d]);
                    for (c = 0; c < h; c++) {
                        for (d in f = {},
                        n)
                            Ke.indexOf(d) < 0 && (f[d] = n[d]);
                        f.stagger = 0,
                        E && (f.yoyoEase = E),
                        v && Lt(f, v),
                        p = P[c],
                        f.duration = +Ve(y, r(u), c, p, P),
                        f.delay = (+Ve(x, r(u), c, p, P) || 0) - u._delay,
                        !w && 1 === h && f.delay && (u._delay = x = f.delay,
                        u._start += x,
                        f.delay = 0),
                        l.to(p, f, g(c, p, P))
                    }
                    l.duration() ? y = x = 0 : u.timeline = 0
                }
                y || u.duration(y = l.duration())
            } else
                u.timeline = 0;
            return !0 !== _ || o || (ze = r(u),
            s.killTweensOf(P),
            ze = 0),
            S && Ut(S, r(u)),
            (b || !y && !T && u._start === kt(S._time) && $(b) && function t(e) {
                return !e || e._ts && t(e.parent)
            }(r(u)) && "nested" !== S.data) && (u._tTime = -1e-8,
            u.render(Math.max(0, -x))),
            C && Vt(r(u), C),
            u
        }
        i(e, t);
        var n = e.prototype;
        return n.render = function(t, e, n) {
            var r, i, o, s, a, u, l, c, f, h = this._time, d = this._tDur, p = this._dur, g = t > d - 1e-8 && t >= 0 ? d : t < 1e-8 ? 0 : t;
            if (p) {
                if (g !== this._tTime || !t || n || !this._initted && this._tTime || this._startAt && this._zTime < 0 != t < 0) {
                    if (r = g,
                    c = this.timeline,
                    this._repeat) {
                        if (s = p + this._rDelay,
                        this._repeat < -1 && t < 0)
                            return this.totalTime(100 * s + t, e, n);
                        if (r = kt(g % s),
                        g === d ? (o = this._repeat,
                        r = p) : ((o = ~~(g / s)) && o === g / s && (r = p,
                        o--),
                        r > p && (r = p)),
                        (u = this._yoyo && 1 & o) && (f = this._yEase,
                        r = p - r),
                        a = Xt(this._tTime, s),
                        r === h && !n && this._initted)
                            return this;
                        o !== a && (c && this._yEase && qe(c, u),
                        !this.vars.repeatRefresh || u || this._lock || (this._lock = n = 1,
                        this.render(kt(s * o), !0).invalidate()._lock = 0))
                    }
                    if (!this._initted) {
                        if (Gt(this, t < 0 ? t : r, n, e))
                            return this._tTime = 0,
                            this;
                        if (p !== this._dur)
                            return this.render(t, e, n)
                    }
                    for (this._tTime = g,
                    this._time = r,
                    !this._act && this._ts && (this._act = 1,
                    this._lazy = 0),
                    this.ratio = l = (f || this._ease)(r / p),
                    this._from && (this.ratio = l = 1 - l),
                    r && !h && !e && ve(this, "onStart"),
                    i = this._pt; i; )
                        i.r(l, i.d),
                        i = i._next;
                    c && c.render(t < 0 ? t : !r && u ? -1e-8 : c._dur * l, e, n) || this._startAt && (this._zTime = t),
                    this._onUpdate && !e && (t < 0 && this._startAt && this._startAt.render(t, !0, n),
                    ve(this, "onUpdate")),
                    this._repeat && o !== a && this.vars.onRepeat && !e && this.parent && ve(this, "onRepeat"),
                    g !== this._tDur && g || this._tTime !== g || (t < 0 && this._startAt && !this._onUpdate && this._startAt.render(t, !0, !0),
                    (t || !p) && (g === this._tDur && this._ts > 0 || !g && this._ts < 0) && It(this, 1),
                    e || t < 0 && !h || !g && !h || (ve(this, g === d ? "onComplete" : "onReverseComplete", !0),
                    this._prom && !(g < d && this.timeScale() > 0) && this._prom()))
                }
            } else
                !function(t, e, n, r) {
                    var i, o, s, a = t.ratio, u = e < 0 || !e && (!t._start && function t(e) {
                        var n = e.parent;
                        return n && n._ts && n._initted && !n._lock && (n.rawTime() < 0 || t(n))
                    }(t) || (t._ts < 0 || t._dp._ts < 0) && "isFromStart" !== t.data && "isStart" !== t.data) ? 0 : 1, l = t._rDelay, c = 0;
                    if (l && t._repeat && (c = ee(0, t._tDur, e),
                    o = Xt(c, l),
                    s = Xt(t._tTime, l),
                    t._yoyo && 1 & o && (u = 1 - u),
                    o !== s && (a = 1 - u,
                    t.vars.repeatRefresh && t._initted && t.invalidate())),
                    u !== a || r || 1e-8 === t._zTime || !e && t._zTime) {
                        if (!t._initted && Gt(t, e, r, n))
                            return;
                        for (s = t._zTime,
                        t._zTime = e || (n ? 1e-8 : 0),
                        n || (n = e && !s),
                        t.ratio = u,
                        t._from && (u = 1 - u),
                        t._time = 0,
                        t._tTime = c,
                        n || ve(t, "onStart"),
                        i = t._pt; i; )
                            i.r(u, i.d),
                            i = i._next;
                        t._startAt && e < 0 && t._startAt.render(e, !0, !0),
                        t._onUpdate && !n && ve(t, "onUpdate"),
                        c && t._repeat && !n && t.parent && ve(t, "onRepeat"),
                        (e >= t._tDur || e < 0) && t.ratio === u && (u && It(t, 1),
                        n || (ve(t, u ? "onComplete" : "onReverseComplete", !0),
                        t._prom && t._prom()))
                    } else
                        t._zTime || (t._zTime = e)
                }(this, t, e, n);
            return this
        }
        ,
        n.targets = function() {
            return this._targets
        }
        ,
        n.invalidate = function() {
            return this._pt = this._op = this._startAt = this._onUpdate = this._lazy = this.ratio = 0,
            this._ptLookup = [],
            this.timeline && this.timeline.invalidate(),
            t.prototype.invalidate.call(this)
        }
        ,
        n.kill = function(t, e) {
            if (void 0 === e && (e = "all"),
            !(t || e && "all" !== e))
                return this._lazy = this._pt = 0,
                this.parent ? me(this) : this;
            if (this.timeline) {
                var n = this.timeline.totalDuration();
                return this.timeline.killTweensOf(t, e, ze && !0 !== ze.vars.overwrite)._first || me(this),
                this.parent && n !== this.timeline.totalDuration() && Kt(this, this._dur * this.timeline._tDur / n, 0, 1),
                this
            }
            var r, i, o, s, a, u, l, c = this._targets, f = t ? se(t) : c, h = this._ptLookup, d = this._pt;
            if ((!e || "all" === e) && function(t, e) {
                for (var n = t.length, r = n === e.length; r && n-- && t[n] === e[n]; )
                    ;
                return n < 0
            }(c, f))
                return "all" === e && (this._pt = 0),
                me(this);
            for (r = this._op = this._op || [],
            "all" !== e && (X(e) && (a = {},
            Tt(e, (function(t) {
                return a[t] = 1
            }
            )),
            e = a),
            e = function(t, e) {
                var n, r, i, o, s = t[0] ? wt(t[0]).harness : 0, a = s && s.aliases;
                if (!a)
                    return e;
                for (r in n = Lt({}, e),
                a)
                    if (r in n)
                        for (i = (o = a[r].split(",")).length; i--; )
                            n[o[i]] = n[r];
                return n
            }(c, e)),
            l = c.length; l--; )
                if (~f.indexOf(c[l]))
                    for (a in i = h[l],
                    "all" === e ? (r[l] = e,
                    s = i,
                    o = {}) : (o = r[l] = r[l] || {},
                    s = e),
                    s)
                        (u = i && i[a]) && ("kill"in u.d && !0 !== u.d.kill(a) || Rt(this, u, "_pt"),
                        delete i[a]),
                        "all" !== o && (o[a] = 1);
            return this._initted && !this._pt && d && me(this),
            this
        }
        ,
        e.to = function(t, n) {
            return new e(t,n,arguments[2])
        }
        ,
        e.from = function(t, n) {
            return new e(t,Et(arguments, 1))
        }
        ,
        e.delayedCall = function(t, n, r, i) {
            return new e(n,0,{
                immediateRender: !1,
                lazy: !1,
                overwrite: !1,
                delay: t,
                onComplete: n,
                onReverseComplete: n,
                onCompleteParams: r,
                onReverseCompleteParams: r,
                callbackScope: i
            })
        }
        ,
        e.fromTo = function(t, n, r) {
            return new e(t,Et(arguments, 2))
        }
        ,
        e.set = function(t, n) {
            return n.duration = 0,
            n.repeatDelay || (n.repeat = 0),
            new e(t,n)
        }
        ,
        e.killTweensOf = function(t, e, n) {
            return s.killTweensOf(t, e, n)
        }
        ,
        e
    }(He);
    Dt(Qe.prototype, {
        _targets: [],
        _lazy: 0,
        _startAt: 0,
        _op: 0,
        _onInit: 0
    }),
    Tt("staggerTo,staggerFrom,staggerFromTo", (function(t) {
        Qe[t] = function() {
            var e = new Xe
              , n = re.call(arguments, 0);
            return n.splice("staggerFromTo" === t ? 5 : 4, 0, 0),
            e[t].apply(e, n)
        }
    }
    ));
    var Je = function(t, e, n) {
        return t[e] = n
    }
      , Ze = function(t, e, n) {
        return t[e](n)
    }
      , tn = function(t, e, n, r) {
        return t[e](r.fp, n)
    }
      , en = function(t, e, n) {
        return t.setAttribute(e, n)
    }
      , nn = function(t, e) {
        return z(t[e]) ? Ze : W(t[e]) && t.setAttribute ? en : Je
    }
      , rn = function(t, e) {
        return e.set(e.t, e.p, Math.round(1e4 * (e.s + e.c * t)) / 1e4, e)
    }
      , on = function(t, e) {
        return e.set(e.t, e.p, !!(e.s + e.c * t), e)
    }
      , sn = function(t, e) {
        var n = e._pt
          , r = "";
        if (!t && e.b)
            r = e.b;
        else if (1 === t && e.e)
            r = e.e;
        else {
            for (; n; )
                r = n.p + (n.m ? n.m(n.s + n.c * t) : Math.round(1e4 * (n.s + n.c * t)) / 1e4) + r,
                n = n._next;
            r += e.c
        }
        e.set(e.t, e.p, r, e)
    }
      , an = function(t, e) {
        for (var n = e._pt; n; )
            n.r(t, n.d),
            n = n._next
    }
      , un = function(t, e, n, r) {
        for (var i, o = this._pt; o; )
            i = o._next,
            o.p === r && o.modifier(t, e, n),
            o = i
    }
      , ln = function(t) {
        for (var e, n, r = this._pt; r; )
            n = r._next,
            r.p === t && !r.op || r.op === t ? Rt(this, r, "_pt") : r.dep || (e = 1),
            r = n;
        return !e
    }
      , cn = function(t, e, n, r) {
        r.mSet(t, e, r.m.call(r.tween, n, r.mt), r)
    }
      , fn = function(t) {
        for (var e, n, r, i, o = t._pt; o; ) {
            for (e = o._next,
            n = r; n && n.pr > o.pr; )
                n = n._next;
            (o._prev = n ? n._prev : i) ? o._prev._next = o : r = o,
            (o._next = n) ? n._prev = o : i = o,
            o = e
        }
        t._pt = r
    }
      , hn = function() {
        function t(t, e, n, r, i, o, s, a, u) {
            this.t = e,
            this.s = r,
            this.c = i,
            this.p = n,
            this.r = o || rn,
            this.d = s || this,
            this.set = a || Je,
            this.pr = u || 0,
            this._next = t,
            t && (t._prev = this)
        }
        return t.prototype.modifier = function(t, e, n) {
            this.mSet = this.mSet || this.set,
            this.set = cn,
            this.m = t,
            this.mt = n,
            this.tween = e
        }
        ,
        t
    }();
    Tt(xt + "parent,duration,ease,delay,overwrite,runBackwards,startAt,yoyo,immediateRender,repeat,repeatDelay,data,paused,reversed,lazy,callbackScope,stringFilter,id,yoyoEase,stagger,inherit,repeatRefresh,keyframes,autoRevert,scrollTrigger", (function(t) {
        return ht[t] = 1
    }
    )),
    ot.TweenMax = ot.TweenLite = Qe,
    ot.TimelineLite = ot.TimelineMax = Xe,
    s = new Xe({
        sortChildren: !1,
        defaults: q,
        autoRemoveChildren: !0,
        id: "root",
        smoothChildTiming: !0
    }),
    L.stringFilter = Ee;
    var dn = {
        registerPlugin: function() {
            for (var t = arguments.length, e = new Array(t), n = 0; n < t; n++)
                e[n] = arguments[n];
            e.forEach((function(t) {
                return ye(t)
            }
            ))
        },
        timeline: function(t) {
            return new Xe(t)
        },
        getTweensOf: function(t, e) {
            return s.getTweensOf(t, e)
        },
        getProperty: function(t, e, n, r) {
            X(t) && (t = se(t)[0]);
            var i = wt(t || {}).get
              , o = n ? Ot : At;
            return "native" === n && (n = ""),
            t ? e ? o((gt[e] && gt[e].get || i)(t, e, n, r)) : function(e, n, r) {
                return o((gt[e] && gt[e].get || i)(t, e, n, r))
            }
            : t
        },
        quickSetter: function(t, e, n) {
            if ((t = se(t)).length > 1) {
                var r = t.map((function(t) {
                    return vn.quickSetter(t, e, n)
                }
                ))
                  , i = r.length;
                return function(t) {
                    for (var e = i; e--; )
                        r[e](t)
                }
            }
            t = t[0] || {};
            var o = gt[e]
              , s = wt(t)
              , a = s.harness && (s.harness.aliases || {})[e] || e
              , u = o ? function(e) {
                var r = new o;
                h._pt = 0,
                r.init(t, n ? e + n : e, h, 0, [t]),
                r.render(1, r),
                h._pt && an(1, h)
            }
            : s.set(t, a);
            return o ? u : function(e) {
                return u(t, a, n ? e + n : e, s, 1)
            }
        },
        isTweening: function(t) {
            return s.getTweensOf(t, !0).length > 0
        },
        defaults: function(t) {
            return t && t.ease && (t.ease = Ne(t.ease, q.ease)),
            qt(q, t || {})
        },
        config: function(t) {
            return qt(L, t || {})
        },
        registerEffect: function(t) {
            var e = t.name
              , n = t.effect
              , r = t.plugins
              , i = t.defaults
              , o = t.extendTimeline;
            (r || "").split(",").forEach((function(t) {
                return t && !gt[t] && !ot[t] && lt(e + " effect requires " + t + " plugin.")
            }
            )),
            vt[e] = function(t, e, r) {
                return n(se(t), Dt(e || {}, i), r)
            }
            ,
            o && (Xe.prototype[e] = function(t, n, r) {
                return this.add(vt[e](t, U(n) ? n : (r = n) && {}, this), r)
            }
            )
        },
        registerEase: function(t, e) {
            Ae[t] = Ne(e)
        },
        parseEase: function(t, e) {
            return arguments.length ? Ne(t, e) : Ae
        },
        getById: function(t) {
            return s.getById(t)
        },
        exportRoot: function(t, e) {
            void 0 === t && (t = {});
            var n, r, i = new Xe(t);
            for (i.smoothChildTiming = $(t.smoothChildTiming),
            s.remove(i),
            i._dp = 0,
            i._time = i._tTime = s._time,
            n = s._first; n; )
                r = n._next,
                !e && !n._dur && n instanceof Qe && n.vars.onComplete === n._targets[0] || $t(i, n, n._start - n._delay),
                n = r;
            return $t(s, i, 0),
            i
        },
        utils: {
            wrap: function t(e, n, r) {
                var i = n - e;
                return Q(e) ? he(e, t(0, e.length), n) : te(r, (function(t) {
                    return (i + (t - e) % i) % i + e
                }
                ))
            },
            wrapYoyo: function t(e, n, r) {
                var i = n - e
                  , o = 2 * i;
                return Q(e) ? he(e, t(0, e.length - 1), n) : te(r, (function(t) {
                    return e + ((t = (o + (t - e) % o) % o || 0) > i ? o - t : t)
                }
                ))
            },
            distribute: ue,
            random: fe,
            snap: ce,
            normalize: function(t, e, n) {
                return pe(t, e, 0, 1, n)
            },
            getUnit: ne,
            clamp: function(t, e, n) {
                return te(n, (function(n) {
                    return ee(t, e, n)
                }
                ))
            },
            splitColor: we,
            toArray: se,
            mapRange: pe,
            pipe: function() {
                for (var t = arguments.length, e = new Array(t), n = 0; n < t; n++)
                    e[n] = arguments[n];
                return function(t) {
                    return e.reduce((function(t, e) {
                        return e(t)
                    }
                    ), t)
                }
            },
            unitize: function(t, e) {
                return function(n) {
                    return t(parseFloat(n)) + (e || ne(n))
                }
            },
            interpolate: function t(e, n, r, i) {
                var o = isNaN(e + n) ? 0 : function(t) {
                    return (1 - t) * e + t * n
                }
                ;
                if (!o) {
                    var s, a, u, l, c, f = X(e), h = {};
                    if (!0 === r && (i = 1) && (r = null),
                    f)
                        e = {
                            p: e
                        },
                        n = {
                            p: n
                        };
                    else if (Q(e) && !Q(n)) {
                        for (u = [],
                        l = e.length,
                        c = l - 2,
                        a = 1; a < l; a++)
                            u.push(t(e[a - 1], e[a]));
                        l--,
                        o = function(t) {
                            t *= l;
                            var e = Math.min(c, ~~t);
                            return u[e](t - e)
                        }
                        ,
                        r = n
                    } else
                        i || (e = Lt(Q(e) ? [] : {}, e));
                    if (!u) {
                        for (s in n)
                            We.call(h, e, s, "get", n[s]);
                        o = function(t) {
                            return an(t, h) || (f ? e.p : e)
                        }
                    }
                }
                return te(r, o)
            },
            shuffle: ae
        },
        install: at,
        effects: vt,
        ticker: Se,
        updateRoot: Xe.updateRoot,
        plugins: gt,
        globalTimeline: s,
        core: {
            PropTween: hn,
            globals: ct,
            Tween: Qe,
            Timeline: Xe,
            Animation: He,
            getCache: wt,
            _removeLinkedListItem: Rt,
            suppressOverwrites: function(t) {
                return o = t
            }
        }
    };
    Tt("to,from,fromTo,delayedCall,set,killTweensOf", (function(t) {
        return dn[t] = Qe[t]
    }
    )),
    Se.add(Xe.updateRoot),
    h = dn.to({}, {
        duration: 0
    });
    var pn = function(t, e) {
        for (var n = t._pt; n && n.p !== e && n.op !== e && n.fp !== e; )
            n = n._next;
        return n
    }
      , gn = function(t, e) {
        return {
            name: t,
            rawVars: 1,
            init: function(t, n, r) {
                r._onInit = function(t) {
                    var r, i;
                    if (X(n) && (r = {},
                    Tt(n, (function(t) {
                        return r[t] = 1
                    }
                    )),
                    n = r),
                    e) {
                        for (i in r = {},
                        n)
                            r[i] = e(n[i]);
                        n = r
                    }
                    !function(t, e) {
                        var n, r, i, o = t._targets;
                        for (n in e)
                            for (r = o.length; r--; )
                                (i = t._ptLookup[r][n]) && (i = i.d) && (i._pt && (i = pn(i, n)),
                                i && i.modifier && i.modifier(e[n], t, o[r], n))
                    }(t, n)
                }
            }
        }
    }
      , vn = dn.registerPlugin({
        name: "attr",
        init: function(t, e, n, r, i) {
            var o, s;
            for (o in e)
                (s = this.add(t, "setAttribute", (t.getAttribute(o) || 0) + "", e[o], r, i, 0, 0, o)) && (s.op = o),
                this._props.push(o)
        }
    }, {
        name: "endArray",
        init: function(t, e) {
            for (var n = e.length; n--; )
                this.add(t, n, t[n] || 0, e[n])
        }
    }, gn("roundProps", le), gn("modifiers"), gn("snap", ce)) || dn;
    Qe.version = Xe.version = vn.version = "3.6.0",
    c = 1,
    V() && Pe();
    Ae.Power0,
    Ae.Power1,
    Ae.Power2,
    Ae.Power3,
    Ae.Power4,
    Ae.Linear,
    Ae.Quad,
    Ae.Cubic,
    Ae.Quart,
    Ae.Quint,
    Ae.Strong,
    Ae.Elastic,
    Ae.Back,
    Ae.SteppedEase,
    Ae.Bounce,
    Ae.Sine,
    Ae.Expo,
    Ae.Circ;
    var mn, yn, xn, bn, wn, _n, Tn, kn, Cn = {}, En = 180 / Math.PI, Sn = Math.PI / 180, Pn = Math.atan2, An = /([A-Z])/g, On = /(?:left|right|width|margin|padding|x)/i, Dn = /[\s,\(]\S/, Mn = {
        autoAlpha: "opacity,visibility",
        scale: "scaleX,scaleY",
        alpha: "opacity"
    }, Ln = function(t, e) {
        return e.set(e.t, e.p, Math.round(1e4 * (e.s + e.c * t)) / 1e4 + e.u, e)
    }, qn = function(t, e) {
        return e.set(e.t, e.p, 1 === t ? e.e : Math.round(1e4 * (e.s + e.c * t)) / 1e4 + e.u, e)
    }, Nn = function(t, e) {
        return e.set(e.t, e.p, t ? Math.round(1e4 * (e.s + e.c * t)) / 1e4 + e.u : e.b, e)
    }, jn = function(t, e) {
        var n = e.s + e.c * t;
        e.set(e.t, e.p, ~~(n + (n < 0 ? -.5 : .5)) + e.u, e)
    }, Rn = function(t, e) {
        return e.set(e.t, e.p, t ? e.e : e.b, e)
    }, In = function(t, e) {
        return e.set(e.t, e.p, 1 !== t ? e.b : e.e, e)
    }, Fn = function(t, e, n) {
        return t.style[e] = n
    }, Bn = function(t, e, n) {
        return t.style.setProperty(e, n)
    }, Hn = function(t, e, n) {
        return t._gsap[e] = n
    }, Xn = function(t, e, n) {
        return t._gsap.scaleX = t._gsap.scaleY = n
    }, zn = function(t, e, n, r, i) {
        var o = t._gsap;
        o.scaleX = o.scaleY = n,
        o.renderTransform(i, o)
    }, Yn = function(t, e, n, r, i) {
        var o = t._gsap;
        o[e] = n,
        o.renderTransform(i, o)
    }, Wn = "transform", Un = Wn + "Origin", $n = function(t, e) {
        var n = yn.createElementNS ? yn.createElementNS((e || "http://www.w3.org/1999/xhtml").replace(/^https/, "http"), t) : yn.createElement(t);
        return n.style ? n : yn.createElement(t)
    }, Vn = function t(e, n, r) {
        var i = getComputedStyle(e);
        return i[n] || i.getPropertyValue(n.replace(An, "-$1").toLowerCase()) || i.getPropertyValue(n) || !r && t(e, Kn(n) || n, 1) || ""
    }, Gn = "O,Moz,ms,Ms,Webkit".split(","), Kn = function(t, e, n) {
        var r = (e || wn).style
          , i = 5;
        if (t in r && !n)
            return t;
        for (t = t.charAt(0).toUpperCase() + t.substr(1); i-- && !(Gn[i] + t in r); )
            ;
        return i < 0 ? null : (3 === i ? "ms" : i >= 0 ? Gn[i] : "") + t
    }, Qn = function() {
        "undefined" != typeof window && window.document && (mn = window,
        yn = mn.document,
        xn = yn.documentElement,
        wn = $n("div") || {
            style: {}
        },
        _n = $n("div"),
        Wn = Kn(Wn),
        Un = Wn + "Origin",
        wn.style.cssText = "border-width:0;line-height:0;position:absolute;padding:0",
        kn = !!Kn("perspective"),
        bn = 1)
    }, Jn = function t(e) {
        var n, r = $n("svg", this.ownerSVGElement && this.ownerSVGElement.getAttribute("xmlns") || "http://www.w3.org/2000/svg"), i = this.parentNode, o = this.nextSibling, s = this.style.cssText;
        if (xn.appendChild(r),
        r.appendChild(this),
        this.style.display = "block",
        e)
            try {
                n = this.getBBox(),
                this._gsapBBox = this.getBBox,
                this.getBBox = t
            } catch (t) {}
        else
            this._gsapBBox && (n = this._gsapBBox());
        return i && (o ? i.insertBefore(this, o) : i.appendChild(this)),
        xn.removeChild(r),
        this.style.cssText = s,
        n
    }, Zn = function(t, e) {
        for (var n = e.length; n--; )
            if (t.hasAttribute(e[n]))
                return t.getAttribute(e[n])
    }, tr = function(t) {
        var e;
        try {
            e = t.getBBox()
        } catch (n) {
            e = Jn.call(t, !0)
        }
        return e && (e.width || e.height) || t.getBBox === Jn || (e = Jn.call(t, !0)),
        !e || e.width || e.x || e.y ? e : {
            x: +Zn(t, ["x", "cx", "x1"]) || 0,
            y: +Zn(t, ["y", "cy", "y1"]) || 0,
            width: 0,
            height: 0
        }
    }, er = function(t) {
        return !(!t.getCTM || t.parentNode && !t.ownerSVGElement || !tr(t))
    }, nr = function(t, e) {
        if (e) {
            var n = t.style;
            e in Cn && e !== Un && (e = Wn),
            n.removeProperty ? ("ms" !== e.substr(0, 2) && "webkit" !== e.substr(0, 6) || (e = "-" + e),
            n.removeProperty(e.replace(An, "-$1").toLowerCase())) : n.removeAttribute(e)
        }
    }, rr = function(t, e, n, r, i, o) {
        var s = new hn(t._pt,e,n,0,1,o ? In : Rn);
        return t._pt = s,
        s.b = r,
        s.e = i,
        t._props.push(n),
        s
    }, ir = {
        deg: 1,
        rad: 1,
        turn: 1
    }, or = function t(e, n, r, i) {
        var o, s, a, u, l = parseFloat(r) || 0, c = (r + "").trim().substr((l + "").length) || "px", f = wn.style, h = On.test(n), d = "svg" === e.tagName.toLowerCase(), p = (d ? "client" : "offset") + (h ? "Width" : "Height"), g = "px" === i, v = "%" === i;
        return i === c || !l || ir[i] || ir[c] ? l : ("px" !== c && !g && (l = t(e, n, r, "px")),
        u = e.getCTM && er(e),
        !v && "%" !== c || !Cn[n] && !~n.indexOf("adius") ? (f[h ? "width" : "height"] = 100 + (g ? c : i),
        s = ~n.indexOf("adius") || "em" === i && e.appendChild && !d ? e : e.parentNode,
        u && (s = (e.ownerSVGElement || {}).parentNode),
        s && s !== yn && s.appendChild || (s = yn.body),
        (a = s._gsap) && v && a.width && h && a.time === Se.time ? kt(l / a.width * 100) : ((v || "%" === c) && (f.position = Vn(e, "position")),
        s === e && (f.position = "static"),
        s.appendChild(wn),
        o = wn[p],
        s.removeChild(wn),
        f.position = "absolute",
        h && v && ((a = wt(s)).time = Se.time,
        a.width = s[p]),
        kt(g ? o * l / 100 : o && l ? 100 / o * l : 0))) : (o = u ? e.getBBox()[h ? "width" : "height"] : e[p],
        kt(v ? l / o * 100 : l / 100 * o)))
    }, sr = function(t, e, n, r) {
        var i;
        return bn || Qn(),
        e in Mn && "transform" !== e && ~(e = Mn[e]).indexOf(",") && (e = e.split(",")[0]),
        Cn[e] && "transform" !== e ? (i = mr(t, r),
        i = "transformOrigin" !== e ? i[e] : yr(Vn(t, Un)) + " " + i.zOrigin + "px") : (!(i = t.style[e]) || "auto" === i || r || ~(i + "").indexOf("calc(")) && (i = cr[e] && cr[e](t, e, n) || Vn(t, e) || _t(t, e) || ("opacity" === e ? 1 : 0)),
        n && !~(i + "").trim().indexOf(" ") ? or(t, e, i, n) + n : i
    }, ar = function(t, e, n, r) {
        if (!n || "none" === n) {
            var i = Kn(e, t, 1)
              , o = i && Vn(t, i, 1);
            o && o !== n ? (e = i,
            n = o) : "borderColor" === e && (n = Vn(t, "borderTopColor"))
        }
        var s, a, u, l, c, f, h, d, p, g, v, m, y = new hn(this._pt,t.style,e,0,1,sn), x = 0, b = 0;
        if (y.b = n,
        y.e = r,
        n += "",
        "auto" === (r += "") && (t.style[e] = r,
        r = Vn(t, e) || r,
        t.style[e] = n),
        Ee(s = [n, r]),
        r = s[1],
        u = (n = s[0]).match(tt) || [],
        (r.match(tt) || []).length) {
            for (; a = tt.exec(r); )
                h = a[0],
                p = r.substring(x, a.index),
                c ? c = (c + 1) % 5 : "rgba(" !== p.substr(-5) && "hsla(" !== p.substr(-5) || (c = 1),
                h !== (f = u[b++] || "") && (l = parseFloat(f) || 0,
                v = f.substr((l + "").length),
                (m = "=" === h.charAt(1) ? +(h.charAt(0) + "1") : 0) && (h = h.substr(2)),
                d = parseFloat(h),
                g = h.substr((d + "").length),
                x = tt.lastIndex - g.length,
                g || (g = g || L.units[e] || v,
                x === r.length && (r += g,
                y.e += g)),
                v !== g && (l = or(t, e, f, g) || 0),
                y._pt = {
                    _next: y._pt,
                    p: p || 1 === b ? p : ",",
                    s: l,
                    c: m ? m * d : d - l,
                    m: c && c < 4 || "zIndex" === e ? Math.round : 0
                });
            y.c = x < r.length ? r.substring(x, r.length) : ""
        } else
            y.r = "display" === e && "none" === r ? In : Rn;
        return nt.test(r) && (y.e = 0),
        this._pt = y,
        y
    }, ur = {
        top: "0%",
        bottom: "100%",
        left: "0%",
        right: "100%",
        center: "50%"
    }, lr = function(t, e) {
        if (e.tween && e.tween._time === e.tween._dur) {
            var n, r, i, o = e.t, s = o.style, a = e.u, u = o._gsap;
            if ("all" === a || !0 === a)
                s.cssText = "",
                r = 1;
            else
                for (i = (a = a.split(",")).length; --i > -1; )
                    n = a[i],
                    Cn[n] && (r = 1,
                    n = "transformOrigin" === n ? Un : Wn),
                    nr(o, n);
            r && (nr(o, Wn),
            u && (u.svg && o.removeAttribute("transform"),
            mr(o, 1),
            u.uncache = 1))
        }
    }, cr = {
        clearProps: function(t, e, n, r, i) {
            if ("isFromStart" !== i.data) {
                var o = t._pt = new hn(t._pt,e,n,0,0,lr);
                return o.u = r,
                o.pr = -10,
                o.tween = i,
                t._props.push(n),
                1
            }
        }
    }, fr = [1, 0, 0, 1, 0, 0], hr = {}, dr = function(t) {
        return "matrix(1, 0, 0, 1, 0, 0)" === t || "none" === t || !t
    }, pr = function(t) {
        var e = Vn(t, Wn);
        return dr(e) ? fr : e.substr(7).match(Z).map(kt)
    }, gr = function(t, e) {
        var n, r, i, o, s = t._gsap || wt(t), a = t.style, u = pr(t);
        return s.svg && t.getAttribute("transform") ? "1,0,0,1,0,0" === (u = [(i = t.transform.baseVal.consolidate().matrix).a, i.b, i.c, i.d, i.e, i.f]).join(",") ? fr : u : (u !== fr || t.offsetParent || t === xn || s.svg || (i = a.display,
        a.display = "block",
        (n = t.parentNode) && t.offsetParent || (o = 1,
        r = t.nextSibling,
        xn.appendChild(t)),
        u = pr(t),
        i ? a.display = i : nr(t, "display"),
        o && (r ? n.insertBefore(t, r) : n ? n.appendChild(t) : xn.removeChild(t))),
        e && u.length > 6 ? [u[0], u[1], u[4], u[5], u[12], u[13]] : u)
    }, vr = function(t, e, n, r, i, o) {
        var s, a, u, l = t._gsap, c = i || gr(t, !0), f = l.xOrigin || 0, h = l.yOrigin || 0, d = l.xOffset || 0, p = l.yOffset || 0, g = c[0], v = c[1], m = c[2], y = c[3], x = c[4], b = c[5], w = e.split(" "), _ = parseFloat(w[0]) || 0, T = parseFloat(w[1]) || 0;
        n ? c !== fr && (a = g * y - v * m) && (u = _ * (-v / a) + T * (g / a) - (g * b - v * x) / a,
        _ = _ * (y / a) + T * (-m / a) + (m * b - y * x) / a,
        T = u) : (_ = (s = tr(t)).x + (~w[0].indexOf("%") ? _ / 100 * s.width : _),
        T = s.y + (~(w[1] || w[0]).indexOf("%") ? T / 100 * s.height : T)),
        r || !1 !== r && l.smooth ? (x = _ - f,
        b = T - h,
        l.xOffset = d + (x * g + b * m) - x,
        l.yOffset = p + (x * v + b * y) - b) : l.xOffset = l.yOffset = 0,
        l.xOrigin = _,
        l.yOrigin = T,
        l.smooth = !!r,
        l.origin = e,
        l.originIsAbsolute = !!n,
        t.style[Un] = "0px 0px",
        o && (rr(o, l, "xOrigin", f, _),
        rr(o, l, "yOrigin", h, T),
        rr(o, l, "xOffset", d, l.xOffset),
        rr(o, l, "yOffset", p, l.yOffset)),
        t.setAttribute("data-svg-origin", _ + " " + T)
    }, mr = function(t, e) {
        var n = t._gsap || new Be(t);
        if ("x"in n && !e && !n.uncache)
            return n;
        var r, i, o, s, a, u, l, c, f, h, d, p, g, v, m, y, x, b, w, _, T, k, C, E, S, P, A, O, D, M, q, N, j = t.style, R = n.scaleX < 0, I = Vn(t, Un) || "0";
        return r = i = o = u = l = c = f = h = d = 0,
        s = a = 1,
        n.svg = !(!t.getCTM || !er(t)),
        v = gr(t, n.svg),
        n.svg && (E = !n.uncache && t.getAttribute("data-svg-origin"),
        vr(t, E || I, !!E || n.originIsAbsolute, !1 !== n.smooth, v)),
        p = n.xOrigin || 0,
        g = n.yOrigin || 0,
        v !== fr && (b = v[0],
        w = v[1],
        _ = v[2],
        T = v[3],
        r = k = v[4],
        i = C = v[5],
        6 === v.length ? (s = Math.sqrt(b * b + w * w),
        a = Math.sqrt(T * T + _ * _),
        u = b || w ? Pn(w, b) * En : 0,
        (f = _ || T ? Pn(_, T) * En + u : 0) && (a *= Math.cos(f * Sn)),
        n.svg && (r -= p - (p * b + g * _),
        i -= g - (p * w + g * T))) : (N = v[6],
        M = v[7],
        A = v[8],
        O = v[9],
        D = v[10],
        q = v[11],
        r = v[12],
        i = v[13],
        o = v[14],
        l = (m = Pn(N, D)) * En,
        m && (E = k * (y = Math.cos(-m)) + A * (x = Math.sin(-m)),
        S = C * y + O * x,
        P = N * y + D * x,
        A = k * -x + A * y,
        O = C * -x + O * y,
        D = N * -x + D * y,
        q = M * -x + q * y,
        k = E,
        C = S,
        N = P),
        c = (m = Pn(-_, D)) * En,
        m && (y = Math.cos(-m),
        q = T * (x = Math.sin(-m)) + q * y,
        b = E = b * y - A * x,
        w = S = w * y - O * x,
        _ = P = _ * y - D * x),
        u = (m = Pn(w, b)) * En,
        m && (E = b * (y = Math.cos(m)) + w * (x = Math.sin(m)),
        S = k * y + C * x,
        w = w * y - b * x,
        C = C * y - k * x,
        b = E,
        k = S),
        l && Math.abs(l) + Math.abs(u) > 359.9 && (l = u = 0,
        c = 180 - c),
        s = kt(Math.sqrt(b * b + w * w + _ * _)),
        a = kt(Math.sqrt(C * C + N * N)),
        m = Pn(k, C),
        f = Math.abs(m) > 2e-4 ? m * En : 0,
        d = q ? 1 / (q < 0 ? -q : q) : 0),
        n.svg && (E = t.getAttribute("transform"),
        n.forceCSS = t.setAttribute("transform", "") || !dr(Vn(t, Wn)),
        E && t.setAttribute("transform", E))),
        Math.abs(f) > 90 && Math.abs(f) < 270 && (R ? (s *= -1,
        f += u <= 0 ? 180 : -180,
        u += u <= 0 ? 180 : -180) : (a *= -1,
        f += f <= 0 ? 180 : -180)),
        n.x = r - ((n.xPercent = r && (n.xPercent || (Math.round(t.offsetWidth / 2) === Math.round(-r) ? -50 : 0))) ? t.offsetWidth * n.xPercent / 100 : 0) + "px",
        n.y = i - ((n.yPercent = i && (n.yPercent || (Math.round(t.offsetHeight / 2) === Math.round(-i) ? -50 : 0))) ? t.offsetHeight * n.yPercent / 100 : 0) + "px",
        n.z = o + "px",
        n.scaleX = kt(s),
        n.scaleY = kt(a),
        n.rotation = kt(u) + "deg",
        n.rotationX = kt(l) + "deg",
        n.rotationY = kt(c) + "deg",
        n.skewX = f + "deg",
        n.skewY = h + "deg",
        n.transformPerspective = d + "px",
        (n.zOrigin = parseFloat(I.split(" ")[2]) || 0) && (j[Un] = yr(I)),
        n.xOffset = n.yOffset = 0,
        n.force3D = L.force3D,
        n.renderTransform = n.svg ? _r : kn ? wr : br,
        n.uncache = 0,
        n
    }, yr = function(t) {
        return (t = t.split(" "))[0] + " " + t[1]
    }, xr = function(t, e, n) {
        var r = ne(e);
        return kt(parseFloat(e) + parseFloat(or(t, "x", n + "px", r))) + r
    }, br = function(t, e) {
        e.z = "0px",
        e.rotationY = e.rotationX = "0deg",
        e.force3D = 0,
        wr(t, e)
    }, wr = function(t, e) {
        var n = e || this
          , r = n.xPercent
          , i = n.yPercent
          , o = n.x
          , s = n.y
          , a = n.z
          , u = n.rotation
          , l = n.rotationY
          , c = n.rotationX
          , f = n.skewX
          , h = n.skewY
          , d = n.scaleX
          , p = n.scaleY
          , g = n.transformPerspective
          , v = n.force3D
          , m = n.target
          , y = n.zOrigin
          , x = ""
          , b = "auto" === v && t && 1 !== t || !0 === v;
        if (y && ("0deg" !== c || "0deg" !== l)) {
            var w, _ = parseFloat(l) * Sn, T = Math.sin(_), k = Math.cos(_);
            _ = parseFloat(c) * Sn,
            w = Math.cos(_),
            o = xr(m, o, T * w * -y),
            s = xr(m, s, -Math.sin(_) * -y),
            a = xr(m, a, k * w * -y + y)
        }
        "0px" !== g && (x += "perspective(" + g + ") "),
        (r || i) && (x += "translate(" + r + "%, " + i + "%) "),
        (b || "0px" !== o || "0px" !== s || "0px" !== a) && (x += "0px" !== a || b ? "translate3d(" + o + ", " + s + ", " + a + ") " : "translate(" + o + ", " + s + ") "),
        "0deg" !== u && (x += "rotate(" + u + ") "),
        "0deg" !== l && (x += "rotateY(" + l + ") "),
        "0deg" !== c && (x += "rotateX(" + c + ") "),
        "0deg" === f && "0deg" === h || (x += "skew(" + f + ", " + h + ") "),
        1 === d && 1 === p || (x += "scale(" + d + ", " + p + ") "),
        m.style[Wn] = x || "translate(0, 0)"
    }, _r = function(t, e) {
        var n, r, i, o, s, a = e || this, u = a.xPercent, l = a.yPercent, c = a.x, f = a.y, h = a.rotation, d = a.skewX, p = a.skewY, g = a.scaleX, v = a.scaleY, m = a.target, y = a.xOrigin, x = a.yOrigin, b = a.xOffset, w = a.yOffset, _ = a.forceCSS, T = parseFloat(c), k = parseFloat(f);
        h = parseFloat(h),
        d = parseFloat(d),
        (p = parseFloat(p)) && (d += p = parseFloat(p),
        h += p),
        h || d ? (h *= Sn,
        d *= Sn,
        n = Math.cos(h) * g,
        r = Math.sin(h) * g,
        i = Math.sin(h - d) * -v,
        o = Math.cos(h - d) * v,
        d && (p *= Sn,
        s = Math.tan(d - p),
        i *= s = Math.sqrt(1 + s * s),
        o *= s,
        p && (s = Math.tan(p),
        n *= s = Math.sqrt(1 + s * s),
        r *= s)),
        n = kt(n),
        r = kt(r),
        i = kt(i),
        o = kt(o)) : (n = g,
        o = v,
        r = i = 0),
        (T && !~(c + "").indexOf("px") || k && !~(f + "").indexOf("px")) && (T = or(m, "x", c, "px"),
        k = or(m, "y", f, "px")),
        (y || x || b || w) && (T = kt(T + y - (y * n + x * i) + b),
        k = kt(k + x - (y * r + x * o) + w)),
        (u || l) && (s = m.getBBox(),
        T = kt(T + u / 100 * s.width),
        k = kt(k + l / 100 * s.height)),
        s = "matrix(" + n + "," + r + "," + i + "," + o + "," + T + "," + k + ")",
        m.setAttribute("transform", s),
        _ && (m.style[Wn] = s)
    }, Tr = function(t, e, n, r, i, o) {
        var s, a, u = X(i), l = parseFloat(i) * (u && ~i.indexOf("rad") ? En : 1), c = o ? l * o : l - r, f = r + c + "deg";
        return u && ("short" === (s = i.split("_")[1]) && (c %= 360) !== c % 180 && (c += c < 0 ? 360 : -360),
        "cw" === s && c < 0 ? c = (c + 36e9) % 360 - 360 * ~~(c / 360) : "ccw" === s && c > 0 && (c = (c - 36e9) % 360 - 360 * ~~(c / 360))),
        t._pt = a = new hn(t._pt,e,n,r,c,qn),
        a.e = f,
        a.u = "deg",
        t._props.push(n),
        a
    }, kr = function(t, e, n) {
        var r, i, o, s, a, u, l, c = _n.style, f = n._gsap;
        for (i in c.cssText = getComputedStyle(n).cssText + ";position:absolute;display:block;",
        c[Wn] = e,
        yn.body.appendChild(_n),
        r = mr(_n, 1),
        Cn)
            (o = f[i]) !== (s = r[i]) && "perspective,force3D,transformOrigin,svgOrigin".indexOf(i) < 0 && (a = ne(o) !== (l = ne(s)) ? or(n, i, o, l) : parseFloat(o),
            u = parseFloat(s),
            t._pt = new hn(t._pt,f,i,a,u - a,Ln),
            t._pt.u = l || 0,
            t._props.push(i));
        yn.body.removeChild(_n)
    };
    Tt("padding,margin,Width,Radius", (function(t, e) {
        var n = "Top"
          , r = "Right"
          , i = "Bottom"
          , o = "Left"
          , s = (e < 3 ? [n, r, i, o] : [n + o, n + r, i + r, i + o]).map((function(n) {
            return e < 2 ? t + n : "border" + n + t
        }
        ));
        cr[e > 1 ? "border" + t : t] = function(t, e, n, r, i) {
            var o, a;
            if (arguments.length < 4)
                return o = s.map((function(e) {
                    return sr(t, e, n)
                }
                )),
                5 === (a = o.join(" ")).split(o[0]).length ? o[0] : a;
            o = (r + "").split(" "),
            a = {},
            s.forEach((function(t, e) {
                return a[t] = o[e] = o[e] || o[(e - 1) / 2 | 0]
            }
            )),
            t.init(e, a, i)
        }
    }
    ));
    var Cr, Er, Sr = {
        name: "css",
        register: Qn,
        targetTest: function(t) {
            return t.style && t.nodeType
        },
        init: function(t, e, n, r, i) {
            var o, s, a, u, l, c, f, h, d, p, g, v, m, y, x, b, w, _, T, k = this._props, C = t.style, E = n.vars.startAt;
            for (f in bn || Qn(),
            e)
                if ("autoRound" !== f && (s = e[f],
                !gt[f] || !Ue(f, e, n, r, t, i)))
                    if (l = typeof s,
                    c = cr[f],
                    "function" === l && (l = typeof (s = s.call(n, r, t, i))),
                    "string" === l && ~s.indexOf("random(") && (s = de(s)),
                    c)
                        c(this, t, f, s, n) && (x = 1);
                    else if ("--" === f.substr(0, 2))
                        o = (getComputedStyle(t).getPropertyValue(f) + "").trim(),
                        s += "",
                        h = ne(o),
                        (d = ne(s)) ? h !== d && (o = or(t, f, o, d) + d) : h && (s += h),
                        this.add(C, "setProperty", o, s, r, i, 0, 0, f);
                    else if ("undefined" !== l) {
                        if (E && f in E ? (o = "function" == typeof E[f] ? E[f].call(n, r, t, i) : E[f],
                        f in L.units && !ne(o) && (o += L.units[f]),
                        "=" === (o + "").charAt(1) && (o = sr(t, f))) : o = sr(t, f),
                        u = parseFloat(o),
                        (p = "string" === l && "=" === s.charAt(1) ? +(s.charAt(0) + "1") : 0) && (s = s.substr(2)),
                        a = parseFloat(s),
                        f in Mn && ("autoAlpha" === f && (1 === u && "hidden" === sr(t, "visibility") && a && (u = 0),
                        rr(this, C, "visibility", u ? "inherit" : "hidden", a ? "inherit" : "hidden", !a)),
                        "scale" !== f && "transform" !== f && ~(f = Mn[f]).indexOf(",") && (f = f.split(",")[0])),
                        g = f in Cn)
                            if (v || ((m = t._gsap).renderTransform && !e.parseTransform || mr(t, e.parseTransform),
                            y = !1 !== e.smoothOrigin && m.smooth,
                            (v = this._pt = new hn(this._pt,C,Wn,0,1,m.renderTransform,m,0,-1)).dep = 1),
                            "scale" === f)
                                this._pt = new hn(this._pt,m,"scaleY",m.scaleY,p ? p * a : a - m.scaleY),
                                k.push("scaleY", f),
                                f += "X";
                            else {
                                if ("transformOrigin" === f) {
                                    w = void 0,
                                    _ = void 0,
                                    T = void 0,
                                    w = (b = s).split(" "),
                                    _ = w[0],
                                    T = w[1] || "50%",
                                    "top" !== _ && "bottom" !== _ && "left" !== T && "right" !== T || (b = _,
                                    _ = T,
                                    T = b),
                                    w[0] = ur[_] || _,
                                    w[1] = ur[T] || T,
                                    s = w.join(" "),
                                    m.svg ? vr(t, s, 0, y, 0, this) : ((d = parseFloat(s.split(" ")[2]) || 0) !== m.zOrigin && rr(this, m, "zOrigin", m.zOrigin, d),
                                    rr(this, C, f, yr(o), yr(s)));
                                    continue
                                }
                                if ("svgOrigin" === f) {
                                    vr(t, s, 1, y, 0, this);
                                    continue
                                }
                                if (f in hr) {
                                    Tr(this, m, f, u, s, p);
                                    continue
                                }
                                if ("smoothOrigin" === f) {
                                    rr(this, m, "smooth", m.smooth, s);
                                    continue
                                }
                                if ("force3D" === f) {
                                    m[f] = s;
                                    continue
                                }
                                if ("transform" === f) {
                                    kr(this, s, t);
                                    continue
                                }
                            }
                        else
                            f in C || (f = Kn(f) || f);
                        if (g || (a || 0 === a) && (u || 0 === u) && !Dn.test(s) && f in C)
                            a || (a = 0),
                            (h = (o + "").substr((u + "").length)) !== (d = ne(s) || (f in L.units ? L.units[f] : h)) && (u = or(t, f, o, d)),
                            this._pt = new hn(this._pt,g ? m : C,f,u,p ? p * a : a - u,g || "px" !== d && "zIndex" !== f || !1 === e.autoRound ? Ln : jn),
                            this._pt.u = d || 0,
                            h !== d && (this._pt.b = o,
                            this._pt.r = Nn);
                        else if (f in C)
                            ar.call(this, t, f, o, s);
                        else {
                            if (!(f in t)) {
                                ut(f, s);
                                continue
                            }
                            this.add(t, f, t[f], s, r, i)
                        }
                        k.push(f)
                    }
            x && fn(this)
        },
        get: sr,
        aliases: Mn,
        getSetter: function(t, e, n) {
            var r = Mn[e];
            return r && r.indexOf(",") < 0 && (e = r),
            e in Cn && e !== Un && (t._gsap.x || sr(t, "x")) ? n && Tn === n ? "scale" === e ? Xn : Hn : (Tn = n || {}) && ("scale" === e ? zn : Yn) : t.style && !W(t.style[e]) ? Fn : ~e.indexOf("-") ? Bn : nn(t, e)
        },
        core: {
            _removeProperty: nr,
            _getMatrix: gr
        }
    };
    vn.utils.checkPrefix = Kn,
    Er = Tt("x,y,z,scale,scaleX,scaleY,xPercent,yPercent," + (Cr = "rotation,rotationX,rotationY,skewX,skewY") + ",transform,transformOrigin,svgOrigin,force3D,smoothOrigin,transformPerspective", (function(t) {
        Cn[t] = 1
    }
    )),
    Tt(Cr, (function(t) {
        L.units[t] = "deg",
        hr[t] = 1
    }
    )),
    Mn[Er[13]] = "x,y,z,scale,scaleX,scaleY,xPercent,yPercent," + Cr,
    Tt("0:translateX,1:translateY,2:translateZ,8:rotate,8:rotationZ,8:rotateZ,9:rotateX,10:rotateY", (function(t) {
        var e = t.split(":");
        Mn[e[1]] = Er[e[0]]
    }
    )),
    Tt("x,y,z,top,right,bottom,left,width,height,fontSize,padding,margin,perspective", (function(t) {
        L.units[t] = "px"
    }
    )),
    vn.registerPlugin(Sr),
    n.d(e, "a", (function() {
        return Pr
    }
    ));
    var Pr = vn.registerPlugin(Sr) || vn;
    Pr.core.Tween
}
, function(t, e, n) {
    /*!
 * jQuery JavaScript Library v3.5.0
 * https://jquery.com/
 *
 * Includes Sizzle.js
 * https://sizzlejs.com/
 *
 * Copyright JS Foundation and other contributors
 * Released under the MIT license
 * https://jquery.org/license
 *
 * Date: 2020-04-10T15:07Z
 */
    !function(e, n) {
        "use strict";
        "object" == typeof t.exports ? t.exports = e.document ? n(e, !0) : function(t) {
            if (!t.document)
                throw new Error("jQuery requires a window with a document");
            return n(t)
        }
        : n(e)
    }("undefined" != typeof window ? window : this, (function(t, e) {
        "use strict";
        var n = []
          , r = Object.getPrototypeOf
          , i = n.slice
          , o = n.flat ? function(t) {
            return n.flat.call(t)
        }
        : function(t) {
            return n.concat.apply([], t)
        }
          , s = n.push
          , a = n.indexOf
          , u = {}
          , l = u.toString
          , c = u.hasOwnProperty
          , f = c.toString
          , h = f.call(Object)
          , d = {}
          , p = function(t) {
            return "function" == typeof t && "number" != typeof t.nodeType
        }
          , g = function(t) {
            return null != t && t === t.window
        }
          , v = t.document
          , m = {
            type: !0,
            src: !0,
            nonce: !0,
            noModule: !0
        };
        function y(t, e, n) {
            var r, i, o = (n = n || v).createElement("script");
            if (o.text = t,
            e)
                for (r in m)
                    (i = e[r] || e.getAttribute && e.getAttribute(r)) && o.setAttribute(r, i);
            n.head.appendChild(o).parentNode.removeChild(o)
        }
        function x(t) {
            return null == t ? t + "" : "object" == typeof t || "function" == typeof t ? u[l.call(t)] || "object" : typeof t
        }
        var b = function(t, e) {
            return new b.fn.init(t,e)
        };
        function w(t) {
            var e = !!t && "length"in t && t.length
              , n = x(t);
            return !p(t) && !g(t) && ("array" === n || 0 === e || "number" == typeof e && e > 0 && e - 1 in t)
        }
        b.fn = b.prototype = {
            jquery: "3.5.0",
            constructor: b,
            length: 0,
            toArray: function() {
                return i.call(this)
            },
            get: function(t) {
                return null == t ? i.call(this) : t < 0 ? this[t + this.length] : this[t]
            },
            pushStack: function(t) {
                var e = b.merge(this.constructor(), t);
                return e.prevObject = this,
                e
            },
            each: function(t) {
                return b.each(this, t)
            },
            map: function(t) {
                return this.pushStack(b.map(this, (function(e, n) {
                    return t.call(e, n, e)
                }
                )))
            },
            slice: function() {
                return this.pushStack(i.apply(this, arguments))
            },
            first: function() {
                return this.eq(0)
            },
            last: function() {
                return this.eq(-1)
            },
            even: function() {
                return this.pushStack(b.grep(this, (function(t, e) {
                    return (e + 1) % 2
                }
                )))
            },
            odd: function() {
                return this.pushStack(b.grep(this, (function(t, e) {
                    return e % 2
                }
                )))
            },
            eq: function(t) {
                var e = this.length
                  , n = +t + (t < 0 ? e : 0);
                return this.pushStack(n >= 0 && n < e ? [this[n]] : [])
            },
            end: function() {
                return this.prevObject || this.constructor()
            },
            push: s,
            sort: n.sort,
            splice: n.splice
        },
        b.extend = b.fn.extend = function() {
            var t, e, n, r, i, o, s = arguments[0] || {}, a = 1, u = arguments.length, l = !1;
            for ("boolean" == typeof s && (l = s,
            s = arguments[a] || {},
            a++),
            "object" == typeof s || p(s) || (s = {}),
            a === u && (s = this,
            a--); a < u; a++)
                if (null != (t = arguments[a]))
                    for (e in t)
                        r = t[e],
                        "__proto__" !== e && s !== r && (l && r && (b.isPlainObject(r) || (i = Array.isArray(r))) ? (n = s[e],
                        o = i && !Array.isArray(n) ? [] : i || b.isPlainObject(n) ? n : {},
                        i = !1,
                        s[e] = b.extend(l, o, r)) : void 0 !== r && (s[e] = r));
            return s
        }
        ,
        b.extend({
            expando: "jQuery" + ("3.5.0" + Math.random()).replace(/\D/g, ""),
            isReady: !0,
            error: function(t) {
                throw new Error(t)
            },
            noop: function() {},
            isPlainObject: function(t) {
                var e, n;
                return !(!t || "[object Object]" !== l.call(t)) && (!(e = r(t)) || "function" == typeof (n = c.call(e, "constructor") && e.constructor) && f.call(n) === h)
            },
            isEmptyObject: function(t) {
                var e;
                for (e in t)
                    return !1;
                return !0
            },
            globalEval: function(t, e, n) {
                y(t, {
                    nonce: e && e.nonce
                }, n)
            },
            each: function(t, e) {
                var n, r = 0;
                if (w(t))
                    for (n = t.length; r < n && !1 !== e.call(t[r], r, t[r]); r++)
                        ;
                else
                    for (r in t)
                        if (!1 === e.call(t[r], r, t[r]))
                            break;
                return t
            },
            makeArray: function(t, e) {
                var n = e || [];
                return null != t && (w(Object(t)) ? b.merge(n, "string" == typeof t ? [t] : t) : s.call(n, t)),
                n
            },
            inArray: function(t, e, n) {
                return null == e ? -1 : a.call(e, t, n)
            },
            merge: function(t, e) {
                for (var n = +e.length, r = 0, i = t.length; r < n; r++)
                    t[i++] = e[r];
                return t.length = i,
                t
            },
            grep: function(t, e, n) {
                for (var r = [], i = 0, o = t.length, s = !n; i < o; i++)
                    !e(t[i], i) !== s && r.push(t[i]);
                return r
            },
            map: function(t, e, n) {
                var r, i, s = 0, a = [];
                if (w(t))
                    for (r = t.length; s < r; s++)
                        null != (i = e(t[s], s, n)) && a.push(i);
                else
                    for (s in t)
                        null != (i = e(t[s], s, n)) && a.push(i);
                return o(a)
            },
            guid: 1,
            support: d
        }),
        "function" == typeof Symbol && (b.fn[Symbol.iterator] = n[Symbol.iterator]),
        b.each("Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "), (function(t, e) {
            u["[object " + e + "]"] = e.toLowerCase()
        }
        ));
        var _ = /*!
 * Sizzle CSS Selector Engine v2.3.5
 * https://sizzlejs.com/
 *
 * Copyright JS Foundation and other contributors
 * Released under the MIT license
 * https://js.foundation/
 *
 * Date: 2020-03-14
 */
        function(t) {
            var e, n, r, i, o, s, a, u, l, c, f, h, d, p, g, v, m, y, x, b = "sizzle" + 1 * new Date, w = t.document, _ = 0, T = 0, k = ut(), C = ut(), E = ut(), S = ut(), P = function(t, e) {
                return t === e && (f = !0),
                0
            }, A = {}.hasOwnProperty, O = [], D = O.pop, M = O.push, L = O.push, q = O.slice, N = function(t, e) {
                for (var n = 0, r = t.length; n < r; n++)
                    if (t[n] === e)
                        return n;
                return -1
            }, j = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped", R = "[\\x20\\t\\r\\n\\f]", I = "(?:\\\\[\\da-fA-F]{1,6}" + R + "?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+", F = "\\[" + R + "*(" + I + ")(?:" + R + "*([*^$|!~]?=)" + R + "*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + I + "))|)" + R + "*\\]", B = ":(" + I + ")(?:\\((('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|((?:\\\\.|[^\\\\()[\\]]|" + F + ")*)|.*)\\)|)", H = new RegExp(R + "+","g"), X = new RegExp("^" + R + "+|((?:^|[^\\\\])(?:\\\\.)*)" + R + "+$","g"), z = new RegExp("^" + R + "*," + R + "*"), Y = new RegExp("^" + R + "*([>+~]|" + R + ")" + R + "*"), W = new RegExp(R + "|>"), U = new RegExp(B), $ = new RegExp("^" + I + "$"), V = {
                ID: new RegExp("^#(" + I + ")"),
                CLASS: new RegExp("^\\.(" + I + ")"),
                TAG: new RegExp("^(" + I + "|[*])"),
                ATTR: new RegExp("^" + F),
                PSEUDO: new RegExp("^" + B),
                CHILD: new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + R + "*(even|odd|(([+-]|)(\\d*)n|)" + R + "*(?:([+-]|)" + R + "*(\\d+)|))" + R + "*\\)|)","i"),
                bool: new RegExp("^(?:" + j + ")$","i"),
                needsContext: new RegExp("^" + R + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + R + "*((?:-\\d)?\\d*)" + R + "*\\)|)(?=[^-]|$)","i")
            }, G = /HTML$/i, K = /^(?:input|select|textarea|button)$/i, Q = /^h\d$/i, J = /^[^{]+\{\s*\[native \w/, Z = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/, tt = /[+~]/, et = new RegExp("\\\\[\\da-fA-F]{1,6}" + R + "?|\\\\([^\\r\\n\\f])","g"), nt = function(t, e) {
                var n = "0x" + t.slice(1) - 65536;
                return e || (n < 0 ? String.fromCharCode(n + 65536) : String.fromCharCode(n >> 10 | 55296, 1023 & n | 56320))
            }, rt = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g, it = function(t, e) {
                return e ? "\0" === t ? "�" : t.slice(0, -1) + "\\" + t.charCodeAt(t.length - 1).toString(16) + " " : "\\" + t
            }, ot = function() {
                h()
            }, st = bt((function(t) {
                return !0 === t.disabled && "fieldset" === t.nodeName.toLowerCase()
            }
            ), {
                dir: "parentNode",
                next: "legend"
            });
            try {
                L.apply(O = q.call(w.childNodes), w.childNodes),
                O[w.childNodes.length].nodeType
            } catch (t) {
                L = {
                    apply: O.length ? function(t, e) {
                        M.apply(t, q.call(e))
                    }
                    : function(t, e) {
                        for (var n = t.length, r = 0; t[n++] = e[r++]; )
                            ;
                        t.length = n - 1
                    }
                }
            }
            function at(t, e, r, i) {
                var o, a, l, c, f, p, m, y = e && e.ownerDocument, w = e ? e.nodeType : 9;
                if (r = r || [],
                "string" != typeof t || !t || 1 !== w && 9 !== w && 11 !== w)
                    return r;
                if (!i && (h(e),
                e = e || d,
                g)) {
                    if (11 !== w && (f = Z.exec(t)))
                        if (o = f[1]) {
                            if (9 === w) {
                                if (!(l = e.getElementById(o)))
                                    return r;
                                if (l.id === o)
                                    return r.push(l),
                                    r
                            } else if (y && (l = y.getElementById(o)) && x(e, l) && l.id === o)
                                return r.push(l),
                                r
                        } else {
                            if (f[2])
                                return L.apply(r, e.getElementsByTagName(t)),
                                r;
                            if ((o = f[3]) && n.getElementsByClassName && e.getElementsByClassName)
                                return L.apply(r, e.getElementsByClassName(o)),
                                r
                        }
                    if (n.qsa && !S[t + " "] && (!v || !v.test(t)) && (1 !== w || "object" !== e.nodeName.toLowerCase())) {
                        if (m = t,
                        y = e,
                        1 === w && (W.test(t) || Y.test(t))) {
                            for ((y = tt.test(t) && mt(e.parentNode) || e) === e && n.scope || ((c = e.getAttribute("id")) ? c = c.replace(rt, it) : e.setAttribute("id", c = b)),
                            a = (p = s(t)).length; a--; )
                                p[a] = (c ? "#" + c : ":scope") + " " + xt(p[a]);
                            m = p.join(",")
                        }
                        try {
                            return L.apply(r, y.querySelectorAll(m)),
                            r
                        } catch (e) {
                            S(t, !0)
                        } finally {
                            c === b && e.removeAttribute("id")
                        }
                    }
                }
                return u(t.replace(X, "$1"), e, r, i)
            }
            function ut() {
                var t = [];
                return function e(n, i) {
                    return t.push(n + " ") > r.cacheLength && delete e[t.shift()],
                    e[n + " "] = i
                }
            }
            function lt(t) {
                return t[b] = !0,
                t
            }
            function ct(t) {
                var e = d.createElement("fieldset");
                try {
                    return !!t(e)
                } catch (t) {
                    return !1
                } finally {
                    e.parentNode && e.parentNode.removeChild(e),
                    e = null
                }
            }
            function ft(t, e) {
                for (var n = t.split("|"), i = n.length; i--; )
                    r.attrHandle[n[i]] = e
            }
            function ht(t, e) {
                var n = e && t
                  , r = n && 1 === t.nodeType && 1 === e.nodeType && t.sourceIndex - e.sourceIndex;
                if (r)
                    return r;
                if (n)
                    for (; n = n.nextSibling; )
                        if (n === e)
                            return -1;
                return t ? 1 : -1
            }
            function dt(t) {
                return function(e) {
                    return "input" === e.nodeName.toLowerCase() && e.type === t
                }
            }
            function pt(t) {
                return function(e) {
                    var n = e.nodeName.toLowerCase();
                    return ("input" === n || "button" === n) && e.type === t
                }
            }
            function gt(t) {
                return function(e) {
                    return "form"in e ? e.parentNode && !1 === e.disabled ? "label"in e ? "label"in e.parentNode ? e.parentNode.disabled === t : e.disabled === t : e.isDisabled === t || e.isDisabled !== !t && st(e) === t : e.disabled === t : "label"in e && e.disabled === t
                }
            }
            function vt(t) {
                return lt((function(e) {
                    return e = +e,
                    lt((function(n, r) {
                        for (var i, o = t([], n.length, e), s = o.length; s--; )
                            n[i = o[s]] && (n[i] = !(r[i] = n[i]))
                    }
                    ))
                }
                ))
            }
            function mt(t) {
                return t && void 0 !== t.getElementsByTagName && t
            }
            for (e in n = at.support = {},
            o = at.isXML = function(t) {
                var e = t.namespaceURI
                  , n = (t.ownerDocument || t).documentElement;
                return !G.test(e || n && n.nodeName || "HTML")
            }
            ,
            h = at.setDocument = function(t) {
                var e, i, s = t ? t.ownerDocument || t : w;
                return s != d && 9 === s.nodeType && s.documentElement ? (p = (d = s).documentElement,
                g = !o(d),
                w != d && (i = d.defaultView) && i.top !== i && (i.addEventListener ? i.addEventListener("unload", ot, !1) : i.attachEvent && i.attachEvent("onunload", ot)),
                n.scope = ct((function(t) {
                    return p.appendChild(t).appendChild(d.createElement("div")),
                    void 0 !== t.querySelectorAll && !t.querySelectorAll(":scope fieldset div").length
                }
                )),
                n.attributes = ct((function(t) {
                    return t.className = "i",
                    !t.getAttribute("className")
                }
                )),
                n.getElementsByTagName = ct((function(t) {
                    return t.appendChild(d.createComment("")),
                    !t.getElementsByTagName("*").length
                }
                )),
                n.getElementsByClassName = J.test(d.getElementsByClassName),
                n.getById = ct((function(t) {
                    return p.appendChild(t).id = b,
                    !d.getElementsByName || !d.getElementsByName(b).length
                }
                )),
                n.getById ? (r.filter.ID = function(t) {
                    var e = t.replace(et, nt);
                    return function(t) {
                        return t.getAttribute("id") === e
                    }
                }
                ,
                r.find.ID = function(t, e) {
                    if (void 0 !== e.getElementById && g) {
                        var n = e.getElementById(t);
                        return n ? [n] : []
                    }
                }
                ) : (r.filter.ID = function(t) {
                    var e = t.replace(et, nt);
                    return function(t) {
                        var n = void 0 !== t.getAttributeNode && t.getAttributeNode("id");
                        return n && n.value === e
                    }
                }
                ,
                r.find.ID = function(t, e) {
                    if (void 0 !== e.getElementById && g) {
                        var n, r, i, o = e.getElementById(t);
                        if (o) {
                            if ((n = o.getAttributeNode("id")) && n.value === t)
                                return [o];
                            for (i = e.getElementsByName(t),
                            r = 0; o = i[r++]; )
                                if ((n = o.getAttributeNode("id")) && n.value === t)
                                    return [o]
                        }
                        return []
                    }
                }
                ),
                r.find.TAG = n.getElementsByTagName ? function(t, e) {
                    return void 0 !== e.getElementsByTagName ? e.getElementsByTagName(t) : n.qsa ? e.querySelectorAll(t) : void 0
                }
                : function(t, e) {
                    var n, r = [], i = 0, o = e.getElementsByTagName(t);
                    if ("*" === t) {
                        for (; n = o[i++]; )
                            1 === n.nodeType && r.push(n);
                        return r
                    }
                    return o
                }
                ,
                r.find.CLASS = n.getElementsByClassName && function(t, e) {
                    if (void 0 !== e.getElementsByClassName && g)
                        return e.getElementsByClassName(t)
                }
                ,
                m = [],
                v = [],
                (n.qsa = J.test(d.querySelectorAll)) && (ct((function(t) {
                    var e;
                    p.appendChild(t).innerHTML = "<a id='" + b + "'></a><select id='" + b + "-\r\\' msallowcapture=''><option selected=''></option></select>",
                    t.querySelectorAll("[msallowcapture^='']").length && v.push("[*^$]=" + R + "*(?:''|\"\")"),
                    t.querySelectorAll("[selected]").length || v.push("\\[" + R + "*(?:value|" + j + ")"),
                    t.querySelectorAll("[id~=" + b + "-]").length || v.push("~="),
                    (e = d.createElement("input")).setAttribute("name", ""),
                    t.appendChild(e),
                    t.querySelectorAll("[name='']").length || v.push("\\[" + R + "*name" + R + "*=" + R + "*(?:''|\"\")"),
                    t.querySelectorAll(":checked").length || v.push(":checked"),
                    t.querySelectorAll("a#" + b + "+*").length || v.push(".#.+[+~]"),
                    t.querySelectorAll("\\\f"),
                    v.push("[\\r\\n\\f]")
                }
                )),
                ct((function(t) {
                    t.innerHTML = "<a href='' disabled='disabled'></a><select disabled='disabled'><option/></select>";
                    var e = d.createElement("input");
                    e.setAttribute("type", "hidden"),
                    t.appendChild(e).setAttribute("name", "D"),
                    t.querySelectorAll("[name=d]").length && v.push("name" + R + "*[*^$|!~]?="),
                    2 !== t.querySelectorAll(":enabled").length && v.push(":enabled", ":disabled"),
                    p.appendChild(t).disabled = !0,
                    2 !== t.querySelectorAll(":disabled").length && v.push(":enabled", ":disabled"),
                    t.querySelectorAll("*,:x"),
                    v.push(",.*:")
                }
                ))),
                (n.matchesSelector = J.test(y = p.matches || p.webkitMatchesSelector || p.mozMatchesSelector || p.oMatchesSelector || p.msMatchesSelector)) && ct((function(t) {
                    n.disconnectedMatch = y.call(t, "*"),
                    y.call(t, "[s!='']:x"),
                    m.push("!=", B)
                }
                )),
                v = v.length && new RegExp(v.join("|")),
                m = m.length && new RegExp(m.join("|")),
                e = J.test(p.compareDocumentPosition),
                x = e || J.test(p.contains) ? function(t, e) {
                    var n = 9 === t.nodeType ? t.documentElement : t
                      , r = e && e.parentNode;
                    return t === r || !(!r || 1 !== r.nodeType || !(n.contains ? n.contains(r) : t.compareDocumentPosition && 16 & t.compareDocumentPosition(r)))
                }
                : function(t, e) {
                    if (e)
                        for (; e = e.parentNode; )
                            if (e === t)
                                return !0;
                    return !1
                }
                ,
                P = e ? function(t, e) {
                    if (t === e)
                        return f = !0,
                        0;
                    var r = !t.compareDocumentPosition - !e.compareDocumentPosition;
                    return r || (1 & (r = (t.ownerDocument || t) == (e.ownerDocument || e) ? t.compareDocumentPosition(e) : 1) || !n.sortDetached && e.compareDocumentPosition(t) === r ? t == d || t.ownerDocument == w && x(w, t) ? -1 : e == d || e.ownerDocument == w && x(w, e) ? 1 : c ? N(c, t) - N(c, e) : 0 : 4 & r ? -1 : 1)
                }
                : function(t, e) {
                    if (t === e)
                        return f = !0,
                        0;
                    var n, r = 0, i = t.parentNode, o = e.parentNode, s = [t], a = [e];
                    if (!i || !o)
                        return t == d ? -1 : e == d ? 1 : i ? -1 : o ? 1 : c ? N(c, t) - N(c, e) : 0;
                    if (i === o)
                        return ht(t, e);
                    for (n = t; n = n.parentNode; )
                        s.unshift(n);
                    for (n = e; n = n.parentNode; )
                        a.unshift(n);
                    for (; s[r] === a[r]; )
                        r++;
                    return r ? ht(s[r], a[r]) : s[r] == w ? -1 : a[r] == w ? 1 : 0
                }
                ,
                d) : d
            }
            ,
            at.matches = function(t, e) {
                return at(t, null, null, e)
            }
            ,
            at.matchesSelector = function(t, e) {
                if (h(t),
                n.matchesSelector && g && !S[e + " "] && (!m || !m.test(e)) && (!v || !v.test(e)))
                    try {
                        var r = y.call(t, e);
                        if (r || n.disconnectedMatch || t.document && 11 !== t.document.nodeType)
                            return r
                    } catch (t) {
                        S(e, !0)
                    }
                return at(e, d, null, [t]).length > 0
            }
            ,
            at.contains = function(t, e) {
                return (t.ownerDocument || t) != d && h(t),
                x(t, e)
            }
            ,
            at.attr = function(t, e) {
                (t.ownerDocument || t) != d && h(t);
                var i = r.attrHandle[e.toLowerCase()]
                  , o = i && A.call(r.attrHandle, e.toLowerCase()) ? i(t, e, !g) : void 0;
                return void 0 !== o ? o : n.attributes || !g ? t.getAttribute(e) : (o = t.getAttributeNode(e)) && o.specified ? o.value : null
            }
            ,
            at.escape = function(t) {
                return (t + "").replace(rt, it)
            }
            ,
            at.error = function(t) {
                throw new Error("Syntax error, unrecognized expression: " + t)
            }
            ,
            at.uniqueSort = function(t) {
                var e, r = [], i = 0, o = 0;
                if (f = !n.detectDuplicates,
                c = !n.sortStable && t.slice(0),
                t.sort(P),
                f) {
                    for (; e = t[o++]; )
                        e === t[o] && (i = r.push(o));
                    for (; i--; )
                        t.splice(r[i], 1)
                }
                return c = null,
                t
            }
            ,
            i = at.getText = function(t) {
                var e, n = "", r = 0, o = t.nodeType;
                if (o) {
                    if (1 === o || 9 === o || 11 === o) {
                        if ("string" == typeof t.textContent)
                            return t.textContent;
                        for (t = t.firstChild; t; t = t.nextSibling)
                            n += i(t)
                    } else if (3 === o || 4 === o)
                        return t.nodeValue
                } else
                    for (; e = t[r++]; )
                        n += i(e);
                return n
            }
            ,
            (r = at.selectors = {
                cacheLength: 50,
                createPseudo: lt,
                match: V,
                attrHandle: {},
                find: {},
                relative: {
                    ">": {
                        dir: "parentNode",
                        first: !0
                    },
                    " ": {
                        dir: "parentNode"
                    },
                    "+": {
                        dir: "previousSibling",
                        first: !0
                    },
                    "~": {
                        dir: "previousSibling"
                    }
                },
                preFilter: {
                    ATTR: function(t) {
                        return t[1] = t[1].replace(et, nt),
                        t[3] = (t[3] || t[4] || t[5] || "").replace(et, nt),
                        "~=" === t[2] && (t[3] = " " + t[3] + " "),
                        t.slice(0, 4)
                    },
                    CHILD: function(t) {
                        return t[1] = t[1].toLowerCase(),
                        "nth" === t[1].slice(0, 3) ? (t[3] || at.error(t[0]),
                        t[4] = +(t[4] ? t[5] + (t[6] || 1) : 2 * ("even" === t[3] || "odd" === t[3])),
                        t[5] = +(t[7] + t[8] || "odd" === t[3])) : t[3] && at.error(t[0]),
                        t
                    },
                    PSEUDO: function(t) {
                        var e, n = !t[6] && t[2];
                        return V.CHILD.test(t[0]) ? null : (t[3] ? t[2] = t[4] || t[5] || "" : n && U.test(n) && (e = s(n, !0)) && (e = n.indexOf(")", n.length - e) - n.length) && (t[0] = t[0].slice(0, e),
                        t[2] = n.slice(0, e)),
                        t.slice(0, 3))
                    }
                },
                filter: {
                    TAG: function(t) {
                        var e = t.replace(et, nt).toLowerCase();
                        return "*" === t ? function() {
                            return !0
                        }
                        : function(t) {
                            return t.nodeName && t.nodeName.toLowerCase() === e
                        }
                    },
                    CLASS: function(t) {
                        var e = k[t + " "];
                        return e || (e = new RegExp("(^|" + R + ")" + t + "(" + R + "|$)")) && k(t, (function(t) {
                            return e.test("string" == typeof t.className && t.className || void 0 !== t.getAttribute && t.getAttribute("class") || "")
                        }
                        ))
                    },
                    ATTR: function(t, e, n) {
                        return function(r) {
                            var i = at.attr(r, t);
                            return null == i ? "!=" === e : !e || (i += "",
                            "=" === e ? i === n : "!=" === e ? i !== n : "^=" === e ? n && 0 === i.indexOf(n) : "*=" === e ? n && i.indexOf(n) > -1 : "$=" === e ? n && i.slice(-n.length) === n : "~=" === e ? (" " + i.replace(H, " ") + " ").indexOf(n) > -1 : "|=" === e && (i === n || i.slice(0, n.length + 1) === n + "-"))
                        }
                    },
                    CHILD: function(t, e, n, r, i) {
                        var o = "nth" !== t.slice(0, 3)
                          , s = "last" !== t.slice(-4)
                          , a = "of-type" === e;
                        return 1 === r && 0 === i ? function(t) {
                            return !!t.parentNode
                        }
                        : function(e, n, u) {
                            var l, c, f, h, d, p, g = o !== s ? "nextSibling" : "previousSibling", v = e.parentNode, m = a && e.nodeName.toLowerCase(), y = !u && !a, x = !1;
                            if (v) {
                                if (o) {
                                    for (; g; ) {
                                        for (h = e; h = h[g]; )
                                            if (a ? h.nodeName.toLowerCase() === m : 1 === h.nodeType)
                                                return !1;
                                        p = g = "only" === t && !p && "nextSibling"
                                    }
                                    return !0
                                }
                                if (p = [s ? v.firstChild : v.lastChild],
                                s && y) {
                                    for (x = (d = (l = (c = (f = (h = v)[b] || (h[b] = {}))[h.uniqueID] || (f[h.uniqueID] = {}))[t] || [])[0] === _ && l[1]) && l[2],
                                    h = d && v.childNodes[d]; h = ++d && h && h[g] || (x = d = 0) || p.pop(); )
                                        if (1 === h.nodeType && ++x && h === e) {
                                            c[t] = [_, d, x];
                                            break
                                        }
                                } else if (y && (x = d = (l = (c = (f = (h = e)[b] || (h[b] = {}))[h.uniqueID] || (f[h.uniqueID] = {}))[t] || [])[0] === _ && l[1]),
                                !1 === x)
                                    for (; (h = ++d && h && h[g] || (x = d = 0) || p.pop()) && ((a ? h.nodeName.toLowerCase() !== m : 1 !== h.nodeType) || !++x || (y && ((c = (f = h[b] || (h[b] = {}))[h.uniqueID] || (f[h.uniqueID] = {}))[t] = [_, x]),
                                    h !== e)); )
                                        ;
                                return (x -= i) === r || x % r == 0 && x / r >= 0
                            }
                        }
                    },
                    PSEUDO: function(t, e) {
                        var n, i = r.pseudos[t] || r.setFilters[t.toLowerCase()] || at.error("unsupported pseudo: " + t);
                        return i[b] ? i(e) : i.length > 1 ? (n = [t, t, "", e],
                        r.setFilters.hasOwnProperty(t.toLowerCase()) ? lt((function(t, n) {
                            for (var r, o = i(t, e), s = o.length; s--; )
                                t[r = N(t, o[s])] = !(n[r] = o[s])
                        }
                        )) : function(t) {
                            return i(t, 0, n)
                        }
                        ) : i
                    }
                },
                pseudos: {
                    not: lt((function(t) {
                        var e = []
                          , n = []
                          , r = a(t.replace(X, "$1"));
                        return r[b] ? lt((function(t, e, n, i) {
                            for (var o, s = r(t, null, i, []), a = t.length; a--; )
                                (o = s[a]) && (t[a] = !(e[a] = o))
                        }
                        )) : function(t, i, o) {
                            return e[0] = t,
                            r(e, null, o, n),
                            e[0] = null,
                            !n.pop()
                        }
                    }
                    )),
                    has: lt((function(t) {
                        return function(e) {
                            return at(t, e).length > 0
                        }
                    }
                    )),
                    contains: lt((function(t) {
                        return t = t.replace(et, nt),
                        function(e) {
                            return (e.textContent || i(e)).indexOf(t) > -1
                        }
                    }
                    )),
                    lang: lt((function(t) {
                        return $.test(t || "") || at.error("unsupported lang: " + t),
                        t = t.replace(et, nt).toLowerCase(),
                        function(e) {
                            var n;
                            do {
                                if (n = g ? e.lang : e.getAttribute("xml:lang") || e.getAttribute("lang"))
                                    return (n = n.toLowerCase()) === t || 0 === n.indexOf(t + "-")
                            } while ((e = e.parentNode) && 1 === e.nodeType);
                            return !1
                        }
                    }
                    )),
                    target: function(e) {
                        var n = t.location && t.location.hash;
                        return n && n.slice(1) === e.id
                    },
                    root: function(t) {
                        return t === p
                    },
                    focus: function(t) {
                        return t === d.activeElement && (!d.hasFocus || d.hasFocus()) && !!(t.type || t.href || ~t.tabIndex)
                    },
                    enabled: gt(!1),
                    disabled: gt(!0),
                    checked: function(t) {
                        var e = t.nodeName.toLowerCase();
                        return "input" === e && !!t.checked || "option" === e && !!t.selected
                    },
                    selected: function(t) {
                        return t.parentNode && t.parentNode.selectedIndex,
                        !0 === t.selected
                    },
                    empty: function(t) {
                        for (t = t.firstChild; t; t = t.nextSibling)
                            if (t.nodeType < 6)
                                return !1;
                        return !0
                    },
                    parent: function(t) {
                        return !r.pseudos.empty(t)
                    },
                    header: function(t) {
                        return Q.test(t.nodeName)
                    },
                    input: function(t) {
                        return K.test(t.nodeName)
                    },
                    button: function(t) {
                        var e = t.nodeName.toLowerCase();
                        return "input" === e && "button" === t.type || "button" === e
                    },
                    text: function(t) {
                        var e;
                        return "input" === t.nodeName.toLowerCase() && "text" === t.type && (null == (e = t.getAttribute("type")) || "text" === e.toLowerCase())
                    },
                    first: vt((function() {
                        return [0]
                    }
                    )),
                    last: vt((function(t, e) {
                        return [e - 1]
                    }
                    )),
                    eq: vt((function(t, e, n) {
                        return [n < 0 ? n + e : n]
                    }
                    )),
                    even: vt((function(t, e) {
                        for (var n = 0; n < e; n += 2)
                            t.push(n);
                        return t
                    }
                    )),
                    odd: vt((function(t, e) {
                        for (var n = 1; n < e; n += 2)
                            t.push(n);
                        return t
                    }
                    )),
                    lt: vt((function(t, e, n) {
                        for (var r = n < 0 ? n + e : n > e ? e : n; --r >= 0; )
                            t.push(r);
                        return t
                    }
                    )),
                    gt: vt((function(t, e, n) {
                        for (var r = n < 0 ? n + e : n; ++r < e; )
                            t.push(r);
                        return t
                    }
                    ))
                }
            }).pseudos.nth = r.pseudos.eq,
            {
                radio: !0,
                checkbox: !0,
                file: !0,
                password: !0,
                image: !0
            })
                r.pseudos[e] = dt(e);
            for (e in {
                submit: !0,
                reset: !0
            })
                r.pseudos[e] = pt(e);
            function yt() {}
            function xt(t) {
                for (var e = 0, n = t.length, r = ""; e < n; e++)
                    r += t[e].value;
                return r
            }
            function bt(t, e, n) {
                var r = e.dir
                  , i = e.next
                  , o = i || r
                  , s = n && "parentNode" === o
                  , a = T++;
                return e.first ? function(e, n, i) {
                    for (; e = e[r]; )
                        if (1 === e.nodeType || s)
                            return t(e, n, i);
                    return !1
                }
                : function(e, n, u) {
                    var l, c, f, h = [_, a];
                    if (u) {
                        for (; e = e[r]; )
                            if ((1 === e.nodeType || s) && t(e, n, u))
                                return !0
                    } else
                        for (; e = e[r]; )
                            if (1 === e.nodeType || s)
                                if (c = (f = e[b] || (e[b] = {}))[e.uniqueID] || (f[e.uniqueID] = {}),
                                i && i === e.nodeName.toLowerCase())
                                    e = e[r] || e;
                                else {
                                    if ((l = c[o]) && l[0] === _ && l[1] === a)
                                        return h[2] = l[2];
                                    if (c[o] = h,
                                    h[2] = t(e, n, u))
                                        return !0
                                }
                    return !1
                }
            }
            function wt(t) {
                return t.length > 1 ? function(e, n, r) {
                    for (var i = t.length; i--; )
                        if (!t[i](e, n, r))
                            return !1;
                    return !0
                }
                : t[0]
            }
            function _t(t, e, n, r, i) {
                for (var o, s = [], a = 0, u = t.length, l = null != e; a < u; a++)
                    (o = t[a]) && (n && !n(o, r, i) || (s.push(o),
                    l && e.push(a)));
                return s
            }
            function Tt(t, e, n, r, i, o) {
                return r && !r[b] && (r = Tt(r)),
                i && !i[b] && (i = Tt(i, o)),
                lt((function(o, s, a, u) {
                    var l, c, f, h = [], d = [], p = s.length, g = o || function(t, e, n) {
                        for (var r = 0, i = e.length; r < i; r++)
                            at(t, e[r], n);
                        return n
                    }(e || "*", a.nodeType ? [a] : a, []), v = !t || !o && e ? g : _t(g, h, t, a, u), m = n ? i || (o ? t : p || r) ? [] : s : v;
                    if (n && n(v, m, a, u),
                    r)
                        for (l = _t(m, d),
                        r(l, [], a, u),
                        c = l.length; c--; )
                            (f = l[c]) && (m[d[c]] = !(v[d[c]] = f));
                    if (o) {
                        if (i || t) {
                            if (i) {
                                for (l = [],
                                c = m.length; c--; )
                                    (f = m[c]) && l.push(v[c] = f);
                                i(null, m = [], l, u)
                            }
                            for (c = m.length; c--; )
                                (f = m[c]) && (l = i ? N(o, f) : h[c]) > -1 && (o[l] = !(s[l] = f))
                        }
                    } else
                        m = _t(m === s ? m.splice(p, m.length) : m),
                        i ? i(null, s, m, u) : L.apply(s, m)
                }
                ))
            }
            function kt(t) {
                for (var e, n, i, o = t.length, s = r.relative[t[0].type], a = s || r.relative[" "], u = s ? 1 : 0, c = bt((function(t) {
                    return t === e
                }
                ), a, !0), f = bt((function(t) {
                    return N(e, t) > -1
                }
                ), a, !0), h = [function(t, n, r) {
                    var i = !s && (r || n !== l) || ((e = n).nodeType ? c(t, n, r) : f(t, n, r));
                    return e = null,
                    i
                }
                ]; u < o; u++)
                    if (n = r.relative[t[u].type])
                        h = [bt(wt(h), n)];
                    else {
                        if ((n = r.filter[t[u].type].apply(null, t[u].matches))[b]) {
                            for (i = ++u; i < o && !r.relative[t[i].type]; i++)
                                ;
                            return Tt(u > 1 && wt(h), u > 1 && xt(t.slice(0, u - 1).concat({
                                value: " " === t[u - 2].type ? "*" : ""
                            })).replace(X, "$1"), n, u < i && kt(t.slice(u, i)), i < o && kt(t = t.slice(i)), i < o && xt(t))
                        }
                        h.push(n)
                    }
                return wt(h)
            }
            return yt.prototype = r.filters = r.pseudos,
            r.setFilters = new yt,
            s = at.tokenize = function(t, e) {
                var n, i, o, s, a, u, l, c = C[t + " "];
                if (c)
                    return e ? 0 : c.slice(0);
                for (a = t,
                u = [],
                l = r.preFilter; a; ) {
                    for (s in n && !(i = z.exec(a)) || (i && (a = a.slice(i[0].length) || a),
                    u.push(o = [])),
                    n = !1,
                    (i = Y.exec(a)) && (n = i.shift(),
                    o.push({
                        value: n,
                        type: i[0].replace(X, " ")
                    }),
                    a = a.slice(n.length)),
                    r.filter)
                        !(i = V[s].exec(a)) || l[s] && !(i = l[s](i)) || (n = i.shift(),
                        o.push({
                            value: n,
                            type: s,
                            matches: i
                        }),
                        a = a.slice(n.length));
                    if (!n)
                        break
                }
                return e ? a.length : a ? at.error(t) : C(t, u).slice(0)
            }
            ,
            a = at.compile = function(t, e) {
                var n, i = [], o = [], a = E[t + " "];
                if (!a) {
                    for (e || (e = s(t)),
                    n = e.length; n--; )
                        (a = kt(e[n]))[b] ? i.push(a) : o.push(a);
                    (a = E(t, function(t, e) {
                        var n = e.length > 0
                          , i = t.length > 0
                          , o = function(o, s, a, u, c) {
                            var f, p, v, m = 0, y = "0", x = o && [], b = [], w = l, T = o || i && r.find.TAG("*", c), k = _ += null == w ? 1 : Math.random() || .1, C = T.length;
                            for (c && (l = s == d || s || c); y !== C && null != (f = T[y]); y++) {
                                if (i && f) {
                                    for (p = 0,
                                    s || f.ownerDocument == d || (h(f),
                                    a = !g); v = t[p++]; )
                                        if (v(f, s || d, a)) {
                                            u.push(f);
                                            break
                                        }
                                    c && (_ = k)
                                }
                                n && ((f = !v && f) && m--,
                                o && x.push(f))
                            }
                            if (m += y,
                            n && y !== m) {
                                for (p = 0; v = e[p++]; )
                                    v(x, b, s, a);
                                if (o) {
                                    if (m > 0)
                                        for (; y--; )
                                            x[y] || b[y] || (b[y] = D.call(u));
                                    b = _t(b)
                                }
                                L.apply(u, b),
                                c && !o && b.length > 0 && m + e.length > 1 && at.uniqueSort(u)
                            }
                            return c && (_ = k,
                            l = w),
                            x
                        };
                        return n ? lt(o) : o
                    }(o, i))).selector = t
                }
                return a
            }
            ,
            u = at.select = function(t, e, n, i) {
                var o, u, l, c, f, h = "function" == typeof t && t, d = !i && s(t = h.selector || t);
                if (n = n || [],
                1 === d.length) {
                    if ((u = d[0] = d[0].slice(0)).length > 2 && "ID" === (l = u[0]).type && 9 === e.nodeType && g && r.relative[u[1].type]) {
                        if (!(e = (r.find.ID(l.matches[0].replace(et, nt), e) || [])[0]))
                            return n;
                        h && (e = e.parentNode),
                        t = t.slice(u.shift().value.length)
                    }
                    for (o = V.needsContext.test(t) ? 0 : u.length; o-- && (l = u[o],
                    !r.relative[c = l.type]); )
                        if ((f = r.find[c]) && (i = f(l.matches[0].replace(et, nt), tt.test(u[0].type) && mt(e.parentNode) || e))) {
                            if (u.splice(o, 1),
                            !(t = i.length && xt(u)))
                                return L.apply(n, i),
                                n;
                            break
                        }
                }
                return (h || a(t, d))(i, e, !g, n, !e || tt.test(t) && mt(e.parentNode) || e),
                n
            }
            ,
            n.sortStable = b.split("").sort(P).join("") === b,
            n.detectDuplicates = !!f,
            h(),
            n.sortDetached = ct((function(t) {
                return 1 & t.compareDocumentPosition(d.createElement("fieldset"))
            }
            )),
            ct((function(t) {
                return t.innerHTML = "<a href='#'></a>",
                "#" === t.firstChild.getAttribute("href")
            }
            )) || ft("type|href|height|width", (function(t, e, n) {
                if (!n)
                    return t.getAttribute(e, "type" === e.toLowerCase() ? 1 : 2)
            }
            )),
            n.attributes && ct((function(t) {
                return t.innerHTML = "<input/>",
                t.firstChild.setAttribute("value", ""),
                "" === t.firstChild.getAttribute("value")
            }
            )) || ft("value", (function(t, e, n) {
                if (!n && "input" === t.nodeName.toLowerCase())
                    return t.defaultValue
            }
            )),
            ct((function(t) {
                return null == t.getAttribute("disabled")
            }
            )) || ft(j, (function(t, e, n) {
                var r;
                if (!n)
                    return !0 === t[e] ? e.toLowerCase() : (r = t.getAttributeNode(e)) && r.specified ? r.value : null
            }
            )),
            at
        }(t);
        b.find = _,
        b.expr = _.selectors,
        b.expr[":"] = b.expr.pseudos,
        b.uniqueSort = b.unique = _.uniqueSort,
        b.text = _.getText,
        b.isXMLDoc = _.isXML,
        b.contains = _.contains,
        b.escapeSelector = _.escape;
        var T = function(t, e, n) {
            for (var r = [], i = void 0 !== n; (t = t[e]) && 9 !== t.nodeType; )
                if (1 === t.nodeType) {
                    if (i && b(t).is(n))
                        break;
                    r.push(t)
                }
            return r
        }
          , k = function(t, e) {
            for (var n = []; t; t = t.nextSibling)
                1 === t.nodeType && t !== e && n.push(t);
            return n
        }
          , C = b.expr.match.needsContext;
        function E(t, e) {
            return t.nodeName && t.nodeName.toLowerCase() === e.toLowerCase()
        }
        var S = /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i;
        function P(t, e, n) {
            return p(e) ? b.grep(t, (function(t, r) {
                return !!e.call(t, r, t) !== n
            }
            )) : e.nodeType ? b.grep(t, (function(t) {
                return t === e !== n
            }
            )) : "string" != typeof e ? b.grep(t, (function(t) {
                return a.call(e, t) > -1 !== n
            }
            )) : b.filter(e, t, n)
        }
        b.filter = function(t, e, n) {
            var r = e[0];
            return n && (t = ":not(" + t + ")"),
            1 === e.length && 1 === r.nodeType ? b.find.matchesSelector(r, t) ? [r] : [] : b.find.matches(t, b.grep(e, (function(t) {
                return 1 === t.nodeType
            }
            )))
        }
        ,
        b.fn.extend({
            find: function(t) {
                var e, n, r = this.length, i = this;
                if ("string" != typeof t)
                    return this.pushStack(b(t).filter((function() {
                        for (e = 0; e < r; e++)
                            if (b.contains(i[e], this))
                                return !0
                    }
                    )));
                for (n = this.pushStack([]),
                e = 0; e < r; e++)
                    b.find(t, i[e], n);
                return r > 1 ? b.uniqueSort(n) : n
            },
            filter: function(t) {
                return this.pushStack(P(this, t || [], !1))
            },
            not: function(t) {
                return this.pushStack(P(this, t || [], !0))
            },
            is: function(t) {
                return !!P(this, "string" == typeof t && C.test(t) ? b(t) : t || [], !1).length
            }
        });
        var A, O = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/;
        (b.fn.init = function(t, e, n) {
            var r, i;
            if (!t)
                return this;
            if (n = n || A,
            "string" == typeof t) {
                if (!(r = "<" === t[0] && ">" === t[t.length - 1] && t.length >= 3 ? [null, t, null] : O.exec(t)) || !r[1] && e)
                    return !e || e.jquery ? (e || n).find(t) : this.constructor(e).find(t);
                if (r[1]) {
                    if (e = e instanceof b ? e[0] : e,
                    b.merge(this, b.parseHTML(r[1], e && e.nodeType ? e.ownerDocument || e : v, !0)),
                    S.test(r[1]) && b.isPlainObject(e))
                        for (r in e)
                            p(this[r]) ? this[r](e[r]) : this.attr(r, e[r]);
                    return this
                }
                return (i = v.getElementById(r[2])) && (this[0] = i,
                this.length = 1),
                this
            }
            return t.nodeType ? (this[0] = t,
            this.length = 1,
            this) : p(t) ? void 0 !== n.ready ? n.ready(t) : t(b) : b.makeArray(t, this)
        }
        ).prototype = b.fn,
        A = b(v);
        var D = /^(?:parents|prev(?:Until|All))/
          , M = {
            children: !0,
            contents: !0,
            next: !0,
            prev: !0
        };
        function L(t, e) {
            for (; (t = t[e]) && 1 !== t.nodeType; )
                ;
            return t
        }
        b.fn.extend({
            has: function(t) {
                var e = b(t, this)
                  , n = e.length;
                return this.filter((function() {
                    for (var t = 0; t < n; t++)
                        if (b.contains(this, e[t]))
                            return !0
                }
                ))
            },
            closest: function(t, e) {
                var n, r = 0, i = this.length, o = [], s = "string" != typeof t && b(t);
                if (!C.test(t))
                    for (; r < i; r++)
                        for (n = this[r]; n && n !== e; n = n.parentNode)
                            if (n.nodeType < 11 && (s ? s.index(n) > -1 : 1 === n.nodeType && b.find.matchesSelector(n, t))) {
                                o.push(n);
                                break
                            }
                return this.pushStack(o.length > 1 ? b.uniqueSort(o) : o)
            },
            index: function(t) {
                return t ? "string" == typeof t ? a.call(b(t), this[0]) : a.call(this, t.jquery ? t[0] : t) : this[0] && this[0].parentNode ? this.first().prevAll().length : -1
            },
            add: function(t, e) {
                return this.pushStack(b.uniqueSort(b.merge(this.get(), b(t, e))))
            },
            addBack: function(t) {
                return this.add(null == t ? this.prevObject : this.prevObject.filter(t))
            }
        }),
        b.each({
            parent: function(t) {
                var e = t.parentNode;
                return e && 11 !== e.nodeType ? e : null
            },
            parents: function(t) {
                return T(t, "parentNode")
            },
            parentsUntil: function(t, e, n) {
                return T(t, "parentNode", n)
            },
            next: function(t) {
                return L(t, "nextSibling")
            },
            prev: function(t) {
                return L(t, "previousSibling")
            },
            nextAll: function(t) {
                return T(t, "nextSibling")
            },
            prevAll: function(t) {
                return T(t, "previousSibling")
            },
            nextUntil: function(t, e, n) {
                return T(t, "nextSibling", n)
            },
            prevUntil: function(t, e, n) {
                return T(t, "previousSibling", n)
            },
            siblings: function(t) {
                return k((t.parentNode || {}).firstChild, t)
            },
            children: function(t) {
                return k(t.firstChild)
            },
            contents: function(t) {
                return null != t.contentDocument && r(t.contentDocument) ? t.contentDocument : (E(t, "template") && (t = t.content || t),
                b.merge([], t.childNodes))
            }
        }, (function(t, e) {
            b.fn[t] = function(n, r) {
                var i = b.map(this, e, n);
                return "Until" !== t.slice(-5) && (r = n),
                r && "string" == typeof r && (i = b.filter(r, i)),
                this.length > 1 && (M[t] || b.uniqueSort(i),
                D.test(t) && i.reverse()),
                this.pushStack(i)
            }
        }
        ));
        var q = /[^\x20\t\r\n\f]+/g;
        function N(t) {
            return t
        }
        function j(t) {
            throw t
        }
        function R(t, e, n, r) {
            var i;
            try {
                t && p(i = t.promise) ? i.call(t).done(e).fail(n) : t && p(i = t.then) ? i.call(t, e, n) : e.apply(void 0, [t].slice(r))
            } catch (t) {
                n.apply(void 0, [t])
            }
        }
        b.Callbacks = function(t) {
            t = "string" == typeof t ? function(t) {
                var e = {};
                return b.each(t.match(q) || [], (function(t, n) {
                    e[n] = !0
                }
                )),
                e
            }(t) : b.extend({}, t);
            var e, n, r, i, o = [], s = [], a = -1, u = function() {
                for (i = i || t.once,
                r = e = !0; s.length; a = -1)
                    for (n = s.shift(); ++a < o.length; )
                        !1 === o[a].apply(n[0], n[1]) && t.stopOnFalse && (a = o.length,
                        n = !1);
                t.memory || (n = !1),
                e = !1,
                i && (o = n ? [] : "")
            }, l = {
                add: function() {
                    return o && (n && !e && (a = o.length - 1,
                    s.push(n)),
                    function e(n) {
                        b.each(n, (function(n, r) {
                            p(r) ? t.unique && l.has(r) || o.push(r) : r && r.length && "string" !== x(r) && e(r)
                        }
                        ))
                    }(arguments),
                    n && !e && u()),
                    this
                },
                remove: function() {
                    return b.each(arguments, (function(t, e) {
                        for (var n; (n = b.inArray(e, o, n)) > -1; )
                            o.splice(n, 1),
                            n <= a && a--
                    }
                    )),
                    this
                },
                has: function(t) {
                    return t ? b.inArray(t, o) > -1 : o.length > 0
                },
                empty: function() {
                    return o && (o = []),
                    this
                },
                disable: function() {
                    return i = s = [],
                    o = n = "",
                    this
                },
                disabled: function() {
                    return !o
                },
                lock: function() {
                    return i = s = [],
                    n || e || (o = n = ""),
                    this
                },
                locked: function() {
                    return !!i
                },
                fireWith: function(t, n) {
                    return i || (n = [t, (n = n || []).slice ? n.slice() : n],
                    s.push(n),
                    e || u()),
                    this
                },
                fire: function() {
                    return l.fireWith(this, arguments),
                    this
                },
                fired: function() {
                    return !!r
                }
            };
            return l
        }
        ,
        b.extend({
            Deferred: function(e) {
                var n = [["notify", "progress", b.Callbacks("memory"), b.Callbacks("memory"), 2], ["resolve", "done", b.Callbacks("once memory"), b.Callbacks("once memory"), 0, "resolved"], ["reject", "fail", b.Callbacks("once memory"), b.Callbacks("once memory"), 1, "rejected"]]
                  , r = "pending"
                  , i = {
                    state: function() {
                        return r
                    },
                    always: function() {
                        return o.done(arguments).fail(arguments),
                        this
                    },
                    catch: function(t) {
                        return i.then(null, t)
                    },
                    pipe: function() {
                        var t = arguments;
                        return b.Deferred((function(e) {
                            b.each(n, (function(n, r) {
                                var i = p(t[r[4]]) && t[r[4]];
                                o[r[1]]((function() {
                                    var t = i && i.apply(this, arguments);
                                    t && p(t.promise) ? t.promise().progress(e.notify).done(e.resolve).fail(e.reject) : e[r[0] + "With"](this, i ? [t] : arguments)
                                }
                                ))
                            }
                            )),
                            t = null
                        }
                        )).promise()
                    },
                    then: function(e, r, i) {
                        var o = 0;
                        function s(e, n, r, i) {
                            return function() {
                                var a = this
                                  , u = arguments
                                  , l = function() {
                                    var t, l;
                                    if (!(e < o)) {
                                        if ((t = r.apply(a, u)) === n.promise())
                                            throw new TypeError("Thenable self-resolution");
                                        l = t && ("object" == typeof t || "function" == typeof t) && t.then,
                                        p(l) ? i ? l.call(t, s(o, n, N, i), s(o, n, j, i)) : (o++,
                                        l.call(t, s(o, n, N, i), s(o, n, j, i), s(o, n, N, n.notifyWith))) : (r !== N && (a = void 0,
                                        u = [t]),
                                        (i || n.resolveWith)(a, u))
                                    }
                                }
                                  , c = i ? l : function() {
                                    try {
                                        l()
                                    } catch (t) {
                                        b.Deferred.exceptionHook && b.Deferred.exceptionHook(t, c.stackTrace),
                                        e + 1 >= o && (r !== j && (a = void 0,
                                        u = [t]),
                                        n.rejectWith(a, u))
                                    }
                                }
                                ;
                                e ? c() : (b.Deferred.getStackHook && (c.stackTrace = b.Deferred.getStackHook()),
                                t.setTimeout(c))
                            }
                        }
                        return b.Deferred((function(t) {
                            n[0][3].add(s(0, t, p(i) ? i : N, t.notifyWith)),
                            n[1][3].add(s(0, t, p(e) ? e : N)),
                            n[2][3].add(s(0, t, p(r) ? r : j))
                        }
                        )).promise()
                    },
                    promise: function(t) {
                        return null != t ? b.extend(t, i) : i
                    }
                }
                  , o = {};
                return b.each(n, (function(t, e) {
                    var s = e[2]
                      , a = e[5];
                    i[e[1]] = s.add,
                    a && s.add((function() {
                        r = a
                    }
                    ), n[3 - t][2].disable, n[3 - t][3].disable, n[0][2].lock, n[0][3].lock),
                    s.add(e[3].fire),
                    o[e[0]] = function() {
                        return o[e[0] + "With"](this === o ? void 0 : this, arguments),
                        this
                    }
                    ,
                    o[e[0] + "With"] = s.fireWith
                }
                )),
                i.promise(o),
                e && e.call(o, o),
                o
            },
            when: function(t) {
                var e = arguments.length
                  , n = e
                  , r = Array(n)
                  , o = i.call(arguments)
                  , s = b.Deferred()
                  , a = function(t) {
                    return function(n) {
                        r[t] = this,
                        o[t] = arguments.length > 1 ? i.call(arguments) : n,
                        --e || s.resolveWith(r, o)
                    }
                };
                if (e <= 1 && (R(t, s.done(a(n)).resolve, s.reject, !e),
                "pending" === s.state() || p(o[n] && o[n].then)))
                    return s.then();
                for (; n--; )
                    R(o[n], a(n), s.reject);
                return s.promise()
            }
        });
        var I = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
        b.Deferred.exceptionHook = function(e, n) {
            t.console && t.console.warn && e && I.test(e.name) && t.console.warn("jQuery.Deferred exception: " + e.message, e.stack, n)
        }
        ,
        b.readyException = function(e) {
            t.setTimeout((function() {
                throw e
            }
            ))
        }
        ;
        var F = b.Deferred();
        function B() {
            v.removeEventListener("DOMContentLoaded", B),
            t.removeEventListener("load", B),
            b.ready()
        }
        b.fn.ready = function(t) {
            return F.then(t).catch((function(t) {
                b.readyException(t)
            }
            )),
            this
        }
        ,
        b.extend({
            isReady: !1,
            readyWait: 1,
            ready: function(t) {
                (!0 === t ? --b.readyWait : b.isReady) || (b.isReady = !0,
                !0 !== t && --b.readyWait > 0 || F.resolveWith(v, [b]))
            }
        }),
        b.ready.then = F.then,
        "complete" === v.readyState || "loading" !== v.readyState && !v.documentElement.doScroll ? t.setTimeout(b.ready) : (v.addEventListener("DOMContentLoaded", B),
        t.addEventListener("load", B));
        var H = function(t, e, n, r, i, o, s) {
            var a = 0
              , u = t.length
              , l = null == n;
            if ("object" === x(n))
                for (a in i = !0,
                n)
                    H(t, e, a, n[a], !0, o, s);
            else if (void 0 !== r && (i = !0,
            p(r) || (s = !0),
            l && (s ? (e.call(t, r),
            e = null) : (l = e,
            e = function(t, e, n) {
                return l.call(b(t), n)
            }
            )),
            e))
                for (; a < u; a++)
                    e(t[a], n, s ? r : r.call(t[a], a, e(t[a], n)));
            return i ? t : l ? e.call(t) : u ? e(t[0], n) : o
        }
          , X = /^-ms-/
          , z = /-([a-z])/g;
        function Y(t, e) {
            return e.toUpperCase()
        }
        function W(t) {
            return t.replace(X, "ms-").replace(z, Y)
        }
        var U = function(t) {
            return 1 === t.nodeType || 9 === t.nodeType || !+t.nodeType
        };
        function $() {
            this.expando = b.expando + $.uid++
        }
        $.uid = 1,
        $.prototype = {
            cache: function(t) {
                var e = t[this.expando];
                return e || (e = Object.create(null),
                U(t) && (t.nodeType ? t[this.expando] = e : Object.defineProperty(t, this.expando, {
                    value: e,
                    configurable: !0
                }))),
                e
            },
            set: function(t, e, n) {
                var r, i = this.cache(t);
                if ("string" == typeof e)
                    i[W(e)] = n;
                else
                    for (r in e)
                        i[W(r)] = e[r];
                return i
            },
            get: function(t, e) {
                return void 0 === e ? this.cache(t) : t[this.expando] && t[this.expando][W(e)]
            },
            access: function(t, e, n) {
                return void 0 === e || e && "string" == typeof e && void 0 === n ? this.get(t, e) : (this.set(t, e, n),
                void 0 !== n ? n : e)
            },
            remove: function(t, e) {
                var n, r = t[this.expando];
                if (void 0 !== r) {
                    if (void 0 !== e) {
                        n = (e = Array.isArray(e) ? e.map(W) : (e = W(e))in r ? [e] : e.match(q) || []).length;
                        for (; n--; )
                            delete r[e[n]]
                    }
                    (void 0 === e || b.isEmptyObject(r)) && (t.nodeType ? t[this.expando] = void 0 : delete t[this.expando])
                }
            },
            hasData: function(t) {
                var e = t[this.expando];
                return void 0 !== e && !b.isEmptyObject(e)
            }
        };
        var V = new $
          , G = new $
          , K = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/
          , Q = /[A-Z]/g;
        function J(t, e, n) {
            var r;
            if (void 0 === n && 1 === t.nodeType)
                if (r = "data-" + e.replace(Q, "-$&").toLowerCase(),
                "string" == typeof (n = t.getAttribute(r))) {
                    try {
                        n = function(t) {
                            return "true" === t || "false" !== t && ("null" === t ? null : t === +t + "" ? +t : K.test(t) ? JSON.parse(t) : t)
                        }(n)
                    } catch (t) {}
                    G.set(t, e, n)
                } else
                    n = void 0;
            return n
        }
        b.extend({
            hasData: function(t) {
                return G.hasData(t) || V.hasData(t)
            },
            data: function(t, e, n) {
                return G.access(t, e, n)
            },
            removeData: function(t, e) {
                G.remove(t, e)
            },
            _data: function(t, e, n) {
                return V.access(t, e, n)
            },
            _removeData: function(t, e) {
                V.remove(t, e)
            }
        }),
        b.fn.extend({
            data: function(t, e) {
                var n, r, i, o = this[0], s = o && o.attributes;
                if (void 0 === t) {
                    if (this.length && (i = G.get(o),
                    1 === o.nodeType && !V.get(o, "hasDataAttrs"))) {
                        for (n = s.length; n--; )
                            s[n] && 0 === (r = s[n].name).indexOf("data-") && (r = W(r.slice(5)),
                            J(o, r, i[r]));
                        V.set(o, "hasDataAttrs", !0)
                    }
                    return i
                }
                return "object" == typeof t ? this.each((function() {
                    G.set(this, t)
                }
                )) : H(this, (function(e) {
                    var n;
                    if (o && void 0 === e)
                        return void 0 !== (n = G.get(o, t)) || void 0 !== (n = J(o, t)) ? n : void 0;
                    this.each((function() {
                        G.set(this, t, e)
                    }
                    ))
                }
                ), null, e, arguments.length > 1, null, !0)
            },
            removeData: function(t) {
                return this.each((function() {
                    G.remove(this, t)
                }
                ))
            }
        }),
        b.extend({
            queue: function(t, e, n) {
                var r;
                if (t)
                    return e = (e || "fx") + "queue",
                    r = V.get(t, e),
                    n && (!r || Array.isArray(n) ? r = V.access(t, e, b.makeArray(n)) : r.push(n)),
                    r || []
            },
            dequeue: function(t, e) {
                e = e || "fx";
                var n = b.queue(t, e)
                  , r = n.length
                  , i = n.shift()
                  , o = b._queueHooks(t, e);
                "inprogress" === i && (i = n.shift(),
                r--),
                i && ("fx" === e && n.unshift("inprogress"),
                delete o.stop,
                i.call(t, (function() {
                    b.dequeue(t, e)
                }
                ), o)),
                !r && o && o.empty.fire()
            },
            _queueHooks: function(t, e) {
                var n = e + "queueHooks";
                return V.get(t, n) || V.access(t, n, {
                    empty: b.Callbacks("once memory").add((function() {
                        V.remove(t, [e + "queue", n])
                    }
                    ))
                })
            }
        }),
        b.fn.extend({
            queue: function(t, e) {
                var n = 2;
                return "string" != typeof t && (e = t,
                t = "fx",
                n--),
                arguments.length < n ? b.queue(this[0], t) : void 0 === e ? this : this.each((function() {
                    var n = b.queue(this, t, e);
                    b._queueHooks(this, t),
                    "fx" === t && "inprogress" !== n[0] && b.dequeue(this, t)
                }
                ))
            },
            dequeue: function(t) {
                return this.each((function() {
                    b.dequeue(this, t)
                }
                ))
            },
            clearQueue: function(t) {
                return this.queue(t || "fx", [])
            },
            promise: function(t, e) {
                var n, r = 1, i = b.Deferred(), o = this, s = this.length, a = function() {
                    --r || i.resolveWith(o, [o])
                };
                for ("string" != typeof t && (e = t,
                t = void 0),
                t = t || "fx"; s--; )
                    (n = V.get(o[s], t + "queueHooks")) && n.empty && (r++,
                    n.empty.add(a));
                return a(),
                i.promise(e)
            }
        });
        var Z = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source
          , tt = new RegExp("^(?:([+-])=|)(" + Z + ")([a-z%]*)$","i")
          , et = ["Top", "Right", "Bottom", "Left"]
          , nt = v.documentElement
          , rt = function(t) {
            return b.contains(t.ownerDocument, t)
        }
          , it = {
            composed: !0
        };
        nt.getRootNode && (rt = function(t) {
            return b.contains(t.ownerDocument, t) || t.getRootNode(it) === t.ownerDocument
        }
        );
        var ot = function(t, e) {
            return "none" === (t = e || t).style.display || "" === t.style.display && rt(t) && "none" === b.css(t, "display")
        };
        function st(t, e, n, r) {
            var i, o, s = 20, a = r ? function() {
                return r.cur()
            }
            : function() {
                return b.css(t, e, "")
            }
            , u = a(), l = n && n[3] || (b.cssNumber[e] ? "" : "px"), c = t.nodeType && (b.cssNumber[e] || "px" !== l && +u) && tt.exec(b.css(t, e));
            if (c && c[3] !== l) {
                for (u /= 2,
                l = l || c[3],
                c = +u || 1; s--; )
                    b.style(t, e, c + l),
                    (1 - o) * (1 - (o = a() / u || .5)) <= 0 && (s = 0),
                    c /= o;
                c *= 2,
                b.style(t, e, c + l),
                n = n || []
            }
            return n && (c = +c || +u || 0,
            i = n[1] ? c + (n[1] + 1) * n[2] : +n[2],
            r && (r.unit = l,
            r.start = c,
            r.end = i)),
            i
        }
        var at = {};
        function ut(t) {
            var e, n = t.ownerDocument, r = t.nodeName, i = at[r];
            return i || (e = n.body.appendChild(n.createElement(r)),
            i = b.css(e, "display"),
            e.parentNode.removeChild(e),
            "none" === i && (i = "block"),
            at[r] = i,
            i)
        }
        function lt(t, e) {
            for (var n, r, i = [], o = 0, s = t.length; o < s; o++)
                (r = t[o]).style && (n = r.style.display,
                e ? ("none" === n && (i[o] = V.get(r, "display") || null,
                i[o] || (r.style.display = "")),
                "" === r.style.display && ot(r) && (i[o] = ut(r))) : "none" !== n && (i[o] = "none",
                V.set(r, "display", n)));
            for (o = 0; o < s; o++)
                null != i[o] && (t[o].style.display = i[o]);
            return t
        }
        b.fn.extend({
            show: function() {
                return lt(this, !0)
            },
            hide: function() {
                return lt(this)
            },
            toggle: function(t) {
                return "boolean" == typeof t ? t ? this.show() : this.hide() : this.each((function() {
                    ot(this) ? b(this).show() : b(this).hide()
                }
                ))
            }
        });
        var ct, ft, ht = /^(?:checkbox|radio)$/i, dt = /<([a-z][^\/\0>\x20\t\r\n\f]*)/i, pt = /^$|^module$|\/(?:java|ecma)script/i;
        ct = v.createDocumentFragment().appendChild(v.createElement("div")),
        (ft = v.createElement("input")).setAttribute("type", "radio"),
        ft.setAttribute("checked", "checked"),
        ft.setAttribute("name", "t"),
        ct.appendChild(ft),
        d.checkClone = ct.cloneNode(!0).cloneNode(!0).lastChild.checked,
        ct.innerHTML = "<textarea>x</textarea>",
        d.noCloneChecked = !!ct.cloneNode(!0).lastChild.defaultValue,
        ct.innerHTML = "<option></option>",
        d.option = !!ct.lastChild;
        var gt = {
            thead: [1, "<table>", "</table>"],
            col: [2, "<table><colgroup>", "</colgroup></table>"],
            tr: [2, "<table><tbody>", "</tbody></table>"],
            td: [3, "<table><tbody><tr>", "</tr></tbody></table>"],
            _default: [0, "", ""]
        };
        function vt(t, e) {
            var n;
            return n = void 0 !== t.getElementsByTagName ? t.getElementsByTagName(e || "*") : void 0 !== t.querySelectorAll ? t.querySelectorAll(e || "*") : [],
            void 0 === e || e && E(t, e) ? b.merge([t], n) : n
        }
        function mt(t, e) {
            for (var n = 0, r = t.length; n < r; n++)
                V.set(t[n], "globalEval", !e || V.get(e[n], "globalEval"))
        }
        gt.tbody = gt.tfoot = gt.colgroup = gt.caption = gt.thead,
        gt.th = gt.td,
        d.option || (gt.optgroup = gt.option = [1, "<select multiple='multiple'>", "</select>"]);
        var yt = /<|&#?\w+;/;
        function xt(t, e, n, r, i) {
            for (var o, s, a, u, l, c, f = e.createDocumentFragment(), h = [], d = 0, p = t.length; d < p; d++)
                if ((o = t[d]) || 0 === o)
                    if ("object" === x(o))
                        b.merge(h, o.nodeType ? [o] : o);
                    else if (yt.test(o)) {
                        for (s = s || f.appendChild(e.createElement("div")),
                        a = (dt.exec(o) || ["", ""])[1].toLowerCase(),
                        u = gt[a] || gt._default,
                        s.innerHTML = u[1] + b.htmlPrefilter(o) + u[2],
                        c = u[0]; c--; )
                            s = s.lastChild;
                        b.merge(h, s.childNodes),
                        (s = f.firstChild).textContent = ""
                    } else
                        h.push(e.createTextNode(o));
            for (f.textContent = "",
            d = 0; o = h[d++]; )
                if (r && b.inArray(o, r) > -1)
                    i && i.push(o);
                else if (l = rt(o),
                s = vt(f.appendChild(o), "script"),
                l && mt(s),
                n)
                    for (c = 0; o = s[c++]; )
                        pt.test(o.type || "") && n.push(o);
            return f
        }
        var bt = /^key/
          , wt = /^(?:mouse|pointer|contextmenu|drag|drop)|click/
          , _t = /^([^.]*)(?:\.(.+)|)/;
        function Tt() {
            return !0
        }
        function kt() {
            return !1
        }
        function Ct(t, e) {
            return t === function() {
                try {
                    return v.activeElement
                } catch (t) {}
            }() == ("focus" === e)
        }
        function Et(t, e, n, r, i, o) {
            var s, a;
            if ("object" == typeof e) {
                for (a in "string" != typeof n && (r = r || n,
                n = void 0),
                e)
                    Et(t, a, n, r, e[a], o);
                return t
            }
            if (null == r && null == i ? (i = n,
            r = n = void 0) : null == i && ("string" == typeof n ? (i = r,
            r = void 0) : (i = r,
            r = n,
            n = void 0)),
            !1 === i)
                i = kt;
            else if (!i)
                return t;
            return 1 === o && (s = i,
            (i = function(t) {
                return b().off(t),
                s.apply(this, arguments)
            }
            ).guid = s.guid || (s.guid = b.guid++)),
            t.each((function() {
                b.event.add(this, e, i, r, n)
            }
            ))
        }
        function St(t, e, n) {
            n ? (V.set(t, e, !1),
            b.event.add(t, e, {
                namespace: !1,
                handler: function(t) {
                    var r, o, s = V.get(this, e);
                    if (1 & t.isTrigger && this[e]) {
                        if (s.length)
                            (b.event.special[e] || {}).delegateType && t.stopPropagation();
                        else if (s = i.call(arguments),
                        V.set(this, e, s),
                        r = n(this, e),
                        this[e](),
                        s !== (o = V.get(this, e)) || r ? V.set(this, e, !1) : o = {},
                        s !== o)
                            return t.stopImmediatePropagation(),
                            t.preventDefault(),
                            o.value
                    } else
                        s.length && (V.set(this, e, {
                            value: b.event.trigger(b.extend(s[0], b.Event.prototype), s.slice(1), this)
                        }),
                        t.stopImmediatePropagation())
                }
            })) : void 0 === V.get(t, e) && b.event.add(t, e, Tt)
        }
        b.event = {
            global: {},
            add: function(t, e, n, r, i) {
                var o, s, a, u, l, c, f, h, d, p, g, v = V.get(t);
                if (U(t))
                    for (n.handler && (n = (o = n).handler,
                    i = o.selector),
                    i && b.find.matchesSelector(nt, i),
                    n.guid || (n.guid = b.guid++),
                    (u = v.events) || (u = v.events = Object.create(null)),
                    (s = v.handle) || (s = v.handle = function(e) {
                        return void 0 !== b && b.event.triggered !== e.type ? b.event.dispatch.apply(t, arguments) : void 0
                    }
                    ),
                    l = (e = (e || "").match(q) || [""]).length; l--; )
                        d = g = (a = _t.exec(e[l]) || [])[1],
                        p = (a[2] || "").split(".").sort(),
                        d && (f = b.event.special[d] || {},
                        d = (i ? f.delegateType : f.bindType) || d,
                        f = b.event.special[d] || {},
                        c = b.extend({
                            type: d,
                            origType: g,
                            data: r,
                            handler: n,
                            guid: n.guid,
                            selector: i,
                            needsContext: i && b.expr.match.needsContext.test(i),
                            namespace: p.join(".")
                        }, o),
                        (h = u[d]) || ((h = u[d] = []).delegateCount = 0,
                        f.setup && !1 !== f.setup.call(t, r, p, s) || t.addEventListener && t.addEventListener(d, s)),
                        f.add && (f.add.call(t, c),
                        c.handler.guid || (c.handler.guid = n.guid)),
                        i ? h.splice(h.delegateCount++, 0, c) : h.push(c),
                        b.event.global[d] = !0)
            },
            remove: function(t, e, n, r, i) {
                var o, s, a, u, l, c, f, h, d, p, g, v = V.hasData(t) && V.get(t);
                if (v && (u = v.events)) {
                    for (l = (e = (e || "").match(q) || [""]).length; l--; )
                        if (d = g = (a = _t.exec(e[l]) || [])[1],
                        p = (a[2] || "").split(".").sort(),
                        d) {
                            for (f = b.event.special[d] || {},
                            h = u[d = (r ? f.delegateType : f.bindType) || d] || [],
                            a = a[2] && new RegExp("(^|\\.)" + p.join("\\.(?:.*\\.|)") + "(\\.|$)"),
                            s = o = h.length; o--; )
                                c = h[o],
                                !i && g !== c.origType || n && n.guid !== c.guid || a && !a.test(c.namespace) || r && r !== c.selector && ("**" !== r || !c.selector) || (h.splice(o, 1),
                                c.selector && h.delegateCount--,
                                f.remove && f.remove.call(t, c));
                            s && !h.length && (f.teardown && !1 !== f.teardown.call(t, p, v.handle) || b.removeEvent(t, d, v.handle),
                            delete u[d])
                        } else
                            for (d in u)
                                b.event.remove(t, d + e[l], n, r, !0);
                    b.isEmptyObject(u) && V.remove(t, "handle events")
                }
            },
            dispatch: function(t) {
                var e, n, r, i, o, s, a = new Array(arguments.length), u = b.event.fix(t), l = (V.get(this, "events") || Object.create(null))[u.type] || [], c = b.event.special[u.type] || {};
                for (a[0] = u,
                e = 1; e < arguments.length; e++)
                    a[e] = arguments[e];
                if (u.delegateTarget = this,
                !c.preDispatch || !1 !== c.preDispatch.call(this, u)) {
                    for (s = b.event.handlers.call(this, u, l),
                    e = 0; (i = s[e++]) && !u.isPropagationStopped(); )
                        for (u.currentTarget = i.elem,
                        n = 0; (o = i.handlers[n++]) && !u.isImmediatePropagationStopped(); )
                            u.rnamespace && !1 !== o.namespace && !u.rnamespace.test(o.namespace) || (u.handleObj = o,
                            u.data = o.data,
                            void 0 !== (r = ((b.event.special[o.origType] || {}).handle || o.handler).apply(i.elem, a)) && !1 === (u.result = r) && (u.preventDefault(),
                            u.stopPropagation()));
                    return c.postDispatch && c.postDispatch.call(this, u),
                    u.result
                }
            },
            handlers: function(t, e) {
                var n, r, i, o, s, a = [], u = e.delegateCount, l = t.target;
                if (u && l.nodeType && !("click" === t.type && t.button >= 1))
                    for (; l !== this; l = l.parentNode || this)
                        if (1 === l.nodeType && ("click" !== t.type || !0 !== l.disabled)) {
                            for (o = [],
                            s = {},
                            n = 0; n < u; n++)
                                void 0 === s[i = (r = e[n]).selector + " "] && (s[i] = r.needsContext ? b(i, this).index(l) > -1 : b.find(i, this, null, [l]).length),
                                s[i] && o.push(r);
                            o.length && a.push({
                                elem: l,
                                handlers: o
                            })
                        }
                return l = this,
                u < e.length && a.push({
                    elem: l,
                    handlers: e.slice(u)
                }),
                a
            },
            addProp: function(t, e) {
                Object.defineProperty(b.Event.prototype, t, {
                    enumerable: !0,
                    configurable: !0,
                    get: p(e) ? function() {
                        if (this.originalEvent)
                            return e(this.originalEvent)
                    }
                    : function() {
                        if (this.originalEvent)
                            return this.originalEvent[t]
                    }
                    ,
                    set: function(e) {
                        Object.defineProperty(this, t, {
                            enumerable: !0,
                            configurable: !0,
                            writable: !0,
                            value: e
                        })
                    }
                })
            },
            fix: function(t) {
                return t[b.expando] ? t : new b.Event(t)
            },
            special: {
                load: {
                    noBubble: !0
                },
                click: {
                    setup: function(t) {
                        var e = this || t;
                        return ht.test(e.type) && e.click && E(e, "input") && St(e, "click", Tt),
                        !1
                    },
                    trigger: function(t) {
                        var e = this || t;
                        return ht.test(e.type) && e.click && E(e, "input") && St(e, "click"),
                        !0
                    },
                    _default: function(t) {
                        var e = t.target;
                        return ht.test(e.type) && e.click && E(e, "input") && V.get(e, "click") || E(e, "a")
                    }
                },
                beforeunload: {
                    postDispatch: function(t) {
                        void 0 !== t.result && t.originalEvent && (t.originalEvent.returnValue = t.result)
                    }
                }
            }
        },
        b.removeEvent = function(t, e, n) {
            t.removeEventListener && t.removeEventListener(e, n)
        }
        ,
        b.Event = function(t, e) {
            if (!(this instanceof b.Event))
                return new b.Event(t,e);
            t && t.type ? (this.originalEvent = t,
            this.type = t.type,
            this.isDefaultPrevented = t.defaultPrevented || void 0 === t.defaultPrevented && !1 === t.returnValue ? Tt : kt,
            this.target = t.target && 3 === t.target.nodeType ? t.target.parentNode : t.target,
            this.currentTarget = t.currentTarget,
            this.relatedTarget = t.relatedTarget) : this.type = t,
            e && b.extend(this, e),
            this.timeStamp = t && t.timeStamp || Date.now(),
            this[b.expando] = !0
        }
        ,
        b.Event.prototype = {
            constructor: b.Event,
            isDefaultPrevented: kt,
            isPropagationStopped: kt,
            isImmediatePropagationStopped: kt,
            isSimulated: !1,
            preventDefault: function() {
                var t = this.originalEvent;
                this.isDefaultPrevented = Tt,
                t && !this.isSimulated && t.preventDefault()
            },
            stopPropagation: function() {
                var t = this.originalEvent;
                this.isPropagationStopped = Tt,
                t && !this.isSimulated && t.stopPropagation()
            },
            stopImmediatePropagation: function() {
                var t = this.originalEvent;
                this.isImmediatePropagationStopped = Tt,
                t && !this.isSimulated && t.stopImmediatePropagation(),
                this.stopPropagation()
            }
        },
        b.each({
            altKey: !0,
            bubbles: !0,
            cancelable: !0,
            changedTouches: !0,
            ctrlKey: !0,
            detail: !0,
            eventPhase: !0,
            metaKey: !0,
            pageX: !0,
            pageY: !0,
            shiftKey: !0,
            view: !0,
            char: !0,
            code: !0,
            charCode: !0,
            key: !0,
            keyCode: !0,
            button: !0,
            buttons: !0,
            clientX: !0,
            clientY: !0,
            offsetX: !0,
            offsetY: !0,
            pointerId: !0,
            pointerType: !0,
            screenX: !0,
            screenY: !0,
            targetTouches: !0,
            toElement: !0,
            touches: !0,
            which: function(t) {
                var e = t.button;
                return null == t.which && bt.test(t.type) ? null != t.charCode ? t.charCode : t.keyCode : !t.which && void 0 !== e && wt.test(t.type) ? 1 & e ? 1 : 2 & e ? 3 : 4 & e ? 2 : 0 : t.which
            }
        }, b.event.addProp),
        b.each({
            focus: "focusin",
            blur: "focusout"
        }, (function(t, e) {
            b.event.special[t] = {
                setup: function() {
                    return St(this, t, Ct),
                    !1
                },
                trigger: function() {
                    return St(this, t),
                    !0
                },
                delegateType: e
            }
        }
        )),
        b.each({
            mouseenter: "mouseover",
            mouseleave: "mouseout",
            pointerenter: "pointerover",
            pointerleave: "pointerout"
        }, (function(t, e) {
            b.event.special[t] = {
                delegateType: e,
                bindType: e,
                handle: function(t) {
                    var n, r = this, i = t.relatedTarget, o = t.handleObj;
                    return i && (i === r || b.contains(r, i)) || (t.type = o.origType,
                    n = o.handler.apply(this, arguments),
                    t.type = e),
                    n
                }
            }
        }
        )),
        b.fn.extend({
            on: function(t, e, n, r) {
                return Et(this, t, e, n, r)
            },
            one: function(t, e, n, r) {
                return Et(this, t, e, n, r, 1)
            },
            off: function(t, e, n) {
                var r, i;
                if (t && t.preventDefault && t.handleObj)
                    return r = t.handleObj,
                    b(t.delegateTarget).off(r.namespace ? r.origType + "." + r.namespace : r.origType, r.selector, r.handler),
                    this;
                if ("object" == typeof t) {
                    for (i in t)
                        this.off(i, e, t[i]);
                    return this
                }
                return !1 !== e && "function" != typeof e || (n = e,
                e = void 0),
                !1 === n && (n = kt),
                this.each((function() {
                    b.event.remove(this, t, n, e)
                }
                ))
            }
        });
        var Pt = /<script|<style|<link/i
          , At = /checked\s*(?:[^=]|=\s*.checked.)/i
          , Ot = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;
        function Dt(t, e) {
            return E(t, "table") && E(11 !== e.nodeType ? e : e.firstChild, "tr") && b(t).children("tbody")[0] || t
        }
        function Mt(t) {
            return t.type = (null !== t.getAttribute("type")) + "/" + t.type,
            t
        }
        function Lt(t) {
            return "true/" === (t.type || "").slice(0, 5) ? t.type = t.type.slice(5) : t.removeAttribute("type"),
            t
        }
        function qt(t, e) {
            var n, r, i, o, s, a;
            if (1 === e.nodeType) {
                if (V.hasData(t) && (a = V.get(t).events))
                    for (i in V.remove(e, "handle events"),
                    a)
                        for (n = 0,
                        r = a[i].length; n < r; n++)
                            b.event.add(e, i, a[i][n]);
                G.hasData(t) && (o = G.access(t),
                s = b.extend({}, o),
                G.set(e, s))
            }
        }
        function Nt(t, e) {
            var n = e.nodeName.toLowerCase();
            "input" === n && ht.test(t.type) ? e.checked = t.checked : "input" !== n && "textarea" !== n || (e.defaultValue = t.defaultValue)
        }
        function jt(t, e, n, r) {
            e = o(e);
            var i, s, a, u, l, c, f = 0, h = t.length, g = h - 1, v = e[0], m = p(v);
            if (m || h > 1 && "string" == typeof v && !d.checkClone && At.test(v))
                return t.each((function(i) {
                    var o = t.eq(i);
                    m && (e[0] = v.call(this, i, o.html())),
                    jt(o, e, n, r)
                }
                ));
            if (h && (s = (i = xt(e, t[0].ownerDocument, !1, t, r)).firstChild,
            1 === i.childNodes.length && (i = s),
            s || r)) {
                for (u = (a = b.map(vt(i, "script"), Mt)).length; f < h; f++)
                    l = i,
                    f !== g && (l = b.clone(l, !0, !0),
                    u && b.merge(a, vt(l, "script"))),
                    n.call(t[f], l, f);
                if (u)
                    for (c = a[a.length - 1].ownerDocument,
                    b.map(a, Lt),
                    f = 0; f < u; f++)
                        l = a[f],
                        pt.test(l.type || "") && !V.access(l, "globalEval") && b.contains(c, l) && (l.src && "module" !== (l.type || "").toLowerCase() ? b._evalUrl && !l.noModule && b._evalUrl(l.src, {
                            nonce: l.nonce || l.getAttribute("nonce")
                        }, c) : y(l.textContent.replace(Ot, ""), l, c))
            }
            return t
        }
        function Rt(t, e, n) {
            for (var r, i = e ? b.filter(e, t) : t, o = 0; null != (r = i[o]); o++)
                n || 1 !== r.nodeType || b.cleanData(vt(r)),
                r.parentNode && (n && rt(r) && mt(vt(r, "script")),
                r.parentNode.removeChild(r));
            return t
        }
        b.extend({
            htmlPrefilter: function(t) {
                return t
            },
            clone: function(t, e, n) {
                var r, i, o, s, a = t.cloneNode(!0), u = rt(t);
                if (!(d.noCloneChecked || 1 !== t.nodeType && 11 !== t.nodeType || b.isXMLDoc(t)))
                    for (s = vt(a),
                    r = 0,
                    i = (o = vt(t)).length; r < i; r++)
                        Nt(o[r], s[r]);
                if (e)
                    if (n)
                        for (o = o || vt(t),
                        s = s || vt(a),
                        r = 0,
                        i = o.length; r < i; r++)
                            qt(o[r], s[r]);
                    else
                        qt(t, a);
                return (s = vt(a, "script")).length > 0 && mt(s, !u && vt(t, "script")),
                a
            },
            cleanData: function(t) {
                for (var e, n, r, i = b.event.special, o = 0; void 0 !== (n = t[o]); o++)
                    if (U(n)) {
                        if (e = n[V.expando]) {
                            if (e.events)
                                for (r in e.events)
                                    i[r] ? b.event.remove(n, r) : b.removeEvent(n, r, e.handle);
                            n[V.expando] = void 0
                        }
                        n[G.expando] && (n[G.expando] = void 0)
                    }
            }
        }),
        b.fn.extend({
            detach: function(t) {
                return Rt(this, t, !0)
            },
            remove: function(t) {
                return Rt(this, t)
            },
            text: function(t) {
                return H(this, (function(t) {
                    return void 0 === t ? b.text(this) : this.empty().each((function() {
                        1 !== this.nodeType && 11 !== this.nodeType && 9 !== this.nodeType || (this.textContent = t)
                    }
                    ))
                }
                ), null, t, arguments.length)
            },
            append: function() {
                return jt(this, arguments, (function(t) {
                    1 !== this.nodeType && 11 !== this.nodeType && 9 !== this.nodeType || Dt(this, t).appendChild(t)
                }
                ))
            },
            prepend: function() {
                return jt(this, arguments, (function(t) {
                    if (1 === this.nodeType || 11 === this.nodeType || 9 === this.nodeType) {
                        var e = Dt(this, t);
                        e.insertBefore(t, e.firstChild)
                    }
                }
                ))
            },
            before: function() {
                return jt(this, arguments, (function(t) {
                    this.parentNode && this.parentNode.insertBefore(t, this)
                }
                ))
            },
            after: function() {
                return jt(this, arguments, (function(t) {
                    this.parentNode && this.parentNode.insertBefore(t, this.nextSibling)
                }
                ))
            },
            empty: function() {
                for (var t, e = 0; null != (t = this[e]); e++)
                    1 === t.nodeType && (b.cleanData(vt(t, !1)),
                    t.textContent = "");
                return this
            },
            clone: function(t, e) {
                return t = null != t && t,
                e = null == e ? t : e,
                this.map((function() {
                    return b.clone(this, t, e)
                }
                ))
            },
            html: function(t) {
                return H(this, (function(t) {
                    var e = this[0] || {}
                      , n = 0
                      , r = this.length;
                    if (void 0 === t && 1 === e.nodeType)
                        return e.innerHTML;
                    if ("string" == typeof t && !Pt.test(t) && !gt[(dt.exec(t) || ["", ""])[1].toLowerCase()]) {
                        t = b.htmlPrefilter(t);
                        try {
                            for (; n < r; n++)
                                1 === (e = this[n] || {}).nodeType && (b.cleanData(vt(e, !1)),
                                e.innerHTML = t);
                            e = 0
                        } catch (t) {}
                    }
                    e && this.empty().append(t)
                }
                ), null, t, arguments.length)
            },
            replaceWith: function() {
                var t = [];
                return jt(this, arguments, (function(e) {
                    var n = this.parentNode;
                    b.inArray(this, t) < 0 && (b.cleanData(vt(this)),
                    n && n.replaceChild(e, this))
                }
                ), t)
            }
        }),
        b.each({
            appendTo: "append",
            prependTo: "prepend",
            insertBefore: "before",
            insertAfter: "after",
            replaceAll: "replaceWith"
        }, (function(t, e) {
            b.fn[t] = function(t) {
                for (var n, r = [], i = b(t), o = i.length - 1, a = 0; a <= o; a++)
                    n = a === o ? this : this.clone(!0),
                    b(i[a])[e](n),
                    s.apply(r, n.get());
                return this.pushStack(r)
            }
        }
        ));
        var It = new RegExp("^(" + Z + ")(?!px)[a-z%]+$","i")
          , Ft = function(e) {
            var n = e.ownerDocument.defaultView;
            return n && n.opener || (n = t),
            n.getComputedStyle(e)
        }
          , Bt = function(t, e, n) {
            var r, i, o = {};
            for (i in e)
                o[i] = t.style[i],
                t.style[i] = e[i];
            for (i in r = n.call(t),
            e)
                t.style[i] = o[i];
            return r
        }
          , Ht = new RegExp(et.join("|"),"i");
        function Xt(t, e, n) {
            var r, i, o, s, a = t.style;
            return (n = n || Ft(t)) && ("" !== (s = n.getPropertyValue(e) || n[e]) || rt(t) || (s = b.style(t, e)),
            !d.pixelBoxStyles() && It.test(s) && Ht.test(e) && (r = a.width,
            i = a.minWidth,
            o = a.maxWidth,
            a.minWidth = a.maxWidth = a.width = s,
            s = n.width,
            a.width = r,
            a.minWidth = i,
            a.maxWidth = o)),
            void 0 !== s ? s + "" : s
        }
        function zt(t, e) {
            return {
                get: function() {
                    if (!t())
                        return (this.get = e).apply(this, arguments);
                    delete this.get
                }
            }
        }
        !function() {
            function e() {
                if (c) {
                    l.style.cssText = "position:absolute;left:-11111px;width:60px;margin-top:1px;padding:0;border:0",
                    c.style.cssText = "position:relative;display:block;box-sizing:border-box;overflow:scroll;margin:auto;border:1px;padding:1px;width:60%;top:1%",
                    nt.appendChild(l).appendChild(c);
                    var e = t.getComputedStyle(c);
                    r = "1%" !== e.top,
                    u = 12 === n(e.marginLeft),
                    c.style.right = "60%",
                    s = 36 === n(e.right),
                    i = 36 === n(e.width),
                    c.style.position = "absolute",
                    o = 12 === n(c.offsetWidth / 3),
                    nt.removeChild(l),
                    c = null
                }
            }
            function n(t) {
                return Math.round(parseFloat(t))
            }
            var r, i, o, s, a, u, l = v.createElement("div"), c = v.createElement("div");
            c.style && (c.style.backgroundClip = "content-box",
            c.cloneNode(!0).style.backgroundClip = "",
            d.clearCloneStyle = "content-box" === c.style.backgroundClip,
            b.extend(d, {
                boxSizingReliable: function() {
                    return e(),
                    i
                },
                pixelBoxStyles: function() {
                    return e(),
                    s
                },
                pixelPosition: function() {
                    return e(),
                    r
                },
                reliableMarginLeft: function() {
                    return e(),
                    u
                },
                scrollboxSize: function() {
                    return e(),
                    o
                },
                reliableTrDimensions: function() {
                    var e, n, r, i;
                    return null == a && (e = v.createElement("table"),
                    n = v.createElement("tr"),
                    r = v.createElement("div"),
                    e.style.cssText = "position:absolute;left:-11111px",
                    n.style.height = "1px",
                    r.style.height = "9px",
                    nt.appendChild(e).appendChild(n).appendChild(r),
                    i = t.getComputedStyle(n),
                    a = parseInt(i.height) > 3,
                    nt.removeChild(e)),
                    a
                }
            }))
        }();
        var Yt = ["Webkit", "Moz", "ms"]
          , Wt = v.createElement("div").style
          , Ut = {};
        function $t(t) {
            var e = b.cssProps[t] || Ut[t];
            return e || (t in Wt ? t : Ut[t] = function(t) {
                for (var e = t[0].toUpperCase() + t.slice(1), n = Yt.length; n--; )
                    if ((t = Yt[n] + e)in Wt)
                        return t
            }(t) || t)
        }
        var Vt = /^(none|table(?!-c[ea]).+)/
          , Gt = /^--/
          , Kt = {
            position: "absolute",
            visibility: "hidden",
            display: "block"
        }
          , Qt = {
            letterSpacing: "0",
            fontWeight: "400"
        };
        function Jt(t, e, n) {
            var r = tt.exec(e);
            return r ? Math.max(0, r[2] - (n || 0)) + (r[3] || "px") : e
        }
        function Zt(t, e, n, r, i, o) {
            var s = "width" === e ? 1 : 0
              , a = 0
              , u = 0;
            if (n === (r ? "border" : "content"))
                return 0;
            for (; s < 4; s += 2)
                "margin" === n && (u += b.css(t, n + et[s], !0, i)),
                r ? ("content" === n && (u -= b.css(t, "padding" + et[s], !0, i)),
                "margin" !== n && (u -= b.css(t, "border" + et[s] + "Width", !0, i))) : (u += b.css(t, "padding" + et[s], !0, i),
                "padding" !== n ? u += b.css(t, "border" + et[s] + "Width", !0, i) : a += b.css(t, "border" + et[s] + "Width", !0, i));
            return !r && o >= 0 && (u += Math.max(0, Math.ceil(t["offset" + e[0].toUpperCase() + e.slice(1)] - o - u - a - .5)) || 0),
            u
        }
        function te(t, e, n) {
            var r = Ft(t)
              , i = (!d.boxSizingReliable() || n) && "border-box" === b.css(t, "boxSizing", !1, r)
              , o = i
              , s = Xt(t, e, r)
              , a = "offset" + e[0].toUpperCase() + e.slice(1);
            if (It.test(s)) {
                if (!n)
                    return s;
                s = "auto"
            }
            return (!d.boxSizingReliable() && i || !d.reliableTrDimensions() && E(t, "tr") || "auto" === s || !parseFloat(s) && "inline" === b.css(t, "display", !1, r)) && t.getClientRects().length && (i = "border-box" === b.css(t, "boxSizing", !1, r),
            (o = a in t) && (s = t[a])),
            (s = parseFloat(s) || 0) + Zt(t, e, n || (i ? "border" : "content"), o, r, s) + "px"
        }
        function ee(t, e, n, r, i) {
            return new ee.prototype.init(t,e,n,r,i)
        }
        b.extend({
            cssHooks: {
                opacity: {
                    get: function(t, e) {
                        if (e) {
                            var n = Xt(t, "opacity");
                            return "" === n ? "1" : n
                        }
                    }
                }
            },
            cssNumber: {
                animationIterationCount: !0,
                columnCount: !0,
                fillOpacity: !0,
                flexGrow: !0,
                flexShrink: !0,
                fontWeight: !0,
                gridArea: !0,
                gridColumn: !0,
                gridColumnEnd: !0,
                gridColumnStart: !0,
                gridRow: !0,
                gridRowEnd: !0,
                gridRowStart: !0,
                lineHeight: !0,
                opacity: !0,
                order: !0,
                orphans: !0,
                widows: !0,
                zIndex: !0,
                zoom: !0
            },
            cssProps: {},
            style: function(t, e, n, r) {
                if (t && 3 !== t.nodeType && 8 !== t.nodeType && t.style) {
                    var i, o, s, a = W(e), u = Gt.test(e), l = t.style;
                    if (u || (e = $t(a)),
                    s = b.cssHooks[e] || b.cssHooks[a],
                    void 0 === n)
                        return s && "get"in s && void 0 !== (i = s.get(t, !1, r)) ? i : l[e];
                    "string" === (o = typeof n) && (i = tt.exec(n)) && i[1] && (n = st(t, e, i),
                    o = "number"),
                    null != n && n == n && ("number" !== o || u || (n += i && i[3] || (b.cssNumber[a] ? "" : "px")),
                    d.clearCloneStyle || "" !== n || 0 !== e.indexOf("background") || (l[e] = "inherit"),
                    s && "set"in s && void 0 === (n = s.set(t, n, r)) || (u ? l.setProperty(e, n) : l[e] = n))
                }
            },
            css: function(t, e, n, r) {
                var i, o, s, a = W(e);
                return Gt.test(e) || (e = $t(a)),
                (s = b.cssHooks[e] || b.cssHooks[a]) && "get"in s && (i = s.get(t, !0, n)),
                void 0 === i && (i = Xt(t, e, r)),
                "normal" === i && e in Qt && (i = Qt[e]),
                "" === n || n ? (o = parseFloat(i),
                !0 === n || isFinite(o) ? o || 0 : i) : i
            }
        }),
        b.each(["height", "width"], (function(t, e) {
            b.cssHooks[e] = {
                get: function(t, n, r) {
                    if (n)
                        return !Vt.test(b.css(t, "display")) || t.getClientRects().length && t.getBoundingClientRect().width ? te(t, e, r) : Bt(t, Kt, (function() {
                            return te(t, e, r)
                        }
                        ))
                },
                set: function(t, n, r) {
                    var i, o = Ft(t), s = !d.scrollboxSize() && "absolute" === o.position, a = (s || r) && "border-box" === b.css(t, "boxSizing", !1, o), u = r ? Zt(t, e, r, a, o) : 0;
                    return a && s && (u -= Math.ceil(t["offset" + e[0].toUpperCase() + e.slice(1)] - parseFloat(o[e]) - Zt(t, e, "border", !1, o) - .5)),
                    u && (i = tt.exec(n)) && "px" !== (i[3] || "px") && (t.style[e] = n,
                    n = b.css(t, e)),
                    Jt(0, n, u)
                }
            }
        }
        )),
        b.cssHooks.marginLeft = zt(d.reliableMarginLeft, (function(t, e) {
            if (e)
                return (parseFloat(Xt(t, "marginLeft")) || t.getBoundingClientRect().left - Bt(t, {
                    marginLeft: 0
                }, (function() {
                    return t.getBoundingClientRect().left
                }
                ))) + "px"
        }
        )),
        b.each({
            margin: "",
            padding: "",
            border: "Width"
        }, (function(t, e) {
            b.cssHooks[t + e] = {
                expand: function(n) {
                    for (var r = 0, i = {}, o = "string" == typeof n ? n.split(" ") : [n]; r < 4; r++)
                        i[t + et[r] + e] = o[r] || o[r - 2] || o[0];
                    return i
                }
            },
            "margin" !== t && (b.cssHooks[t + e].set = Jt)
        }
        )),
        b.fn.extend({
            css: function(t, e) {
                return H(this, (function(t, e, n) {
                    var r, i, o = {}, s = 0;
                    if (Array.isArray(e)) {
                        for (r = Ft(t),
                        i = e.length; s < i; s++)
                            o[e[s]] = b.css(t, e[s], !1, r);
                        return o
                    }
                    return void 0 !== n ? b.style(t, e, n) : b.css(t, e)
                }
                ), t, e, arguments.length > 1)
            }
        }),
        b.Tween = ee,
        ee.prototype = {
            constructor: ee,
            init: function(t, e, n, r, i, o) {
                this.elem = t,
                this.prop = n,
                this.easing = i || b.easing._default,
                this.options = e,
                this.start = this.now = this.cur(),
                this.end = r,
                this.unit = o || (b.cssNumber[n] ? "" : "px")
            },
            cur: function() {
                var t = ee.propHooks[this.prop];
                return t && t.get ? t.get(this) : ee.propHooks._default.get(this)
            },
            run: function(t) {
                var e, n = ee.propHooks[this.prop];
                return this.options.duration ? this.pos = e = b.easing[this.easing](t, this.options.duration * t, 0, 1, this.options.duration) : this.pos = e = t,
                this.now = (this.end - this.start) * e + this.start,
                this.options.step && this.options.step.call(this.elem, this.now, this),
                n && n.set ? n.set(this) : ee.propHooks._default.set(this),
                this
            }
        },
        ee.prototype.init.prototype = ee.prototype,
        ee.propHooks = {
            _default: {
                get: function(t) {
                    var e;
                    return 1 !== t.elem.nodeType || null != t.elem[t.prop] && null == t.elem.style[t.prop] ? t.elem[t.prop] : (e = b.css(t.elem, t.prop, "")) && "auto" !== e ? e : 0
                },
                set: function(t) {
                    b.fx.step[t.prop] ? b.fx.step[t.prop](t) : 1 !== t.elem.nodeType || !b.cssHooks[t.prop] && null == t.elem.style[$t(t.prop)] ? t.elem[t.prop] = t.now : b.style(t.elem, t.prop, t.now + t.unit)
                }
            }
        },
        ee.propHooks.scrollTop = ee.propHooks.scrollLeft = {
            set: function(t) {
                t.elem.nodeType && t.elem.parentNode && (t.elem[t.prop] = t.now)
            }
        },
        b.easing = {
            linear: function(t) {
                return t
            },
            swing: function(t) {
                return .5 - Math.cos(t * Math.PI) / 2
            },
            _default: "swing"
        },
        b.fx = ee.prototype.init,
        b.fx.step = {};
        var ne, re, ie = /^(?:toggle|show|hide)$/, oe = /queueHooks$/;
        function se() {
            re && (!1 === v.hidden && t.requestAnimationFrame ? t.requestAnimationFrame(se) : t.setTimeout(se, b.fx.interval),
            b.fx.tick())
        }
        function ae() {
            return t.setTimeout((function() {
                ne = void 0
            }
            )),
            ne = Date.now()
        }
        function ue(t, e) {
            var n, r = 0, i = {
                height: t
            };
            for (e = e ? 1 : 0; r < 4; r += 2 - e)
                i["margin" + (n = et[r])] = i["padding" + n] = t;
            return e && (i.opacity = i.width = t),
            i
        }
        function le(t, e, n) {
            for (var r, i = (ce.tweeners[e] || []).concat(ce.tweeners["*"]), o = 0, s = i.length; o < s; o++)
                if (r = i[o].call(n, e, t))
                    return r
        }
        function ce(t, e, n) {
            var r, i, o = 0, s = ce.prefilters.length, a = b.Deferred().always((function() {
                delete u.elem
            }
            )), u = function() {
                if (i)
                    return !1;
                for (var e = ne || ae(), n = Math.max(0, l.startTime + l.duration - e), r = 1 - (n / l.duration || 0), o = 0, s = l.tweens.length; o < s; o++)
                    l.tweens[o].run(r);
                return a.notifyWith(t, [l, r, n]),
                r < 1 && s ? n : (s || a.notifyWith(t, [l, 1, 0]),
                a.resolveWith(t, [l]),
                !1)
            }, l = a.promise({
                elem: t,
                props: b.extend({}, e),
                opts: b.extend(!0, {
                    specialEasing: {},
                    easing: b.easing._default
                }, n),
                originalProperties: e,
                originalOptions: n,
                startTime: ne || ae(),
                duration: n.duration,
                tweens: [],
                createTween: function(e, n) {
                    var r = b.Tween(t, l.opts, e, n, l.opts.specialEasing[e] || l.opts.easing);
                    return l.tweens.push(r),
                    r
                },
                stop: function(e) {
                    var n = 0
                      , r = e ? l.tweens.length : 0;
                    if (i)
                        return this;
                    for (i = !0; n < r; n++)
                        l.tweens[n].run(1);
                    return e ? (a.notifyWith(t, [l, 1, 0]),
                    a.resolveWith(t, [l, e])) : a.rejectWith(t, [l, e]),
                    this
                }
            }), c = l.props;
            for (!function(t, e) {
                var n, r, i, o, s;
                for (n in t)
                    if (i = e[r = W(n)],
                    o = t[n],
                    Array.isArray(o) && (i = o[1],
                    o = t[n] = o[0]),
                    n !== r && (t[r] = o,
                    delete t[n]),
                    (s = b.cssHooks[r]) && "expand"in s)
                        for (n in o = s.expand(o),
                        delete t[r],
                        o)
                            n in t || (t[n] = o[n],
                            e[n] = i);
                    else
                        e[r] = i
            }(c, l.opts.specialEasing); o < s; o++)
                if (r = ce.prefilters[o].call(l, t, c, l.opts))
                    return p(r.stop) && (b._queueHooks(l.elem, l.opts.queue).stop = r.stop.bind(r)),
                    r;
            return b.map(c, le, l),
            p(l.opts.start) && l.opts.start.call(t, l),
            l.progress(l.opts.progress).done(l.opts.done, l.opts.complete).fail(l.opts.fail).always(l.opts.always),
            b.fx.timer(b.extend(u, {
                elem: t,
                anim: l,
                queue: l.opts.queue
            })),
            l
        }
        b.Animation = b.extend(ce, {
            tweeners: {
                "*": [function(t, e) {
                    var n = this.createTween(t, e);
                    return st(n.elem, t, tt.exec(e), n),
                    n
                }
                ]
            },
            tweener: function(t, e) {
                p(t) ? (e = t,
                t = ["*"]) : t = t.match(q);
                for (var n, r = 0, i = t.length; r < i; r++)
                    n = t[r],
                    ce.tweeners[n] = ce.tweeners[n] || [],
                    ce.tweeners[n].unshift(e)
            },
            prefilters: [function(t, e, n) {
                var r, i, o, s, a, u, l, c, f = "width"in e || "height"in e, h = this, d = {}, p = t.style, g = t.nodeType && ot(t), v = V.get(t, "fxshow");
                for (r in n.queue || (null == (s = b._queueHooks(t, "fx")).unqueued && (s.unqueued = 0,
                a = s.empty.fire,
                s.empty.fire = function() {
                    s.unqueued || a()
                }
                ),
                s.unqueued++,
                h.always((function() {
                    h.always((function() {
                        s.unqueued--,
                        b.queue(t, "fx").length || s.empty.fire()
                    }
                    ))
                }
                ))),
                e)
                    if (i = e[r],
                    ie.test(i)) {
                        if (delete e[r],
                        o = o || "toggle" === i,
                        i === (g ? "hide" : "show")) {
                            if ("show" !== i || !v || void 0 === v[r])
                                continue;
                            g = !0
                        }
                        d[r] = v && v[r] || b.style(t, r)
                    }
                if ((u = !b.isEmptyObject(e)) || !b.isEmptyObject(d))
                    for (r in f && 1 === t.nodeType && (n.overflow = [p.overflow, p.overflowX, p.overflowY],
                    null == (l = v && v.display) && (l = V.get(t, "display")),
                    "none" === (c = b.css(t, "display")) && (l ? c = l : (lt([t], !0),
                    l = t.style.display || l,
                    c = b.css(t, "display"),
                    lt([t]))),
                    ("inline" === c || "inline-block" === c && null != l) && "none" === b.css(t, "float") && (u || (h.done((function() {
                        p.display = l
                    }
                    )),
                    null == l && (c = p.display,
                    l = "none" === c ? "" : c)),
                    p.display = "inline-block")),
                    n.overflow && (p.overflow = "hidden",
                    h.always((function() {
                        p.overflow = n.overflow[0],
                        p.overflowX = n.overflow[1],
                        p.overflowY = n.overflow[2]
                    }
                    ))),
                    u = !1,
                    d)
                        u || (v ? "hidden"in v && (g = v.hidden) : v = V.access(t, "fxshow", {
                            display: l
                        }),
                        o && (v.hidden = !g),
                        g && lt([t], !0),
                        h.done((function() {
                            for (r in g || lt([t]),
                            V.remove(t, "fxshow"),
                            d)
                                b.style(t, r, d[r])
                        }
                        ))),
                        u = le(g ? v[r] : 0, r, h),
                        r in v || (v[r] = u.start,
                        g && (u.end = u.start,
                        u.start = 0))
            }
            ],
            prefilter: function(t, e) {
                e ? ce.prefilters.unshift(t) : ce.prefilters.push(t)
            }
        }),
        b.speed = function(t, e, n) {
            var r = t && "object" == typeof t ? b.extend({}, t) : {
                complete: n || !n && e || p(t) && t,
                duration: t,
                easing: n && e || e && !p(e) && e
            };
            return b.fx.off ? r.duration = 0 : "number" != typeof r.duration && (r.duration in b.fx.speeds ? r.duration = b.fx.speeds[r.duration] : r.duration = b.fx.speeds._default),
            null != r.queue && !0 !== r.queue || (r.queue = "fx"),
            r.old = r.complete,
            r.complete = function() {
                p(r.old) && r.old.call(this),
                r.queue && b.dequeue(this, r.queue)
            }
            ,
            r
        }
        ,
        b.fn.extend({
            fadeTo: function(t, e, n, r) {
                return this.filter(ot).css("opacity", 0).show().end().animate({
                    opacity: e
                }, t, n, r)
            },
            animate: function(t, e, n, r) {
                var i = b.isEmptyObject(t)
                  , o = b.speed(e, n, r)
                  , s = function() {
                    var e = ce(this, b.extend({}, t), o);
                    (i || V.get(this, "finish")) && e.stop(!0)
                };
                return s.finish = s,
                i || !1 === o.queue ? this.each(s) : this.queue(o.queue, s)
            },
            stop: function(t, e, n) {
                var r = function(t) {
                    var e = t.stop;
                    delete t.stop,
                    e(n)
                };
                return "string" != typeof t && (n = e,
                e = t,
                t = void 0),
                e && this.queue(t || "fx", []),
                this.each((function() {
                    var e = !0
                      , i = null != t && t + "queueHooks"
                      , o = b.timers
                      , s = V.get(this);
                    if (i)
                        s[i] && s[i].stop && r(s[i]);
                    else
                        for (i in s)
                            s[i] && s[i].stop && oe.test(i) && r(s[i]);
                    for (i = o.length; i--; )
                        o[i].elem !== this || null != t && o[i].queue !== t || (o[i].anim.stop(n),
                        e = !1,
                        o.splice(i, 1));
                    !e && n || b.dequeue(this, t)
                }
                ))
            },
            finish: function(t) {
                return !1 !== t && (t = t || "fx"),
                this.each((function() {
                    var e, n = V.get(this), r = n[t + "queue"], i = n[t + "queueHooks"], o = b.timers, s = r ? r.length : 0;
                    for (n.finish = !0,
                    b.queue(this, t, []),
                    i && i.stop && i.stop.call(this, !0),
                    e = o.length; e--; )
                        o[e].elem === this && o[e].queue === t && (o[e].anim.stop(!0),
                        o.splice(e, 1));
                    for (e = 0; e < s; e++)
                        r[e] && r[e].finish && r[e].finish.call(this);
                    delete n.finish
                }
                ))
            }
        }),
        b.each(["toggle", "show", "hide"], (function(t, e) {
            var n = b.fn[e];
            b.fn[e] = function(t, r, i) {
                return null == t || "boolean" == typeof t ? n.apply(this, arguments) : this.animate(ue(e, !0), t, r, i)
            }
        }
        )),
        b.each({
            slideDown: ue("show"),
            slideUp: ue("hide"),
            slideToggle: ue("toggle"),
            fadeIn: {
                opacity: "show"
            },
            fadeOut: {
                opacity: "hide"
            },
            fadeToggle: {
                opacity: "toggle"
            }
        }, (function(t, e) {
            b.fn[t] = function(t, n, r) {
                return this.animate(e, t, n, r)
            }
        }
        )),
        b.timers = [],
        b.fx.tick = function() {
            var t, e = 0, n = b.timers;
            for (ne = Date.now(); e < n.length; e++)
                (t = n[e])() || n[e] !== t || n.splice(e--, 1);
            n.length || b.fx.stop(),
            ne = void 0
        }
        ,
        b.fx.timer = function(t) {
            b.timers.push(t),
            b.fx.start()
        }
        ,
        b.fx.interval = 13,
        b.fx.start = function() {
            re || (re = !0,
            se())
        }
        ,
        b.fx.stop = function() {
            re = null
        }
        ,
        b.fx.speeds = {
            slow: 600,
            fast: 200,
            _default: 400
        },
        b.fn.delay = function(e, n) {
            return e = b.fx && b.fx.speeds[e] || e,
            n = n || "fx",
            this.queue(n, (function(n, r) {
                var i = t.setTimeout(n, e);
                r.stop = function() {
                    t.clearTimeout(i)
                }
            }
            ))
        }
        ,
        function() {
            var t = v.createElement("input")
              , e = v.createElement("select").appendChild(v.createElement("option"));
            t.type = "checkbox",
            d.checkOn = "" !== t.value,
            d.optSelected = e.selected,
            (t = v.createElement("input")).value = "t",
            t.type = "radio",
            d.radioValue = "t" === t.value
        }();
        var fe, he = b.expr.attrHandle;
        b.fn.extend({
            attr: function(t, e) {
                return H(this, b.attr, t, e, arguments.length > 1)
            },
            removeAttr: function(t) {
                return this.each((function() {
                    b.removeAttr(this, t)
                }
                ))
            }
        }),
        b.extend({
            attr: function(t, e, n) {
                var r, i, o = t.nodeType;
                if (3 !== o && 8 !== o && 2 !== o)
                    return void 0 === t.getAttribute ? b.prop(t, e, n) : (1 === o && b.isXMLDoc(t) || (i = b.attrHooks[e.toLowerCase()] || (b.expr.match.bool.test(e) ? fe : void 0)),
                    void 0 !== n ? null === n ? void b.removeAttr(t, e) : i && "set"in i && void 0 !== (r = i.set(t, n, e)) ? r : (t.setAttribute(e, n + ""),
                    n) : i && "get"in i && null !== (r = i.get(t, e)) ? r : null == (r = b.find.attr(t, e)) ? void 0 : r)
            },
            attrHooks: {
                type: {
                    set: function(t, e) {
                        if (!d.radioValue && "radio" === e && E(t, "input")) {
                            var n = t.value;
                            return t.setAttribute("type", e),
                            n && (t.value = n),
                            e
                        }
                    }
                }
            },
            removeAttr: function(t, e) {
                var n, r = 0, i = e && e.match(q);
                if (i && 1 === t.nodeType)
                    for (; n = i[r++]; )
                        t.removeAttribute(n)
            }
        }),
        fe = {
            set: function(t, e, n) {
                return !1 === e ? b.removeAttr(t, n) : t.setAttribute(n, n),
                n
            }
        },
        b.each(b.expr.match.bool.source.match(/\w+/g), (function(t, e) {
            var n = he[e] || b.find.attr;
            he[e] = function(t, e, r) {
                var i, o, s = e.toLowerCase();
                return r || (o = he[s],
                he[s] = i,
                i = null != n(t, e, r) ? s : null,
                he[s] = o),
                i
            }
        }
        ));
        var de = /^(?:input|select|textarea|button)$/i
          , pe = /^(?:a|area)$/i;
        function ge(t) {
            return (t.match(q) || []).join(" ")
        }
        function ve(t) {
            return t.getAttribute && t.getAttribute("class") || ""
        }
        function me(t) {
            return Array.isArray(t) ? t : "string" == typeof t && t.match(q) || []
        }
        b.fn.extend({
            prop: function(t, e) {
                return H(this, b.prop, t, e, arguments.length > 1)
            },
            removeProp: function(t) {
                return this.each((function() {
                    delete this[b.propFix[t] || t]
                }
                ))
            }
        }),
        b.extend({
            prop: function(t, e, n) {
                var r, i, o = t.nodeType;
                if (3 !== o && 8 !== o && 2 !== o)
                    return 1 === o && b.isXMLDoc(t) || (e = b.propFix[e] || e,
                    i = b.propHooks[e]),
                    void 0 !== n ? i && "set"in i && void 0 !== (r = i.set(t, n, e)) ? r : t[e] = n : i && "get"in i && null !== (r = i.get(t, e)) ? r : t[e]
            },
            propHooks: {
                tabIndex: {
                    get: function(t) {
                        var e = b.find.attr(t, "tabindex");
                        return e ? parseInt(e, 10) : de.test(t.nodeName) || pe.test(t.nodeName) && t.href ? 0 : -1
                    }
                }
            },
            propFix: {
                for: "htmlFor",
                class: "className"
            }
        }),
        d.optSelected || (b.propHooks.selected = {
            get: function(t) {
                var e = t.parentNode;
                return e && e.parentNode && e.parentNode.selectedIndex,
                null
            },
            set: function(t) {
                var e = t.parentNode;
                e && (e.selectedIndex,
                e.parentNode && e.parentNode.selectedIndex)
            }
        }),
        b.each(["tabIndex", "readOnly", "maxLength", "cellSpacing", "cellPadding", "rowSpan", "colSpan", "useMap", "frameBorder", "contentEditable"], (function() {
            b.propFix[this.toLowerCase()] = this
        }
        )),
        b.fn.extend({
            addClass: function(t) {
                var e, n, r, i, o, s, a, u = 0;
                if (p(t))
                    return this.each((function(e) {
                        b(this).addClass(t.call(this, e, ve(this)))
                    }
                    ));
                if ((e = me(t)).length)
                    for (; n = this[u++]; )
                        if (i = ve(n),
                        r = 1 === n.nodeType && " " + ge(i) + " ") {
                            for (s = 0; o = e[s++]; )
                                r.indexOf(" " + o + " ") < 0 && (r += o + " ");
                            i !== (a = ge(r)) && n.setAttribute("class", a)
                        }
                return this
            },
            removeClass: function(t) {
                var e, n, r, i, o, s, a, u = 0;
                if (p(t))
                    return this.each((function(e) {
                        b(this).removeClass(t.call(this, e, ve(this)))
                    }
                    ));
                if (!arguments.length)
                    return this.attr("class", "");
                if ((e = me(t)).length)
                    for (; n = this[u++]; )
                        if (i = ve(n),
                        r = 1 === n.nodeType && " " + ge(i) + " ") {
                            for (s = 0; o = e[s++]; )
                                for (; r.indexOf(" " + o + " ") > -1; )
                                    r = r.replace(" " + o + " ", " ");
                            i !== (a = ge(r)) && n.setAttribute("class", a)
                        }
                return this
            },
            toggleClass: function(t, e) {
                var n = typeof t
                  , r = "string" === n || Array.isArray(t);
                return "boolean" == typeof e && r ? e ? this.addClass(t) : this.removeClass(t) : p(t) ? this.each((function(n) {
                    b(this).toggleClass(t.call(this, n, ve(this), e), e)
                }
                )) : this.each((function() {
                    var e, i, o, s;
                    if (r)
                        for (i = 0,
                        o = b(this),
                        s = me(t); e = s[i++]; )
                            o.hasClass(e) ? o.removeClass(e) : o.addClass(e);
                    else
                        void 0 !== t && "boolean" !== n || ((e = ve(this)) && V.set(this, "__className__", e),
                        this.setAttribute && this.setAttribute("class", e || !1 === t ? "" : V.get(this, "__className__") || ""))
                }
                ))
            },
            hasClass: function(t) {
                var e, n, r = 0;
                for (e = " " + t + " "; n = this[r++]; )
                    if (1 === n.nodeType && (" " + ge(ve(n)) + " ").indexOf(e) > -1)
                        return !0;
                return !1
            }
        });
        var ye = /\r/g;
        b.fn.extend({
            val: function(t) {
                var e, n, r, i = this[0];
                return arguments.length ? (r = p(t),
                this.each((function(n) {
                    var i;
                    1 === this.nodeType && (null == (i = r ? t.call(this, n, b(this).val()) : t) ? i = "" : "number" == typeof i ? i += "" : Array.isArray(i) && (i = b.map(i, (function(t) {
                        return null == t ? "" : t + ""
                    }
                    ))),
                    (e = b.valHooks[this.type] || b.valHooks[this.nodeName.toLowerCase()]) && "set"in e && void 0 !== e.set(this, i, "value") || (this.value = i))
                }
                ))) : i ? (e = b.valHooks[i.type] || b.valHooks[i.nodeName.toLowerCase()]) && "get"in e && void 0 !== (n = e.get(i, "value")) ? n : "string" == typeof (n = i.value) ? n.replace(ye, "") : null == n ? "" : n : void 0
            }
        }),
        b.extend({
            valHooks: {
                option: {
                    get: function(t) {
                        var e = b.find.attr(t, "value");
                        return null != e ? e : ge(b.text(t))
                    }
                },
                select: {
                    get: function(t) {
                        var e, n, r, i = t.options, o = t.selectedIndex, s = "select-one" === t.type, a = s ? null : [], u = s ? o + 1 : i.length;
                        for (r = o < 0 ? u : s ? o : 0; r < u; r++)
                            if (((n = i[r]).selected || r === o) && !n.disabled && (!n.parentNode.disabled || !E(n.parentNode, "optgroup"))) {
                                if (e = b(n).val(),
                                s)
                                    return e;
                                a.push(e)
                            }
                        return a
                    },
                    set: function(t, e) {
                        for (var n, r, i = t.options, o = b.makeArray(e), s = i.length; s--; )
                            ((r = i[s]).selected = b.inArray(b.valHooks.option.get(r), o) > -1) && (n = !0);
                        return n || (t.selectedIndex = -1),
                        o
                    }
                }
            }
        }),
        b.each(["radio", "checkbox"], (function() {
            b.valHooks[this] = {
                set: function(t, e) {
                    if (Array.isArray(e))
                        return t.checked = b.inArray(b(t).val(), e) > -1
                }
            },
            d.checkOn || (b.valHooks[this].get = function(t) {
                return null === t.getAttribute("value") ? "on" : t.value
            }
            )
        }
        )),
        d.focusin = "onfocusin"in t;
        var xe = /^(?:focusinfocus|focusoutblur)$/
          , be = function(t) {
            t.stopPropagation()
        };
        b.extend(b.event, {
            trigger: function(e, n, r, i) {
                var o, s, a, u, l, f, h, d, m = [r || v], y = c.call(e, "type") ? e.type : e, x = c.call(e, "namespace") ? e.namespace.split(".") : [];
                if (s = d = a = r = r || v,
                3 !== r.nodeType && 8 !== r.nodeType && !xe.test(y + b.event.triggered) && (y.indexOf(".") > -1 && (x = y.split("."),
                y = x.shift(),
                x.sort()),
                l = y.indexOf(":") < 0 && "on" + y,
                (e = e[b.expando] ? e : new b.Event(y,"object" == typeof e && e)).isTrigger = i ? 2 : 3,
                e.namespace = x.join("."),
                e.rnamespace = e.namespace ? new RegExp("(^|\\.)" + x.join("\\.(?:.*\\.|)") + "(\\.|$)") : null,
                e.result = void 0,
                e.target || (e.target = r),
                n = null == n ? [e] : b.makeArray(n, [e]),
                h = b.event.special[y] || {},
                i || !h.trigger || !1 !== h.trigger.apply(r, n))) {
                    if (!i && !h.noBubble && !g(r)) {
                        for (u = h.delegateType || y,
                        xe.test(u + y) || (s = s.parentNode); s; s = s.parentNode)
                            m.push(s),
                            a = s;
                        a === (r.ownerDocument || v) && m.push(a.defaultView || a.parentWindow || t)
                    }
                    for (o = 0; (s = m[o++]) && !e.isPropagationStopped(); )
                        d = s,
                        e.type = o > 1 ? u : h.bindType || y,
                        (f = (V.get(s, "events") || Object.create(null))[e.type] && V.get(s, "handle")) && f.apply(s, n),
                        (f = l && s[l]) && f.apply && U(s) && (e.result = f.apply(s, n),
                        !1 === e.result && e.preventDefault());
                    return e.type = y,
                    i || e.isDefaultPrevented() || h._default && !1 !== h._default.apply(m.pop(), n) || !U(r) || l && p(r[y]) && !g(r) && ((a = r[l]) && (r[l] = null),
                    b.event.triggered = y,
                    e.isPropagationStopped() && d.addEventListener(y, be),
                    r[y](),
                    e.isPropagationStopped() && d.removeEventListener(y, be),
                    b.event.triggered = void 0,
                    a && (r[l] = a)),
                    e.result
                }
            },
            simulate: function(t, e, n) {
                var r = b.extend(new b.Event, n, {
                    type: t,
                    isSimulated: !0
                });
                b.event.trigger(r, null, e)
            }
        }),
        b.fn.extend({
            trigger: function(t, e) {
                return this.each((function() {
                    b.event.trigger(t, e, this)
                }
                ))
            },
            triggerHandler: function(t, e) {
                var n = this[0];
                if (n)
                    return b.event.trigger(t, e, n, !0)
            }
        }),
        d.focusin || b.each({
            focus: "focusin",
            blur: "focusout"
        }, (function(t, e) {
            var n = function(t) {
                b.event.simulate(e, t.target, b.event.fix(t))
            };
            b.event.special[e] = {
                setup: function() {
                    var r = this.ownerDocument || this.document || this
                      , i = V.access(r, e);
                    i || r.addEventListener(t, n, !0),
                    V.access(r, e, (i || 0) + 1)
                },
                teardown: function() {
                    var r = this.ownerDocument || this.document || this
                      , i = V.access(r, e) - 1;
                    i ? V.access(r, e, i) : (r.removeEventListener(t, n, !0),
                    V.remove(r, e))
                }
            }
        }
        ));
        var we = t.location
          , _e = {
            guid: Date.now()
        }
          , Te = /\?/;
        b.parseXML = function(e) {
            var n;
            if (!e || "string" != typeof e)
                return null;
            try {
                n = (new t.DOMParser).parseFromString(e, "text/xml")
            } catch (t) {
                n = void 0
            }
            return n && !n.getElementsByTagName("parsererror").length || b.error("Invalid XML: " + e),
            n
        }
        ;
        var ke = /\[\]$/
          , Ce = /\r?\n/g
          , Ee = /^(?:submit|button|image|reset|file)$/i
          , Se = /^(?:input|select|textarea|keygen)/i;
        function Pe(t, e, n, r) {
            var i;
            if (Array.isArray(e))
                b.each(e, (function(e, i) {
                    n || ke.test(t) ? r(t, i) : Pe(t + "[" + ("object" == typeof i && null != i ? e : "") + "]", i, n, r)
                }
                ));
            else if (n || "object" !== x(e))
                r(t, e);
            else
                for (i in e)
                    Pe(t + "[" + i + "]", e[i], n, r)
        }
        b.param = function(t, e) {
            var n, r = [], i = function(t, e) {
                var n = p(e) ? e() : e;
                r[r.length] = encodeURIComponent(t) + "=" + encodeURIComponent(null == n ? "" : n)
            };
            if (null == t)
                return "";
            if (Array.isArray(t) || t.jquery && !b.isPlainObject(t))
                b.each(t, (function() {
                    i(this.name, this.value)
                }
                ));
            else
                for (n in t)
                    Pe(n, t[n], e, i);
            return r.join("&")
        }
        ,
        b.fn.extend({
            serialize: function() {
                return b.param(this.serializeArray())
            },
            serializeArray: function() {
                return this.map((function() {
                    var t = b.prop(this, "elements");
                    return t ? b.makeArray(t) : this
                }
                )).filter((function() {
                    var t = this.type;
                    return this.name && !b(this).is(":disabled") && Se.test(this.nodeName) && !Ee.test(t) && (this.checked || !ht.test(t))
                }
                )).map((function(t, e) {
                    var n = b(this).val();
                    return null == n ? null : Array.isArray(n) ? b.map(n, (function(t) {
                        return {
                            name: e.name,
                            value: t.replace(Ce, "\r\n")
                        }
                    }
                    )) : {
                        name: e.name,
                        value: n.replace(Ce, "\r\n")
                    }
                }
                )).get()
            }
        });
        var Ae = /%20/g
          , Oe = /#.*$/
          , De = /([?&])_=[^&]*/
          , Me = /^(.*?):[ \t]*([^\r\n]*)$/gm
          , Le = /^(?:GET|HEAD)$/
          , qe = /^\/\//
          , Ne = {}
          , je = {}
          , Re = "*/".concat("*")
          , Ie = v.createElement("a");
        function Fe(t) {
            return function(e, n) {
                "string" != typeof e && (n = e,
                e = "*");
                var r, i = 0, o = e.toLowerCase().match(q) || [];
                if (p(n))
                    for (; r = o[i++]; )
                        "+" === r[0] ? (r = r.slice(1) || "*",
                        (t[r] = t[r] || []).unshift(n)) : (t[r] = t[r] || []).push(n)
            }
        }
        function Be(t, e, n, r) {
            var i = {}
              , o = t === je;
            function s(a) {
                var u;
                return i[a] = !0,
                b.each(t[a] || [], (function(t, a) {
                    var l = a(e, n, r);
                    return "string" != typeof l || o || i[l] ? o ? !(u = l) : void 0 : (e.dataTypes.unshift(l),
                    s(l),
                    !1)
                }
                )),
                u
            }
            return s(e.dataTypes[0]) || !i["*"] && s("*")
        }
        function He(t, e) {
            var n, r, i = b.ajaxSettings.flatOptions || {};
            for (n in e)
                void 0 !== e[n] && ((i[n] ? t : r || (r = {}))[n] = e[n]);
            return r && b.extend(!0, t, r),
            t
        }
        Ie.href = we.href,
        b.extend({
            active: 0,
            lastModified: {},
            etag: {},
            ajaxSettings: {
                url: we.href,
                type: "GET",
                isLocal: /^(?:about|app|app-storage|.+-extension|file|res|widget):$/.test(we.protocol),
                global: !0,
                processData: !0,
                async: !0,
                contentType: "application/x-www-form-urlencoded; charset=UTF-8",
                accepts: {
                    "*": Re,
                    text: "text/plain",
                    html: "text/html",
                    xml: "application/xml, text/xml",
                    json: "application/json, text/javascript"
                },
                contents: {
                    xml: /\bxml\b/,
                    html: /\bhtml/,
                    json: /\bjson\b/
                },
                responseFields: {
                    xml: "responseXML",
                    text: "responseText",
                    json: "responseJSON"
                },
                converters: {
                    "* text": String,
                    "text html": !0,
                    "text json": JSON.parse,
                    "text xml": b.parseXML
                },
                flatOptions: {
                    url: !0,
                    context: !0
                }
            },
            ajaxSetup: function(t, e) {
                return e ? He(He(t, b.ajaxSettings), e) : He(b.ajaxSettings, t)
            },
            ajaxPrefilter: Fe(Ne),
            ajaxTransport: Fe(je),
            ajax: function(e, n) {
                "object" == typeof e && (n = e,
                e = void 0),
                n = n || {};
                var r, i, o, s, a, u, l, c, f, h, d = b.ajaxSetup({}, n), p = d.context || d, g = d.context && (p.nodeType || p.jquery) ? b(p) : b.event, m = b.Deferred(), y = b.Callbacks("once memory"), x = d.statusCode || {}, w = {}, _ = {}, T = "canceled", k = {
                    readyState: 0,
                    getResponseHeader: function(t) {
                        var e;
                        if (l) {
                            if (!s)
                                for (s = {}; e = Me.exec(o); )
                                    s[e[1].toLowerCase() + " "] = (s[e[1].toLowerCase() + " "] || []).concat(e[2]);
                            e = s[t.toLowerCase() + " "]
                        }
                        return null == e ? null : e.join(", ")
                    },
                    getAllResponseHeaders: function() {
                        return l ? o : null
                    },
                    setRequestHeader: function(t, e) {
                        return null == l && (t = _[t.toLowerCase()] = _[t.toLowerCase()] || t,
                        w[t] = e),
                        this
                    },
                    overrideMimeType: function(t) {
                        return null == l && (d.mimeType = t),
                        this
                    },
                    statusCode: function(t) {
                        var e;
                        if (t)
                            if (l)
                                k.always(t[k.status]);
                            else
                                for (e in t)
                                    x[e] = [x[e], t[e]];
                        return this
                    },
                    abort: function(t) {
                        var e = t || T;
                        return r && r.abort(e),
                        C(0, e),
                        this
                    }
                };
                if (m.promise(k),
                d.url = ((e || d.url || we.href) + "").replace(qe, we.protocol + "//"),
                d.type = n.method || n.type || d.method || d.type,
                d.dataTypes = (d.dataType || "*").toLowerCase().match(q) || [""],
                null == d.crossDomain) {
                    u = v.createElement("a");
                    try {
                        u.href = d.url,
                        u.href = u.href,
                        d.crossDomain = Ie.protocol + "//" + Ie.host != u.protocol + "//" + u.host
                    } catch (t) {
                        d.crossDomain = !0
                    }
                }
                if (d.data && d.processData && "string" != typeof d.data && (d.data = b.param(d.data, d.traditional)),
                Be(Ne, d, n, k),
                l)
                    return k;
                for (f in (c = b.event && d.global) && 0 == b.active++ && b.event.trigger("ajaxStart"),
                d.type = d.type.toUpperCase(),
                d.hasContent = !Le.test(d.type),
                i = d.url.replace(Oe, ""),
                d.hasContent ? d.data && d.processData && 0 === (d.contentType || "").indexOf("application/x-www-form-urlencoded") && (d.data = d.data.replace(Ae, "+")) : (h = d.url.slice(i.length),
                d.data && (d.processData || "string" == typeof d.data) && (i += (Te.test(i) ? "&" : "?") + d.data,
                delete d.data),
                !1 === d.cache && (i = i.replace(De, "$1"),
                h = (Te.test(i) ? "&" : "?") + "_=" + _e.guid++ + h),
                d.url = i + h),
                d.ifModified && (b.lastModified[i] && k.setRequestHeader("If-Modified-Since", b.lastModified[i]),
                b.etag[i] && k.setRequestHeader("If-None-Match", b.etag[i])),
                (d.data && d.hasContent && !1 !== d.contentType || n.contentType) && k.setRequestHeader("Content-Type", d.contentType),
                k.setRequestHeader("Accept", d.dataTypes[0] && d.accepts[d.dataTypes[0]] ? d.accepts[d.dataTypes[0]] + ("*" !== d.dataTypes[0] ? ", " + Re + "; q=0.01" : "") : d.accepts["*"]),
                d.headers)
                    k.setRequestHeader(f, d.headers[f]);
                if (d.beforeSend && (!1 === d.beforeSend.call(p, k, d) || l))
                    return k.abort();
                if (T = "abort",
                y.add(d.complete),
                k.done(d.success),
                k.fail(d.error),
                r = Be(je, d, n, k)) {
                    if (k.readyState = 1,
                    c && g.trigger("ajaxSend", [k, d]),
                    l)
                        return k;
                    d.async && d.timeout > 0 && (a = t.setTimeout((function() {
                        k.abort("timeout")
                    }
                    ), d.timeout));
                    try {
                        l = !1,
                        r.send(w, C)
                    } catch (t) {
                        if (l)
                            throw t;
                        C(-1, t)
                    }
                } else
                    C(-1, "No Transport");
                function C(e, n, s, u) {
                    var f, h, v, w, _, T = n;
                    l || (l = !0,
                    a && t.clearTimeout(a),
                    r = void 0,
                    o = u || "",
                    k.readyState = e > 0 ? 4 : 0,
                    f = e >= 200 && e < 300 || 304 === e,
                    s && (w = function(t, e, n) {
                        for (var r, i, o, s, a = t.contents, u = t.dataTypes; "*" === u[0]; )
                            u.shift(),
                            void 0 === r && (r = t.mimeType || e.getResponseHeader("Content-Type"));
                        if (r)
                            for (i in a)
                                if (a[i] && a[i].test(r)) {
                                    u.unshift(i);
                                    break
                                }
                        if (u[0]in n)
                            o = u[0];
                        else {
                            for (i in n) {
                                if (!u[0] || t.converters[i + " " + u[0]]) {
                                    o = i;
                                    break
                                }
                                s || (s = i)
                            }
                            o = o || s
                        }
                        if (o)
                            return o !== u[0] && u.unshift(o),
                            n[o]
                    }(d, k, s)),
                    !f && b.inArray("script", d.dataTypes) > -1 && (d.converters["text script"] = function() {}
                    ),
                    w = function(t, e, n, r) {
                        var i, o, s, a, u, l = {}, c = t.dataTypes.slice();
                        if (c[1])
                            for (s in t.converters)
                                l[s.toLowerCase()] = t.converters[s];
                        for (o = c.shift(); o; )
                            if (t.responseFields[o] && (n[t.responseFields[o]] = e),
                            !u && r && t.dataFilter && (e = t.dataFilter(e, t.dataType)),
                            u = o,
                            o = c.shift())
                                if ("*" === o)
                                    o = u;
                                else if ("*" !== u && u !== o) {
                                    if (!(s = l[u + " " + o] || l["* " + o]))
                                        for (i in l)
                                            if ((a = i.split(" "))[1] === o && (s = l[u + " " + a[0]] || l["* " + a[0]])) {
                                                !0 === s ? s = l[i] : !0 !== l[i] && (o = a[0],
                                                c.unshift(a[1]));
                                                break
                                            }
                                    if (!0 !== s)
                                        if (s && t.throws)
                                            e = s(e);
                                        else
                                            try {
                                                e = s(e)
                                            } catch (t) {
                                                return {
                                                    state: "parsererror",
                                                    error: s ? t : "No conversion from " + u + " to " + o
                                                }
                                            }
                                }
                        return {
                            state: "success",
                            data: e
                        }
                    }(d, w, k, f),
                    f ? (d.ifModified && ((_ = k.getResponseHeader("Last-Modified")) && (b.lastModified[i] = _),
                    (_ = k.getResponseHeader("etag")) && (b.etag[i] = _)),
                    204 === e || "HEAD" === d.type ? T = "nocontent" : 304 === e ? T = "notmodified" : (T = w.state,
                    h = w.data,
                    f = !(v = w.error))) : (v = T,
                    !e && T || (T = "error",
                    e < 0 && (e = 0))),
                    k.status = e,
                    k.statusText = (n || T) + "",
                    f ? m.resolveWith(p, [h, T, k]) : m.rejectWith(p, [k, T, v]),
                    k.statusCode(x),
                    x = void 0,
                    c && g.trigger(f ? "ajaxSuccess" : "ajaxError", [k, d, f ? h : v]),
                    y.fireWith(p, [k, T]),
                    c && (g.trigger("ajaxComplete", [k, d]),
                    --b.active || b.event.trigger("ajaxStop")))
                }
                return k
            },
            getJSON: function(t, e, n) {
                return b.get(t, e, n, "json")
            },
            getScript: function(t, e) {
                return b.get(t, void 0, e, "script")
            }
        }),
        b.each(["get", "post"], (function(t, e) {
            b[e] = function(t, n, r, i) {
                return p(n) && (i = i || r,
                r = n,
                n = void 0),
                b.ajax(b.extend({
                    url: t,
                    type: e,
                    dataType: i,
                    data: n,
                    success: r
                }, b.isPlainObject(t) && t))
            }
        }
        )),
        b.ajaxPrefilter((function(t) {
            var e;
            for (e in t.headers)
                "content-type" === e.toLowerCase() && (t.contentType = t.headers[e] || "")
        }
        )),
        b._evalUrl = function(t, e, n) {
            return b.ajax({
                url: t,
                type: "GET",
                dataType: "script",
                cache: !0,
                async: !1,
                global: !1,
                converters: {
                    "text script": function() {}
                },
                dataFilter: function(t) {
                    b.globalEval(t, e, n)
                }
            })
        }
        ,
        b.fn.extend({
            wrapAll: function(t) {
                var e;
                return this[0] && (p(t) && (t = t.call(this[0])),
                e = b(t, this[0].ownerDocument).eq(0).clone(!0),
                this[0].parentNode && e.insertBefore(this[0]),
                e.map((function() {
                    for (var t = this; t.firstElementChild; )
                        t = t.firstElementChild;
                    return t
                }
                )).append(this)),
                this
            },
            wrapInner: function(t) {
                return p(t) ? this.each((function(e) {
                    b(this).wrapInner(t.call(this, e))
                }
                )) : this.each((function() {
                    var e = b(this)
                      , n = e.contents();
                    n.length ? n.wrapAll(t) : e.append(t)
                }
                ))
            },
            wrap: function(t) {
                var e = p(t);
                return this.each((function(n) {
                    b(this).wrapAll(e ? t.call(this, n) : t)
                }
                ))
            },
            unwrap: function(t) {
                return this.parent(t).not("body").each((function() {
                    b(this).replaceWith(this.childNodes)
                }
                )),
                this
            }
        }),
        b.expr.pseudos.hidden = function(t) {
            return !b.expr.pseudos.visible(t)
        }
        ,
        b.expr.pseudos.visible = function(t) {
            return !!(t.offsetWidth || t.offsetHeight || t.getClientRects().length)
        }
        ,
        b.ajaxSettings.xhr = function() {
            try {
                return new t.XMLHttpRequest
            } catch (t) {}
        }
        ;
        var Xe = {
            0: 200,
            1223: 204
        }
          , ze = b.ajaxSettings.xhr();
        d.cors = !!ze && "withCredentials"in ze,
        d.ajax = ze = !!ze,
        b.ajaxTransport((function(e) {
            var n, r;
            if (d.cors || ze && !e.crossDomain)
                return {
                    send: function(i, o) {
                        var s, a = e.xhr();
                        if (a.open(e.type, e.url, e.async, e.username, e.password),
                        e.xhrFields)
                            for (s in e.xhrFields)
                                a[s] = e.xhrFields[s];
                        for (s in e.mimeType && a.overrideMimeType && a.overrideMimeType(e.mimeType),
                        e.crossDomain || i["X-Requested-With"] || (i["X-Requested-With"] = "XMLHttpRequest"),
                        i)
                            a.setRequestHeader(s, i[s]);
                        n = function(t) {
                            return function() {
                                n && (n = r = a.onload = a.onerror = a.onabort = a.ontimeout = a.onreadystatechange = null,
                                "abort" === t ? a.abort() : "error" === t ? "number" != typeof a.status ? o(0, "error") : o(a.status, a.statusText) : o(Xe[a.status] || a.status, a.statusText, "text" !== (a.responseType || "text") || "string" != typeof a.responseText ? {
                                    binary: a.response
                                } : {
                                    text: a.responseText
                                }, a.getAllResponseHeaders()))
                            }
                        }
                        ,
                        a.onload = n(),
                        r = a.onerror = a.ontimeout = n("error"),
                        void 0 !== a.onabort ? a.onabort = r : a.onreadystatechange = function() {
                            4 === a.readyState && t.setTimeout((function() {
                                n && r()
                            }
                            ))
                        }
                        ,
                        n = n("abort");
                        try {
                            a.send(e.hasContent && e.data || null)
                        } catch (t) {
                            if (n)
                                throw t
                        }
                    },
                    abort: function() {
                        n && n()
                    }
                }
        }
        )),
        b.ajaxPrefilter((function(t) {
            t.crossDomain && (t.contents.script = !1)
        }
        )),
        b.ajaxSetup({
            accepts: {
                script: "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"
            },
            contents: {
                script: /\b(?:java|ecma)script\b/
            },
            converters: {
                "text script": function(t) {
                    return b.globalEval(t),
                    t
                }
            }
        }),
        b.ajaxPrefilter("script", (function(t) {
            void 0 === t.cache && (t.cache = !1),
            t.crossDomain && (t.type = "GET")
        }
        )),
        b.ajaxTransport("script", (function(t) {
            var e, n;
            if (t.crossDomain || t.scriptAttrs)
                return {
                    send: function(r, i) {
                        e = b("<script>").attr(t.scriptAttrs || {}).prop({
                            charset: t.scriptCharset,
                            src: t.url
                        }).on("load error", n = function(t) {
                            e.remove(),
                            n = null,
                            t && i("error" === t.type ? 404 : 200, t.type)
                        }
                        ),
                        v.head.appendChild(e[0])
                    },
                    abort: function() {
                        n && n()
                    }
                }
        }
        ));
        var Ye, We = [], Ue = /(=)\?(?=&|$)|\?\?/;
        b.ajaxSetup({
            jsonp: "callback",
            jsonpCallback: function() {
                var t = We.pop() || b.expando + "_" + _e.guid++;
                return this[t] = !0,
                t
            }
        }),
        b.ajaxPrefilter("json jsonp", (function(e, n, r) {
            var i, o, s, a = !1 !== e.jsonp && (Ue.test(e.url) ? "url" : "string" == typeof e.data && 0 === (e.contentType || "").indexOf("application/x-www-form-urlencoded") && Ue.test(e.data) && "data");
            if (a || "jsonp" === e.dataTypes[0])
                return i = e.jsonpCallback = p(e.jsonpCallback) ? e.jsonpCallback() : e.jsonpCallback,
                a ? e[a] = e[a].replace(Ue, "$1" + i) : !1 !== e.jsonp && (e.url += (Te.test(e.url) ? "&" : "?") + e.jsonp + "=" + i),
                e.converters["script json"] = function() {
                    return s || b.error(i + " was not called"),
                    s[0]
                }
                ,
                e.dataTypes[0] = "json",
                o = t[i],
                t[i] = function() {
                    s = arguments
                }
                ,
                r.always((function() {
                    void 0 === o ? b(t).removeProp(i) : t[i] = o,
                    e[i] && (e.jsonpCallback = n.jsonpCallback,
                    We.push(i)),
                    s && p(o) && o(s[0]),
                    s = o = void 0
                }
                )),
                "script"
        }
        )),
        d.createHTMLDocument = ((Ye = v.implementation.createHTMLDocument("").body).innerHTML = "<form></form><form></form>",
        2 === Ye.childNodes.length),
        b.parseHTML = function(t, e, n) {
            return "string" != typeof t ? [] : ("boolean" == typeof e && (n = e,
            e = !1),
            e || (d.createHTMLDocument ? ((r = (e = v.implementation.createHTMLDocument("")).createElement("base")).href = v.location.href,
            e.head.appendChild(r)) : e = v),
            o = !n && [],
            (i = S.exec(t)) ? [e.createElement(i[1])] : (i = xt([t], e, o),
            o && o.length && b(o).remove(),
            b.merge([], i.childNodes)));
            var r, i, o
        }
        ,
        b.fn.load = function(t, e, n) {
            var r, i, o, s = this, a = t.indexOf(" ");
            return a > -1 && (r = ge(t.slice(a)),
            t = t.slice(0, a)),
            p(e) ? (n = e,
            e = void 0) : e && "object" == typeof e && (i = "POST"),
            s.length > 0 && b.ajax({
                url: t,
                type: i || "GET",
                dataType: "html",
                data: e
            }).done((function(t) {
                o = arguments,
                s.html(r ? b("<div>").append(b.parseHTML(t)).find(r) : t)
            }
            )).always(n && function(t, e) {
                s.each((function() {
                    n.apply(this, o || [t.responseText, e, t])
                }
                ))
            }
            ),
            this
        }
        ,
        b.expr.pseudos.animated = function(t) {
            return b.grep(b.timers, (function(e) {
                return t === e.elem
            }
            )).length
        }
        ,
        b.offset = {
            setOffset: function(t, e, n) {
                var r, i, o, s, a, u, l = b.css(t, "position"), c = b(t), f = {};
                "static" === l && (t.style.position = "relative"),
                a = c.offset(),
                o = b.css(t, "top"),
                u = b.css(t, "left"),
                ("absolute" === l || "fixed" === l) && (o + u).indexOf("auto") > -1 ? (s = (r = c.position()).top,
                i = r.left) : (s = parseFloat(o) || 0,
                i = parseFloat(u) || 0),
                p(e) && (e = e.call(t, n, b.extend({}, a))),
                null != e.top && (f.top = e.top - a.top + s),
                null != e.left && (f.left = e.left - a.left + i),
                "using"in e ? e.using.call(t, f) : ("number" == typeof f.top && (f.top += "px"),
                "number" == typeof f.left && (f.left += "px"),
                c.css(f))
            }
        },
        b.fn.extend({
            offset: function(t) {
                if (arguments.length)
                    return void 0 === t ? this : this.each((function(e) {
                        b.offset.setOffset(this, t, e)
                    }
                    ));
                var e, n, r = this[0];
                return r ? r.getClientRects().length ? (e = r.getBoundingClientRect(),
                n = r.ownerDocument.defaultView,
                {
                    top: e.top + n.pageYOffset,
                    left: e.left + n.pageXOffset
                }) : {
                    top: 0,
                    left: 0
                } : void 0
            },
            position: function() {
                if (this[0]) {
                    var t, e, n, r = this[0], i = {
                        top: 0,
                        left: 0
                    };
                    if ("fixed" === b.css(r, "position"))
                        e = r.getBoundingClientRect();
                    else {
                        for (e = this.offset(),
                        n = r.ownerDocument,
                        t = r.offsetParent || n.documentElement; t && (t === n.body || t === n.documentElement) && "static" === b.css(t, "position"); )
                            t = t.parentNode;
                        t && t !== r && 1 === t.nodeType && ((i = b(t).offset()).top += b.css(t, "borderTopWidth", !0),
                        i.left += b.css(t, "borderLeftWidth", !0))
                    }
                    return {
                        top: e.top - i.top - b.css(r, "marginTop", !0),
                        left: e.left - i.left - b.css(r, "marginLeft", !0)
                    }
                }
            },
            offsetParent: function() {
                return this.map((function() {
                    for (var t = this.offsetParent; t && "static" === b.css(t, "position"); )
                        t = t.offsetParent;
                    return t || nt
                }
                ))
            }
        }),
        b.each({
            scrollLeft: "pageXOffset",
            scrollTop: "pageYOffset"
        }, (function(t, e) {
            var n = "pageYOffset" === e;
            b.fn[t] = function(r) {
                return H(this, (function(t, r, i) {
                    var o;
                    if (g(t) ? o = t : 9 === t.nodeType && (o = t.defaultView),
                    void 0 === i)
                        return o ? o[e] : t[r];
                    o ? o.scrollTo(n ? o.pageXOffset : i, n ? i : o.pageYOffset) : t[r] = i
                }
                ), t, r, arguments.length)
            }
        }
        )),
        b.each(["top", "left"], (function(t, e) {
            b.cssHooks[e] = zt(d.pixelPosition, (function(t, n) {
                if (n)
                    return n = Xt(t, e),
                    It.test(n) ? b(t).position()[e] + "px" : n
            }
            ))
        }
        )),
        b.each({
            Height: "height",
            Width: "width"
        }, (function(t, e) {
            b.each({
                padding: "inner" + t,
                content: e,
                "": "outer" + t
            }, (function(n, r) {
                b.fn[r] = function(i, o) {
                    var s = arguments.length && (n || "boolean" != typeof i)
                      , a = n || (!0 === i || !0 === o ? "margin" : "border");
                    return H(this, (function(e, n, i) {
                        var o;
                        return g(e) ? 0 === r.indexOf("outer") ? e["inner" + t] : e.document.documentElement["client" + t] : 9 === e.nodeType ? (o = e.documentElement,
                        Math.max(e.body["scroll" + t], o["scroll" + t], e.body["offset" + t], o["offset" + t], o["client" + t])) : void 0 === i ? b.css(e, n, a) : b.style(e, n, i, a)
                    }
                    ), e, s ? i : void 0, s)
                }
            }
            ))
        }
        )),
        b.each(["ajaxStart", "ajaxStop", "ajaxComplete", "ajaxError", "ajaxSuccess", "ajaxSend"], (function(t, e) {
            b.fn[e] = function(t) {
                return this.on(e, t)
            }
        }
        )),
        b.fn.extend({
            bind: function(t, e, n) {
                return this.on(t, null, e, n)
            },
            unbind: function(t, e) {
                return this.off(t, null, e)
            },
            delegate: function(t, e, n, r) {
                return this.on(e, t, n, r)
            },
            undelegate: function(t, e, n) {
                return 1 === arguments.length ? this.off(t, "**") : this.off(e, t || "**", n)
            },
            hover: function(t, e) {
                return this.mouseenter(t).mouseleave(e || t)
            }
        }),
        b.each("blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu".split(" "), (function(t, e) {
            b.fn[e] = function(t, n) {
                return arguments.length > 0 ? this.on(e, null, t, n) : this.trigger(e)
            }
        }
        ));
        var $e = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;
        b.proxy = function(t, e) {
            var n, r, o;
            if ("string" == typeof e && (n = t[e],
            e = t,
            t = n),
            p(t))
                return r = i.call(arguments, 2),
                (o = function() {
                    return t.apply(e || this, r.concat(i.call(arguments)))
                }
                ).guid = t.guid = t.guid || b.guid++,
                o
        }
        ,
        b.holdReady = function(t) {
            t ? b.readyWait++ : b.ready(!0)
        }
        ,
        b.isArray = Array.isArray,
        b.parseJSON = JSON.parse,
        b.nodeName = E,
        b.isFunction = p,
        b.isWindow = g,
        b.camelCase = W,
        b.type = x,
        b.now = Date.now,
        b.isNumeric = function(t) {
            var e = b.type(t);
            return ("number" === e || "string" === e) && !isNaN(t - parseFloat(t))
        }
        ,
        b.trim = function(t) {
            return null == t ? "" : (t + "").replace($e, "")
        }
        ;
        var Ve = t.jQuery
          , Ge = t.$;
        return b.noConflict = function(e) {
            return t.$ === b && (t.$ = Ge),
            e && t.jQuery === b && (t.jQuery = Ve),
            b
        }
        ,
        void 0 === e && (t.jQuery = t.$ = b),
        b
    }
    ))
}
, function(t, e, n) {
    "use strict";
    (function(t) {
        n.d(e, "a", (function() {
            return o
        }
        ));
        var r = n(3);
        function i(t, e) {
            for (var n = 0; n < e.length; n++) {
                var r = e[n];
                r.enumerable = r.enumerable || !1,
                r.configurable = !0,
                "value"in r && (r.writable = !0),
                Object.defineProperty(t, r.key, r)
            }
        }
        var o = new (function() {
            function e() {
                !function(t, e) {
                    if (!(t instanceof e))
                        throw new TypeError("Cannot call a class as a function")
                }(this, e)
            }
            var n, o, s;
            return n = e,
            (o = [{
                key: "init",
                value: function() {
                    var t = document;
                    this.qsa = function(e) {
                        var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : t;
                        return n.querySelectorAll(e)
                    }
                    ,
                    this.qs = function(e) {
                        var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : t;
                        return n.querySelector(e)
                    }
                }
            }, {
                key: "onClick",
                value: function(e) {
                    var n = this;
                    this.contentPage = e,
                    this.add_btn = this.contentPage.querySelectorAll(".js-add-cart"),
                    t(this.add_btn).submit((function(e) {
                        e.preventDefault();
                        var r = t(this);
                        n.fecthItem(r)
                    }
                    ))
                }
            }, {
                key: "fecthItem",
                value: function(t) {
                    var e = new FormData(t[0]);
                    fetch("/cart/add.js", {
                        method: "POST",
                        body: e
                    }).then((function(t) {
                        return r.a.insertCart(),
                        t.json()
                    }
                    )).then((function(t) {
                        return t
                    }
                    )).catch((function(t) {
                        console.error("Error:", t)
                    }
                    ))
                }
            }, {
                key: "removeItem",
                value: function(e) {
                    var n = e.querySelectorAll(".item-remove");
                    t(n).click((function(e) {
                        e.preventDefault();
                        var n = t(this).data("line");
                        fetch("/cart/change.js", {
                            method: "POST",
                            headers: {
                                "Content-Type": "application/json"
                            },
                            body: JSON.stringify({
                                line: n,
                                quantity: 0
                            })
                        }).then((function(t) {
                            return r.a.insertCart(),
                            t.json()
                        }
                        )).catch((function(t) {
                            console.error("Error:", t)
                        }
                        ))
                    }
                    ))
                }
            }, {
                key: "ajaxItem",
                value: function(e) {
                    t.ajax({
                        type: "POST",
                        url: "/cart/add.js",
                        data: t(e).serialize(),
                        dataType: "json",
                        success: this.onCartUpdated(t(this).serialize()),
                        error: function(t) {
                            console.log(t)
                        }
                    })
                }
            }, {
                key: "onCartUpdated",
                value: function(t) {
                    console.log("item Ajaxed"),
                    r.a.insertCart()
                }
            }]) && i(n.prototype, o),
            s && i(n, s),
            e
        }())
    }
    ).call(this, n(1))
}
, function(t, e, n) {
    "use strict";
    (function(t) {
        n.d(e, "a", (function() {
            return o
        }
        ));
        var r = n(2);
        function i(t, e) {
            for (var n = 0; n < e.length; n++) {
                var r = e[n];
                r.enumerable = r.enumerable || !1,
                r.configurable = !0,
                "value"in r && (r.writable = !0),
                Object.defineProperty(t, r.key, r)
            }
        }
        var o = new (function() {
            function e() {
                !function(t, e) {
                    if (!(t instanceof e))
                        throw new TypeError("Cannot call a class as a function")
                }(this, e)
            }
            var n, o, s;
            return n = e,
            (o = [{
                key: "init",
                value: function() {
                    var t = document;
                    this.qsa = function(e) {
                        var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : t;
                        return n.querySelectorAll(e)
                    }
                    ,
                    this.qs = function(e) {
                        var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : t;
                        return n.querySelector(e)
                    }
                    ,
                    this.body = this.qs("body"),
                    this.cart_counter = this.qsa(".cart-counter "),
                    this.firstload = !1,
                    this.cart = {
                        receiver: this.qs(".minicart__hold"),
                        trg: this.qsa(".trg-cart"),
                        close: this.qsa(".cart__close"),
                        fader_close: this.qsa(".minicart__fader"),
                        links: this.qsa(".cart a"),
                        trg_close: null
                    },
                    this.insertCart()
                }
            }, {
                key: "insertCart",
                value: function() {
                    var e = this;
                    fetch("/cart").then((function(t) {
                        return t.text()
                    }
                    )).then((function(n) {
                        var i = (new DOMParser).parseFromString(n, "text/html").querySelector(".page-cart__content");
                        e.cart.receiver.appendChild(i),
                        e.verifyNew(),
                        e.onClick(i),
                        t(e.cart_counter).text("(".concat(t(i).data("cartcounter"), ")")),
                        r.a.removeItem(i),
                        t("#add-to-cart-button").removeClass("loading-item"),
                        t(".collect-index__add button").removeClass("loading-item")
                    }
                    )).catch((function(t) {
                        console.warn("Something went wrong.", t)
                    }
                    ))
                }
            }, {
                key: "onClick",
                value: function(e) {
                    var n = this;
                    t(this.cart.trg).click((function() {
                        t(n.body).addClass("is-minicart")
                    }
                    )),
                    this.cart.close = e.querySelectorAll(".cart__close, .browse, .cart a"),
                    t(this.cart.close).add(this.cart.fader_close).click((function() {
                        t(n.body).removeClass("is-minicart"),
                        console.log("remove cart")
                    }
                    ))
                }
            }, {
                key: "verifyNew",
                value: function() {
                    this.firstload ? (console.log("verify"),
                    t(".page-cart__content").not(t(".page-cart__content").eq(-1)).remove(),
                    t(this.cart.trg).trigger("click")) : this.firstload = !0
                }
            }]) && i(n.prototype, o),
            s && i(n, s),
            e
        }())
    }
    ).call(this, n(1))
}
, function(t, e, n) {
    "use strict";
    (function(t) {
        n.d(e, "a", (function() {
            return a
        }
        ));
        var r = n(0)
          , i = n(11)
          , o = n(23);
        function s(t, e) {
            for (var n = 0; n < e.length; n++) {
                var r = e[n];
                r.enumerable = r.enumerable || !1,
                r.configurable = !0,
                "value"in r && (r.writable = !0),
                Object.defineProperty(t, r.key, r)
            }
        }
        r.a.registerPlugin(i.a, o.a);
        var a = function() {
            function e(t) {
                !function(t, e) {
                    if (!(t instanceof e))
                        throw new TypeError("Cannot call a class as a function")
                }(this, e),
                this.el = t,
                this.slider = {
                    el: this.el,
                    holder: this.el.querySelector(".js-slider__holder"),
                    each: this.el.querySelectorAll(".js-slider__each"),
                    btn_prev: this.el.querySelector(".btn-prev") || null,
                    btn_next: this.el.querySelector(".btn-next") || null,
                    line_indic: this.el.querySelector(".indic") || null,
                    number_indic: this.el.querySelector(".js-slider__counter") || null
                },
                this.el_width = this.slider.each[1].getBoundingClientRect().width,
                this.target = 0,
                this.holder_x = r.a.getProperty(this.slider.holder, "x"),
                this.length = this.slider.each.length,
                this.change_numb = 1,
                this.setters(),
                this.onResize(),
                this.listeners(),
                this.onDrag()
            }
            var n, o, a;
            return n = e,
            (o = [{
                key: "setters",
                value: function() {
                    this.slider.holder.style.display = "inline-flex",
                    r.a.set(this.slider.line_indic, {
                        scaleX: 0,
                        transformOrigin: "right"
                    })
                }
            }, {
                key: "onResize",
                value: function() {
                    this.el_width = this.slider.each[1].getBoundingClientRect().width,
                    r.a.to(this.slider.holder, {
                        x: this.target * this.el_width
                    })
                }
            }, {
                key: "onProgress",
                value: function() {
                    this.holder_x = r.a.getProperty(this.slider.holder, "x"),
                    this.target = Math.round(this.holder_x / this.el_width),
                    r.a.set(this.slider.line_indic, {
                        scaleX: this.holder_x / (this.el_width * -(this.length - 1))
                    }),
                    t(this.slider.number_indic).text(1 + -1 * this.target)
                }
            }, {
                key: "onDrag",
                value: function() {
                    var t = this;
                    i.a.create(t.slider.holder, {
                        type: "x",
                        edgeResistance: .5,
                        dragResistance: .475,
                        bounds: t.slider.el,
                        inertia: !0,
                        onDrag: t.onProgress.bind(this),
                        onThrowUpdate: t.onProgress.bind(this),
                        snap: {
                            x: function(e) {
                                return Math.round(e / t.el_width) * t.el_width
                            }
                        }
                    })
                }
            }, {
                key: "onPrev",
                value: function() {
                    var t = this;
                    this.target < 0 && (this.target++,
                    r.a.to(this.slider.holder, {
                        duration: 1.4,
                        x: this.el_width * this.target,
                        overwrite: "auto",
                        ease: "expo.out",
                        onUpdate: function() {
                            return t.onProgress()
                        }
                    }))
                }
            }, {
                key: "onNext",
                value: function() {
                    var t = this;
                    this.target > -(this.length - 1) && (this.target--,
                    this.change_numb++,
                    r.a.to(this.slider.holder, {
                        duration: 1.4,
                        x: this.el_width * this.target,
                        overwrite: "auto",
                        ease: "expo.out",
                        onUpdate: function() {
                            return t.onProgress()
                        }
                    }))
                }
            }, {
                key: "listeners",
                value: function() {
                    window.addEventListener("resize", this.onResize.bind(this), {
                        passive: !0
                    }),
                    this.slider.btn_prev.addEventListener("click", this.onPrev.bind(this), {
                        passive: !0
                    }),
                    this.slider.btn_next.addEventListener("click", this.onNext.bind(this), {
                        passive: !0
                    })
                }
            }]) && s(n.prototype, o),
            a && s(n, a),
            e
        }()
    }
    ).call(this, n(1))
}
, function(t, e, n) {
    "use strict";
    function r(t, e) {
        for (var n = 0; n < e.length; n++) {
            var r = e[n];
            r.enumerable = r.enumerable || !1,
            r.configurable = !0,
            "value"in r && (r.writable = !0),
            Object.defineProperty(t, r.key, r)
        }
    }
    n.d(e, "a", (function() {
        return s
    }
    ));
    var i = n(12)
      , o = n(1)
      , s = new (function() {
        function t() {
            !function(t, e) {
                if (!(t instanceof e))
                    throw new TypeError("Cannot call a class as a function")
            }(this, t)
        }
        var e, n, s;
        return e = t,
        (n = [{
            key: "init",
            value: function() {
                this.preloader_master = document.querySelector(".preloader-master");
                var t = this;
                i.makeJQueryPlugin(o);
                var e = o(".img-load");
                i(".img-load"),
                e.imagesLoaded().always((function(e) {
                    window.dispatchEvent(new Event("resize")),
                    o(t.preloader_master).length > 0 && o(t.preloader_master).remove()
                }
                )).progress((function(t, e) {}
                ))
            }
        }]) && r(e.prototype, n),
        s && r(e, s),
        t
    }())
}
, function(t, e, n) {
    t.exports = function() {
        function t(t, e) {
            for (var n = 0; n < e.length; n++) {
                var r = e[n];
                r.enumerable = r.enumerable || !1,
                r.configurable = !0,
                "value"in r && (r.writable = !0),
                Object.defineProperty(t, r.key, r)
            }
        }
        function e(e, n, r) {
            return n && t(e.prototype, n),
            r && t(e, r),
            e
        }
        function n() {
            return (n = Object.assign || function(t) {
                for (var e = 1; e < arguments.length; e++) {
                    var n = arguments[e];
                    for (var r in n)
                        Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r])
                }
                return t
            }
            ).apply(this, arguments)
        }
        function r(t, e) {
            t.prototype = Object.create(e.prototype),
            t.prototype.constructor = t,
            t.__proto__ = e
        }
        function i(t) {
            return (i = Object.setPrototypeOf ? Object.getPrototypeOf : function(t) {
                return t.__proto__ || Object.getPrototypeOf(t)
            }
            )(t)
        }
        function o(t, e) {
            return (o = Object.setPrototypeOf || function(t, e) {
                return t.__proto__ = e,
                t
            }
            )(t, e)
        }
        function s(t, e, n) {
            return (s = function() {
                if ("undefined" == typeof Reflect || !Reflect.construct)
                    return !1;
                if (Reflect.construct.sham)
                    return !1;
                if ("function" == typeof Proxy)
                    return !0;
                try {
                    return Date.prototype.toString.call(Reflect.construct(Date, [], (function() {}
                    ))),
                    !0
                } catch (t) {
                    return !1
                }
            }() ? Reflect.construct : function(t, e, n) {
                var r = [null];
                r.push.apply(r, e);
                var i = new (Function.bind.apply(t, r));
                return n && o(i, n.prototype),
                i
            }
            ).apply(null, arguments)
        }
        function a(t) {
            var e = "function" == typeof Map ? new Map : void 0;
            return (a = function(t) {
                if (null === t || -1 === Function.toString.call(t).indexOf("[native code]"))
                    return t;
                if ("function" != typeof t)
                    throw new TypeError("Super expression must either be null or a function");
                if (void 0 !== e) {
                    if (e.has(t))
                        return e.get(t);
                    e.set(t, n)
                }
                function n() {
                    return s(t, arguments, i(this).constructor)
                }
                return n.prototype = Object.create(t.prototype, {
                    constructor: {
                        value: n,
                        enumerable: !1,
                        writable: !0,
                        configurable: !0
                    }
                }),
                o(n, t)
            }
            )(t)
        }
        function u(t, e) {
            try {
                var n = t()
            } catch (t) {
                return e(t)
            }
            return n && n.then ? n.then(void 0, e) : n
        }
        var l;
        "undefined" != typeof Symbol && (Symbol.iterator || (Symbol.iterator = Symbol("Symbol.iterator"))),
        "undefined" != typeof Symbol && (Symbol.asyncIterator || (Symbol.asyncIterator = Symbol("Symbol.asyncIterator"))),
        function(t) {
            t[t.off = 0] = "off",
            t[t.error = 1] = "error",
            t[t.warning = 2] = "warning",
            t[t.info = 3] = "info",
            t[t.debug = 4] = "debug"
        }(l || (l = {}));
        var c = l.off
          , f = function() {
            function t(t) {
                this.t = t
            }
            t.getLevel = function() {
                return c
            }
            ,
            t.setLevel = function(t) {
                return c = l[t]
            }
            ;
            var e = t.prototype;
            return e.error = function() {
                for (var t = arguments.length, e = new Array(t), n = 0; n < t; n++)
                    e[n] = arguments[n];
                this.i(console.error, l.error, e)
            }
            ,
            e.warn = function() {
                for (var t = arguments.length, e = new Array(t), n = 0; n < t; n++)
                    e[n] = arguments[n];
                this.i(console.warn, l.warning, e)
            }
            ,
            e.info = function() {
                for (var t = arguments.length, e = new Array(t), n = 0; n < t; n++)
                    e[n] = arguments[n];
                this.i(console.info, l.info, e)
            }
            ,
            e.debug = function() {
                for (var t = arguments.length, e = new Array(t), n = 0; n < t; n++)
                    e[n] = arguments[n];
                this.i(console.log, l.debug, e)
            }
            ,
            e.i = function(e, n, r) {
                n <= t.getLevel() && e.apply(console, ["[" + this.t + "] "].concat(r))
            }
            ,
            t
        }()
          , h = C
          , d = x
          , p = y
          , g = b
          , v = k
          , m = new RegExp(["(\\\\.)", "(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?"].join("|"),"g");
        function y(t, e) {
            for (var n, r = [], i = 0, o = 0, s = "", a = e && e.delimiter || "/", u = e && e.whitelist || void 0, l = !1; null !== (n = m.exec(t)); ) {
                var c = n[0]
                  , f = n[1]
                  , h = n.index;
                if (s += t.slice(o, h),
                o = h + c.length,
                f)
                    s += f[1],
                    l = !0;
                else {
                    var d = ""
                      , p = n[2]
                      , g = n[3]
                      , v = n[4]
                      , y = n[5];
                    if (!l && s.length) {
                        var x = s.length - 1
                          , b = s[x];
                        (!u || u.indexOf(b) > -1) && (d = b,
                        s = s.slice(0, x))
                    }
                    s && (r.push(s),
                    s = "",
                    l = !1);
                    var T = g || v
                      , k = d || a;
                    r.push({
                        name: p || i++,
                        prefix: d,
                        delimiter: k,
                        optional: "?" === y || "*" === y,
                        repeat: "+" === y || "*" === y,
                        pattern: T ? _(T) : "[^" + w(k === a ? k : k + a) + "]+?"
                    })
                }
            }
            return (s || o < t.length) && r.push(s + t.substr(o)),
            r
        }
        function x(t, e) {
            return function(n, r) {
                var i = t.exec(n);
                if (!i)
                    return !1;
                for (var o = i[0], s = i.index, a = {}, u = r && r.decode || decodeURIComponent, l = 1; l < i.length; l++)
                    if (void 0 !== i[l]) {
                        var c = e[l - 1];
                        a[c.name] = c.repeat ? i[l].split(c.delimiter).map((function(t) {
                            return u(t, c)
                        }
                        )) : u(i[l], c)
                    }
                return {
                    path: o,
                    index: s,
                    params: a
                }
            }
        }
        function b(t, e) {
            for (var n = new Array(t.length), r = 0; r < t.length; r++)
                "object" == typeof t[r] && (n[r] = new RegExp("^(?:" + t[r].pattern + ")$",T(e)));
            return function(e, r) {
                for (var i = "", o = r && r.encode || encodeURIComponent, s = !r || !1 !== r.validate, a = 0; a < t.length; a++) {
                    var u = t[a];
                    if ("string" != typeof u) {
                        var l, c = e ? e[u.name] : void 0;
                        if (Array.isArray(c)) {
                            if (!u.repeat)
                                throw new TypeError('Expected "' + u.name + '" to not repeat, but got array');
                            if (0 === c.length) {
                                if (u.optional)
                                    continue;
                                throw new TypeError('Expected "' + u.name + '" to not be empty')
                            }
                            for (var f = 0; f < c.length; f++) {
                                if (l = o(c[f], u),
                                s && !n[a].test(l))
                                    throw new TypeError('Expected all "' + u.name + '" to match "' + u.pattern + '"');
                                i += (0 === f ? u.prefix : u.delimiter) + l
                            }
                        } else if ("string" != typeof c && "number" != typeof c && "boolean" != typeof c) {
                            if (!u.optional)
                                throw new TypeError('Expected "' + u.name + '" to be ' + (u.repeat ? "an array" : "a string"))
                        } else {
                            if (l = o(String(c), u),
                            s && !n[a].test(l))
                                throw new TypeError('Expected "' + u.name + '" to match "' + u.pattern + '", but got "' + l + '"');
                            i += u.prefix + l
                        }
                    } else
                        i += u
                }
                return i
            }
        }
        function w(t) {
            return t.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1")
        }
        function _(t) {
            return t.replace(/([=!:$/()])/g, "\\$1")
        }
        function T(t) {
            return t && t.sensitive ? "" : "i"
        }
        function k(t, e, n) {
            for (var r = (n = n || {}).strict, i = !1 !== n.start, o = !1 !== n.end, s = n.delimiter || "/", a = [].concat(n.endsWith || []).map(w).concat("$").join("|"), u = i ? "^" : "", l = 0; l < t.length; l++) {
                var c = t[l];
                if ("string" == typeof c)
                    u += w(c);
                else {
                    var f = c.repeat ? "(?:" + c.pattern + ")(?:" + w(c.delimiter) + "(?:" + c.pattern + "))*" : c.pattern;
                    e && e.push(c),
                    u += c.optional ? c.prefix ? "(?:" + w(c.prefix) + "(" + f + "))?" : "(" + f + ")?" : w(c.prefix) + "(" + f + ")"
                }
            }
            if (o)
                r || (u += "(?:" + w(s) + ")?"),
                u += "$" === a ? "$" : "(?=" + a + ")";
            else {
                var h = t[t.length - 1]
                  , d = "string" == typeof h ? h[h.length - 1] === s : void 0 === h;
                r || (u += "(?:" + w(s) + "(?=" + a + "))?"),
                d || (u += "(?=" + w(s) + "|" + a + ")")
            }
            return new RegExp(u,T(n))
        }
        function C(t, e, n) {
            return t instanceof RegExp ? function(t, e) {
                if (!e)
                    return t;
                var n = t.source.match(/\((?!\?)/g);
                if (n)
                    for (var r = 0; r < n.length; r++)
                        e.push({
                            name: r,
                            prefix: null,
                            delimiter: null,
                            optional: !1,
                            repeat: !1,
                            pattern: null
                        });
                return t
            }(t, e) : Array.isArray(t) ? function(t, e, n) {
                for (var r = [], i = 0; i < t.length; i++)
                    r.push(C(t[i], e, n).source);
                return new RegExp("(?:" + r.join("|") + ")",T(n))
            }(t, e, n) : function(t, e, n) {
                return k(y(t, n), e, n)
            }(t, e, n)
        }
        h.match = function(t, e) {
            var n = [];
            return x(C(t, n, e), n)
        }
        ,
        h.regexpToFunction = d,
        h.parse = p,
        h.compile = function(t, e) {
            return b(y(t, e), e)
        }
        ,
        h.tokensToFunction = g,
        h.tokensToRegExp = v;
        var E = {
            container: "container",
            history: "history",
            namespace: "namespace",
            prefix: "data-barba",
            prevent: "prevent",
            wrapper: "wrapper"
        }
          , S = new (function() {
            function t() {
                this.o = E,
                this.u = new DOMParser
            }
            var e = t.prototype;
            return e.toString = function(t) {
                return t.outerHTML
            }
            ,
            e.toDocument = function(t) {
                return this.u.parseFromString(t, "text/html")
            }
            ,
            e.toElement = function(t) {
                var e = document.createElement("div");
                return e.innerHTML = t,
                e
            }
            ,
            e.getHtml = function(t) {
                return void 0 === t && (t = document),
                this.toString(t.documentElement)
            }
            ,
            e.getWrapper = function(t) {
                return void 0 === t && (t = document),
                t.querySelector("[" + this.o.prefix + '="' + this.o.wrapper + '"]')
            }
            ,
            e.getContainer = function(t) {
                return void 0 === t && (t = document),
                t.querySelector("[" + this.o.prefix + '="' + this.o.container + '"]')
            }
            ,
            e.removeContainer = function(t) {
                document.body.contains(t) && t.parentNode.removeChild(t)
            }
            ,
            e.addContainer = function(t, e) {
                var n = this.getContainer();
                n ? this.s(t, n) : e.appendChild(t)
            }
            ,
            e.getNamespace = function(t) {
                void 0 === t && (t = document);
                var e = t.querySelector("[" + this.o.prefix + "-" + this.o.namespace + "]");
                return e ? e.getAttribute(this.o.prefix + "-" + this.o.namespace) : null
            }
            ,
            e.getHref = function(t) {
                if (t.tagName && "a" === t.tagName.toLowerCase()) {
                    if ("string" == typeof t.href)
                        return t.href;
                    var e = t.getAttribute("href") || t.getAttribute("xlink:href");
                    if (e)
                        return this.resolveUrl(e.baseVal || e)
                }
                return null
            }
            ,
            e.resolveUrl = function() {
                for (var t = arguments.length, e = new Array(t), n = 0; n < t; n++)
                    e[n] = arguments[n];
                var r = e.length;
                if (0 === r)
                    throw new Error("resolveUrl requires at least one argument; got none.");
                var i = document.createElement("base");
                if (i.href = arguments[0],
                1 === r)
                    return i.href;
                var o = document.getElementsByTagName("head")[0];
                o.insertBefore(i, o.firstChild);
                for (var s, a = document.createElement("a"), u = 1; u < r; u++)
                    a.href = arguments[u],
                    i.href = s = a.href;
                return o.removeChild(i),
                s
            }
            ,
            e.s = function(t, e) {
                e.parentNode.insertBefore(t, e.nextSibling)
            }
            ,
            t
        }())
          , P = new (function() {
            function t() {
                this.h = [],
                this.v = -1
            }
            var r = t.prototype;
            return r.init = function(t, e) {
                this.l = "barba";
                var n = {
                    ns: e,
                    scroll: {
                        x: window.scrollX,
                        y: window.scrollY
                    },
                    url: t
                };
                this.h.push(n),
                this.v = 0;
                var r = {
                    from: this.l,
                    index: 0,
                    states: [].concat(this.h)
                };
                window.history && window.history.replaceState(r, "", t)
            }
            ,
            r.change = function(t, e, n) {
                if (n && n.state) {
                    var r = n.state
                      , i = r.index;
                    e = this.m(this.v - i),
                    this.replace(r.states),
                    this.v = i
                } else
                    this.add(t, e);
                return e
            }
            ,
            r.add = function(t, e) {
                var n = this.size
                  , r = this.p(e)
                  , i = {
                    ns: "tmp",
                    scroll: {
                        x: window.scrollX,
                        y: window.scrollY
                    },
                    url: t
                };
                this.h.push(i),
                this.v = n;
                var o = {
                    from: this.l,
                    index: n,
                    states: [].concat(this.h)
                };
                switch (r) {
                case "push":
                    window.history && window.history.pushState(o, "", t);
                    break;
                case "replace":
                    window.history && window.history.replaceState(o, "", t)
                }
            }
            ,
            r.update = function(t, e) {
                var r = e || this.v
                  , i = n({}, this.get(r), {}, t);
                this.set(r, i)
            }
            ,
            r.remove = function(t) {
                t ? this.h.splice(t, 1) : this.h.pop(),
                this.v--
            }
            ,
            r.clear = function() {
                this.h = [],
                this.v = -1
            }
            ,
            r.replace = function(t) {
                this.h = t
            }
            ,
            r.get = function(t) {
                return this.h[t]
            }
            ,
            r.set = function(t, e) {
                return this.h[t] = e
            }
            ,
            r.p = function(t) {
                var e = "push"
                  , n = t
                  , r = E.prefix + "-" + E.history;
                return n.hasAttribute && n.hasAttribute(r) && (e = n.getAttribute(r)),
                e
            }
            ,
            r.m = function(t) {
                return Math.abs(t) > 1 ? t > 0 ? "forward" : "back" : 0 === t ? "popstate" : t > 0 ? "back" : "forward"
            }
            ,
            e(t, [{
                key: "current",
                get: function() {
                    return this.h[this.v]
                }
            }, {
                key: "state",
                get: function() {
                    return this.h[this.h.length - 1]
                }
            }, {
                key: "previous",
                get: function() {
                    return this.v < 1 ? null : this.h[this.v - 1]
                }
            }, {
                key: "size",
                get: function() {
                    return this.h.length
                }
            }]),
            t
        }())
          , A = function(t, e) {
            try {
                var n = function() {
                    if (!e.next.html)
                        return Promise.resolve(t).then((function(t) {
                            var n = e.next;
                            if (t) {
                                var r = S.toElement(t);
                                n.namespace = S.getNamespace(r),
                                n.container = S.getContainer(r),
                                n.html = t,
                                P.update({
                                    ns: n.namespace
                                });
                                var i = S.toDocument(t);
                                document.title = i.title
                            }
                        }
                        ))
                }();
                return Promise.resolve(n && n.then ? n.then((function() {}
                )) : void 0)
            } catch (t) {
                return Promise.reject(t)
            }
        }
          , O = h
          , D = {
            __proto__: null,
            update: A,
            nextTick: function() {
                return new Promise((function(t) {
                    window.requestAnimationFrame(t)
                }
                ))
            },
            pathToRegexp: O
        }
          , M = function() {
            return window.location.origin
        }
          , L = function(t) {
            return void 0 === t && (t = window.location.href),
            q(t).port
        }
          , q = function(t) {
            var e, n = t.match(/:\d+/);
            if (null === n)
                /^http/.test(t) && (e = 80),
                /^https/.test(t) && (e = 443);
            else {
                var r = n[0].substring(1);
                e = parseInt(r, 10)
            }
            var i, o = t.replace(M(), ""), s = {}, a = o.indexOf("#");
            a >= 0 && (i = o.slice(a + 1),
            o = o.slice(0, a));
            var u = o.indexOf("?");
            return u >= 0 && (s = N(o.slice(u + 1)),
            o = o.slice(0, u)),
            {
                hash: i,
                path: o,
                port: e,
                query: s
            }
        }
          , N = function(t) {
            return t.split("&").reduce((function(t, e) {
                var n = e.split("=");
                return t[n[0]] = n[1],
                t
            }
            ), {})
        }
          , j = function(t) {
            return void 0 === t && (t = window.location.href),
            t.replace(/(\/#.*|\/|#.*)$/, "")
        }
          , R = {
            __proto__: null,
            getHref: function() {
                return window.location.href
            },
            getOrigin: M,
            getPort: L,
            getPath: function(t) {
                return void 0 === t && (t = window.location.href),
                q(t).path
            },
            parse: q,
            parseQuery: N,
            clean: j
        };
        function I(t, e, n) {
            return void 0 === e && (e = 2e3),
            new Promise((function(r, i) {
                var o = new XMLHttpRequest;
                o.onreadystatechange = function() {
                    if (o.readyState === XMLHttpRequest.DONE)
                        if (200 === o.status)
                            r(o.responseText);
                        else if (o.status) {
                            var e = {
                                status: o.status,
                                statusText: o.statusText
                            };
                            n(t, e),
                            i(e)
                        }
                }
                ,
                o.ontimeout = function() {
                    var r = new Error("Timeout error [" + e + "]");
                    n(t, r),
                    i(r)
                }
                ,
                o.onerror = function() {
                    var e = new Error("Fetch error");
                    n(t, e),
                    i(e)
                }
                ,
                o.open("GET", t),
                o.timeout = e,
                o.setRequestHeader("Accept", "text/html,application/xhtml+xml,application/xml"),
                o.setRequestHeader("x-barba", "yes"),
                o.send()
            }
            ))
        }
        var F = function(t) {
            return !!t && ("object" == typeof t || "function" == typeof t) && "function" == typeof t.then
        };
        function B(t, e) {
            return void 0 === e && (e = {}),
            function() {
                for (var n = arguments.length, r = new Array(n), i = 0; i < n; i++)
                    r[i] = arguments[i];
                var o = !1
                  , s = new Promise((function(n, i) {
                    e.async = function() {
                        return o = !0,
                        function(t, e) {
                            t ? i(t) : n(e)
                        }
                    }
                    ;
                    var s = t.apply(e, r);
                    o || (F(s) ? s.then(n, i) : n(s))
                }
                ));
                return s
            }
        }
        var H = new (function(t) {
            function e() {
                var e;
                return (e = t.call(this) || this).logger = new f("@barba/core"),
                e.all = ["ready", "page", "reset", "currentAdded", "currentRemoved", "nextAdded", "nextRemoved", "beforeOnce", "once", "afterOnce", "before", "beforeLeave", "leave", "afterLeave", "beforeEnter", "enter", "afterEnter", "after"],
                e.registered = new Map,
                e.init(),
                e
            }
            r(e, t);
            var n = e.prototype;
            return n.init = function() {
                var t = this;
                this.registered.clear(),
                this.all.forEach((function(e) {
                    t[e] || (t[e] = function(n, r) {
                        t.registered.has(e) || t.registered.set(e, new Set),
                        t.registered.get(e).add({
                            ctx: r || {},
                            fn: n
                        })
                    }
                    )
                }
                ))
            }
            ,
            n.do = function(t) {
                for (var e = this, n = arguments.length, r = new Array(n > 1 ? n - 1 : 0), i = 1; i < n; i++)
                    r[i - 1] = arguments[i];
                if (this.registered.has(t)) {
                    var o = Promise.resolve();
                    return this.registered.get(t).forEach((function(t) {
                        o = o.then((function() {
                            return B(t.fn, t.ctx).apply(void 0, r)
                        }
                        ))
                    }
                    )),
                    o.catch((function(n) {
                        e.logger.debug("Hook error [" + t + "]"),
                        e.logger.error(n)
                    }
                    ))
                }
                return Promise.resolve()
            }
            ,
            n.clear = function() {
                var t = this;
                this.all.forEach((function(e) {
                    delete t[e]
                }
                )),
                this.init()
            }
            ,
            n.help = function() {
                this.logger.info("Available hooks: " + this.all.join(","));
                var t = [];
                this.registered.forEach((function(e, n) {
                    return t.push(n)
                }
                )),
                this.logger.info("Registered hooks: " + t.join(","))
            }
            ,
            e
        }((function() {}
        )))
          , X = function() {
            function t(t) {
                if (this.P = [],
                "boolean" == typeof t)
                    this.g = t;
                else {
                    var e = Array.isArray(t) ? t : [t];
                    this.P = e.map((function(t) {
                        return O(t)
                    }
                    ))
                }
            }
            return t.prototype.checkHref = function(t) {
                if ("boolean" == typeof this.g)
                    return this.g;
                var e = q(t).path;
                return this.P.some((function(t) {
                    return null !== t.exec(e)
                }
                ))
            }
            ,
            t
        }()
          , z = function(t) {
            function e(e) {
                var n;
                return (n = t.call(this, e) || this).k = new Map,
                n
            }
            r(e, t);
            var i = e.prototype;
            return i.set = function(t, e, n) {
                return this.k.set(t, {
                    action: n,
                    request: e
                }),
                {
                    action: n,
                    request: e
                }
            }
            ,
            i.get = function(t) {
                return this.k.get(t)
            }
            ,
            i.getRequest = function(t) {
                return this.k.get(t).request
            }
            ,
            i.getAction = function(t) {
                return this.k.get(t).action
            }
            ,
            i.has = function(t) {
                return !this.checkHref(t) && this.k.has(t)
            }
            ,
            i.delete = function(t) {
                return this.k.delete(t)
            }
            ,
            i.update = function(t, e) {
                var r = n({}, this.k.get(t), {}, e);
                return this.k.set(t, r),
                r
            }
            ,
            e
        }(X)
          , Y = function() {
            return !window.history.pushState
        }
          , W = function(t) {
            return !t.el || !t.href
        }
          , U = function(t) {
            var e = t.event;
            return e.which > 1 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey
        }
          , $ = function(t) {
            var e = t.el;
            return e.hasAttribute("target") && "_blank" === e.target
        }
          , V = function(t) {
            var e = t.el;
            return void 0 !== e.protocol && window.location.protocol !== e.protocol || void 0 !== e.hostname && window.location.hostname !== e.hostname
        }
          , G = function(t) {
            var e = t.el;
            return void 0 !== e.port && L() !== L(e.href)
        }
          , K = function(t) {
            var e = t.el;
            return e.getAttribute && "string" == typeof e.getAttribute("download")
        }
          , Q = function(t) {
            return t.el.hasAttribute(E.prefix + "-" + E.prevent)
        }
          , J = function(t) {
            return Boolean(t.el.closest("[" + E.prefix + "-" + E.prevent + '="all"]'))
        }
          , Z = function(t) {
            var e = t.href;
            return j(e) === j() && L(e) === L()
        }
          , tt = function(t) {
            function e(e) {
                var n;
                return (n = t.call(this, e) || this).suite = [],
                n.tests = new Map,
                n.init(),
                n
            }
            r(e, t);
            var n = e.prototype;
            return n.init = function() {
                this.add("pushState", Y),
                this.add("exists", W),
                this.add("newTab", U),
                this.add("blank", $),
                this.add("corsDomain", V),
                this.add("corsPort", G),
                this.add("download", K),
                this.add("preventSelf", Q),
                this.add("preventAll", J),
                this.add("sameUrl", Z, !1)
            }
            ,
            n.add = function(t, e, n) {
                void 0 === n && (n = !0),
                this.tests.set(t, e),
                n && this.suite.push(t)
            }
            ,
            n.run = function(t, e, n, r) {
                return this.tests.get(t)({
                    el: e,
                    event: n,
                    href: r
                })
            }
            ,
            n.checkLink = function(t, e, n) {
                var r = this;
                return this.suite.some((function(i) {
                    return r.run(i, t, e, n)
                }
                ))
            }
            ,
            e
        }(X)
          , et = function(t) {
            function e(n, r) {
                var i;
                void 0 === r && (r = "Barba error");
                for (var o = arguments.length, s = new Array(o > 2 ? o - 2 : 0), a = 2; a < o; a++)
                    s[a - 2] = arguments[a];
                return (i = t.call.apply(t, [this].concat(s)) || this).error = n,
                i.label = r,
                Error.captureStackTrace && Error.captureStackTrace(function(t) {
                    if (void 0 === t)
                        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                    return t
                }(i), e),
                i.name = "BarbaError",
                i
            }
            return r(e, t),
            e
        }(a(Error))
          , nt = function() {
            function t(t) {
                void 0 === t && (t = []),
                this.logger = new f("@barba/core"),
                this.all = [],
                this.page = [],
                this.once = [],
                this.A = [{
                    name: "namespace",
                    type: "strings"
                }, {
                    name: "custom",
                    type: "function"
                }],
                t && (this.all = this.all.concat(t)),
                this.update()
            }
            var e = t.prototype;
            return e.add = function(t, e) {
                switch (t) {
                case "rule":
                    this.A.splice(e.position || 0, 0, e.value);
                    break;
                case "transition":
                default:
                    this.all.push(e)
                }
                this.update()
            }
            ,
            e.resolve = function(t, e) {
                var n = this;
                void 0 === e && (e = {});
                var r = e.once ? this.once : this.page;
                r = r.filter(e.self ? function(t) {
                    return t.name && "self" === t.name
                }
                : function(t) {
                    return !t.name || "self" !== t.name
                }
                );
                var i = new Map
                  , o = r.find((function(r) {
                    var o = !0
                      , s = {};
                    return !(!e.self || "self" !== r.name) || (n.A.reverse().forEach((function(e) {
                        o && (o = n.R(r, e, t, s),
                        r.from && r.to && (o = n.R(r, e, t, s, "from") && n.R(r, e, t, s, "to")),
                        r.from && !r.to && (o = n.R(r, e, t, s, "from")),
                        !r.from && r.to && (o = n.R(r, e, t, s, "to")))
                    }
                    )),
                    i.set(r, s),
                    o)
                }
                ))
                  , s = i.get(o)
                  , a = [];
                if (a.push(e.once ? "once" : "page"),
                e.self && a.push("self"),
                s) {
                    var u, l = [o];
                    Object.keys(s).length > 0 && l.push(s),
                    (u = this.logger).info.apply(u, ["Transition found [" + a.join(",") + "]"].concat(l))
                } else
                    this.logger.info("No transition found [" + a.join(",") + "]");
                return o
            }
            ,
            e.update = function() {
                var t = this;
                this.all = this.all.map((function(e) {
                    return t.T(e)
                }
                )).sort((function(t, e) {
                    return t.priority - e.priority
                }
                )).reverse().map((function(t) {
                    return delete t.priority,
                    t
                }
                )),
                this.page = this.all.filter((function(t) {
                    return void 0 !== t.leave || void 0 !== t.enter
                }
                )),
                this.once = this.all.filter((function(t) {
                    return void 0 !== t.once
                }
                ))
            }
            ,
            e.R = function(t, e, n, r, i) {
                var o = !0
                  , s = !1
                  , a = t
                  , u = e.name
                  , l = u
                  , c = u
                  , f = u
                  , h = i ? a[i] : a
                  , d = "to" === i ? n.next : n.current;
                if (i ? h && h[u] : h[u]) {
                    switch (e.type) {
                    case "strings":
                    default:
                        var p = Array.isArray(h[l]) ? h[l] : [h[l]];
                        d[l] && -1 !== p.indexOf(d[l]) && (s = !0),
                        -1 === p.indexOf(d[l]) && (o = !1);
                        break;
                    case "object":
                        var g = Array.isArray(h[c]) ? h[c] : [h[c]];
                        d[c] ? (d[c].name && -1 !== g.indexOf(d[c].name) && (s = !0),
                        -1 === g.indexOf(d[c].name) && (o = !1)) : o = !1;
                        break;
                    case "function":
                        h[f](n) ? s = !0 : o = !1
                    }
                    s && (i ? (r[i] = r[i] || {},
                    r[i][u] = a[i][u]) : r[u] = a[u])
                }
                return o
            }
            ,
            e.O = function(t, e, n) {
                var r = 0;
                return (t[e] || t.from && t.from[e] || t.to && t.to[e]) && (r += Math.pow(10, n),
                t.from && t.from[e] && (r += 1),
                t.to && t.to[e] && (r += 2)),
                r
            }
            ,
            e.T = function(t) {
                var e = this;
                t.priority = 0;
                var n = 0;
                return this.A.forEach((function(r, i) {
                    n += e.O(t, r.name, i + 1)
                }
                )),
                t.priority = n,
                t
            }
            ,
            t
        }()
          , rt = function() {
            function t(t) {
                void 0 === t && (t = []),
                this.logger = new f("@barba/core"),
                this.S = !1,
                this.store = new nt(t)
            }
            var n = t.prototype;
            return n.get = function(t, e) {
                return this.store.resolve(t, e)
            }
            ,
            n.doOnce = function(t) {
                var e = t.data
                  , n = t.transition;
                try {
                    var r = function() {
                        i.S = !1
                    }
                      , i = this
                      , o = n || {};
                    i.S = !0;
                    var s = u((function() {
                        return Promise.resolve(i.j("beforeOnce", e, o)).then((function() {
                            return Promise.resolve(i.once(e, o)).then((function() {
                                return Promise.resolve(i.j("afterOnce", e, o)).then((function() {}
                                ))
                            }
                            ))
                        }
                        ))
                    }
                    ), (function(t) {
                        i.S = !1,
                        i.logger.debug("Transition error [before/after/once]"),
                        i.logger.error(t)
                    }
                    ));
                    return Promise.resolve(s && s.then ? s.then(r) : r())
                } catch (t) {
                    return Promise.reject(t)
                }
            }
            ,
            n.doPage = function(t) {
                var e = t.data
                  , n = t.transition
                  , r = t.page
                  , i = t.wrapper;
                try {
                    var o = function(t) {
                        if (s)
                            return t;
                        a.S = !1
                    }
                      , s = !1
                      , a = this
                      , l = n || {}
                      , c = !0 === l.sync || !1;
                    a.S = !0;
                    var f = u((function() {
                        function t() {
                            return Promise.resolve(a.j("before", e, l)).then((function() {
                                function t(t) {
                                    return Promise.resolve(a.remove(e)).then((function() {
                                        return Promise.resolve(a.j("after", e, l)).then((function() {}
                                        ))
                                    }
                                    ))
                                }
                                var n = function() {
                                    if (c)
                                        return u((function() {
                                            return Promise.resolve(a.add(e, i)).then((function() {
                                                return Promise.resolve(a.j("beforeLeave", e, l)).then((function() {
                                                    return Promise.resolve(a.j("beforeEnter", e, l)).then((function() {
                                                        return Promise.resolve(Promise.all([a.leave(e, l), a.enter(e, l)])).then((function() {
                                                            return Promise.resolve(a.j("afterLeave", e, l)).then((function() {
                                                                return Promise.resolve(a.j("afterEnter", e, l)).then((function() {}
                                                                ))
                                                            }
                                                            ))
                                                        }
                                                        ))
                                                    }
                                                    ))
                                                }
                                                ))
                                            }
                                            ))
                                        }
                                        ), (function(t) {
                                            if (a.M(t))
                                                throw new et(t,"Transition error [sync]")
                                        }
                                        ));
                                    var t = function(t) {
                                        return u((function() {
                                            var t = function() {
                                                if (!1 !== n)
                                                    return Promise.resolve(a.add(e, i)).then((function() {
                                                        return Promise.resolve(a.j("beforeEnter", e, l)).then((function() {
                                                            return Promise.resolve(a.enter(e, l, n)).then((function() {
                                                                return Promise.resolve(a.j("afterEnter", e, l)).then((function() {}
                                                                ))
                                                            }
                                                            ))
                                                        }
                                                        ))
                                                    }
                                                    ))
                                            }();
                                            if (t && t.then)
                                                return t.then((function() {}
                                                ))
                                        }
                                        ), (function(t) {
                                            if (a.M(t))
                                                throw new et(t,"Transition error [before/after/enter]")
                                        }
                                        ))
                                    }
                                      , n = !1
                                      , o = u((function() {
                                        return Promise.resolve(a.j("beforeLeave", e, l)).then((function() {
                                            return Promise.resolve(Promise.all([a.leave(e, l), A(r, e)]).then((function(t) {
                                                return t[0]
                                            }
                                            ))).then((function(t) {
                                                return n = t,
                                                Promise.resolve(a.j("afterLeave", e, l)).then((function() {}
                                                ))
                                            }
                                            ))
                                        }
                                        ))
                                    }
                                    ), (function(t) {
                                        if (a.M(t))
                                            throw new et(t,"Transition error [before/after/leave]")
                                    }
                                    ));
                                    return o && o.then ? o.then(t) : t()
                                }();
                                return n && n.then ? n.then(t) : t()
                            }
                            ))
                        }
                        var n = function() {
                            if (c)
                                return Promise.resolve(A(r, e)).then((function() {}
                                ))
                        }();
                        return n && n.then ? n.then(t) : t()
                    }
                    ), (function(t) {
                        if (a.S = !1,
                        t.name && "BarbaError" === t.name)
                            throw a.logger.debug(t.label),
                            a.logger.error(t.error),
                            t;
                        throw a.logger.debug("Transition error [page]"),
                        a.logger.error(t),
                        t
                    }
                    ));
                    return Promise.resolve(f && f.then ? f.then(o) : o(f))
                } catch (t) {
                    return Promise.reject(t)
                }
            }
            ,
            n.once = function(t, e) {
                try {
                    return Promise.resolve(H.do("once", t, e)).then((function() {
                        return e.once ? B(e.once, e)(t) : Promise.resolve()
                    }
                    ))
                } catch (t) {
                    return Promise.reject(t)
                }
            }
            ,
            n.leave = function(t, e) {
                try {
                    return Promise.resolve(H.do("leave", t, e)).then((function() {
                        return e.leave ? B(e.leave, e)(t) : Promise.resolve()
                    }
                    ))
                } catch (t) {
                    return Promise.reject(t)
                }
            }
            ,
            n.enter = function(t, e, n) {
                try {
                    return Promise.resolve(H.do("enter", t, e)).then((function() {
                        return e.enter ? B(e.enter, e)(t, n) : Promise.resolve()
                    }
                    ))
                } catch (t) {
                    return Promise.reject(t)
                }
            }
            ,
            n.add = function(t, e) {
                try {
                    return S.addContainer(t.next.container, e),
                    H.do("nextAdded", t),
                    Promise.resolve()
                } catch (t) {
                    return Promise.reject(t)
                }
            }
            ,
            n.remove = function(t) {
                try {
                    return S.removeContainer(t.current.container),
                    H.do("currentRemoved", t),
                    Promise.resolve()
                } catch (t) {
                    return Promise.reject(t)
                }
            }
            ,
            n.M = function(t) {
                return t.message ? !/Timeout error|Fetch error/.test(t.message) : !t.status
            }
            ,
            n.j = function(t, e, n) {
                try {
                    return Promise.resolve(H.do(t, e, n)).then((function() {
                        return n[t] ? B(n[t], n)(e) : Promise.resolve()
                    }
                    ))
                } catch (t) {
                    return Promise.reject(t)
                }
            }
            ,
            e(t, [{
                key: "isRunning",
                get: function() {
                    return this.S
                },
                set: function(t) {
                    this.S = t
                }
            }, {
                key: "hasOnce",
                get: function() {
                    return this.store.once.length > 0
                }
            }, {
                key: "hasSelf",
                get: function() {
                    return this.store.all.some((function(t) {
                        return "self" === t.name
                    }
                    ))
                }
            }, {
                key: "shouldWait",
                get: function() {
                    return this.store.all.some((function(t) {
                        return t.to && !t.to.route || t.sync
                    }
                    ))
                }
            }]),
            t
        }()
          , it = function() {
            function t(t) {
                var e = this;
                this.names = ["beforeLeave", "afterLeave", "beforeEnter", "afterEnter"],
                this.byNamespace = new Map,
                0 !== t.length && (t.forEach((function(t) {
                    e.byNamespace.set(t.namespace, t)
                }
                )),
                this.names.forEach((function(t) {
                    H[t](e.L(t))
                }
                )))
            }
            return t.prototype.L = function(t) {
                var e = this;
                return function(n) {
                    var r = t.match(/enter/i) ? n.next : n.current
                      , i = e.byNamespace.get(r.namespace);
                    return i && i[t] ? B(i[t], i)(n) : Promise.resolve()
                }
            }
            ,
            t
        }();
        Element.prototype.matches || (Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector),
        Element.prototype.closest || (Element.prototype.closest = function(t) {
            var e = this;
            do {
                if (e.matches(t))
                    return e;
                e = e.parentElement || e.parentNode
            } while (null !== e && 1 === e.nodeType);
            return null
        }
        );
        var ot = {
            container: null,
            html: "",
            namespace: "",
            url: {
                hash: "",
                href: "",
                path: "",
                port: null,
                query: {}
            }
        };
        return new (function() {
            function t() {
                this.version = "2.9.7",
                this.schemaPage = ot,
                this.Logger = f,
                this.logger = new f("@barba/core"),
                this.plugins = [],
                this.hooks = H,
                this.dom = S,
                this.helpers = D,
                this.history = P,
                this.request = I,
                this.url = R
            }
            var r = t.prototype;
            return r.use = function(t, e) {
                var n = this.plugins;
                n.indexOf(t) > -1 ? this.logger.warn("Plugin [" + t.name + "] already installed.") : "function" == typeof t.install ? (t.install(this, e),
                n.push(t)) : this.logger.warn("Plugin [" + t.name + '] has no "install" method.')
            }
            ,
            r.init = function(t) {
                var e = void 0 === t ? {} : t
                  , r = e.transitions
                  , i = void 0 === r ? [] : r
                  , o = e.views
                  , s = void 0 === o ? [] : o
                  , a = e.schema
                  , u = void 0 === a ? E : a
                  , l = e.requestError
                  , c = e.timeout
                  , h = void 0 === c ? 2e3 : c
                  , d = e.cacheIgnore
                  , p = void 0 !== d && d
                  , g = e.prefetchIgnore
                  , v = void 0 !== g && g
                  , m = e.preventRunning
                  , y = void 0 !== m && m
                  , x = e.prevent
                  , b = void 0 === x ? null : x
                  , w = e.debug
                  , _ = e.logLevel;
                if (f.setLevel(!0 === (void 0 !== w && w) ? "debug" : void 0 === _ ? "off" : _),
                this.logger.info(this.version),
                Object.keys(u).forEach((function(t) {
                    E[t] && (E[t] = u[t])
                }
                )),
                this.$ = l,
                this.timeout = h,
                this.cacheIgnore = p,
                this.prefetchIgnore = v,
                this.preventRunning = y,
                this._ = this.dom.getWrapper(),
                !this._)
                    throw new Error("[@barba/core] No Barba wrapper found");
                this._.setAttribute("aria-live", "polite"),
                this.q();
                var T = this.data.current;
                if (!T.container)
                    throw new Error("[@barba/core] No Barba container found");
                if (this.cache = new z(p),
                this.prevent = new tt(v),
                this.transitions = new rt(i),
                this.views = new it(s),
                null !== b) {
                    if ("function" != typeof b)
                        throw new Error("[@barba/core] Prevent should be a function");
                    this.prevent.add("preventCustom", b)
                }
                this.history.init(T.url.href, T.namespace),
                this.B = this.B.bind(this),
                this.U = this.U.bind(this),
                this.D = this.D.bind(this),
                this.F(),
                this.plugins.forEach((function(t) {
                    return t.init()
                }
                ));
                var k = this.data;
                k.trigger = "barba",
                k.next = k.current,
                k.current = n({}, this.schemaPage),
                this.hooks.do("ready", k),
                this.once(k),
                this.q()
            }
            ,
            r.destroy = function() {
                this.q(),
                this.H(),
                this.history.clear(),
                this.hooks.clear(),
                this.plugins = []
            }
            ,
            r.force = function(t) {
                window.location.assign(t)
            }
            ,
            r.go = function(t, e, n) {
                var r;
                if (void 0 === e && (e = "barba"),
                this.transitions.isRunning)
                    this.force(t);
                else if (!(r = "popstate" === e ? this.history.current && this.url.getPath(this.history.current.url) === this.url.getPath(t) : this.prevent.run("sameUrl", null, null, t)) || this.transitions.hasSelf)
                    return e = this.history.change(t, e, n),
                    n && (n.stopPropagation(),
                    n.preventDefault()),
                    this.page(t, e, r)
            }
            ,
            r.once = function(t) {
                try {
                    var e = this;
                    return Promise.resolve(e.hooks.do("beforeEnter", t)).then((function() {
                        function n() {
                            return Promise.resolve(e.hooks.do("afterEnter", t)).then((function() {}
                            ))
                        }
                        var r = function() {
                            if (e.transitions.hasOnce) {
                                var n = e.transitions.get(t, {
                                    once: !0
                                });
                                return Promise.resolve(e.transitions.doOnce({
                                    transition: n,
                                    data: t
                                })).then((function() {}
                                ))
                            }
                        }();
                        return r && r.then ? r.then(n) : n()
                    }
                    ))
                } catch (t) {
                    return Promise.reject(t)
                }
            }
            ,
            r.page = function(t, e, r) {
                try {
                    var i = function() {
                        var t = o.data;
                        return Promise.resolve(o.hooks.do("page", t)).then((function() {
                            var e = u((function() {
                                var e = o.transitions.get(t, {
                                    once: !1,
                                    self: r
                                });
                                return Promise.resolve(o.transitions.doPage({
                                    data: t,
                                    page: s,
                                    transition: e,
                                    wrapper: o._
                                })).then((function() {
                                    o.q()
                                }
                                ))
                            }
                            ), (function() {
                                0 === f.getLevel() && o.force(t.current.url.href)
                            }
                            ));
                            if (e && e.then)
                                return e.then((function() {}
                                ))
                        }
                        ))
                    }
                      , o = this;
                    o.data.next.url = n({
                        href: t
                    }, o.url.parse(t)),
                    o.data.trigger = e;
                    var s = o.cache.has(t) ? o.cache.update(t, {
                        action: "click"
                    }).request : o.cache.set(t, o.request(t, o.timeout, o.onRequestError.bind(o, e)), "click").request
                      , a = function() {
                        if (o.transitions.shouldWait)
                            return Promise.resolve(A(s, o.data)).then((function() {}
                            ))
                    }();
                    return Promise.resolve(a && a.then ? a.then(i) : i())
                } catch (t) {
                    return Promise.reject(t)
                }
            }
            ,
            r.onRequestError = function(t) {
                this.transitions.isRunning = !1;
                for (var e = arguments.length, n = new Array(e > 1 ? e - 1 : 0), r = 1; r < e; r++)
                    n[r - 1] = arguments[r];
                var i = n[0]
                  , o = n[1]
                  , s = this.cache.getAction(i);
                return this.cache.delete(i),
                !(this.$ && !1 === this.$(t, s, i, o) || ("click" === s && this.force(i),
                1))
            }
            ,
            r.prefetch = function(t) {
                var e = this;
                this.cache.has(t) || this.cache.set(t, this.request(t, this.timeout, this.onRequestError.bind(this, "barba")).catch((function(t) {
                    e.logger.error(t)
                }
                )), "prefetch")
            }
            ,
            r.F = function() {
                !0 !== this.prefetchIgnore && (document.addEventListener("mouseover", this.B),
                document.addEventListener("touchstart", this.B)),
                document.addEventListener("click", this.U),
                window.addEventListener("popstate", this.D)
            }
            ,
            r.H = function() {
                !0 !== this.prefetchIgnore && (document.removeEventListener("mouseover", this.B),
                document.removeEventListener("touchstart", this.B)),
                document.removeEventListener("click", this.U),
                window.removeEventListener("popstate", this.D)
            }
            ,
            r.B = function(t) {
                var e = this
                  , n = this.I(t);
                if (n) {
                    var r = this.dom.getHref(n);
                    this.prevent.checkHref(r) || this.cache.has(r) || this.cache.set(r, this.request(r, this.timeout, this.onRequestError.bind(this, n)).catch((function(t) {
                        e.logger.error(t)
                    }
                    )), "enter")
                }
            }
            ,
            r.U = function(t) {
                var e = this.I(t);
                if (e)
                    return this.transitions.isRunning && this.preventRunning ? (t.preventDefault(),
                    void t.stopPropagation()) : void this.go(this.dom.getHref(e), e, t)
            }
            ,
            r.D = function(t) {
                this.go(this.url.getHref(), "popstate", t)
            }
            ,
            r.I = function(t) {
                for (var e = t.target; e && !this.dom.getHref(e); )
                    e = e.parentNode;
                if (e && !this.prevent.checkLink(e, t, this.dom.getHref(e)))
                    return e
            }
            ,
            r.q = function() {
                var t = this.url.getHref()
                  , e = {
                    container: this.dom.getContainer(),
                    html: this.dom.getHtml(),
                    namespace: this.dom.getNamespace(),
                    url: n({
                        href: t
                    }, this.url.parse(t))
                };
                this.C = {
                    current: e,
                    next: n({}, this.schemaPage),
                    trigger: void 0
                },
                this.hooks.do("reset", this.data)
            }
            ,
            e(t, [{
                key: "data",
                get: function() {
                    return this.C
                }
            }, {
                key: "wrapper",
                get: function() {
                    return this._
                }
            }]),
            t
        }())
    }()
}
, function(t, e, n) {
    "use strict";
    (function(t) {
        n.d(e, "a", (function() {
            return f
        }
        ));
        var r = n(8)
          , i = n(16)
          , o = (n(5),
        n(4))
          , s = n(17)
          , a = n(18)
          , u = n(19)
          , l = n(9);
        function c(t, e) {
            for (var n = 0; n < e.length; n++) {
                var r = e[n];
                r.enumerable = r.enumerable || !1,
                r.configurable = !0,
                "value"in r && (r.writable = !0),
                Object.defineProperty(t, r.key, r)
            }
        }
        var f = new (function() {
            function e() {
                !function(t, e) {
                    if (!(t instanceof e))
                        throw new TypeError("Cannot call a class as a function")
                }(this, e)
            }
            var n, f, h;
            return n = e,
            (f = [{
                key: "bindMethods",
                value: function() {
                    var t = this;
                    ["scroll", "run", "resize"].forEach((function(e) {
                        return t[e] = t[e].bind(t)
                    }
                    ))
                }
            }, {
                key: "setStyles",
                value: function() {
                    this.dom.el.style.position = "fixed",
                    this.dom.el.style.top = 0,
                    this.dom.el.style.left = 0,
                    this.dom.el.style.height = "100%",
                    this.dom.el.style.width = "100%",
                    this.dom.el.style.overflow = "hidden"
                }
            }, {
                key: "setHeight",
                value: function() {
                    document.body.style.height = "".concat(this.dom.content.offsetHeight, "px")
                }
            }, {
                key: "resize",
                value: function() {
                    this.setHeight(),
                    this.scroll()
                }
            }, {
                key: "scroll",
                value: function() {
                    this.data.current = window.scrollY
                }
            }, {
                key: "run",
                value: function() {
                    this.data.last = this.math.lerp(this.data.last, this.data.current, this.data.ease),
                    this.data.last = Math.floor(100 * this.data.last) / 100,
                    this.data.current,
                    this.data.last,
                    this.config.width,
                    t(window).width() > 1024 && (this.dom.content.style.transform = "translate3d(0, -".concat(this.data.last.toFixed(0), "px, 0)")),
                    //! - =========================  conditions  ========================= -//
                    "index" === this.isPage && (this.once || (r.a.init(this.contentPage),
                    this.once = !0),
                    t(window).width() > 1024 && r.a.onScroll(this.data.last)),
                    "product" === this.isPage && (this.once || (t(window).width() < 1024 && (this.slider = this.contentPage.querySelectorAll(".js-slider").forEach((function(t) {
                        new o.a(t)
                    }
                    ))),
                    l.a.init(this.contentPage),
                    i.a.init(this.contentPage),
                    u.a.init(this.contentPage),
                    this.once = !0),
                    t(window).width() > 1024 && l.a.onScroll(this.data.last.toFixed(0))),
                    "collection" === this.isPage && (this.once || (s.a.init(this.contentPage),
                    this.once = !0)),
                    "article" === this.isPage && (this.once || (a.a.init(this.contentPage),
                    this.once = !0)),
                    this.requestAnimationFrame()
                }
            }, {
                key: "on",
                value: function() {
                    var e = !(arguments.length > 0 && void 0 !== arguments[0]) || arguments[0];
                    t(window).width() > 1024 && (this.setStyles(),
                    this.setHeight()),
                    this.addEvents(),
                    e && this.requestAnimationFrame()
                }
            }, {
                key: "off",
                value: function() {
                    var t = !(arguments.length > 0 && void 0 !== arguments[0]) || arguments[0];
                    t && this.cancelAnimationFrame(),
                    this.removeEvents()
                }
            }, {
                key: "requestAnimationFrame",
                value: function(t) {
                    function e() {
                        return t.apply(this, arguments)
                    }
                    return e.toString = function() {
                        return t.toString()
                    }
                    ,
                    e
                }((function() {
                    this.rAF = requestAnimationFrame(this.run)
                }
                ))
            }, {
                key: "cancelAnimationFrame",
                value: function(t) {
                    function e() {
                        return t.apply(this, arguments)
                    }
                    return e.toString = function() {
                        return t.toString()
                    }
                    ,
                    e
                }((function() {
                    cancelAnimationFrame(this.rAF)
                }
                ))
            }, {
                key: "destroy",
                value: function() {
                    this.off(),
                    document.body.style.height = "",
                    this.data = null
                }
            }, {
                key: "resize",
                value: function() {
                    this.setHeight()
                }
            }, {
                key: "addEvents",
                value: function() {
                    window.addEventListener("resize", this.resize, {
                        passive: !0
                    }),
                    window.addEventListener("scroll", this.scroll, {
                        passive: !0
                    })
                }
            }, {
                key: "removeEvents",
                value: function() {
                    window.removeEventListener("resize", this.resize, {
                        passive: !0
                    }),
                    window.removeEventListener("scroll", this.scroll, {
                        passive: !0
                    })
                }
            }, {
                key: "init",
                value: function(e, n, r) {
                    this.contentPage = document.querySelector("[data-scroll-content]"),
                    this.isPage = t(this.contentPage).data("ispage"),
                    this.once = !1,
                    this.math = {
                        lerp: function(t, e, n) {
                            return (1 - n) * t + n * e
                        },
                        norm: function(t, e, n) {
                            return (t - e) / (n - e)
                        }
                    },
                    this.config = {
                        height: window.innerHeight,
                        width: window.innerWidth
                    },
                    this.bindMethods(),
                    this.data = {
                        ease: .06,
                        current: 0,
                        last: 0
                    },
                    this.dom = {
                        el: document.querySelector("[data-scroll]"),
                        content: document.querySelector("[data-scroll-content]")
                    },
                    this.rAF = null,
                    this.on()
                }
            }]) && c(n.prototype, f),
            h && c(n, h),
            e
        }())
    }
    ).call(this, n(1))
}
, function(t, e, n) {
    "use strict";
    (function(t) {
        n.d(e, "a", (function() {
            return a
        }
        ));
        var r = n(0)
          , i = n(15)
          , o = n(4);
        function s(t, e) {
            for (var n = 0; n < e.length; n++) {
                var r = e[n];
                r.enumerable = r.enumerable || !1,
                r.configurable = !0,
                "value"in r && (r.writable = !0),
                Object.defineProperty(t, r.key, r)
            }
        }
        r.a.registerPlugin(i.a);
        var a = new (function() {
            function e() {
                !function(t, e) {
                    if (!(t instanceof e))
                        throw new TypeError("Cannot call a class as a function")
                }(this, e)
            }
            var n, i, a;
            return n = e,
            (i = [{
                key: "init",
                value: function(e) {
                    this.contentPage = e,
                    this.body = document.querySelector("body");
                    var n = this.contentPage;
                    this.qsa = function(t) {
                        var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : n;
                        return e.querySelectorAll(t)
                    }
                    ,
                    this.qs = function(t) {
                        var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : n;
                        return e.querySelector(t)
                    }
                    ,
                    this.add_to_cart_all = this.qsa(".collect-index__add button"),
                    this.slider = this.contentPage.querySelectorAll(".js-slider"),
                    this.slider.forEach((function(t) {
                        new o.a(t)
                    }
                    )),
                    this.vh = window.innerHeight,
                    t(window).width() > 1024 && this.onScene(),
                    this.onResize(),
                    this.onClick()                }
            }, {
                key: "onScene",
                value: function() {
                    this.collection = this.qs(".collect-index__travel"),
                    this.each_prod = this.qsa(".collect-index__each"),
                    this.arrows = this.qsa(".trg-nav"),
                    r.a.timeline({
                        scrollTrigger: {
                            start: "top 50% ",
                            trigger: this.collection,
                            once: !0
                        }
                    }).from(this.each_prod, {
                        duration: 2,
                        yPercent: 30,
                        ease: "expo.out",
                        stagger: .08
                    }).from(this.each_prod, {
                        duration: .8,
                        opacity: 0,
                        ease: "none",
                        stagger: .08
                    }, 0).from(this.arrows, {
                        duration: .8,
                        opacity: 0,
                        ease: "none"
                    }, 1.5),
                    this.blog_hold = this.qs(".blog-index__hold"),
                    this.blog_title = this.qs("h1.the-sl"),
                    r.a.timeline({
                        scrollTrigger: {
                            start: "top 50% ",
                            trigger: this.blog_hold,
                            once: !0
                        }
                    }).from(this.blog_hold, {
                        duration: 1.2,
                        scale: .6,
                        yPercent: -22.5,
                        ease: "expo.inOut"
                    }, 0).to(this.blog_title, {
                        duration: 1.2,
                        xPercent: 4,
                        ease: "expo.inOut"
                    }, 0)
                }
            }, {
                key: "onClick",
                value: function() {
                    t(this.add_to_cart_all).click((function() {
                        t(this).addClass("loading-item")
                    }
                    ))
                }
            }, {
                key: "onScroll",
                value: function(e) {
                    e < .05 * this.vh ? t(this.body).addClass("is-top-home") : t(this.body).hasClass("is-top-home") && t(this.body).removeClass("is-top-home")
                }
            }, {
                key: "onResize",
                value: function() {
                    var e = this;
                    t(window).resize((function() {
                        e.vh = window.innerHeight
                    }
                    ))
                }
            }]) && s(n.prototype, i),
            a && s(n, a),
            e
        }())
    }
    ).call(this, n(1))
}
, function(t, e, n) {
    "use strict";
    (function(t) {
        function r(t, e) {
            for (var n = 0; n < e.length; n++) {
                var r = e[n];
                r.enumerable = r.enumerable || !1,
                r.configurable = !0,
                "value"in r && (r.writable = !0),
                Object.defineProperty(t, r.key, r)
            }
        }
        n.d(e, "a", (function() {
            return i
        }
        ));
        var i = new (function() {
            function e() {
                !function(t, e) {
                    if (!(t instanceof e))
                        throw new TypeError("Cannot call a class as a function")
                }(this, e)
            }
            var n, i, o;
            return n = e,
            (i = [{
                key: "init",
                value: function(t) {
                    this.contentPage = t;
                    var e = this.contentPage;
                    this.qsa = function(t) {
                        var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : e;
                        return n.querySelectorAll(t)
                    }
                    ,
                    this.qs = function(t) {
                        var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : e;
                        return n.querySelector(t)
                    }
                    ,
                    this.header = {
                        release: this.qs(".release-infos"),
                        infos: this.qs(".header-prod__infos")
                    },
                    this.vh = window.innerHeight,
                    this.onResize()
                }
            }, {
                key: "onScroll",
                value: function(t) {
                    var e = this.header.release.getBoundingClientRect().top;
                    t > .18 * this.vh && e > this.vh - .03 * this.vh && (this.header.infos.style.transform = "translate3d(0px, ".concat(t - .18 * this.vh, "px, 0px)"))
                }
            }, {
                key: "onResize",
                value: function() {
                    var e = this;
                    t(window).resize((function() {
                        e.vh = window.innerHeight
                    }
                    ))
                }
            }]) && r(n.prototype, i),
            o && r(n, o),
            e
        }())
    }
    ).call(this, n(1))
}
, function(t, e, n) {
    "use strict";
    (function(t) {
        n.d(e, "a", (function() {
            return o
        }
        ));
        var r = n(0);
        function i(t, e) {
            for (var n = 0; n < e.length; n++) {
                var r = e[n];
                r.enumerable = r.enumerable || !1,
                r.configurable = !0,
                "value"in r && (r.writable = !0),
                Object.defineProperty(t, r.key, r)
            }
        }
        var o = new (function() {
            function e() {
                !function(t, e) {
                    if (!(t instanceof e))
                        throw new TypeError("Cannot call a class as a function")
                }(this, e)
            }
            var n, o, s;
            return n = e,
            (o = [{
                key: "init",
                value: function() {
                    var t = document;
                    this.qsa = function(e) {
                        var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : t;
                        return n.querySelectorAll(e)
                    }
                    ,
                    this.qs = function(e) {
                        var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : t;
                        return n.querySelector(e)
                    }
                    ,
                    this.my_storage = localStorage.getItem("cookieBar", null),
                    this.menu = {
                        main: this.qs(".menu-fs"),
                        close: this.qs(".menu-fs__close"),
                        trg: this.qs(".menu-trg"),
                        shop_trg: this.qs(".shop-text"),
                        dropd_shop: this.qs(".menu-fs__shop__link"),
                        links: this.qsa(".menu-fs__links li a")
                    },
                    this.cookies = {
                        el: this.qs(".cookies"),
                        close: this.qs(".cookies__close")
                    },
                    this.onClick(),
                    this.verifyStorage()
                }
            }, {
                key: "onClick",
                value: function() {
                    var e = this;
                    t(this.menu.trg).click((function() {
                        t(e.menu.main).toggleClass("active-menu")
                    }
                    )),
                    this.lines = this.qsa(".menu-trg__hold .line"),
                    t(this.menu.trg).mouseenter((function() {
                        e.lines.forEach((function(t, e) {
                            r.a.delayedCall(.1 * e, (function() {
                                r.a.to(t, {
                                    duration: .3,
                                    scaleX: 0,
                                    transformOrigin: "right",
                                    ease: "expo.in",
                                    overwrite: "auto"
                                }),
                                r.a.to(t, {
                                    delay: .3,
                                    duration: .6,
                                    scaleX: 1,
                                    transformOrigin: "left",
                                    ease: "expo.out",
                                    overwrite: "auto"
                                })
                            }
                            ))
                        }
                        ))
                    }
                    )),
                    t(this.menu.close).add(this.menu.links).click((function() {
                        t(e.menu.main).toggleClass("active-menu"),
                        console.log("to-close")
                    }
                    )),
                    t(this.menu.shop_trg).click((function() {
                        t(e.menu.dropd_shop).toggleClass("hide-drop")
                    }
                    )),
                    t(this.cookies.close).click((function() {
                        r.a.set(e.cookies.el, {
                            duration: 1,
                            autoAlpha: 0,
                            onComplete: function() {
                                t(e.cookies.el).remove(),
                                e.my_storage = localStorage.setItem("cookieBar", !0)
                            }
                        })
                    }
                    ))
                }
            }, {
                key: "fixMobile",
                value: function() {
                    var e = .01 * window.innerHeight;
                    document.documentElement.style.setProperty("--vh", "".concat(e, "px"));
                    var n = Math.max(document.documentElement.clientWidth, 320)
                      , r = .01 * n;
                    document.documentElement.style.setProperty("--vw", "".concat(r, "px")),
                    t(window).resize((function() {
                        e = .01 * window.innerHeight,
                        r = .01 * n,
                        document.documentElement.style.setProperty("--vh", "".concat(e, "px")),
                        n = Math.max(document.documentElement.clientWidth, 320),
                        document.documentElement.style.setProperty("--vw", "".concat(r, "px"))
                    }
                    ))
                }
            }, {
                key: "verifyStorage",
                value: function() {
                    this.my_storage ? t(this.cookies.el).removeClass("new-user") : t(this.cookies.el).addClass("new-user")
                }
            }]) && i(n.prototype, o),
            s && i(n, s),
            e
        }())
    }
    ).call(this, n(1))
}
, function(t, e, n) {
    "use strict";
    var r, i, o, s, a, u, l, c, f = "transform", h = f + "Origin", d = function(t) {
        var e = t.ownerDocument || t;
        !(f in t.style) && "msTransform"in t.style && (h = (f = "msTransform") + "Origin");
        for (; e.parentNode && (e = e.parentNode); )
            ;
        if (i = window,
        l = new b,
        e) {
            r = e,
            o = e.documentElement,
            s = e.body;
            var n = e.createElement("div")
              , a = e.createElement("div");
            s.appendChild(n),
            n.appendChild(a),
            n.style.position = "static",
            n.style[f] = "translate3d(0,0,1px)",
            c = a.offsetParent !== n,
            s.removeChild(n)
        }
        return e
    }, p = [], g = [], v = function(t) {
        return t.ownerSVGElement || ("svg" === (t.tagName + "").toLowerCase() ? t : null)
    }, m = function t(e, n) {
        if (e.parentNode && (r || d(e))) {
            var i = v(e)
              , o = i ? i.getAttribute("xmlns") || "http://www.w3.org/2000/svg" : "http://www.w3.org/1999/xhtml"
              , s = i ? n ? "rect" : "g" : "div"
              , l = 2 !== n ? 0 : 100
              , c = 3 === n ? 100 : 0
              , f = "position:absolute;display:block;pointer-events:none;margin:0;padding:0;"
              , h = r.createElementNS ? r.createElementNS(o.replace(/^https/, "http"), s) : r.createElement(s);
            return n && (i ? (u || (u = t(e)),
            h.setAttribute("width", .01),
            h.setAttribute("height", .01),
            h.setAttribute("transform", "translate(" + l + "," + c + ")"),
            u.appendChild(h)) : (a || ((a = t(e)).style.cssText = f),
            h.style.cssText = f + "width:0.1px;height:0.1px;top:" + c + "px;left:" + l + "px",
            a.appendChild(h))),
            h
        }
        throw "Need document and parent."
    }, y = function(t, e) {
        var n, r, o, s, d, y, x = v(t), w = t === x, _ = x ? p : g, T = t.parentNode;
        if (t === i)
            return t;
        if (_.length || _.push(m(t, 1), m(t, 2), m(t, 3)),
        n = x ? u : a,
        x)
            o = w ? {
                x: 0,
                y: 0
            } : t.getBBox(),
            (r = t.transform ? t.transform.baseVal : {}).numberOfItems ? (s = (r = r.numberOfItems > 1 ? function(t) {
                for (var e = new b, n = 0; n < t.numberOfItems; n++)
                    e.multiply(t.getItem(n).matrix);
                return e
            }(r) : r.getItem(0).matrix).a * o.x + r.c * o.y,
            d = r.b * o.x + r.d * o.y) : (r = l,
            s = o.x,
            d = o.y),
            e && "g" === t.tagName.toLowerCase() && (s = d = 0),
            n.setAttribute("transform", "matrix(" + r.a + "," + r.b + "," + r.c + "," + r.d + "," + (r.e + s) + "," + (r.f + d) + ")"),
            (w ? x : T).appendChild(n);
        else {
            if (s = d = 0,
            c)
                for (r = t.offsetParent,
                o = t; o && (o = o.parentNode) && o !== r && o.parentNode; )
                    (i.getComputedStyle(o)[f] + "").length > 4 && (s = o.offsetLeft,
                    d = o.offsetTop,
                    o = 0);
            if ("absolute" !== (y = i.getComputedStyle(t)).position)
                for (r = t.offsetParent; T !== r; )
                    s += T.scrollLeft || 0,
                    d += T.scrollTop || 0,
                    T = T.parentNode;
            (o = n.style).top = t.offsetTop - d + "px",
            o.left = t.offsetLeft - s + "px",
            o[f] = y[f],
            o[h] = y[h],
            o.position = "fixed" === y.position ? "fixed" : "absolute",
            t.parentNode.appendChild(n)
        }
        return n
    }, x = function(t, e, n, r, i, o, s) {
        return t.a = e,
        t.b = n,
        t.c = r,
        t.d = i,
        t.e = o,
        t.f = s,
        t
    }, b = function() {
        function t(t, e, n, r, i, o) {
            void 0 === t && (t = 1),
            void 0 === e && (e = 0),
            void 0 === n && (n = 0),
            void 0 === r && (r = 1),
            void 0 === i && (i = 0),
            void 0 === o && (o = 0),
            x(this, t, e, n, r, i, o)
        }
        var e = t.prototype;
        return e.inverse = function() {
            var t = this.a
              , e = this.b
              , n = this.c
              , r = this.d
              , i = this.e
              , o = this.f
              , s = t * r - e * n || 1e-10;
            return x(this, r / s, -e / s, -n / s, t / s, (n * o - r * i) / s, -(t * o - e * i) / s)
        }
        ,
        e.multiply = function(t) {
            var e = this.a
              , n = this.b
              , r = this.c
              , i = this.d
              , o = this.e
              , s = this.f
              , a = t.a
              , u = t.c
              , l = t.b
              , c = t.d
              , f = t.e
              , h = t.f;
            return x(this, a * e + l * r, a * n + l * i, u * e + c * r, u * n + c * i, o + f * e + h * r, s + f * n + h * i)
        }
        ,
        e.clone = function() {
            return new t(this.a,this.b,this.c,this.d,this.e,this.f)
        }
        ,
        e.equals = function(t) {
            var e = this.a
              , n = this.b
              , r = this.c
              , i = this.d
              , o = this.e
              , s = this.f;
            return e === t.a && n === t.b && r === t.c && i === t.d && o === t.e && s === t.f
        }
        ,
        e.apply = function(t, e) {
            void 0 === e && (e = {});
            var n = t.x
              , r = t.y
              , i = this.a
              , o = this.b
              , s = this.c
              , a = this.d
              , u = this.e
              , l = this.f;
            return e.x = n * i + r * s + u || 0,
            e.y = n * o + r * a + l || 0,
            e
        }
        ,
        t
    }();
    /*!
 * matrix 3.6.0
 * https://greensock.com
 *
 * Copyright 2008-2021, GreenSock. All rights reserved.
 * Subject to the terms at https://greensock.com/standard-license or for
 * Club GreenSock members, the agreement issued with that membership.
 * @author: Jack Doyle, jack@greensock.com
*/
    function w(t, e, n, a) {
        if (!t || !t.parentNode || (r || d(t)).documentElement === t)
            return new b;
        var u = function(t) {
            for (var e, n; t && t !== s; )
                (n = t._gsap) && n.uncache && n.get(t, "x"),
                n && !n.scaleX && !n.scaleY && n.renderTransform && (n.scaleX = n.scaleY = 1e-4,
                n.renderTransform(1, n),
                e ? e.push(n) : e = [n]),
                t = t.parentNode;
            return e
        }(t)
          , l = v(t) ? p : g
          , c = y(t, n)
          , f = l[0].getBoundingClientRect()
          , h = l[1].getBoundingClientRect()
          , m = l[2].getBoundingClientRect()
          , x = c.parentNode
          , w = !a && function t(e) {
            return "fixed" === i.getComputedStyle(e).position || ((e = e.parentNode) && 1 === e.nodeType ? t(e) : void 0)
        }(t)
          , _ = new b((h.left - f.left) / 100,(h.top - f.top) / 100,(m.left - f.left) / 100,(m.top - f.top) / 100,f.left + (w ? 0 : i.pageXOffset || r.scrollLeft || o.scrollLeft || s.scrollLeft || 0),f.top + (w ? 0 : i.pageYOffset || r.scrollTop || o.scrollTop || s.scrollTop || 0));
        if (x.removeChild(c),
        u)
            for (f = u.length; f--; )
                (h = u[f]).scaleX = h.scaleY = 0,
                h.renderTransform(1, h);
        return e ? _.inverse() : _
    }
    n.d(e, "a", (function() {
        return Ht
    }
    ));
    /*!
 * Draggable 3.6.0
 * https://greensock.com
 *
 * @license Copyright 2008-2021, GreenSock. All rights reserved.
 * Subject to the terms at https://greensock.com/standard-license or for
 * Club GreenSock members, the agreement issued with that membership.
 * @author: Jack Doyle, jack@greensock.com
 */
    var _, T, k, C, E, S, P, A, O, D, M, L, q, N, j, R, I, F, B, H, X, z = function() {
        return "undefined" != typeof window
    }, Y = function() {
        return _ || z() && (_ = window.gsap) && _.registerPlugin && _
    }, W = function(t) {
        return "function" == typeof t
    }, U = function(t) {
        return "object" == typeof t
    }, $ = function(t) {
        return void 0 === t
    }, V = function() {
        return !1
    }, G = "transform", K = "transformOrigin", Q = function(t) {
        return Math.round(1e4 * t) / 1e4
    }, J = Array.isArray, Z = function(t, e) {
        var n = k.createElementNS ? k.createElementNS((e || "http://www.w3.org/1999/xhtml").replace(/^https/, "http"), t) : k.createElement(t);
        return n.style ? n : k.createElement(t)
    }, tt = 180 / Math.PI, et = 1e20, nt = new b, rt = Date.now || function() {
        return (new Date).getTime()
    }
    , it = [], ot = {}, st = 0, at = /^(?:a|input|textarea|button|select)$/i, ut = 0, lt = {}, ct = {}, ft = function(t, e) {
        var n, r = {};
        for (n in t)
            r[n] = e ? t[n] * e : t[n];
        return r
    }, ht = function t(e, n) {
        for (var r, i = e.length; i--; )
            n ? e[i].style.touchAction = n : e[i].style.removeProperty("touch-action"),
            (r = e[i].children) && r.length && t(r, n)
    }, dt = function() {
        return it.forEach((function(t) {
            return t()
        }
        ))
    }, pt = function() {
        return !it.length && _.ticker.remove(dt)
    }, gt = function(t) {
        for (var e = it.length; e--; )
            it[e] === t && it.splice(e, 1);
        _.to(pt, {
            overwrite: !0,
            delay: 15,
            duration: 0,
            onComplete: pt,
            data: "_draggable"
        })
    }, vt = function(t, e, n, r) {
        if (t.addEventListener) {
            var i = q[e];
            r = r || (M ? {
                passive: !1
            } : null),
            t.addEventListener(i || e, n, r),
            i && e !== i && t.addEventListener(e, n, r)
        }
    }, mt = function(t, e, n) {
        if (t.removeEventListener) {
            var r = q[e];
            t.removeEventListener(r || e, n),
            r && e !== r && t.removeEventListener(e, n)
        }
    }, yt = function(t) {
        t.preventDefault && t.preventDefault(),
        t.preventManipulation && t.preventManipulation()
    }, xt = function t(e) {
        j = e.touches && N < e.touches.length,
        mt(e.target, "touchend", t)
    }, bt = function(t) {
        j = t.touches && N < t.touches.length,
        vt(t.target, "touchend", xt)
    }, wt = function(t) {
        return T.pageYOffset || t.scrollTop || t.documentElement.scrollTop || t.body.scrollTop || 0
    }, _t = function(t) {
        return T.pageXOffset || t.scrollLeft || t.documentElement.scrollLeft || t.body.scrollLeft || 0
    }, Tt = function t(e, n) {
        vt(e, "scroll", n),
        Ct(e.parentNode) || t(e.parentNode, n)
    }, kt = function t(e, n) {
        mt(e, "scroll", n),
        Ct(e.parentNode) || t(e.parentNode, n)
    }, Ct = function(t) {
        return !(t && t !== C && 9 !== t.nodeType && t !== k.body && t !== T && t.nodeType && t.parentNode)
    }, Et = function(t, e) {
        var n = "x" === e ? "Width" : "Height"
          , r = "scroll" + n
          , i = "client" + n;
        return Math.max(0, Ct(t) ? Math.max(C[r], E[r]) - (T["inner" + n] || C[i] || E[i]) : t[r] - t[i])
    }, St = function t(e, n) {
        var r = Et(e, "x")
          , i = Et(e, "y");
        Ct(e) ? e = ct : t(e.parentNode, n),
        e._gsMaxScrollX = r,
        e._gsMaxScrollY = i,
        n || (e._gsScrollX = e.scrollLeft || 0,
        e._gsScrollY = e.scrollTop || 0)
    }, Pt = function(t, e, n) {
        var r = t.style;
        r && ($(r[e]) && (e = O(e, t) || e),
        null == n ? r.removeProperty && r.removeProperty(e.replace(/([A-Z])/g, "-$1").toLowerCase()) : r[e] = n)
    }, At = function(t) {
        return T.getComputedStyle(t instanceof Element ? t : t.host || (t.parentNode || {}).host || t)
    }, Ot = {}, Dt = function(t) {
        if (t === T)
            return Ot.left = Ot.top = 0,
            Ot.width = Ot.right = C.clientWidth || t.innerWidth || E.clientWidth || 0,
            Ot.height = Ot.bottom = (t.innerHeight || 0) - 20 < C.clientHeight ? C.clientHeight : t.innerHeight || E.clientHeight || 0,
            Ot;
        var e = t.ownerDocument || k
          , n = $(t.pageX) ? t.nodeType || $(t.left) || $(t.top) ? D(t)[0].getBoundingClientRect() : t : {
            left: t.pageX - _t(e),
            top: t.pageY - wt(e),
            right: t.pageX - _t(e) + 1,
            bottom: t.pageY - wt(e) + 1
        };
        return $(n.right) && !$(n.width) ? (n.right = n.left + n.width,
        n.bottom = n.top + n.height) : $(n.width) && (n = {
            width: n.right - n.left,
            height: n.bottom - n.top,
            right: n.right,
            left: n.left,
            bottom: n.bottom,
            top: n.top
        }),
        n
    }, Mt = function(t, e, n) {
        var r, i = t.vars, o = i[n], s = t._listeners[e];
        return W(o) && (r = o.apply(i.callbackScope || t, i[n + "Params"] || [t.pointerEvent])),
        s && !1 === t.dispatchEvent(e) && (r = !1),
        r
    }, Lt = function(t, e) {
        var n, r, i, o = D(t)[0];
        return o.nodeType || o === T ? Nt(o, e) : $(t.left) ? {
            left: r = t.min || t.minX || t.minRotation || 0,
            top: n = t.min || t.minY || 0,
            width: (t.max || t.maxX || t.maxRotation || 0) - r,
            height: (t.max || t.maxY || 0) - n
        } : (i = {
            x: 0,
            y: 0
        },
        {
            left: t.left - i.x,
            top: t.top - i.y,
            width: t.width,
            height: t.height
        })
    }, qt = {}, Nt = function(t, e) {
        e = D(e)[0];
        var n, r, i, o, s, a, u, l, c, f, h, d, p, g, v = t.getBBox && t.ownerSVGElement, m = t.ownerDocument || k;
        if (t === T)
            i = wt(m),
            r = (n = _t(m)) + (m.documentElement.clientWidth || t.innerWidth || m.body.clientWidth || 0),
            o = i + ((t.innerHeight || 0) - 20 < m.documentElement.clientHeight ? m.documentElement.clientHeight : t.innerHeight || m.body.clientHeight || 0);
        else {
            if (e === T || $(e))
                return t.getBoundingClientRect();
            n = i = 0,
            v ? (h = (f = t.getBBox()).width,
            d = f.height) : (t.viewBox && (f = t.viewBox.baseVal) && (n = f.x || 0,
            i = f.y || 0,
            h = f.width,
            d = f.height),
            h || (f = "border-box" === (p = At(t)).boxSizing,
            h = (parseFloat(p.width) || t.clientWidth || 0) + (f ? 0 : parseFloat(p.borderLeftWidth) + parseFloat(p.borderRightWidth)),
            d = (parseFloat(p.height) || t.clientHeight || 0) + (f ? 0 : parseFloat(p.borderTopWidth) + parseFloat(p.borderBottomWidth)))),
            r = h,
            o = d
        }
        return t === e ? {
            left: n,
            top: i,
            width: r - n,
            height: o - i
        } : (a = (s = w(e, !0).multiply(w(t))).apply({
            x: n,
            y: i
        }),
        u = s.apply({
            x: r,
            y: i
        }),
        l = s.apply({
            x: r,
            y: o
        }),
        c = s.apply({
            x: n,
            y: o
        }),
        n = Math.min(a.x, u.x, l.x, c.x),
        i = Math.min(a.y, u.y, l.y, c.y),
        {
            left: n + ((g = e.parentNode || {}).scrollLeft || 0),
            top: i + (g.scrollTop || 0),
            width: Math.max(a.x, u.x, l.x, c.x) - n,
            height: Math.max(a.y, u.y, l.y, c.y) - i
        })
    }, jt = function(t, e, n, r, i, o) {
        var s, a, u, l = {};
        if (e)
            if (1 !== i && e instanceof Array) {
                if (l.end = s = [],
                u = e.length,
                U(e[0]))
                    for (a = 0; a < u; a++)
                        s[a] = ft(e[a], i);
                else
                    for (a = 0; a < u; a++)
                        s[a] = e[a] * i;
                n += 1.1,
                r -= 1.1
            } else
                W(e) ? l.end = function(n) {
                    var r, o, s = e.call(t, n);
                    if (1 !== i)
                        if (U(s)) {
                            for (o in r = {},
                            s)
                                r[o] = s[o] * i;
                            s = r
                        } else
                            s *= i;
                    return s
                }
                : l.end = e;
        return (n || 0 === n) && (l.max = n),
        (r || 0 === r) && (l.min = r),
        o && (l.velocity = 0),
        l
    }, Rt = function t(e) {
        var n;
        return !(!e || !e.getAttribute || e === E) && (!("true" !== (n = e.getAttribute("data-clickable")) && ("false" === n || !e.onclick && !at.test(e.nodeName + "") && "true" !== e.getAttribute("contentEditable"))) || t(e.parentNode))
    }, It = function(t, e) {
        for (var n, r = t.length; r--; )
            (n = t[r]).ondragstart = n.onselectstart = e ? null : V,
            _.set(n, {
                lazy: !0,
                userSelect: e ? "text" : "none"
            })
    }, Ft = function(t, e) {
        t = _.utils.toArray(t)[0],
        e = e || {};
        var n, r, i, o, s, a, u = document.createElement("div"), l = u.style, c = t.firstChild, f = 0, h = 0, d = t.scrollTop, p = t.scrollLeft, g = t.scrollWidth, v = t.scrollHeight, m = 0, y = 0, x = 0;
        H && !1 !== e.force3D ? (s = "translate3d(",
        a = "px,0px)") : G && (s = "translate(",
        a = "px)"),
        this.scrollTop = function(t, e) {
            if (!arguments.length)
                return -this.top();
            this.top(-t, e)
        }
        ,
        this.scrollLeft = function(t, e) {
            if (!arguments.length)
                return -this.left();
            this.left(-t, e)
        }
        ,
        this.left = function(n, r) {
            if (!arguments.length)
                return -(t.scrollLeft + h);
            var i = t.scrollLeft - p
              , o = h;
            if ((i > 2 || i < -2) && !r)
                return p = t.scrollLeft,
                _.killTweensOf(this, {
                    left: 1,
                    scrollLeft: 1
                }),
                this.left(-p),
                void (e.onKill && e.onKill());
            (n = -n) < 0 ? (h = n - .5 | 0,
            n = 0) : n > y ? (h = n - y | 0,
            n = y) : h = 0,
            (h || o) && (this._skip || (l[G] = s + -h + "px," + -f + a),
            h + m >= 0 && (l.paddingRight = h + m + "px")),
            t.scrollLeft = 0 | n,
            p = t.scrollLeft
        }
        ,
        this.top = function(n, r) {
            if (!arguments.length)
                return -(t.scrollTop + f);
            var i = t.scrollTop - d
              , o = f;
            if ((i > 2 || i < -2) && !r)
                return d = t.scrollTop,
                _.killTweensOf(this, {
                    top: 1,
                    scrollTop: 1
                }),
                this.top(-d),
                void (e.onKill && e.onKill());
            (n = -n) < 0 ? (f = n - .5 | 0,
            n = 0) : n > x ? (f = n - x | 0,
            n = x) : f = 0,
            (f || o) && (this._skip || (l[G] = s + -h + "px," + -f + a)),
            t.scrollTop = 0 | n,
            d = t.scrollTop
        }
        ,
        this.maxScrollTop = function() {
            return x
        }
        ,
        this.maxScrollLeft = function() {
            return y
        }
        ,
        this.disable = function() {
            for (c = u.firstChild; c; )
                o = c.nextSibling,
                t.appendChild(c),
                c = o;
            t === u.parentNode && t.removeChild(u)
        }
        ,
        this.enable = function() {
            if ((c = t.firstChild) !== u) {
                for (; c; )
                    o = c.nextSibling,
                    u.appendChild(c),
                    c = o;
                t.appendChild(u),
                this.calibrate()
            }
        }
        ,
        this.calibrate = function(e) {
            var o, s, a, c = t.clientWidth === n;
            d = t.scrollTop,
            p = t.scrollLeft,
            c && t.clientHeight === r && u.offsetHeight === i && g === t.scrollWidth && v === t.scrollHeight && !e || ((f || h) && (s = this.left(),
            a = this.top(),
            this.left(-t.scrollLeft),
            this.top(-t.scrollTop)),
            o = At(t),
            c && !e || (l.display = "block",
            l.width = "auto",
            l.paddingRight = "0px",
            (m = Math.max(0, t.scrollWidth - t.clientWidth)) && (m += parseFloat(o.paddingLeft) + (X ? parseFloat(o.paddingRight) : 0))),
            l.display = "inline-block",
            l.position = "relative",
            l.overflow = "visible",
            l.verticalAlign = "top",
            l.boxSizing = "content-box",
            l.width = "100%",
            l.paddingRight = m + "px",
            X && (l.paddingBottom = o.paddingBottom),
            n = t.clientWidth,
            r = t.clientHeight,
            g = t.scrollWidth,
            v = t.scrollHeight,
            y = t.scrollWidth - n,
            x = t.scrollHeight - r,
            i = u.offsetHeight,
            l.display = "block",
            (s || a) && (this.left(s),
            this.top(a)))
        }
        ,
        this.content = u,
        this.element = t,
        this._skip = !1,
        this.enable()
    }, Bt = function(t) {
        if (z() && document.body) {
            var e = window && window.navigator;
            T = window,
            k = document,
            C = k.documentElement,
            E = k.body,
            S = Z("div"),
            B = !!window.PointerEvent,
            (P = Z("div")).style.cssText = "visibility:hidden;height:1px;top:-1px;pointer-events:none;position:relative;clear:both;cursor:grab",
            F = "grab" === P.style.cursor ? "grab" : "move",
            R = e && -1 !== e.userAgent.toLowerCase().indexOf("android"),
            L = "ontouchstart"in C && "orientation"in T || e && (e.MaxTouchPoints > 0 || e.msMaxTouchPoints > 0),
            r = Z("div"),
            i = Z("div"),
            o = i.style,
            s = E,
            o.display = "inline-block",
            o.position = "relative",
            r.style.cssText = i.innerHTML = "width:90px;height:40px;padding:10px;overflow:auto;visibility:hidden",
            r.appendChild(i),
            s.appendChild(r),
            n = i.offsetHeight + 18 > r.scrollHeight,
            s.removeChild(r),
            X = n,
            q = function(t) {
                for (var e = t.split(","), n = (("onpointerdown"in S ? "pointerdown,pointermove,pointerup,pointercancel" : "onmspointerdown"in S ? "MSPointerDown,MSPointerMove,MSPointerUp,MSPointerCancel" : t).split(",")), r = {}, i = 4; --i > -1; )
                    r[e[i]] = n[i],
                    r[n[i]] = e[i];
                try {
                    C.addEventListener("test", null, Object.defineProperty({}, "passive", {
                        get: function() {
                            M = 1
                        }
                    }))
                } catch (t) {}
                return r
            }("touchstart,touchmove,touchend,touchcancel"),
            vt(k, "touchcancel", V),
            vt(T, "touchmove", V),
            E && E.addEventListener("touchstart", V),
            vt(k, "contextmenu", (function() {
                for (var t in ot)
                    ot[t].isPressed && ot[t].endDrag()
            }
            )),
            _ = A = Y()
        }
        var n, r, i, o, s;
        _ ? (I = _.plugins.inertia,
        O = _.utils.checkPrefix,
        G = O(G),
        K = O(K),
        D = _.utils.toArray,
        H = !!O("perspective")) : t && console.warn("Please gsap.registerPlugin(Draggable)")
    }, Ht = function(t) {
        var e, n;
        function r(e, n) {
            var i;
            i = t.call(this) || this,
            _ || Bt(1),
            e = D(e)[0],
            I || (I = _.plugins.inertia),
            i.vars = n = ft(n || {}),
            i.target = e,
            i.x = i.y = i.rotation = 0,
            i.dragResistance = parseFloat(n.dragResistance) || 0,
            i.edgeResistance = isNaN(n.edgeResistance) ? 1 : parseFloat(n.edgeResistance) || 0,
            i.lockAxis = n.lockAxis,
            i.autoScroll = n.autoScroll || 0,
            i.lockedAxis = null,
            i.allowEventDefault = !!n.allowEventDefault,
            _.getProperty(e, "x");
            var o, s, a, u, l, c, f, h, d, p, g, v, m, y, x, E, S, A, O, M, H, X, z, Y, V, G, Z, at, pt, xt, Et, Ot = (n.type || "x,y").toLowerCase(), Nt = ~Ot.indexOf("x") || ~Ot.indexOf("y"), Ht = -1 !== Ot.indexOf("rotation"), Xt = Ht ? "rotation" : Nt ? "x" : "left", zt = Nt ? "y" : "top", Yt = !(!~Ot.indexOf("x") && !~Ot.indexOf("left") && "scroll" !== Ot), Wt = !(!~Ot.indexOf("y") && !~Ot.indexOf("top") && "scroll" !== Ot), Ut = n.minimumMovement || 2, $t = function(t) {
                if (void 0 === t)
                    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return t
            }(i), Vt = D(n.trigger || n.handle || e), Gt = {}, Kt = 0, Qt = !1, Jt = n.autoScrollMarginTop || 40, Zt = n.autoScrollMarginRight || 40, te = n.autoScrollMarginBottom || 40, ee = n.autoScrollMarginLeft || 40, ne = n.clickableTest || Rt, re = 0, ie = e._gsap || _.core.getCache(e), oe = function t(e) {
                return "fixed" === At(e).position || ((e = e.parentNode) && 1 === e.nodeType ? t(e) : void 0)
            }(e), se = function(t, n) {
                return parseFloat(ie.get(e, t, n))
            }, ae = e.ownerDocument || k, ue = function(t) {
                return yt(t),
                t.stopImmediatePropagation && t.stopImmediatePropagation(),
                !1
            }, le = function t(n) {
                if ($t.autoScroll && $t.isDragging && (Qt || S)) {
                    var r, i, o, a, u, l, c, f, d = e, p = 15 * $t.autoScroll;
                    for (Qt = !1,
                    ct.scrollTop = null != T.pageYOffset ? T.pageYOffset : null != ae.documentElement.scrollTop ? ae.documentElement.scrollTop : ae.body.scrollTop,
                    ct.scrollLeft = null != T.pageXOffset ? T.pageXOffset : null != ae.documentElement.scrollLeft ? ae.documentElement.scrollLeft : ae.body.scrollLeft,
                    a = $t.pointerX - ct.scrollLeft,
                    u = $t.pointerY - ct.scrollTop; d && !i; )
                        r = (i = Ct(d.parentNode)) ? ct : d.parentNode,
                        o = i ? {
                            bottom: Math.max(C.clientHeight, T.innerHeight || 0),
                            right: Math.max(C.clientWidth, T.innerWidth || 0),
                            left: 0,
                            top: 0
                        } : r.getBoundingClientRect(),
                        l = c = 0,
                        Wt && ((f = r._gsMaxScrollY - r.scrollTop) < 0 ? c = f : u > o.bottom - te && f ? (Qt = !0,
                        c = Math.min(f, p * (1 - Math.max(0, o.bottom - u) / te) | 0)) : u < o.top + Jt && r.scrollTop && (Qt = !0,
                        c = -Math.min(r.scrollTop, p * (1 - Math.max(0, u - o.top) / Jt) | 0)),
                        c && (r.scrollTop += c)),
                        Yt && ((f = r._gsMaxScrollX - r.scrollLeft) < 0 ? l = f : a > o.right - Zt && f ? (Qt = !0,
                        l = Math.min(f, p * (1 - Math.max(0, o.right - a) / Zt) | 0)) : a < o.left + ee && r.scrollLeft && (Qt = !0,
                        l = -Math.min(r.scrollLeft, p * (1 - Math.max(0, a - o.left) / ee) | 0)),
                        l && (r.scrollLeft += l)),
                        i && (l || c) && (T.scrollTo(r.scrollLeft, r.scrollTop),
                        _e($t.pointerX + l, $t.pointerY + c)),
                        d = r
                }
                if (S) {
                    var g = $t.x
                      , v = $t.y;
                    Ht ? ($t.deltaX = g - parseFloat(ie.rotation),
                    $t.rotation = g,
                    ie.rotation = g + "deg",
                    ie.renderTransform(1, ie)) : s ? (Wt && ($t.deltaY = v - s.top(),
                    s.top(v)),
                    Yt && ($t.deltaX = g - s.left(),
                    s.left(g))) : Nt ? (Wt && ($t.deltaY = v - parseFloat(ie.y),
                    ie.y = v + "px"),
                    Yt && ($t.deltaX = g - parseFloat(ie.x),
                    ie.x = g + "px"),
                    ie.renderTransform(1, ie)) : (Wt && ($t.deltaY = v - parseFloat(e.style.top || 0),
                    e.style.top = v + "px"),
                    Yt && ($t.deltaY = g - parseFloat(e.style.left || 0),
                    e.style.left = g + "px")),
                    !h || n || at || (at = !0,
                    !1 === Mt($t, "drag", "onDrag") && (Yt && ($t.x -= $t.deltaX),
                    Wt && ($t.y -= $t.deltaY),
                    t(!0)),
                    at = !1)
                }
                S = !1
            }, ce = function(t, n) {
                var r, i, o = $t.x, a = $t.y;
                e._gsap || (ie = _.core.getCache(e)),
                ie.uncache && _.getProperty(e, "x"),
                Nt ? ($t.x = parseFloat(ie.x),
                $t.y = parseFloat(ie.y)) : Ht ? $t.x = $t.rotation = parseFloat(ie.rotation) : s ? ($t.y = s.top(),
                $t.x = s.left()) : ($t.y = parseInt(e.style.top || (i = At(e)) && i.top, 10) || 0,
                $t.x = parseInt(e.style.left || (i || {}).left, 10) || 0),
                (O || M || H) && !n && ($t.isDragging || $t.isThrowing) && (H && (lt.x = $t.x,
                lt.y = $t.y,
                (r = H(lt)).x !== $t.x && ($t.x = r.x,
                S = !0),
                r.y !== $t.y && ($t.y = r.y,
                S = !0)),
                O && (r = O($t.x)) !== $t.x && ($t.x = r,
                Ht && ($t.rotation = r),
                S = !0),
                M && ((r = M($t.y)) !== $t.y && ($t.y = r),
                S = !0)),
                S && le(!0),
                t || ($t.deltaX = $t.x - o,
                $t.deltaY = $t.y - a,
                Mt($t, "throwupdate", "onThrowUpdate"))
            }, fe = function(t, e, n, r) {
                return null == e && (e = -et),
                null == n && (n = et),
                W(t) ? function(i) {
                    var o = $t.isPressed ? 1 - $t.edgeResistance : 1;
                    return t.call($t, i > n ? n + (i - n) * o : i < e ? e + (i - e) * o : i) * r
                }
                : J(t) ? function(r) {
                    for (var i, o, s = t.length, a = 0, u = et; --s > -1; )
                        (o = (i = t[s]) - r) < 0 && (o = -o),
                        o < u && i >= e && i <= n && (a = s,
                        u = o);
                    return t[a]
                }
                : isNaN(t) ? function(t) {
                    return t
                }
                : function() {
                    return t * r
                }
            }, he = function() {
                var t, r, i, o;
                f = !1,
                s ? (s.calibrate(),
                $t.minX = g = -s.maxScrollLeft(),
                $t.minY = m = -s.maxScrollTop(),
                $t.maxX = p = $t.maxY = v = 0,
                f = !0) : n.bounds && (t = Lt(n.bounds, e.parentNode),
                Ht ? ($t.minX = g = t.left,
                $t.maxX = p = t.left + t.width,
                $t.minY = m = $t.maxY = v = 0) : $(n.bounds.maxX) && $(n.bounds.maxY) ? (r = Lt(e, e.parentNode),
                $t.minX = g = Math.round(se(Xt, "px") + t.left - r.left - .5),
                $t.minY = m = Math.round(se(zt, "px") + t.top - r.top - .5),
                $t.maxX = p = Math.round(g + (t.width - r.width)),
                $t.maxY = v = Math.round(m + (t.height - r.height))) : (t = n.bounds,
                $t.minX = g = t.minX,
                $t.minY = m = t.minY,
                $t.maxX = p = t.maxX,
                $t.maxY = v = t.maxY),
                g > p && ($t.minX = p,
                $t.maxX = p = g,
                g = $t.minX),
                m > v && ($t.minY = v,
                $t.maxY = v = m,
                m = $t.minY),
                Ht && ($t.minRotation = g,
                $t.maxRotation = p),
                f = !0),
                n.liveSnap && (i = !0 === n.liveSnap ? n.snap || {} : n.liveSnap,
                o = J(i) || W(i),
                Ht ? (O = fe(o ? i : i.rotation, g, p, 1),
                M = null) : i.points ? H = function(t, e, n, r, i, o, s) {
                    return o = o && o < et ? o * o : et,
                    W(t) ? function(a) {
                        var u, l, c, f = $t.isPressed ? 1 - $t.edgeResistance : 1, h = a.x, d = a.y;
                        return a.x = h = h > n ? n + (h - n) * f : h < e ? e + (h - e) * f : h,
                        a.y = d = d > i ? i + (d - i) * f : d < r ? r + (d - r) * f : d,
                        (u = t.call($t, a)) !== a && (a.x = u.x,
                        a.y = u.y),
                        1 !== s && (a.x *= s,
                        a.y *= s),
                        o < et && (l = a.x - h) * l + (c = a.y - d) * c > o && (a.x = h,
                        a.y = d),
                        a
                    }
                    : J(t) ? function(e) {
                        for (var n, r, i, s, a = t.length, u = 0, l = et; --a > -1; )
                            (s = (n = (i = t[a]).x - e.x) * n + (r = i.y - e.y) * r) < l && (u = a,
                            l = s);
                        return l <= o ? t[u] : e
                    }
                    : function(t) {
                        return t
                    }
                }(o ? i : i.points, g, p, m, v, i.radius, s ? -1 : 1) : (Yt && (O = fe(o ? i : i.x || i.left || i.scrollLeft, g, p, s ? -1 : 1)),
                Wt && (M = fe(o ? i : i.y || i.top || i.scrollTop, m, v, s ? -1 : 1))))
            }, de = function() {
                $t.isThrowing = !1,
                Mt($t, "throwcomplete", "onThrowComplete")
            }, pe = function() {
                $t.isThrowing = !1
            }, ge = function(t, r) {
                var i, o, a, u;
                t && I ? (!0 === t && (i = n.snap || n.liveSnap || {},
                o = J(i) || W(i),
                t = {
                    resistance: (n.throwResistance || n.resistance || 1e3) / (Ht ? 10 : 1)
                },
                Ht ? t.rotation = jt($t, o ? i : i.rotation, p, g, 1, r) : (Yt && (t[Xt] = jt($t, o ? i : i.points || i.x || i.left, p, g, s ? -1 : 1, r || "x" === $t.lockedAxis)),
                Wt && (t[zt] = jt($t, o ? i : i.points || i.y || i.top, v, m, s ? -1 : 1, r || "y" === $t.lockedAxis)),
                (i.points || J(i) && U(i[0])) && (t.linkedProps = Xt + "," + zt,
                t.radius = i.radius))),
                $t.isThrowing = !0,
                u = isNaN(n.overshootTolerance) ? 1 === n.edgeResistance ? 0 : 1 - $t.edgeResistance + .2 : n.overshootTolerance,
                t.duration || (t.duration = {
                    max: Math.max(n.minDuration || 0, "maxDuration"in n ? n.maxDuration : 2),
                    min: isNaN(n.minDuration) ? 0 === u || U(t) && t.resistance > 1e3 ? 0 : .5 : n.minDuration,
                    overshoot: u
                }),
                $t.tween = a = _.to(s || e, {
                    inertia: t,
                    data: "_draggable",
                    onComplete: de,
                    onInterrupt: pe,
                    onUpdate: n.fastMode ? Mt : ce,
                    onUpdateParams: n.fastMode ? [$t, "onthrowupdate", "onThrowUpdate"] : i && i.radius ? [!1, !0] : []
                }),
                n.fastMode || (s && (s._skip = !0),
                a.render(1e9, !0, !0),
                ce(!0, !0),
                $t.endX = $t.x,
                $t.endY = $t.y,
                Ht && ($t.endRotation = $t.x),
                a.play(0),
                ce(!0, !0),
                s && (s._skip = !1))) : f && $t.applyBounds()
            }, ve = function(t) {
                var n, r = Y;
                Y = w(e.parentNode, !0),
                t && $t.isPressed && !Y.equals(r || new b) && (n = r.inverse().apply({
                    x: a,
                    y: u
                }),
                Y.apply(n, n),
                a = n.x,
                u = n.y),
                Y.equals(nt) && (Y = null)
            }, me = function() {
                var t, n, r, i = 1 - $t.edgeResistance, o = oe ? _t(ae) : 0, h = oe ? wt(ae) : 0;
                ve(!1),
                qt.x = $t.pointerX - o,
                qt.y = $t.pointerY - h,
                Y && Y.apply(qt, qt),
                a = qt.x,
                u = qt.y,
                S && (_e($t.pointerX, $t.pointerY),
                le(!0)),
                s ? (he(),
                c = s.top(),
                l = s.left()) : (ye() ? (ce(!0, !0),
                he()) : $t.applyBounds(),
                Ht ? (t = e.ownerSVGElement ? [ie.xOrigin - e.getBBox().x, ie.yOrigin - e.getBBox().y] : (At(e)[K] || "0 0").split(" "),
                E = $t.rotationOrigin = w(e).apply({
                    x: parseFloat(t[0]) || 0,
                    y: parseFloat(t[1]) || 0
                }),
                ce(!0, !0),
                n = $t.pointerX - E.x - o,
                r = E.y - $t.pointerY + h,
                l = $t.x,
                c = $t.y = Math.atan2(r, n) * tt) : (c = se(zt, "px"),
                l = se(Xt, "px"))),
                f && i && (l > p ? l = p + (l - p) / i : l < g && (l = g - (g - l) / i),
                Ht || (c > v ? c = v + (c - v) / i : c < m && (c = m - (m - c) / i))),
                $t.startX = l,
                $t.startY = c
            }, ye = function() {
                return $t.tween && $t.tween.isActive()
            }, xe = function() {
                !P.parentNode || ye() || $t.isDragging || P.parentNode.removeChild(P)
            }, be = function(t, i) {
                var l;
                if (!o || $t.isPressed || !t || !("mousedown" !== t.type && "pointerdown" !== t.type || i) && rt() - re < 30 && q[$t.pointerEvent.type])
                    Et && t && o && yt(t);
                else {
                    if (V = ye(),
                    $t.pointerEvent = t,
                    q[t.type] ? (z = ~t.type.indexOf("touch") ? t.currentTarget || t.target : ae,
                    vt(z, "touchend", Te),
                    vt(z, "touchmove", we),
                    vt(z, "touchcancel", Te),
                    vt(ae, "touchstart", bt)) : (z = null,
                    vt(ae, "mousemove", we)),
                    Z = null,
                    B && z || (vt(ae, "mouseup", Te),
                    t && t.target && vt(t.target, "mouseup", Te)),
                    X = ne.call($t, t.target) && !1 === n.dragClickables && !i)
                        return vt(t.target, "change", Te),
                        Mt($t, "pressInit", "onPressInit"),
                        Mt($t, "press", "onPress"),
                        It(Vt, !0),
                        void (Et = !1);
                    var c;
                    if (G = !(!z || Yt === Wt || !1 === $t.vars.allowNativeTouchScrolling || $t.vars.allowContextMenu && t && (t.ctrlKey || t.which > 2)) && (Yt ? "y" : "x"),
                    (Et = !G && !$t.allowEventDefault) && (yt(t),
                    vt(T, "touchforcechange", yt)),
                    t.changedTouches ? (t = y = t.changedTouches[0],
                    x = t.identifier) : t.pointerId ? x = t.pointerId : y = x = null,
                    N++,
                    c = le,
                    it.push(c),
                    1 === it.length && _.ticker.add(dt),
                    u = $t.pointerY = t.pageY,
                    a = $t.pointerX = t.pageX,
                    Mt($t, "pressInit", "onPressInit"),
                    (G || $t.autoScroll) && St(e.parentNode),
                    !e.parentNode || !$t.autoScroll || s || Ht || !e.parentNode._gsMaxScrollX || P.parentNode || e.getBBox || (P.style.width = e.parentNode.scrollWidth + "px",
                    e.parentNode.appendChild(P)),
                    me(),
                    $t.tween && $t.tween.kill(),
                    $t.isThrowing = !1,
                    _.killTweensOf(s || e, Gt, !0),
                    s && _.killTweensOf(e, {
                        scrollTo: 1
                    }, !0),
                    $t.tween = $t.lockedAxis = null,
                    (n.zIndexBoost || !Ht && !s && !1 !== n.zIndexBoost) && (e.style.zIndex = r.zIndex++),
                    $t.isPressed = !0,
                    h = !(!n.onDrag && !$t._listeners.drag),
                    d = !(!n.onMove && !$t._listeners.move),
                    !Ht && (!1 !== n.cursor || n.activeCursor))
                        for (l = Vt.length; --l > -1; )
                            _.set(Vt[l], {
                                cursor: n.activeCursor || n.cursor || ("grab" === F ? "grabbing" : F)
                            });
                    Mt($t, "press", "onPress")
                }
            }, we = function(t) {
                var n, r, i, s, l, c, f = t;
                if (o && !j && $t.isPressed && t) {
                    if ($t.pointerEvent = t,
                    n = t.changedTouches) {
                        if ((t = n[0]) !== y && t.identifier !== x) {
                            for (s = n.length; --s > -1 && (t = n[s]).identifier !== x && t.target !== e; )
                                ;
                            if (s < 0)
                                return
                        }
                    } else if (t.pointerId && x && t.pointerId !== x)
                        return;
                    z && G && !Z && (qt.x = t.pageX,
                    qt.y = t.pageY,
                    Y && Y.apply(qt, qt),
                    r = qt.x,
                    i = qt.y,
                    ((l = Math.abs(r - a)) !== (c = Math.abs(i - u)) && (l > Ut || c > Ut) || R && G === Z) && (Z = l > c && Yt ? "x" : "y",
                    G && Z !== G && vt(T, "touchforcechange", yt),
                    !1 !== $t.vars.lockAxisOnTouchScroll && Yt && Wt && ($t.lockedAxis = "x" === Z ? "y" : "x",
                    W($t.vars.onLockAxis) && $t.vars.onLockAxis.call($t, f)),
                    R && G === Z)) ? Te(f) : ($t.allowEventDefault || G && (!Z || G === Z) || !1 === f.cancelable ? Et && (Et = !1) : (yt(f),
                    Et = !0),
                    $t.autoScroll && (Qt = !0),
                    _e(t.pageX, t.pageY, d))
                } else
                    Et && t && o && yt(t)
            }, _e = function(t, e, n) {
                var r, i, o, s, h, d, y = 1 - $t.dragResistance, x = 1 - $t.edgeResistance, b = $t.pointerX, w = $t.pointerY, _ = c, T = $t.x, k = $t.y, C = $t.endX, P = $t.endY, A = $t.endRotation, D = S;
                $t.pointerX = t,
                $t.pointerY = e,
                oe && (t -= _t(ae),
                e -= wt(ae)),
                Ht ? (s = Math.atan2(E.y - e, t - E.x) * tt,
                (h = $t.y - s) > 180 ? (c -= 360,
                $t.y = s) : h < -180 && (c += 360,
                $t.y = s),
                $t.x !== l || Math.abs(c - s) > Ut ? ($t.y = s,
                o = l + (c - s) * y) : o = l) : (Y && (d = t * Y.a + e * Y.c + Y.e,
                e = t * Y.b + e * Y.d + Y.f,
                t = d),
                (i = e - u) < Ut && i > -Ut && (i = 0),
                (r = t - a) < Ut && r > -Ut && (r = 0),
                ($t.lockAxis || $t.lockedAxis) && (r || i) && ((d = $t.lockedAxis) || ($t.lockedAxis = d = Yt && Math.abs(r) > Math.abs(i) ? "y" : Wt ? "x" : null,
                d && W($t.vars.onLockAxis) && $t.vars.onLockAxis.call($t, $t.pointerEvent)),
                "y" === d ? i = 0 : "x" === d && (r = 0)),
                o = Q(l + r * y),
                s = Q(c + i * y)),
                (O || M || H) && ($t.x !== o || $t.y !== s && !Ht) ? (H && (lt.x = o,
                lt.y = s,
                d = H(lt),
                o = Q(d.x),
                s = Q(d.y)),
                O && (o = Q(O(o))),
                M && (s = Q(M(s)))) : f && (o > p ? o = p + Math.round((o - p) * x) : o < g && (o = g + Math.round((o - g) * x)),
                Ht || (s > v ? s = Math.round(v + (s - v) * x) : s < m && (s = Math.round(m + (s - m) * x)))),
                ($t.x !== o || $t.y !== s && !Ht) && (Ht ? ($t.endRotation = $t.x = $t.endX = o,
                S = !0) : (Wt && ($t.y = $t.endY = s,
                S = !0),
                Yt && ($t.x = $t.endX = o,
                S = !0)),
                n && !1 === Mt($t, "move", "onMove") ? ($t.pointerX = b,
                $t.pointerY = w,
                c = _,
                $t.x = T,
                $t.y = k,
                $t.endX = C,
                $t.endY = P,
                $t.endRotation = A,
                S = D) : !$t.isDragging && $t.isPressed && ($t.isDragging = !0,
                Mt($t, "dragstart", "onDragStart")))
            }, Te = function t(r, i) {
                if (o && $t.isPressed && (!r || null == x || i || !(r.pointerId && r.pointerId !== x && r.target !== e || r.changedTouches && !function(t, e) {
                    for (var n = t.length; n--; )
                        if (t[n].identifier === e)
                            return !0
                }(r.changedTouches, x)))) {
                    $t.isPressed = !1;
                    var s, a, u, l, c, f = r, h = $t.isDragging, d = $t.vars.allowContextMenu && r && (r.ctrlKey || r.which > 2), p = _.delayedCall(.001, xe);
                    if (z ? (mt(z, "touchend", t),
                    mt(z, "touchmove", we),
                    mt(z, "touchcancel", t),
                    mt(ae, "touchstart", bt)) : mt(ae, "mousemove", we),
                    mt(T, "touchforcechange", yt),
                    B && z || (mt(ae, "mouseup", t),
                    r && r.target && mt(r.target, "mouseup", t)),
                    S = !1,
                    X && !d)
                        return r && (mt(r.target, "change", t),
                        $t.pointerEvent = f),
                        It(Vt, !1),
                        Mt($t, "release", "onRelease"),
                        Mt($t, "click", "onClick"),
                        void (X = !1);
                    if (gt(le),
                    !Ht)
                        for (a = Vt.length; --a > -1; )
                            Pt(Vt[a], "cursor", n.cursor || (!1 !== n.cursor ? F : null));
                    if (h && (Kt = ut = rt(),
                    $t.isDragging = !1),
                    N--,
                    r) {
                        if ((s = r.changedTouches) && (r = s[0]) !== y && r.identifier !== x) {
                            for (a = s.length; --a > -1 && (r = s[a]).identifier !== x && r.target !== e; )
                                ;
                            if (a < 0)
                                return
                        }
                        $t.pointerEvent = f,
                        $t.pointerX = r.pageX,
                        $t.pointerY = r.pageY
                    }
                    return d && f ? (yt(f),
                    Et = !0,
                    Mt($t, "release", "onRelease")) : f && !h ? (Et = !1,
                    V && (n.snap || n.bounds) && ge(n.inertia || n.throwProps),
                    Mt($t, "release", "onRelease"),
                    R && "touchmove" === f.type || -1 !== f.type.indexOf("cancel") || (Mt($t, "click", "onClick"),
                    rt() - re < 300 && Mt($t, "doubleclick", "onDoubleClick"),
                    l = f.target || e,
                    re = rt(),
                    c = function() {
                        re === pt || !$t.enabled() || $t.isPressed || f.defaultPrevented || (l.click ? l.click() : ae.createEvent && ((u = ae.createEvent("MouseEvents")).initMouseEvent("click", !0, !0, T, 1, $t.pointerEvent.screenX, $t.pointerEvent.screenY, $t.pointerX, $t.pointerY, !1, !1, !1, !1, 0, null),
                        l.dispatchEvent(u)))
                    }
                    ,
                    R || f.defaultPrevented || _.delayedCall(.05, c))) : (ge(n.inertia || n.throwProps),
                    $t.allowEventDefault || !f || !1 === n.dragClickables && ne.call($t, f.target) || !h || G && (!Z || G !== Z) || !1 === f.cancelable ? Et = !1 : (Et = !0,
                    yt(f)),
                    Mt($t, "release", "onRelease")),
                    ye() && p.duration($t.tween.duration()),
                    h && Mt($t, "dragend", "onDragEnd"),
                    !0
                }
                Et && r && o && yt(r)
            }, ke = function(t) {
                if (t && $t.isDragging && !s) {
                    var n = t.target || e.parentNode
                      , r = n.scrollLeft - n._gsScrollX
                      , i = n.scrollTop - n._gsScrollY;
                    (r || i) && (Y ? (a -= r * Y.a + i * Y.c,
                    u -= i * Y.d + r * Y.b) : (a -= r,
                    u -= i),
                    n._gsScrollX += r,
                    n._gsScrollY += i,
                    _e($t.pointerX, $t.pointerY))
                }
            }, Ce = function(t) {
                var e = rt()
                  , n = e - re < 40
                  , r = e - Kt < 40
                  , i = n && pt === re
                  , o = $t.pointerEvent && $t.pointerEvent.defaultPrevented
                  , s = n && xt === re
                  , a = t.isTrusted || null == t.isTrusted && n && i;
                if ((i || r && !1 !== $t.vars.suppressClickOnDrag) && t.stopImmediatePropagation && t.stopImmediatePropagation(),
                n && (!$t.pointerEvent || !$t.pointerEvent.defaultPrevented) && (!i || a && !s))
                    return a && i && (xt = re),
                    void (pt = re);
                ($t.isPressed || r || n) && (a && t.detail && n && !o || yt(t)),
                n || r || (t && t.target && ($t.pointerEvent = t),
                Mt($t, "click", "onClick"))
            }, Ee = function(t) {
                return Y ? {
                    x: t.x * Y.a + t.y * Y.c + Y.e,
                    y: t.x * Y.b + t.y * Y.d + Y.f
                } : {
                    x: t.x,
                    y: t.y
                }
            };
            return (A = r.get(e)) && A.kill(),
            i.startDrag = function(t, n) {
                var r, i, o, s;
                be(t || $t.pointerEvent, !0),
                n && !$t.hitTest(t || $t.pointerEvent) && (r = Dt(t || $t.pointerEvent),
                i = Dt(e),
                o = Ee({
                    x: r.left + r.width / 2,
                    y: r.top + r.height / 2
                }),
                s = Ee({
                    x: i.left + i.width / 2,
                    y: i.top + i.height / 2
                }),
                a -= o.x - s.x,
                u -= o.y - s.y),
                $t.isDragging || ($t.isDragging = !0,
                Mt($t, "dragstart", "onDragStart"))
            }
            ,
            i.drag = we,
            i.endDrag = function(t) {
                return Te(t || $t.pointerEvent, !0)
            }
            ,
            i.timeSinceDrag = function() {
                return $t.isDragging ? 0 : (rt() - Kt) / 1e3
            }
            ,
            i.timeSinceClick = function() {
                return (rt() - re) / 1e3
            }
            ,
            i.hitTest = function(t, e) {
                return r.hitTest($t.target, t, e)
            }
            ,
            i.getDirection = function(t, n) {
                var r, i, o, s, a, u, f = "velocity" === t && I ? t : U(t) && !Ht ? "element" : "start";
                return "element" === f && (a = Dt($t.target),
                u = Dt(t)),
                r = "start" === f ? $t.x - l : "velocity" === f ? I.getVelocity(e, Xt) : a.left + a.width / 2 - (u.left + u.width / 2),
                Ht ? r < 0 ? "counter-clockwise" : "clockwise" : (n = n || 2,
                i = "start" === f ? $t.y - c : "velocity" === f ? I.getVelocity(e, zt) : a.top + a.height / 2 - (u.top + u.height / 2),
                s = (o = Math.abs(r / i)) < 1 / n ? "" : r < 0 ? "left" : "right",
                o < n && ("" !== s && (s += "-"),
                s += i < 0 ? "up" : "down"),
                s)
            }
            ,
            i.applyBounds = function(t, r) {
                var i, o, s, a, u, l;
                if (t && n.bounds !== t)
                    return n.bounds = t,
                    $t.update(!0, r);
                if (ce(!0),
                he(),
                f && !ye()) {
                    if (i = $t.x,
                    o = $t.y,
                    i > p ? i = p : i < g && (i = g),
                    o > v ? o = v : o < m && (o = m),
                    ($t.x !== i || $t.y !== o) && (s = !0,
                    $t.x = $t.endX = i,
                    Ht ? $t.endRotation = i : $t.y = $t.endY = o,
                    S = !0,
                    le(!0),
                    $t.autoScroll && !$t.isDragging))
                        for (St(e.parentNode),
                        a = e,
                        ct.scrollTop = null != T.pageYOffset ? T.pageYOffset : null != ae.documentElement.scrollTop ? ae.documentElement.scrollTop : ae.body.scrollTop,
                        ct.scrollLeft = null != T.pageXOffset ? T.pageXOffset : null != ae.documentElement.scrollLeft ? ae.documentElement.scrollLeft : ae.body.scrollLeft; a && !l; )
                            u = (l = Ct(a.parentNode)) ? ct : a.parentNode,
                            Wt && u.scrollTop > u._gsMaxScrollY && (u.scrollTop = u._gsMaxScrollY),
                            Yt && u.scrollLeft > u._gsMaxScrollX && (u.scrollLeft = u._gsMaxScrollX),
                            a = u;
                    $t.isThrowing && (s || $t.endX > p || $t.endX < g || $t.endY > v || $t.endY < m) && ge(n.inertia || n.throwProps, s)
                }
                return $t
            }
            ,
            i.update = function(t, n, r) {
                var i = $t.x
                  , o = $t.y;
                return ve(!n),
                t ? $t.applyBounds() : (S && r && le(!0),
                ce(!0)),
                n && (_e($t.pointerX, $t.pointerY),
                S && le(!0)),
                $t.isPressed && !n && (Yt && Math.abs(i - $t.x) > .01 || Wt && Math.abs(o - $t.y) > .01 && !Ht) && me(),
                $t.autoScroll && (St(e.parentNode, $t.isDragging),
                Qt = $t.isDragging,
                le(!0),
                kt(e, ke),
                Tt(e, ke)),
                $t
            }
            ,
            i.enable = function(t) {
                var r, i, a, u = {
                    lazy: !0
                };
                if (Ht || !1 === n.cursor || (u.cursor = n.cursor || F),
                _.utils.checkPrefix("touchCallout") && (u.touchCallout = "none"),
                "soft" !== t) {
                    for (ht(Vt, Yt === Wt ? "none" : n.allowNativeTouchScrolling && e.scrollHeight === e.clientHeight == (e.scrollWidth === e.clientHeight) || n.allowEventDefault ? "manipulation" : Yt ? "pan-y" : "pan-x"),
                    i = Vt.length; --i > -1; )
                        a = Vt[i],
                        B || vt(a, "mousedown", be),
                        vt(a, "touchstart", be),
                        vt(a, "click", Ce, !0),
                        _.set(a, u),
                        a.getBBox && a.ownerSVGElement && _.set(a.ownerSVGElement, {
                            touchAction: Yt === Wt ? "none" : n.allowNativeTouchScrolling || n.allowEventDefault ? "manipulation" : Yt ? "pan-y" : "pan-x"
                        }),
                        n.allowContextMenu || vt(a, "contextmenu", ue);
                    It(Vt, !1)
                }
                return Tt(e, ke),
                o = !0,
                I && "soft" !== t && I.track(s || e, Nt ? "x,y" : Ht ? "rotation" : "top,left"),
                e._gsDragID = r = "d" + st++,
                ot[r] = $t,
                s && (s.enable(),
                s.element._gsDragID = r),
                (n.bounds || Ht) && me(),
                n.bounds && $t.applyBounds(),
                $t
            }
            ,
            i.disable = function(t) {
                var n, r, i = $t.isDragging;
                if (!Ht)
                    for (n = Vt.length; --n > -1; )
                        Pt(Vt[n], "cursor", null);
                if ("soft" !== t) {
                    for (ht(Vt, null),
                    n = Vt.length; --n > -1; )
                        r = Vt[n],
                        Pt(r, "touchCallout", null),
                        mt(r, "mousedown", be),
                        mt(r, "touchstart", be),
                        mt(r, "click", Ce),
                        mt(r, "contextmenu", ue);
                    It(Vt, !0),
                    z && (mt(z, "touchcancel", Te),
                    mt(z, "touchend", Te),
                    mt(z, "touchmove", we)),
                    mt(ae, "mouseup", Te),
                    mt(ae, "mousemove", we)
                }
                return kt(e, ke),
                o = !1,
                I && "soft" !== t && I.untrack(s || e, Nt ? "x,y" : Ht ? "rotation" : "top,left"),
                s && s.disable(),
                gt(le),
                $t.isDragging = $t.isPressed = X = !1,
                i && Mt($t, "dragend", "onDragEnd"),
                $t
            }
            ,
            i.enabled = function(t, e) {
                return arguments.length ? t ? $t.enable(e) : $t.disable(e) : o
            }
            ,
            i.kill = function() {
                return $t.isThrowing = !1,
                $t.tween && $t.tween.kill(),
                $t.disable(),
                _.set(Vt, {
                    clearProps: "userSelect"
                }),
                delete ot[e._gsDragID],
                $t
            }
            ,
            ~Ot.indexOf("scroll") && (s = i.scrollProxy = new Ft(e,function(t, e) {
                for (var n in e)
                    n in t || (t[n] = e[n]);
                return t
            }({
                onKill: function() {
                    $t.isPressed && Te(null)
                }
            }, n)),
            e.style.overflowY = Wt && !L ? "auto" : "hidden",
            e.style.overflowX = Yt && !L ? "auto" : "hidden",
            e = s.content),
            Ht ? Gt.rotation = 1 : (Yt && (Gt[Xt] = 1),
            Wt && (Gt[zt] = 1)),
            ie.force3D = !("force3D"in n) || n.force3D,
            i.enable(),
            i
        }
        return n = t,
        (e = r).prototype = Object.create(n.prototype),
        e.prototype.constructor = e,
        e.__proto__ = n,
        r.register = function(t) {
            _ = t,
            Bt()
        }
        ,
        r.create = function(t, e) {
            return A || Bt(!0),
            D(t).map((function(t) {
                return new r(t,e)
            }
            ))
        }
        ,
        r.get = function(t) {
            return ot[(D(t)[0] || {})._gsDragID]
        }
        ,
        r.timeSinceDrag = function() {
            return (rt() - ut) / 1e3
        }
        ,
        r.hitTest = function(t, e, n) {
            if (t === e)
                return !1;
            var r, i, o, s = Dt(t), a = Dt(e), u = s.top, l = s.left, c = s.right, f = s.bottom, h = s.width, d = s.height, p = a.left > c || a.right < l || a.top > f || a.bottom < u;
            return p || !n ? !p : (o = -1 !== (n + "").indexOf("%"),
            n = parseFloat(n) || 0,
            (r = {
                left: Math.max(l, a.left),
                top: Math.max(u, a.top)
            }).width = Math.min(c, a.right) - r.left,
            r.height = Math.min(f, a.bottom) - r.top,
            !(r.width < 0 || r.height < 0) && (o ? (n *= .01,
            (i = r.width * r.height) >= h * d * n || i >= a.width * a.height * n) : r.width > n && r.height > n))
        }
        ,
        r
    }(function() {
        function t(t) {
            this._listeners = {},
            this.target = t || this
        }
        var e = t.prototype;
        return e.addEventListener = function(t, e) {
            var n = this._listeners[t] || (this._listeners[t] = []);
            ~n.indexOf(e) || n.push(e)
        }
        ,
        e.removeEventListener = function(t, e) {
            var n = this._listeners[t]
              , r = n && n.indexOf(e) || -1;
            r > -1 && n.splice(r, 1)
        }
        ,
        e.dispatchEvent = function(t) {
            var e, n = this;
            return (this._listeners[t] || []).forEach((function(r) {
                return !1 === r.call(n, {
                    type: t,
                    target: n.target
                }) && (e = !1)
            }
            )),
            e
        }
        ,
        t
    }());
    !function(t, e) {
        for (var n in e)
            n in t || (t[n] = e[n])
    }(Ht.prototype, {
        pointerX: 0,
        pointerY: 0,
        startX: 0,
        startY: 0,
        deltaX: 0,
        deltaY: 0,
        isDragging: !1,
        isPressed: !1
    }),
    Ht.zIndex = 1e3,
    Ht.version = "3.6.0",
    Y() && _.registerPlugin(Ht)
}
, function(t, e, n) {
    /*!
 * imagesLoaded v4.1.4
 * JavaScript is all like "You images are done yet or what?"
 * MIT License
 */
    !function(e, r) {
        "use strict";
        t.exports ? t.exports = r(e, n(25)) : e.imagesLoaded = r(e, e.EvEmitter)
    }("undefined" != typeof window ? window : this, (function(t, e) {
        "use strict";
        var n = t.jQuery
          , r = t.console;
        function i(t, e) {
            for (var n in e)
                t[n] = e[n];
            return t
        }
        var o = Array.prototype.slice;
        function s(t, e, a) {
            if (!(this instanceof s))
                return new s(t,e,a);
            var u, l = t;
            ("string" == typeof t && (l = document.querySelectorAll(t)),
            l) ? (this.elements = (u = l,
            Array.isArray(u) ? u : "object" == typeof u && "number" == typeof u.length ? o.call(u) : [u]),
            this.options = i({}, this.options),
            "function" == typeof e ? a = e : i(this.options, e),
            a && this.on("always", a),
            this.getImages(),
            n && (this.jqDeferred = new n.Deferred),
            setTimeout(this.check.bind(this))) : r.error("Bad element for imagesLoaded " + (l || t))
        }
        s.prototype = Object.create(e.prototype),
        s.prototype.options = {},
        s.prototype.getImages = function() {
            this.images = [],
            this.elements.forEach(this.addElementImages, this)
        }
        ,
        s.prototype.addElementImages = function(t) {
            "IMG" == t.nodeName && this.addImage(t),
            !0 === this.options.background && this.addElementBackgroundImages(t);
            var e = t.nodeType;
            if (e && a[e]) {
                for (var n = t.querySelectorAll("img"), r = 0; r < n.length; r++) {
                    var i = n[r];
                    this.addImage(i)
                }
                if ("string" == typeof this.options.background) {
                    var o = t.querySelectorAll(this.options.background);
                    for (r = 0; r < o.length; r++) {
                        var s = o[r];
                        this.addElementBackgroundImages(s)
                    }
                }
            }
        }
        ;
        var a = {
            1: !0,
            9: !0,
            11: !0
        };
        function u(t) {
            this.img = t
        }
        function l(t, e) {
            this.url = t,
            this.element = e,
            this.img = new Image
        }
        return s.prototype.addElementBackgroundImages = function(t) {
            var e = getComputedStyle(t);
            if (e)
                for (var n = /url\((['"])?(.*?)\1\)/gi, r = n.exec(e.backgroundImage); null !== r; ) {
                    var i = r && r[2];
                    i && this.addBackground(i, t),
                    r = n.exec(e.backgroundImage)
                }
        }
        ,
        s.prototype.addImage = function(t) {
            var e = new u(t);
            this.images.push(e)
        }
        ,
        s.prototype.addBackground = function(t, e) {
            var n = new l(t,e);
            this.images.push(n)
        }
        ,
        s.prototype.check = function() {
            var t = this;
            function e(e, n, r) {
                setTimeout((function() {
                    t.progress(e, n, r)
                }
                ))
            }
            this.progressedCount = 0,
            this.hasAnyBroken = !1,
            this.images.length ? this.images.forEach((function(t) {
                t.once("progress", e),
                t.check()
            }
            )) : this.complete()
        }
        ,
        s.prototype.progress = function(t, e, n) {
            this.progressedCount++,
            this.hasAnyBroken = this.hasAnyBroken || !t.isLoaded,
            this.emitEvent("progress", [this, t, e]),
            this.jqDeferred && this.jqDeferred.notify && this.jqDeferred.notify(this, t),
            this.progressedCount == this.images.length && this.complete(),
            this.options.debug && r && r.log("progress: " + n, t, e)
        }
        ,
        s.prototype.complete = function() {
            var t = this.hasAnyBroken ? "fail" : "done";
            if (this.isComplete = !0,
            this.emitEvent(t, [this]),
            this.emitEvent("always", [this]),
            this.jqDeferred) {
                var e = this.hasAnyBroken ? "reject" : "resolve";
                this.jqDeferred[e](this)
            }
        }
        ,
        u.prototype = Object.create(e.prototype),
        u.prototype.check = function() {
            this.getIsImageComplete() ? this.confirm(0 !== this.img.naturalWidth, "naturalWidth") : (this.proxyImage = new Image,
            this.proxyImage.addEventListener("load", this),
            this.proxyImage.addEventListener("error", this),
            this.img.addEventListener("load", this),
            this.img.addEventListener("error", this),
            this.proxyImage.src = this.img.src)
        }
        ,
        u.prototype.getIsImageComplete = function() {
            return this.img.complete && this.img.naturalWidth
        }
        ,
        u.prototype.confirm = function(t, e) {
            this.isLoaded = t,
            this.emitEvent("progress", [this, this.img, e])
        }
        ,
        u.prototype.handleEvent = function(t) {
            var e = "on" + t.type;
            this[e] && this[e](t)
        }
        ,
        u.prototype.onload = function() {
            this.confirm(!0, "onload"),
            this.unbindEvents()
        }
        ,
        u.prototype.onerror = function() {
            this.confirm(!1, "onerror"),
            this.unbindEvents()
        }
        ,
        u.prototype.unbindEvents = function() {
            this.proxyImage.removeEventListener("load", this),
            this.proxyImage.removeEventListener("error", this),
            this.img.removeEventListener("load", this),
            this.img.removeEventListener("error", this)
        }
        ,
        l.prototype = Object.create(u.prototype),
        l.prototype.check = function() {
            this.img.addEventListener("load", this),
            this.img.addEventListener("error", this),
            this.img.src = this.url,
            this.getIsImageComplete() && (this.confirm(0 !== this.img.naturalWidth, "naturalWidth"),
            this.unbindEvents())
        }
        ,
        l.prototype.unbindEvents = function() {
            this.img.removeEventListener("load", this),
            this.img.removeEventListener("error", this)
        }
        ,
        l.prototype.confirm = function(t, e) {
            this.isLoaded = t,
            this.emitEvent("progress", [this, this.element, e])
        }
        ,
        s.makeJQueryPlugin = function(e) {
            (e = e || t.jQuery) && ((n = e).fn.imagesLoaded = function(t, e) {
                return new s(this,t,e).jqDeferred.promise(n(this))
            }
            )
        }
        ,
        s.makeJQueryPlugin(),
        s
    }
    ))
}
, function(t, e, n) {
    "use strict";
    (function(t) {
        n.d(e, "a", (function() {
            return p
        }
        ));
        var r = n(6)
          , i = n.n(r)
          , o = n(14)
          , s = n.n(o)
          , a = n(0)
          , u = n(7)
          , l = n(5)
          , c = n(2)
          , f = (n(26),
        n(20))
          , h = n(21);
        function d(t, e) {
            for (var n = 0; n < e.length; n++) {
                var r = e[n];
                r.enumerable = r.enumerable || !1,
                r.configurable = !0,
                "value"in r && (r.writable = !0),
                Object.defineProperty(t, r.key, r)
            }
        }
        i.a.use(s.a);
        var p = function() {
            function e() {
                !function(t, e) {
                    if (!(t instanceof e))
                        throw new TypeError("Cannot call a class as a function")
                }(this, e),
                this.init()
            }
            var n, r, o;
            return n = e,
            (r = [{
                key: "init",
                value: function() {
                    this.body = document.querySelector("body"),
                    this.pagesFromMenu = document.querySelectorAll(".menu-fs__each");
                    var e = this;
                    i.a.init({
                        preventRunning: !0,
                        timeout: 5e3,
                        views: [{
                            namespace: "index",
                            beforeLeave: function(n) {
                                t(e.body).hasClass("is-top-home") && t(e.body).removeClass("is-top-home")
                            }
                        }, {
                            namespace: "about",
                            beforeEnter: function(t) {}
                        }, {
                            namespace: "login",
                            beforeEnter: function(e) {
                                var n = t(".toggle-forgot")
                                  , r = t(".forgot-form");
                                t(n).click((function() {
                                    t(r).toggleClass("js-hidden")
                                }
                                ))
                            }
                        }, {
                            namespace: "register",
                            beforeEnter: function(e) {
                                var n = t(".toggle-forgot")
                                  , r = t(".forgot-form");
                                t(n).click((function() {
                                    t(r).toggleClass("js-hidden")
                                }
                                ))
                            }
                        }, {
                            namespace: "account",
                            beforeEnter: function(t) {
                                h.a.init(t.next.container)
                            }
                        }, {
                            namespace: "wishlist",
                            beforeEnter: function(t) {
                                f.a.init(t.next.container)
                            }
                        }],
                        transitions: [{
                            sync: !0,
                            preventRunning: !0,
                            leave: function(t) {
                                var e = this.async();
                                a.a.set("body", {
                                    overflow: "hidden"
                                }),
                                u.a.destroy(),
                                t.trigger,
                                a.a.to("#barba-wrapper", {
                                    duration: .5,
                                    xPercent: -50,
                                    opacity: 0,
                                    ease: "power2.in",
                                    onComplete: function() {
                                        e();
                                        // kiwiSizeChartTrigger();
                                        setTimeout(() => {
                                            moveAnnouncementBar();
                                        }, 700);
                                        
                                        stoqTrigger(); 
                                    }
                                })
                            },
                            enter: function(t) {
                                t.current.namespace,
                                t.next.namespace
                            },
                            after: function(t) {
                                var n = t.next;
                                a.a.set("body", {
                                    overflowY: "auto"
                                }),
                                a.a.fromTo("#barba-wrapper", {
                                    opacity: 0,
                                    xPercent: 50
                                }, {
                                    delay: .15,
                                    xPercent: 0,
                                    duration: .8,
                                    opacity: 1,
                                    ease: "power3.out"
                                }),
                                e.callingFunctions(n)
                            },
                            once: function(n) {
                                var r = n.next;
                                e.callingFunctions(r),
                                t("body").hasClass("search") && a.a.delayedCall(2, (function() {
                                    window.dispatchEvent(new Event("resize"))
                                }
                                ))
                            }
                        }]
                    })
                }
            }, {
                key: "callingFunctions",
                value: function(t) {
                    function e() {
                        dataLayer.push(arguments)
                    }
                    window.scrollTo(0, 0),
                    history.scrollRestoration = "manual",
                    c.a.onClick(t.container),
                    "wishlist" != t.namespace && u.a.init(t.namespace, !1, t.container),
                    l.a.init(),
                    this.preventLink(),
                    window.dataLayer = window.dataLayer || [];
                    var n = window.location.href.replace(window.location.origin, "").toLowerCase();
                    e("js", new Date),
                    e("config", "UA-208122489-1", {
                        anonymize_ip: !0,
                        page_title: document.title,
                        page_path: n
                    })
                }
            }, {
                key: "preventLink",
                value: function() {
                    for (var t = document.querySelectorAll("a[href]"), e = function(t) {
                        t.currentTarget.href === window.location.href && (t.preventDefault(),
                        t.stopPropagation())
                    }, n = 0; n < t.length; n++)
                        t[n].addEventListener("click", e)
                }
            }]) && d(n.prototype, r),
            o && d(n, o),
            e
        }()
    }
    ).call(this, n(1))
}
, function(t, e, n) {
    var r;
    t.exports = (r = window.requestIdleCallback || function(t) {
        var e = Date.now();
        return setTimeout((function() {
            t({
                didTimeout: !1,
                timeRemaining: function() {
                    return Math.max(0, 50 - (Date.now() - e))
                }
            })
        }
        ), 1)
    }
    ,
    new (function() {
        function t() {
            this.name = "@barba/prefetch",
            this.version = "2.1.10",
            this.toPrefetch = new Set
        }
        var e = t.prototype;
        return e.install = function(t, e) {
            var n = void 0 === e ? {} : e
              , r = n.root
              , i = void 0 === r ? document.body : r
              , o = n.timeout
              , s = void 0 === o ? 2e3 : o;
            this.logger = new t.Logger(this.name),
            this.logger.info(this.version),
            this.barba = t,
            this.root = i,
            this.timeout = s
        }
        ,
        e.init = function() {
            var t = this;
            this.barba.prefetchIgnore ? this.logger.warn("barba.prefetchIgnore is enabled") : this.barba.cacheIgnore ? this.logger.warn("barba.cacheIgnore is enabled") : (this.observer = new IntersectionObserver((function(e) {
                e.forEach((function(e) {
                    if (e.isIntersecting) {
                        var n = e.target
                          , r = t.barba.dom.getHref(n);
                        t.toPrefetch.has(r) && (t.observer.unobserve(n),
                        t.barba.cache.has(r) ? t.barba.cache.update(r, {
                            action: "prefetch"
                        }) : t.barba.cache.set(r, t.barba.request(r, t.barba.timeout, t.barba.onRequestError.bind(t.barba, "barba")).catch((function(e) {
                            t.logger.error(e)
                        }
                        )), "prefetch"))
                    }
                }
                ))
            }
            )),
            this.observe(),
            this.barba.hooks.after(this.observe, this))
        }
        ,
        e.observe = function() {
            var t = this;
            r((function() {
                t.root.querySelectorAll("a").forEach((function(e) {
                    var n = e
                      , r = t.barba.dom.getHref(n);
                    t.barba.cache.has(r) || t.barba.prevent.checkHref(r) || t.barba.prevent.checkLink(n, {}, r) || (t.observer.observe(e),
                    t.toPrefetch.add(r))
                }
                ))
            }
            ), {
                timeout: this.timeout
            })
        }
        ,
        t
    }()))
}
, function(t, e, n) {
    "use strict";
    n.d(e, "a", (function() {
        return Ut
    }
    ));
    var r, i, o, s, a, u, l, c, f, h, d, p, g, v, m, y, x, b, w, _, T, k, C, E, S, P, A, O = 1, D = [], M = [], L = Date.now, q = L(), N = 0, j = 1, R = function(t) {
        return t
    }, I = function() {
        return "undefined" != typeof window
    }, F = function() {
        return r || I() && (r = window.gsap) && r.registerPlugin && r
    }, B = function(t) {
        return !!~l.indexOf(t)
    }, H = function(t, e) {
        return ~D.indexOf(t) && D[D.indexOf(t) + 1][e]
    }, X = function(t, e) {
        var n = e.s
          , r = e.sc
          , i = M.indexOf(t)
          , o = r === nt.sc ? 1 : 2;
        return !~i && (i = M.push(t) - 1),
        M[i + o] || (M[i + o] = H(t, n) || (B(t) ? r : function(e) {
            return arguments.length ? t[n] = e : t[n]
        }
        ))
    }, z = function(t) {
        return H(t, "getBoundingClientRect") || (B(t) ? function() {
            return Ht.width = o.innerWidth,
            Ht.height = o.innerHeight,
            Ht
        }
        : function() {
            return ot(t)
        }
        )
    }, Y = function(t, e) {
        var n = e.s
          , r = e.d2
          , i = e.d
          , s = e.a;
        return (n = "scroll" + r) && (s = H(t, n)) ? s() - z(t)()[i] : B(t) ? Math.max(a[n], u[n]) - (o["inner" + r] || a["client" + r] || u["client" + r]) : t[n] - t["offset" + r]
    }, W = function(t, e) {
        for (var n = 0; n < T.length; n += 3)
            (!e || ~e.indexOf(T[n + 1])) && t(T[n], T[n + 1], T[n + 2])
    }, U = function(t) {
        return "string" == typeof t
    }, $ = function(t) {
        return "function" == typeof t
    }, V = function(t) {
        return "number" == typeof t
    }, G = function(t) {
        return "object" == typeof t
    }, K = function(t) {
        return $(t) && t()
    }, Q = function(t, e) {
        return function() {
            var n = K(t)
              , r = K(e);
            return function() {
                K(n),
                K(r)
            }
        }
    }, J = Math.abs, Z = "padding", tt = "px", et = {
        s: "scrollLeft",
        p: "left",
        p2: "Left",
        os: "right",
        os2: "Right",
        d: "width",
        d2: "Width",
        a: "x",
        sc: function(t) {
            return arguments.length ? o.scrollTo(t, nt.sc()) : o.pageXOffset || s.scrollLeft || a.scrollLeft || u.scrollLeft || 0
        }
    }, nt = {
        s: "scrollTop",
        p: "top",
        p2: "Top",
        os: "bottom",
        os2: "Bottom",
        d: "height",
        d2: "Height",
        a: "y",
        op: et,
        sc: function(t) {
            return arguments.length ? o.scrollTo(et.sc(), t) : o.pageYOffset || s.scrollTop || a.scrollTop || u.scrollTop || 0
        }
    }, rt = function(t) {
        return o.getComputedStyle(t)
    }, it = function(t, e) {
        for (var n in e)
            n in t || (t[n] = e[n]);
        return t
    }, ot = function(t, e) {
        var n = e && "matrix(1, 0, 0, 1, 0, 0)" !== rt(t)[x] && r.to(t, {
            x: 0,
            y: 0,
            xPercent: 0,
            yPercent: 0,
            rotation: 0,
            rotationX: 0,
            rotationY: 0,
            scale: 1,
            skewX: 0,
            skewY: 0
        }).progress(1)
          , i = t.getBoundingClientRect();
        return n && n.progress(0).kill(),
        i
    }, st = function(t, e) {
        var n = e.d2;
        return t["offset" + n] || t["client" + n] || 0
    }, at = function(t) {
        var e, n = [], r = t.labels, i = t.duration();
        for (e in r)
            n.push(r[e] / i);
        return n
    }, ut = function(t, e, n, r) {
        return n.split(",").forEach((function(n) {
            return t(e, n, r)
        }
        ))
    }, lt = function(t, e, n) {
        return t.addEventListener(e, n, {
            passive: !0
        })
    }, ct = function(t, e, n) {
        return t.removeEventListener(e, n)
    }, ft = {
        startColor: "green",
        endColor: "red",
        indent: 0,
        fontSize: "16px",
        fontWeight: "normal"
    }, ht = {
        toggleActions: "play",
        anticipatePin: 0
    }, dt = {
        top: 0,
        left: 0,
        center: .5,
        bottom: 1,
        right: 1
    }, pt = function(t, e) {
        if (U(t)) {
            var n = t.indexOf("=")
              , r = ~n ? +(t.charAt(n - 1) + 1) * parseFloat(t.substr(n + 1)) : 0;
            ~n && (t.indexOf("%") > n && (r *= e / 100),
            t = t.substr(0, n - 1)),
            t = r + (t in dt ? dt[t] * e : ~t.indexOf("%") ? parseFloat(t) * e / 100 : parseFloat(t) || 0)
        }
        return t
    }, gt = function(t, e, n, r, i, o, a) {
        var l = i.startColor
          , c = i.endColor
          , f = i.fontSize
          , h = i.indent
          , d = i.fontWeight
          , p = s.createElement("div")
          , g = B(n) || "fixed" === H(n, "pinType")
          , v = -1 !== t.indexOf("scroller")
          , m = g ? u : n
          , y = -1 !== t.indexOf("start")
          , x = y ? l : c
          , b = "border-color:" + x + ";font-size:" + f + ";color:" + x + ";font-weight:" + d + ";pointer-events:none;white-space:nowrap;font-family:sans-serif,Arial;z-index:1000;padding:4px 8px;border-width:0;border-style:solid;";
        return b += "position:" + (v && g ? "fixed;" : "absolute;"),
        (v || !g) && (b += (r === nt ? "right" : "bottom") + ":" + (o + parseFloat(h)) + "px;"),
        a && (b += "box-sizing:border-box;text-align:left;width:" + a.offsetWidth + "px;"),
        p._isStart = y,
        p.setAttribute("class", "gsap-marker-" + t),
        p.style.cssText = b,
        p.innerText = e || 0 === e ? t + "-" + e : t,
        m.children[0] ? m.insertBefore(p, m.children[0]) : m.appendChild(p),
        p._offset = p["offset" + r.op.d2],
        vt(p, 0, r, y),
        p
    }, vt = function(t, e, n, i) {
        var o = {
            display: "block"
        }
          , s = n[i ? "os2" : "p2"]
          , a = n[i ? "p2" : "os2"];
        t._isFlipped = i,
        o[n.a + "Percent"] = i ? -100 : 0,
        o[n.a] = i ? "1px" : 0,
        o["border" + s + "Width"] = 1,
        o["border" + a + "Width"] = 0,
        o[n.p] = e + "px",
        r.set(t, o)
    }, mt = [], yt = {}, xt = function() {
        return h || (h = f(qt))
    }, bt = function() {
        h || (h = f(qt),
        N || St("scrollStart"),
        N = L())
    }, wt = function() {
        return !m && !E && !s.fullscreenElement && c.restart(!0)
    }, _t = {}, Tt = [], kt = [], Ct = function(t) {
        var e, n = r.ticker.frame, s = [], a = 0;
        if (A !== n || O) {
            for (Ot(); a < kt.length; a += 4)
                (e = o.matchMedia(kt[a]).matches) !== kt[a + 3] && (kt[a + 3] = e,
                e ? s.push(a) : Ot(1, kt[a]) || $(kt[a + 2]) && kt[a + 2]());
            for (At(),
            a = 0; a < s.length; a++)
                e = s[a],
                P = kt[e],
                kt[e + 2] = kt[e + 1](t);
            P = 0,
            i && Dt(0, 1),
            A = n,
            St("matchMedia")
        }
    }, Et = function t() {
        return ct(Ut, "scrollEnd", t) || Dt(!0)
    }, St = function(t) {
        return _t[t] && _t[t].map((function(t) {
            return t()
        }
        )) || Tt
    }, Pt = [], At = function(t) {
        for (var e = 0; e < Pt.length; e += 4)
            t && Pt[e + 3] !== t || (Pt[e].style.cssText = Pt[e + 1],
            Pt[e + 2].uncache = 1)
    }, Ot = function(t, e) {
        var n;
        for (b = 0; b < mt.length; b++)
            n = mt[b],
            e && n.media !== e || (t ? n.kill(1) : (n.scroll.rec || (n.scroll.rec = n.scroll()),
            n.revert()));
        At(e),
        e || St("revert")
    }, Dt = function(t, e) {
        if (!N || t) {
            var n = St("refreshInit");
            for (k && Ut.sort(),
            e || Ot(),
            b = 0; b < mt.length; b++)
                mt[b].refresh();
            for (n.forEach((function(t) {
                return t && t.render && t.render(-1)
            }
            )),
            b = mt.length; b--; )
                mt[b].scroll.rec = 0;
            c.pause(),
            St("refresh")
        } else
            lt(Ut, "scrollEnd", Et)
    }, Mt = 0, Lt = 1, qt = function() {
        var t = mt.length
          , e = L()
          , n = e - q >= 50
          , r = t && mt[0].scroll();
        if (Lt = Mt > r ? -1 : 1,
        Mt = r,
        n && (N && !y && e - N > 200 && (N = 0,
        St("scrollEnd")),
        g = q,
        q = e),
        Lt < 0) {
            for (b = t; b--; )
                mt[b] && mt[b].update(0, n);
            Lt = 1
        } else
            for (b = 0; b < t; b++)
                mt[b] && mt[b].update(0, n);
        h = 0
    }, Nt = ["left", "top", "bottom", "right", "marginBottom", "marginRight", "marginTop", "marginLeft", "display", "flexShrink", "float", "zIndex"], jt = Nt.concat(["width", "height", "boxSizing", "maxWidth", "maxHeight", "position", "margin", Z, Z + "Top", Z + "Right", Z + "Bottom", Z + "Left"]), Rt = function(t, e, n, r) {
        if (t.parentNode !== e) {
            for (var i, o = Nt.length, s = e.style, a = t.style; o--; )
                s[i = Nt[o]] = n[i];
            s.position = "absolute" === n.position ? "absolute" : "relative",
            "inline" === n.display && (s.display = "inline-block"),
            a.bottom = a.right = "auto",
            s.overflow = "visible",
            s.boxSizing = "border-box",
            s.width = st(t, et) + tt,
            s.height = st(t, nt) + tt,
            s[Z] = a.margin = a.top = a.left = "0",
            Ft(r),
            a.width = a.maxWidth = n.width,
            a.height = a.maxHeight = n.height,
            a[Z] = n[Z],
            t.parentNode.insertBefore(e, t),
            e.appendChild(t)
        }
    }, It = /([A-Z])/g, Ft = function(t) {
        if (t) {
            var e, n, i = t.t.style, o = t.length, s = 0;
            for ((t.t._gsap || r.core.getCache(t.t)).uncache = 1; s < o; s += 2)
                n = t[s + 1],
                e = t[s],
                n ? i[e] = n : i[e] && i.removeProperty(e.replace(It, "-$1").toLowerCase())
        }
    }, Bt = function(t) {
        for (var e = jt.length, n = t.style, r = [], i = 0; i < e; i++)
            r.push(jt[i], n[jt[i]]);
        return r.t = t,
        r
    }, Ht = {
        left: 0,
        top: 0
    }, Xt = function(t, e, n, r, i, o, s, l, c, f, h, p) {
        if ($(t) && (t = t(l)),
        U(t) && "max" === t.substr(0, 3) && (t = p + ("=" === t.charAt(4) ? pt("0" + t.substr(3), n) : 0)),
        V(t))
            s && vt(s, n, r, !0);
        else {
            $(e) && (e = e(l));
            var g, v, m, y = d(e)[0] || u, x = ot(y) || {}, b = t.split(" ");
            x && (x.left || x.top) || "none" !== rt(y).display || (m = y.style.display,
            y.style.display = "block",
            x = ot(y),
            m ? y.style.display = m : y.style.removeProperty("display")),
            g = pt(b[0], x[r.d]),
            v = pt(b[1] || "0", n),
            t = x[r.p] - c[r.p] - f + g + i - v,
            s && vt(s, v, r, n - v < 20 || s._isStart && v > 20),
            n -= n - v
        }
        if (o) {
            var w = t + n
              , _ = o._isStart;
            p = "scroll" + r.d2,
            vt(o, w, r, _ && w > 20 || !_ && (h ? Math.max(u[p], a[p]) : o.parentNode[p]) <= w + 1),
            h && (c = ot(s),
            h && (o.style[r.op.p] = c[r.op.p] - r.op.m - o._offset + tt))
        }
        return Math.round(t)
    }, zt = /(?:webkit|moz|length|cssText|inset)/i, Yt = function(t, e, n, i) {
        if (t.parentNode !== e) {
            var o, s, a = t.style;
            if (e === u) {
                for (o in t._stOrig = a.cssText,
                s = rt(t))
                    +o || zt.test(o) || !s[o] || "string" != typeof a[o] || "0" === o || (a[o] = s[o]);
                a.top = n,
                a.left = i
            } else
                a.cssText = t._stOrig;
            r.core.getCache(t).uncache = 1,
            e.appendChild(t)
        }
    }, Wt = function(t, e) {
        var n, i, o = X(t, e), s = "_scroll" + e.p2, a = function e(a, u, l, c, f) {
            var h = e.tween
              , d = u.onComplete
              , p = {};
            return h && h.kill(),
            n = Math.round(l),
            u[s] = a,
            u.modifiers = p,
            p[s] = function(t) {
                return (t = Math.round(o())) !== n && t !== i && Math.abs(t - n) > 2 ? (h.kill(),
                e.tween = 0) : t = l + c * h.ratio + f * h.ratio * h.ratio,
                i = n,
                n = Math.round(t)
            }
            ,
            u.onComplete = function() {
                e.tween = 0,
                d && d.call(h)
            }
            ,
            h = e.tween = r.to(t, u)
        };
        return t[s] = o,
        t.addEventListener("mousewheel", (function() {
            return a.tween && a.tween.kill() && (a.tween = 0)
        }
        )),
        a
    };
    /*!
 * ScrollTrigger 3.6.0
 * https://greensock.com
 *
 * @license Copyright 2008-2021, GreenSock. All rights reserved.
 * Subject to the terms at https://greensock.com/standard-license or for
 * Club GreenSock members, the agreement issued with that membership.
 * @author: Jack Doyle, jack@greensock.com
*/
    et.op = nt;
    var Ut = function() {
        function t(e, n) {
            i || t.register(r) || console.warn("Please gsap.registerPlugin(ScrollTrigger)"),
            this.init(e, n)
        }
        return t.prototype.init = function(e, n) {
            if (this.progress = this.start = 0,
            this.vars && this.kill(1),
            j) {
                var i, l, c, f, h, v, x, w, _, T, E, A, M, q, I, F, W, K, Q, ut, dt, vt, xt, _t, Tt, kt, Ct, St, Pt, At, Ot, Dt, Mt, qt, Nt, jt, It, zt, Ut, $t = (e = it(U(e) || V(e) || e.nodeType ? {
                    trigger: e
                } : e, ht)).horizontal ? et : nt, Vt = e, Gt = Vt.onUpdate, Kt = Vt.toggleClass, Qt = Vt.id, Jt = Vt.onToggle, Zt = Vt.onRefresh, te = Vt.scrub, ee = Vt.trigger, ne = Vt.pin, re = Vt.pinSpacing, ie = Vt.invalidateOnRefresh, oe = Vt.anticipatePin, se = Vt.onScrubComplete, ae = Vt.onSnapComplete, ue = Vt.once, le = Vt.snap, ce = Vt.pinReparent, fe = !te && 0 !== te, he = d(e.scroller || o)[0], de = r.core.getCache(he), pe = B(he), ge = "pinType"in e ? "fixed" === e.pinType : pe || "fixed" === H(he, "pinType"), ve = [e.onEnter, e.onLeave, e.onEnterBack, e.onLeaveBack], me = fe && e.toggleActions.split(" "), ye = "markers"in e ? e.markers : ht.markers, xe = pe ? 0 : parseFloat(rt(he)["border" + $t.p2 + "Width"]) || 0, be = this, we = e.onRefreshInit && function() {
                    return e.onRefreshInit(be)
                }
                , _e = function(t, e, n) {
                    var r = n.d
                      , i = n.d2
                      , s = n.a;
                    return (s = H(t, "getBoundingClientRect")) ? function() {
                        return s()[r]
                    }
                    : function() {
                        return (e ? o["inner" + i] : t["client" + i]) || 0
                    }
                }(he, pe, $t), Te = function(t, e) {
                    return !e || ~D.indexOf(t) ? z(t) : function() {
                        return Ht
                    }
                }(he, pe);
                be.media = P,
                oe *= 45,
                mt.push(be),
                be.scroller = he,
                be.scroll = X(he, $t),
                h = be.scroll(),
                be.vars = e,
                n = n || e.animation,
                "refreshPriority"in e && (k = 1),
                de.tweenScroll = de.tweenScroll || {
                    top: Wt(he, nt),
                    left: Wt(he, et)
                },
                be.tweenTo = i = de.tweenScroll[$t.p],
                n && (n.vars.lazy = !1,
                n._initted || !1 !== n.vars.immediateRender && !1 !== e.immediateRender && n.render(0, !0, !0),
                be.animation = n.pause(),
                n.scrollTrigger = be,
                (Dt = V(te) && te) && (Ot = r.to(n, {
                    ease: "power3",
                    duration: Dt,
                    onComplete: function() {
                        return se && se(be)
                    }
                })),
                Pt = 0,
                Qt || (Qt = n.vars.id)),
                le && (G(le) || (le = {
                    snapTo: le
                }),
                "scrollBehavior"in u.style && r.set(pe ? [u, a] : he, {
                    scrollBehavior: "auto"
                }),
                c = $(le.snapTo) ? le.snapTo : "labels" === le.snapTo ? function(t) {
                    return function(e) {
                        return r.utils.snap(at(t), e)
                    }
                }(n) : "labelsDirectional" === le.snapTo ? (zt = n,
                function(t, e) {
                    var n, r = at(zt);
                    if (r.sort((function(t, e) {
                        return t - e
                    }
                    )),
                    e.direction > 0) {
                        for (n = 0; n < r.length; n++)
                            if (r[n] >= t)
                                return r[n];
                        return r.pop()
                    }
                    for (n = r.length; n--; )
                        if (r[n] <= t)
                            return r[n];
                    return r[0]
                }
                ) : r.utils.snap(le.snapTo),
                Mt = le.duration || {
                    min: .1,
                    max: 2
                },
                Mt = G(Mt) ? p(Mt.min, Mt.max) : p(Mt, Mt),
                qt = r.delayedCall(le.delay || Dt / 2 || .1, (function() {
                    if (Math.abs(be.getVelocity()) < 10 && !y) {
                        var t = n && !fe ? n.totalProgress() : be.progress
                          , e = (t - At) / (L() - g) * 1e3 || 0
                          , r = J(e / 2) * e / .185
                          , o = t + r
                          , s = p(0, 1, c(o, be))
                          , a = be.scroll()
                          , u = Math.round(x + s * q)
                          , l = i.tween;
                        if (a <= w && a >= x && u !== a) {
                            if (l && !l._initted && l.data <= Math.abs(u - a))
                                return;
                            i(u, {
                                duration: Mt(J(.185 * Math.max(J(o - t), J(s - t)) / e / .05 || 0)),
                                ease: le.ease || "power3",
                                data: Math.abs(u - a),
                                onComplete: function() {
                                    Pt = At = n && !fe ? n.totalProgress() : be.progress,
                                    ae && ae(be)
                                }
                            }, a, r * q, u - a - r * q)
                        }
                    } else
                        be.isActive && qt.restart(!0)
                }
                )).pause()),
                Qt && (yt[Qt] = be),
                ee = be.trigger = d(ee || ne)[0],
                ne = !0 === ne ? ee : d(ne)[0],
                U(Kt) && (Kt = {
                    targets: ee,
                    className: Kt
                }),
                ne && (!1 === re || "margin" === re || (re = !(!re && "flex" === rt(ne.parentNode).display) && Z),
                be.pin = ne,
                !1 !== e.force3D && r.set(ne, {
                    force3D: !0
                }),
                (l = r.core.getCache(ne)).spacer ? I = l.pinState : (l.spacer = K = s.createElement("div"),
                K.setAttribute("class", "pin-spacer" + (Qt ? " pin-spacer-" + Qt : "")),
                l.pinState = I = Bt(ne)),
                be.spacer = K = l.spacer,
                St = rt(ne),
                _t = St[re + $t.os2],
                ut = r.getProperty(ne),
                dt = r.quickSetter(ne, $t.a, tt),
                Rt(ne, K, St),
                W = Bt(ne)),
                ye && (M = G(ye) ? it(ye, ft) : ft,
                E = gt("scroller-start", Qt, he, $t, M, 0),
                A = gt("scroller-end", Qt, he, $t, M, 0, E),
                Q = E["offset" + $t.op.d2],
                _ = gt("start", Qt, he, $t, M, Q),
                T = gt("end", Qt, he, $t, M, Q),
                ge || ((Ut = pe ? u : he).style.position = "absolute" === rt(Ut).position ? "absolute" : "relative",
                r.set([E, A], {
                    force3D: !0
                }),
                kt = r.quickSetter(E, $t.a, tt),
                Ct = r.quickSetter(A, $t.a, tt))),
                be.revert = function(t) {
                    var e = !1 !== t || !be.enabled
                      , r = m;
                    e !== f && (e && (jt = Math.max(be.scroll(), be.scroll.rec || 0),
                    Nt = be.progress,
                    It = n && n.progress()),
                    _ && [_, T, E, A].forEach((function(t) {
                        return t.style.display = e ? "none" : "block"
                    }
                    )),
                    e && (m = 1),
                    be.update(e),
                    m = r,
                    ne && (e ? function(t, e, n) {
                        if (Ft(n),
                        t.parentNode === e) {
                            var r = e.parentNode;
                            r && (r.insertBefore(t, e),
                            r.removeChild(e))
                        }
                    }(ne, K, I) : (!ce || !be.isActive) && Rt(ne, K, rt(ne), Tt)),
                    f = e)
                }
                ,
                be.refresh = function(i) {
                    if (!m && be.enabled)
                        if (ne && i && N)
                            lt(t, "scrollEnd", Et);
                        else {
                            m = 1,
                            Ot && Ot.pause(),
                            ie && n && n.progress(0).invalidate(),
                            f || be.revert();
                            for (var o, s, a, l, c, d, p, g, y, b = _e(), k = Te(), S = Y(he, $t), P = 0, O = 0, D = e.end, M = e.endTrigger || ee, L = e.start || (0 !== e.start && ee ? ne ? "0 0" : "0 100%" : 0), j = ee && Math.max(0, mt.indexOf(be)) || 0, R = j; R--; )
                                (p = mt[R].pin) && (p === ee || p === ne) && mt[R].revert();
                            for (x = Xt(L, ee, b, $t, be.scroll(), _, E, be, k, xe, ge, S) || (ne ? -.001 : 0),
                            $(D) && (D = D(be)),
                            U(D) && !D.indexOf("+=") && (~D.indexOf(" ") ? D = (U(L) ? L.split(" ")[0] : "") + D : (P = pt(D.substr(2), b),
                            D = U(L) ? L : x + P,
                            M = ee)),
                            w = Math.max(x, Xt(D || (M ? "100% 0" : S), M, b, $t, be.scroll() + P, T, A, be, k, xe, ge, S)) || -.001,
                            q = w - x || (x -= .01) && .001,
                            P = 0,
                            R = j; R--; )
                                (p = (d = mt[R]).pin) && d.start - d._pinPush < x && (o = d.end - d.start,
                                p === ee && (P += o),
                                p === ne && (O += o));
                            if (x += P,
                            w += P,
                            be._pinPush = O,
                            _ && P && ((o = {})[$t.a] = "+=" + P,
                            r.set([_, T], o)),
                            ne)
                                o = rt(ne),
                                l = $t === nt,
                                a = be.scroll(),
                                vt = parseFloat(ut($t.a)) + O,
                                !S && w > 1 && ((pe ? u : he).style["overflow-" + $t.a] = "scroll"),
                                Rt(ne, K, o),
                                W = Bt(ne),
                                s = ot(ne, !0),
                                g = ge && X(he, l ? et : nt)(),
                                re && ((Tt = [re + $t.os2, q + O + tt]).t = K,
                                (R = re === Z ? st(ne, $t) + q + O : 0) && Tt.push($t.d, R + tt),
                                Ft(Tt),
                                ge && be.scroll(jt)),
                                ge && ((c = {
                                    top: s.top + (l ? a - x : g) + tt,
                                    left: s.left + (l ? g : a - x) + tt,
                                    boxSizing: "border-box",
                                    position: "fixed"
                                }).width = c.maxWidth = Math.ceil(s.width) + tt,
                                c.height = c.maxHeight = Math.ceil(s.height) + tt,
                                c.margin = c.marginTop = c.marginRight = c.marginBottom = c.marginLeft = "0",
                                c[Z] = o[Z],
                                c[Z + "Top"] = o[Z + "Top"],
                                c[Z + "Right"] = o[Z + "Right"],
                                c[Z + "Bottom"] = o[Z + "Bottom"],
                                c[Z + "Left"] = o[Z + "Left"],
                                F = function(t, e, n) {
                                    for (var r, i = [], o = t.length, s = n ? 8 : 0; s < o; s += 2)
                                        r = t[s],
                                        i.push(r, r in e ? e[r] : t[s + 1]);
                                    return i.t = t.t,
                                    i
                                }(I, c, ce)),
                                n ? (y = n._initted,
                                C(1),
                                n.progress(1, !0),
                                xt = ut($t.a) - vt + q + O,
                                q !== xt && F.splice(F.length - 2, 2),
                                n.progress(0, !0),
                                y || n.invalidate(),
                                C(0)) : xt = q;
                            else if (ee && be.scroll())
                                for (s = ee.parentNode; s && s !== u; )
                                    s._pinOffset && (x -= s._pinOffset,
                                    w -= s._pinOffset),
                                    s = s.parentNode;
                            for (R = 0; R < j; R++)
                                (d = mt[R].pin) && (d === ee || d === ne) && mt[R].revert(!1);
                            be.start = x,
                            be.end = w,
                            (h = v = be.scroll()) < jt && be.scroll(jt),
                            be.revert(!1),
                            m = 0,
                            n && fe && n._initted && n.progress(It, !0).render(n.time(), !0, !0),
                            Nt !== be.progress && (Ot && n.totalProgress(Nt, !0),
                            be.progress = Nt,
                            be.update()),
                            ne && re && (K._pinOffset = Math.round(be.progress * xt)),
                            Zt && Zt(be)
                        }
                }
                ,
                be.getVelocity = function() {
                    return (be.scroll() - v) / (L() - g) * 1e3 || 0
                }
                ,
                be.update = function(t, e) {
                    var r, o, s, a, l, c = be.scroll(), f = t ? 0 : (c - x) / q, p = f < 0 ? 0 : f > 1 ? 1 : f || 0, y = be.progress;
                    if (e && (v = h,
                    h = c,
                    le && (At = Pt,
                    Pt = n && !fe ? n.totalProgress() : p)),
                    oe && !p && ne && !m && !O && N && x < c + (c - v) / (L() - g) * oe && (p = 1e-4),
                    p !== y && be.enabled) {
                        if (a = (l = (r = be.isActive = !!p && p < 1) !== (!!y && y < 1)) || !!p != !!y,
                        be.direction = p > y ? 1 : -1,
                        be.progress = p,
                        fe || (!Ot || m || O ? n && n.totalProgress(p, !!m) : (Ot.vars.totalProgress = p,
                        Ot.invalidate().restart())),
                        ne)
                            if (t && re && (K.style[re + $t.os2] = _t),
                            ge) {
                                if (a) {
                                    if (s = !t && p > y && w + 1 > c && c + 1 >= Y(he, $t),
                                    ce)
                                        if (t || !r && !s)
                                            Yt(ne, K);
                                        else {
                                            var b = ot(ne, !0)
                                              , _ = c - x;
                                            Yt(ne, u, b.top + ($t === nt ? _ : 0) + tt, b.left + ($t === nt ? 0 : _) + tt)
                                        }
                                    Ft(r || s ? F : W),
                                    xt !== q && p < 1 && r || dt(vt + (1 !== p || s ? 0 : xt))
                                }
                            } else
                                dt(vt + xt * p);
                        le && !i.tween && !m && !O && qt.restart(!0),
                        Kt && (l || ue && p && (p < 1 || !S)) && d(Kt.targets).forEach((function(t) {
                            return t.classList[r || ue ? "add" : "remove"](Kt.className)
                        }
                        )),
                        Gt && !fe && !t && Gt(be),
                        a && !m ? (o = p && !y ? 0 : 1 === p ? 1 : 1 === y ? 2 : 3,
                        fe && (s = !l && "none" !== me[o + 1] && me[o + 1] || me[o],
                        n && ("complete" === s || "reset" === s || s in n) && ("complete" === s ? n.pause().totalProgress(1) : "reset" === s ? n.restart(!0).pause() : n[s]()),
                        Gt && Gt(be)),
                        !l && S || (Jt && l && Jt(be),
                        ve[o] && ve[o](be),
                        ue && (1 === p ? be.kill(!1, 1) : ve[o] = 0),
                        l || ve[o = 1 === p ? 1 : 3] && ve[o](be))) : fe && Gt && !m && Gt(be)
                    }
                    Ct && (kt(c + (E._isFlipped ? 1 : 0)),
                    Ct(c))
                }
                ,
                be.enable = function() {
                    be.enabled || (be.enabled = !0,
                    lt(he, "resize", wt),
                    lt(he, "scroll", bt),
                    we && lt(t, "refreshInit", we),
                    n && n.add ? r.delayedCall(.01, (function() {
                        return x || w || be.refresh()
                    }
                    )) && (q = .01) && (x = w = 0) : be.refresh())
                }
                ,
                be.disable = function(e, n) {
                    if (be.enabled && (!1 !== e && be.revert(),
                    be.enabled = be.isActive = !1,
                    n || Ot && Ot.pause(),
                    jt = 0,
                    l && (l.uncache = 1),
                    we && ct(t, "refreshInit", we),
                    qt && (qt.pause(),
                    i.tween && i.tween.kill() && (i.tween = 0)),
                    !pe)) {
                        for (var r = mt.length; r--; )
                            if (mt[r].scroller === he && mt[r] !== be)
                                return;
                        ct(he, "resize", wt),
                        ct(he, "scroll", bt)
                    }
                }
                ,
                be.kill = function(t, e) {
                    be.disable(t, e),
                    Qt && delete yt[Qt];
                    var r = mt.indexOf(be);
                    mt.splice(r, 1),
                    r === b && Lt > 0 && b--,
                    n && (n.scrollTrigger = null,
                    t && n.render(-1),
                    e || n.kill()),
                    _ && [_, T, E, A].forEach((function(t) {
                        return t.parentNode.removeChild(t)
                    }
                    )),
                    ne && (l && (l.uncache = 1),
                    r = 0,
                    mt.forEach((function(t) {
                        return t.pin === ne && r++
                    }
                    )),
                    r || (l.spacer = 0))
                }
                ,
                be.enable()
            } else
                this.update = this.refresh = this.kill = R
        }
        ,
        t.register = function(e) {
            if (!i && (r = e || F(),
            I() && window.document && (o = window,
            s = document,
            a = s.documentElement,
            u = s.body),
            r && (d = r.utils.toArray,
            p = r.utils.clamp,
            C = r.core.suppressOverwrites || R,
            r.core.globals("ScrollTrigger", t),
            u))) {
                f = o.requestAnimationFrame || function(t) {
                    return setTimeout(t, 16)
                }
                ,
                lt(o, "mousewheel", bt),
                l = [o, s, a, u],
                lt(s, "scroll", bt);
                var n, h = u.style, g = h.borderTop;
                h.borderTop = "1px solid #000",
                n = ot(u),
                nt.m = Math.round(n.top + nt.sc()) || 0,
                et.m = Math.round(n.left + et.sc()) || 0,
                g ? h.borderTop = g : h.removeProperty("border-top"),
                v = setInterval(xt, 200),
                r.delayedCall(.5, (function() {
                    return O = 0
                }
                )),
                lt(s, "touchcancel", R),
                lt(u, "touchstart", R),
                ut(lt, s, "pointerdown,touchstart,mousedown", (function() {
                    return y = 1
                }
                )),
                ut(lt, s, "pointerup,touchend,mouseup", (function() {
                    return y = 0
                }
                )),
                x = r.utils.checkPrefix("transform"),
                jt.push(x),
                i = L(),
                c = r.delayedCall(.2, Dt).pause(),
                T = [s, "visibilitychange", function() {
                    var t = o.innerWidth
                      , e = o.innerHeight;
                    s.hidden ? (w = t,
                    _ = e) : w === t && _ === e || wt()
                }
                , s, "DOMContentLoaded", Dt, o, "load", function() {
                    return N || Dt()
                }
                , o, "resize", wt],
                W(lt)
            }
            return i
        }
        ,
        t.defaults = function(t) {
            for (var e in t)
                ht[e] = t[e]
        }
        ,
        t.kill = function() {
            j = 0,
            mt.slice(0).forEach((function(t) {
                return t.kill(1)
            }
            ))
        }
        ,
        t.config = function(t) {
            "limitCallbacks"in t && (S = !!t.limitCallbacks);
            var e = t.syncInterval;
            e && clearInterval(v) || (v = e) && setInterval(xt, e),
            "autoRefreshEvents"in t && (W(ct) || W(lt, t.autoRefreshEvents || "none"),
            E = -1 === (t.autoRefreshEvents + "").indexOf("resize"))
        }
        ,
        t.scrollerProxy = function(t, e) {
            var n = d(t)[0]
              , r = M.indexOf(n)
              , i = B(n);
            ~r && M.splice(r, i ? 6 : 2),
            i ? D.unshift(o, e, u, e, a, e) : D.unshift(n, e)
        }
        ,
        t.matchMedia = function(t) {
            var e, n, r, i, s;
            for (n in t)
                r = kt.indexOf(n),
                i = t[n],
                P = n,
                "all" === n ? i() : (e = o.matchMedia(n)) && (e.matches && (s = i()),
                ~r ? (kt[r + 1] = Q(kt[r + 1], i),
                kt[r + 2] = Q(kt[r + 2], s)) : (r = kt.length,
                kt.push(n, i, s),
                e.addListener ? e.addListener(Ct) : e.addEventListener("change", Ct)),
                kt[r + 3] = e.matches),
                P = 0;
            return kt
        }
        ,
        t.clearMatchMedia = function(t) {
            t || (kt.length = 0),
            (t = kt.indexOf(t)) >= 0 && kt.splice(t, 4)
        }
        ,
        t
    }();
    Ut.version = "3.6.0",
    Ut.saveStyles = function(t) {
        return t ? d(t).forEach((function(t) {
            if (t && t.style) {
                var e = Pt.indexOf(t);
                e >= 0 && Pt.splice(e, 4),
                Pt.push(t, t.style.cssText, r.core.getCache(t), P)
            }
        }
        )) : Pt
    }
    ,
    Ut.revert = function(t, e) {
        return Ot(!t, e)
    }
    ,
    Ut.create = function(t, e) {
        return new Ut(t,e)
    }
    ,
    Ut.refresh = function(t) {
        return t ? wt() : Dt(!0)
    }
    ,
    Ut.update = qt,
    Ut.maxScroll = function(t, e) {
        return Y(t, e ? et : nt)
    }
    ,
    Ut.getScrollFunc = function(t, e) {
        return X(d(t)[0], e ? et : nt)
    }
    ,
    Ut.getById = function(t) {
        return yt[t]
    }
    ,
    Ut.getAll = function() {
        return mt.slice(0)
    }
    ,
    Ut.isScrolling = function() {
        return !!N
    }
    ,
    Ut.addEventListener = function(t, e) {
        var n = _t[t] || (_t[t] = []);
        ~n.indexOf(e) || n.push(e)
    }
    ,
    Ut.removeEventListener = function(t, e) {
        var n = _t[t]
          , r = n && n.indexOf(e);
        r >= 0 && n.splice(r, 1)
    }
    ,
    Ut.batch = function(t, e) {
        var n, i = [], o = {}, s = e.interval || .016, a = e.batchMax || 1e9, u = function(t, e) {
            var n = []
              , i = []
              , o = r.delayedCall(s, (function() {
                e(n, i),
                n = [],
                i = []
            }
            )).pause();
            return function(t) {
                n.length || o.restart(!0),
                n.push(t.trigger),
                i.push(t),
                a <= n.length && o.progress(1)
            }
        };
        for (n in e)
            o[n] = "on" === n.substr(0, 2) && $(e[n]) && "onRefreshInit" !== n ? u(0, e[n]) : e[n];
        return $(a) && (a = a(),
        lt(Ut, "refresh", (function() {
            return a = e.batchMax()
        }
        ))),
        d(t).forEach((function(t) {
            var e = {};
            for (n in o)
                e[n] = o[n];
            e.trigger = t,
            i.push(Ut.create(e))
        }
        )),
        i
    }
    ,
    Ut.sort = function(t) {
        return mt.sort(t || function(t, e) {
            return -1e6 * (t.vars.refreshPriority || 0) + t.start - (e.start + -1e6 * (e.vars.refreshPriority || 0))
        }
        )
    }
    ,
    F() && r.registerPlugin(Ut)
}
, function(t, e, n) {
    "use strict";
    (function(t) {
        function r(t, e) {
            for (var n = 0; n < e.length; n++) {
                var r = e[n];
                r.enumerable = r.enumerable || !1,
                r.configurable = !0,
                "value"in r && (r.writable = !0),
                Object.defineProperty(t, r.key, r)
            }
        }
        n.d(e, "a", (function() {
            return i
        }
        ));
        var i = new (function() {
            function e() {
                !function(t, e) {
                    if (!(t instanceof e))
                        throw new TypeError("Cannot call a class as a function")
                }(this, e)
            }
            var n, i, o;
            return n = e,
            (i = [{
                key: "init",
                value: function(t) {
                    this.contentPage = t;
                    var e = this.contentPage;
                    this.qsa = function(t) {
                        var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : e;
                        return n.querySelectorAll(t)
                    }
                    ,
                    this.qs = function(t) {
                        var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : e;
                        return n.querySelector(t)
                    }
                    ,
                    this.onClick()
                }
            }, {
                key: "changeVal",
                value: function(t, e, n) {
                    t < 2 ? e.prop("disabled", !0).addClass("disabled") : e.prop("disabled", !1).removeClass("disabled"),
                    n.text(t),
                    console.log(t,e,n, 'console')
                }
            }, {
                key: "onClick",
                value: function() {
                    var e = this;
                    this.qty_btns = this.qsa(".js-qty-btn"),
                    this.qty_fields = this.qsa(".js-qty-field"),
                    this.variant_radio = this.qsa(".js-variant-radio");
                    var n = this.qsa("#add-to-cart-button");
                    t(n).click((function() {
                        t(this).addClass("loading-item")
                    }
                    )),
                    t(this.qty_btns).click((function() {
                        var n = t(this)
                          , r = n.closest("form")
                          , i = r.find(".js-qty-field")
                          , o = r.find(".js-qty-text")
                          , s = r.find(".minus")
                          , a = parseInt(i.val())
                          , u = i.attr("max") ? parseInt(i.attr("max")) : null;
                        n.hasClass("minus") && (i.val(a - 1),
                        e.changeVal(parseInt(i.val()), s, o)),
                        n.hasClass("plus") && (null === u || a + 1 <= u) && (i.val(a + 1),
                        e.changeVal(parseInt(i.val()), s, o))
                    }
                    )),
                    t(this.qty_fields).change((function() {
                        var n = t(this).closest("form")
                          , r = n.find(".js-qty-text")
                          , i = n.find(".minus")
                          , o = parseInt(t(this).val());
                        e.changeVal(o, i, r)
                    }
                    )),
                    t(this.variant_radio).change((function() {
                        var e = t(this)
                          , n = t(this).closest("form")
                          , r = n.find(".js-qty-field")
                          , i = n.find("#add-to-cart-button")
                          , o = e.data("inventory-qty");
                        i.hasClass("disabled") && i.removeClass("disabled"),
                        i.prop && r.attr("max", o),
                        parseInt(r.val()) > o && r.val(o).change(),
                        console.log(e,'event');
                    }
                    ))
                }
            }]) && r(n.prototype, i),
            o && r(n, o),
            e
        }())
    }
    ).call(this, n(1))
}
, function(t, e, n) {
    "use strict";
    (function(t) {
        function r(t, e) {
            for (var n = 0; n < e.length; n++) {
                var r = e[n];
                r.enumerable = r.enumerable || !1,
                r.configurable = !0,
                "value"in r && (r.writable = !0),
                Object.defineProperty(t, r.key, r)
            }
        }
        n.d(e, "a", (function() {
            return i
        }
        ));
        var i = new (function() {
            function e() {
                !function(t, e) {
                    if (!(t instanceof e))
                        throw new TypeError("Cannot call a class as a function")
                }(this, e)
            }
            var n, i, o;
            return n = e,
            (i = [{
                key: "init",
                value: function(e) {
                    this.contentPage = e;
                    var n = this.contentPage;
                    this.qsa = function(t) {
                        var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : n;
                        return e.querySelectorAll(t)
                    }
                    ,
                    this.qs = function(t) {
                        var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : n;
                        return e.querySelector(t)
                    }
                    ,
                    this.collection_decor = this.qs(".collection-decor"),
                    this.each_filter = this.qsa(".link-filter"),
                    this.isCollection = t(".header-collections").data("current");
                    var r = this;
                    t(this.each_filter).each((function() {
                        t(this).removeClass("current"),
                        t(this).data("collection") == r.isCollection && t(this).addClass("is-filter")
                    }
                    )),
                    "Products" != this.isCollection && t(this.collection_decor).show()
                }
            }, {
                key: "onScroll",
                value: function(t) {}
            }]) && r(n.prototype, i),
            o && r(n, o),
            e
        }())
    }
    ).call(this, n(1))
}
, function(t, e, n) {
    "use strict";
    function r(t, e) {
        for (var n = 0; n < e.length; n++) {
            var r = e[n];
            r.enumerable = r.enumerable || !1,
            r.configurable = !0,
            "value"in r && (r.writable = !0),
            Object.defineProperty(t, r.key, r)
        }
    }
    n.d(e, "a", (function() {
        return o
    }
    ));
    var i = n(12)
      , o = (n(1),
    new (function() {
        function t() {
            !function(t, e) {
                if (!(t instanceof e))
                    throw new TypeError("Cannot call a class as a function")
            }(this, t)
        }
        var e, n, o;
        return e = t,
        (n = [{
            key: "init",
            value: function(t) {
                this.contentPage = t;
                var e = this.contentPage;
                this.qsa = function(t) {
                    var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : e;
                    return n.querySelectorAll(t)
                }
                ,
                this.qs = function(t) {
                    var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : e;
                    return n.querySelector(t)
                }
                ,
                this.imgs = this.qsa("img"),
                i(this.imgs).on("always", (function() {
                    window.dispatchEvent(new Event("resize"))
                }
                ))
            }
        }, {
            key: "onScroll",
            value: function(t) {}
        }]) && r(e.prototype, n),
        o && r(e, o),
        t
    }()))
}
, function(t, e, n) {
    "use strict";
    (function(t) {
        n.d(e, "a", (function() {
            return o
        }
        ));
        var r = n(0);
        function i(t, e) {
            for (var n = 0; n < e.length; n++) {
                var r = e[n];
                r.enumerable = r.enumerable || !1,
                r.configurable = !0,
                "value"in r && (r.writable = !0),
                Object.defineProperty(t, r.key, r)
            }
        }
        var o = new (function() {
            function e() {
                !function(t, e) {
                    if (!(t instanceof e))
                        throw new TypeError("Cannot call a class as a function")
                }(this, e)
            }
            var n, o, s;
            return n = e,
            (o = [{
                key: "init",
                value: function(e) {
                    this.contentPage = e;
                    var n = this.contentPage;
                    this.qsa = function(t) {
                        var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : n;
                        return e.querySelectorAll(t)
                    }
                    ,
                    this.qs = function(t) {
                        var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : n;
                        return e.querySelector(t)
                    }
                    ,
                    this.accd = {
                        hold: this.qsa(".ctn-accord .hold-content"),
                        trg: this.qsa(".ctn-accord__item")
                    },
                    r.a.set(this.accd.hold, {
                        height: 0,
                        opacity: 0
                    });
                    var i = t(this.accd.trg)
                      , o = !1;
                    window.innerWidth < 1024 && i.click((function() {
                        o || (t(this).hasClass("active-accd") ? (o = !0,
                        t(this).removeClass("active-accd"),
                        r.a.to(".hold-content", .3, {
                            opacity: 0
                        }),
                        r.a.to(i.find(".svg-arrow svg"), .6, {
                            rotation: 0,
                            ease: "power3.inOut"
                        }),
                        r.a.to(i.find(".trg-acc h5"), .6, {
                            ease: "power3.inOut"
                        }),
                        r.a.to(".hold-content", .6, {
                            height: 0,
                            ease: "power3.inOut",
                            onComplete: function() {
                                window.dispatchEvent(new Event("resize")),
                                o = !1
                            }
                        })) : (o = !0,
                        t(".ctn-accord__item").removeClass("active-accd"),
                        t(this).addClass("active-accd"),
                        r.a.to(".hold-content", .3, {
                            opacity: 0
                        }),
                        r.a.to(".hold-content", .6, {
                            height: 0,
                            ease: "power3.inOut"
                        }),
                        r.a.to(i.find(".svg-arrow svg"), .6, {
                            rotation: 0,
                            ease: "power3.inOut"
                        }),
                        r.a.to(i.find(".trg-acc h5"), .6, {
                            ease: "power3.inOut"
                        }),
                        r.a.from(t(this).find(".hold-content"), .6, {
                            height: 0,
                            ease: "power3.inOut"
                        }),
                        r.a.set(t(this).find(".hold-content"), {
                            height: "auto"
                        }),
                        r.a.to(t(this).find(".hold-content"), .2, {
                            delay: .6 - .15,
                            opacity: 1,
                            onComplete: function() {
                                window.dispatchEvent(new Event("resize")),
                                o = !1
                            }
                        }),
                        r.a.to(t(this).find(".svg-arrow svg"), .6, {
                            rotation: 180,
                            transformOrigin: "center center",
                            ease: "power3.inOut"
                        }),
                        r.a.to(t(this).find(".trg-acc h5"), .6, {
                            transformOrigin: "center center",
                            ease: "power3.inOut"
                        })))
                    }
                    )),
                    this.modal_infos = this.qs(".modal-infos"),
                    this.modal_infos_close = this.qs(".modal-infos__close");
                    var s, a = this;
                    i.click((function() {
                        t(a.modal_infos).addClass("modal-active");
                        var e = t(this).data("trg");
                        t(".".concat(e)).addClass("modal-active"),
                        s = t(".".concat(e))
                    }
                    )),
                    t(this.modal_infos_close).click((function() {
                        t(a.modal_infos).removeClass("modal-active"),
                        s.removeClass("modal-active")
                    }
                    ))
                }
            }]) && i(n.prototype, o),
            s && i(n, s),
            e
        }())
    }
    ).call(this, n(1))
}
, function(t, e, n) {
    "use strict";
    function r(t, e) {
        for (var n = 0; n < e.length; n++) {
            var r = e[n];
            r.enumerable = r.enumerable || !1,
            r.configurable = !0,
            "value"in r && (r.writable = !0),
            Object.defineProperty(t, r.key, r)
        }
    }
    n.d(e, "a", (function() {
        return i
    }
    ));
    var i = new (function() {
        function t() {
            !function(t, e) {
                if (!(t instanceof e))
                    throw new TypeError("Cannot call a class as a function")
            }(this, t)
        }
        var e, n, i;
        return e = t,
        (n = [{
            key: "init",
            value: function() {
                window._swat.wishlistCount((function(t) {
                    console.log("Wishlist items - ", t)
                }
                ))
            }
        }, {
            key: "onScroll",
            value: function(t) {}
        }]) && r(e.prototype, n),
        i && r(e, i),
        t
    }())
}
, function(t, e, n) {
    "use strict";
    (function(t) {
        n.d(e, "a", (function() {
            return s
        }
        ));
        var r = n(0)
          , i = n(22);
        function o(t, e) {
            for (var n = 0; n < e.length; n++) {
                var r = e[n];
                r.enumerable = r.enumerable || !1,
                r.configurable = !0,
                "value"in r && (r.writable = !0),
                Object.defineProperty(t, r.key, r)
            }
        }
        r.a.registerPlugin(i.a);
        var s = new (function() {
            function e() {
                !function(t, e) {
                    if (!(t instanceof e))
                        throw new TypeError("Cannot call a class as a function")
                }(this, e)
            }
            var n, r, i;
            return n = e,
            (r = [{
                key: "init",
                value: function(t) {
                    this.contentPage = t;
                    var e = this.contentPage;
                    this.qsa = function(t) {
                        var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : e;
                        return n.querySelectorAll(t)
                    }
                    ,
                    this.qs = function(t) {
                        var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : e;
                        return n.querySelector(t)
                    }
                    ,
                    this.btn_details = this.qs(".to-details"),
                    this.btn_orders = this.qs(".to-orders"),
                    this.gap = .1 * window.innerHeight,
                    window.innerWidth < 1024 && (this.gap = .08 * window.innerHeight),
                    this.onClick()
                }
            }, {
                key: "onClick",
                value: function() {
                    var e = this;
                    t(window).resize((function() {
                        e.gap = .1 * window.innerHeight,
                        window.innerWidth < 1024 && (e.gap = .08 * window.innerHeight)
                    }
                    ))
                }
            }]) && o(n.prototype, r),
            i && o(n, i),
            e
        }())
    }
    ).call(this, n(1))
}
, function(t, e, n) {
    "use strict";
    n.d(e, "a", (function() {
        return x
    }
    ));
    var r, i, o, s, a, u, l, c = function() {
        return "undefined" != typeof window
    }, f = function() {
        return r || c() && (r = window.gsap) && r.registerPlugin && r
    }, h = function(t) {
        return "string" == typeof t
    }, d = function(t) {
        return "function" == typeof t
    }, p = function(t, e) {
        var n = "x" === e ? "Width" : "Height"
          , r = "scroll" + n
          , i = "client" + n;
        return t === o || t === s || t === a ? Math.max(s[r], a[r]) - (o["inner" + n] || s[i] || a[i]) : t[r] - t["offset" + n]
    }, g = function(t, e) {
        var n = "scroll" + ("x" === e ? "Left" : "Top");
        return t === o && (null != t.pageXOffset ? n = "page" + e.toUpperCase() + "Offset" : t = null != s[n] ? s : a),
        function() {
            return t[n]
        }
    }, v = function(t, e) {
        if (!(t = u(t)[0]) || !t.getBoundingClientRect)
            return console.warn("scrollTo target doesn't exist. Using 0") || {
                x: 0,
                y: 0
            };
        var n = t.getBoundingClientRect()
          , r = !e || e === o || e === a
          , i = r ? {
            top: s.clientTop - (o.pageYOffset || s.scrollTop || a.scrollTop || 0),
            left: s.clientLeft - (o.pageXOffset || s.scrollLeft || a.scrollLeft || 0)
        } : e.getBoundingClientRect()
          , l = {
            x: n.left - i.left,
            y: n.top - i.top
        };
        return !r && e && (l.x += g(e, "x")(),
        l.y += g(e, "y")()),
        l
    }, m = function(t, e, n, r, i) {
        return isNaN(t) || "object" == typeof t ? h(t) && "=" === t.charAt(1) ? parseFloat(t.substr(2)) * ("-" === t.charAt(0) ? -1 : 1) + r - i : "max" === t ? p(e, n) - i : Math.min(p(e, n), v(t, e)[n] - i) : parseFloat(t) - i
    }, y = function() {
        r = f(),
        c() && r && document.body && (o = window,
        a = document.body,
        s = document.documentElement,
        u = r.utils.toArray,
        r.config({
            autoKillThreshold: 7
        }),
        l = r.config(),
        i = 1)
    }, x = {
        version: "3.6.0",
        name: "scrollTo",
        rawVars: 1,
        register: function(t) {
            r = t,
            y()
        },
        init: function(t, e, n, r, s) {
            i || y();
            this.isWin = t === o,
            this.target = t,
            this.tween = n,
            e = function(t, e, n, r) {
                if (d(t) && (t = t(e, n, r)),
                "object" != typeof t)
                    return h(t) && "max" !== t && "=" !== t.charAt(1) ? {
                        x: t,
                        y: t
                    } : {
                        y: t
                    };
                if (t.nodeType)
                    return {
                        y: t,
                        x: t
                    };
                var i, o = {};
                for (i in t)
                    "onAutoKill" !== i && (o[i] = d(t[i]) ? t[i](e, n, r) : t[i]);
                return o
            }(e, r, t, s),
            this.vars = e,
            this.autoKill = !!e.autoKill,
            this.getX = g(t, "x"),
            this.getY = g(t, "y"),
            this.x = this.xPrev = this.getX(),
            this.y = this.yPrev = this.getY(),
            null != e.x ? (this.add(this, "x", this.x, m(e.x, t, "x", this.x, e.offsetX || 0), r, s, Math.round),
            this._props.push("scrollTo_x")) : this.skipX = 1,
            null != e.y ? (this.add(this, "y", this.y, m(e.y, t, "y", this.y, e.offsetY || 0), r, s, Math.round),
            this._props.push("scrollTo_y")) : this.skipY = 1
        },
        render: function(t, e) {
            for (var n, r, i, s, a, u = e._pt, c = e.target, f = e.tween, h = e.autoKill, d = e.xPrev, g = e.yPrev, v = e.isWin; u; )
                u.r(t, u.d),
                u = u._next;
            n = v || !e.skipX ? e.getX() : d,
            i = (r = v || !e.skipY ? e.getY() : g) - g,
            s = n - d,
            a = l.autoKillThreshold,
            e.x < 0 && (e.x = 0),
            e.y < 0 && (e.y = 0),
            h && (!e.skipX && (s > a || s < -a) && n < p(c, "x") && (e.skipX = 1),
            !e.skipY && (i > a || i < -a) && r < p(c, "y") && (e.skipY = 1),
            e.skipX && e.skipY && (f.kill(),
            e.vars.onAutoKill && e.vars.onAutoKill.apply(f, e.vars.onAutoKillParams || []))),
            v ? o.scrollTo(e.skipX ? n : e.x, e.skipY ? r : e.y) : (e.skipY || (c.scrollTop = e.y),
            e.skipX || (c.scrollLeft = e.x)),
            e.xPrev = e.x,
            e.yPrev = e.y
        },
        kill: function(t) {
            var e = "scrollTo" === t;
            (e || "scrollTo_x" === t) && (this.skipX = 1),
            (e || "scrollTo_y" === t) && (this.skipY = 1)
        }
    };
    /*!
 * ScrollToPlugin 3.6.0
 * https://greensock.com
 *
 * @license Copyright 2008-2021, GreenSock. All rights reserved.
 * Subject to the terms at https://greensock.com/standard-license or for
 * Club GreenSock members, the agreement issued with that membership.
 * @author: Jack Doyle, jack@greensock.com
*/
    x.max = p,
    x.getOffset = v,
    x.buildGetter = g,
    f() && r.registerPlugin(x)
}
, function(t, e, n) {
    "use strict";
    var r, i, o, s, a, u, l, c, f = function() {
        return r || "undefined" != typeof window && (r = window.gsap)
    }, h = {}, d = function(t) {
        return c(t).id
    }, p = function(t) {
        return h[d("string" == typeof t ? o(t)[0] : t)]
    }, g = function(t) {
        var e, n = a;
        if (t - l >= .05)
            for (l,
            l = t; n; )
                ((e = n.g(n.t, n.p)) !== n.v1 || t - n.t1 > .2) && (n.v2 = n.v1,
                n.v1 = e,
                n.t2 = n.t1,
                n.t1 = t),
                n = n._next
    }, v = {
        deg: 360,
        rad: 2 * Math.PI
    }, m = function() {
        (r = f()) && (o = r.utils.toArray,
        s = r.utils.getUnit,
        c = r.core.getCache,
        u = r.ticker,
        i = 1)
    }, y = function(t, e, n, r) {
        this.t = t,
        this.p = e,
        this.g = t._gsap.get,
        this.rCap = v[n || s(this.g(t, e))],
        this.v1 = this.v2 = 0,
        this.t1 = this.t2 = u.time,
        r && (this._next = r,
        r._prev = this)
    }, x = function() {
        function t(t, e) {
            i || m(),
            this.target = o(t)[0],
            h[d(this.target)] = this,
            this._props = {},
            e && this.add(e)
        }
        t.register = function(t) {
            r = t,
            m()
        }
        ;
        var e = t.prototype;
        return e.get = function(t, e) {
            var n, r, i, o = this._props[t] || console.warn("Not tracking " + t + " velocity.");
            return n = parseFloat(e ? o.v1 : o.g(o.t, o.p)) - parseFloat(o.v2),
            (r = o.rCap) && (n %= r) !== n % (r / 2) && (n = n < 0 ? n + r : n - r),
            i = n / ((e ? o.t1 : u.time) - o.t2),
            Math.round(1e4 * i) / 1e4
        }
        ,
        e.getAll = function() {
            var t, e = {}, n = this._props;
            for (t in n)
                e[t] = this.get(t);
            return e
        }
        ,
        e.isTracking = function(t) {
            return t in this._props
        }
        ,
        e.add = function(t, e) {
            t in this._props || (a || (u.add(g),
            l = u.time),
            a = this._props[t] = new y(this.target,t,e,a))
        }
        ,
        e.remove = function(t) {
            var e, n, r = this._props[t];
            r && (e = r._prev,
            n = r._next,
            e && (e._next = n),
            n ? n._prev = e : a === r && (u.remove(g),
            a = 0),
            delete this._props[t])
        }
        ,
        e.kill = function(t) {
            for (var e in this._props)
                this.remove(e);
            t || delete h[d(this.target)]
        }
        ,
        t.track = function(e, n, r) {
            i || m();
            for (var s, a, u = [], l = o(e), c = n.split(","), f = (r || "").split(","), h = l.length; h--; ) {
                for (s = p(l[h]) || new t(l[h]),
                a = c.length; a--; )
                    s.add(c[a], f[a] || f[0]);
                u.push(s)
            }
            return u
        }
        ,
        t.untrack = function(t, e) {
            var n = (e || "").split(",");
            o(t).forEach((function(t) {
                var e = p(t);
                e && (n.length ? n.forEach((function(t) {
                    return e.remove(t)
                }
                )) : e.kill(1))
            }
            ))
        }
        ,
        t.isTracking = function(t, e) {
            var n = p(t);
            return n && n.isTracking(e)
        }
        ,
        t.getVelocity = function(t, e) {
            var n = p(t);
            return n && n.isTracking(e) ? n.get(e) : console.warn("Not tracking velocity of " + e)
        }
        ,
        t
    }();
    /*!
 * VelocityTracker: 3.6.0
 * https://greensock.com
 *
 * Copyright 2008-2021, GreenSock. All rights reserved.
 * Subject to the terms at https://greensock.com/standard-license or for
 * Club GreenSock members, the agreement issued with that membership.
 * @author: Jack Doyle, jack@greensock.com
*/
    x.getByTarget = p,
    f() && r.registerPlugin(x),
    n.d(e, "a", (function() {
        return K
    }
    ));
    var b, w, _, T, k, C, E, S, P, A, O, D, M = x.getByTarget, L = function() {
        return b || "undefined" != typeof window && (b = window.gsap) && b.registerPlugin && b
    }, q = function(t) {
        return "number" == typeof t
    }, N = function(t) {
        return "object" == typeof t
    }, j = function(t) {
        return "function" == typeof t
    }, R = Array.isArray, I = function(t) {
        return t
    }, F = 1e10, B = function(t, e, n) {
        for (var r in e)
            r in t || r === n || (t[r] = e[r]);
        return t
    }, H = function t(e) {
        var n, r, i = {};
        for (n in e)
            i[n] = N(r = e[n]) ? t(r) : r;
        return i
    }, X = function(t, e, n, r, i) {
        var o, s, a, u, l = e.length, c = 0, f = F;
        if (N(t)) {
            for (; l--; ) {
                for (a in o = e[l],
                s = 0,
                t)
                    s += (u = o[a] - t[a]) * u;
                s < f && (c = l,
                f = s)
            }
            if ((i || F) < F && i < Math.sqrt(f))
                return t
        } else
            for (; l--; )
                (s = (o = e[l]) - t) < 0 && (s = -s),
                s < f && o >= r && o <= n && (c = l,
                f = s);
        return e[c]
    }, z = function(t, e, n, r, i, o) {
        if ("auto" === t.end)
            return t;
        var s, a, u = t.end;
        if (n = isNaN(n) ? F : n,
        r = isNaN(r) ? -F : r,
        N(e)) {
            if (s = e.calculated ? e : (j(u) ? u(e) : X(e, u, n, r, o)) || e,
            !e.calculated) {
                for (a in s)
                    e[a] = s[a];
                e.calculated = !0
            }
            s = s[i]
        } else
            s = j(u) ? u(e) : R(u) ? X(e, u, n, r, o) : parseFloat(u);
        return s > n ? s = n : s < r && (s = r),
        {
            max: s,
            min: s,
            unitFactor: t.unitFactor
        }
    }, Y = function(t, e, n) {
        return isNaN(t[e]) ? n : +t[e]
    }, W = function(t, e) {
        return .05 * e * t / A
    }, U = function(t, e, n) {
        return Math.abs((e - t) * A / n / .05)
    }, $ = {
        resistance: 1,
        checkpoint: 1,
        preventOvershoot: 1,
        linkedProps: 1,
        radius: 1,
        duration: 1
    }, V = function(t, e, n, r) {
        if (e.linkedProps) {
            var i, o, s, a, u, l, c = e.linkedProps.split(","), f = {};
            for (i = 0; i < c.length; i++)
                (s = e[o = c[i]]) && (a = q(s.velocity) ? s.velocity : (u = u || M(t)) && u.isTracking(o) ? u.get(o) : 0,
                l = Math.abs(a / Y(s, "resistance", r)),
                f[o] = parseFloat(n(t, o)) + W(a, l));
            return f
        }
    }, G = function() {
        (b = L()) && (_ = b.parseEase,
        T = b.utils.toArray,
        E = b.utils.getUnit,
        P = b.core.getCache,
        O = b.utils.clamp,
        k = _("power3"),
        A = k(.05),
        S = b.core.PropTween,
        b.config({
            resistance: 100,
            unitFactors: {
                time: 1e3,
                totalTime: 1e3,
                progress: 1e3,
                totalProgress: 1e3
            }
        }),
        C = b.config(),
        b.registerPlugin(x),
        w = 1)
    }, K = {
        version: "3.6.0",
        name: "inertia",
        register: function(t) {
            b = t,
            G()
        },
        init: function(t, e, n, r, i) {
            w || G();
            var o = M(t);
            if ("auto" === e) {
                if (!o)
                    return void console.warn("No inertia tracking on " + t + ". InertiaPlugin.track(target) first.");
                e = o.getAll()
            }
            this.target = t,
            this.tween = n,
            D = e;
            var s, a, u, l, c, f, h, d, p, g = t._gsap, v = g.get, m = e.duration, y = N(m), x = e.preventOvershoot || y && 0 === m.overshoot, b = Y(e, "resistance", C.resistance), _ = q(m) ? m : function(t, e, n, r, i, o) {
                if (void 0 === n && (n = 10),
                void 0 === r && (r = .2),
                void 0 === i && (i = 1),
                void 0 === o && (o = 0),
                "string" == typeof t && (t = T(t)[0]),
                !t)
                    return 0;
                var s, a, u, l, c, f, h, d, p, g, v = 0, m = F, y = e.inertia || e, x = P(t).get, b = Y(y, "resistance", C.resistance);
                for (s in g = V(t, y, x, b),
                y)
                    $[s] || (a = y[s],
                    N(a) || ((d = d || M(t)) && d.isTracking(s) ? a = q(a) ? {
                        velocity: a
                    } : {
                        velocity: d.get(s)
                    } : (l = +a || 0,
                    u = Math.abs(l / b))),
                    N(a) && (l = q(a.velocity) ? a.velocity : (d = d || M(t)) && d.isTracking(s) ? d.get(s) : 0,
                    u = O(r, n, Math.abs(l / Y(a, "resistance", b))),
                    f = (c = parseFloat(x(t, s)) || 0) + W(l, u),
                    "end"in a && (a = z(a, g && s in g ? g : f, a.max, a.min, s, y.radius),
                    o && (D === e && (D = y = H(e)),
                    y[s] = B(a, y[s], "end"))),
                    "max"in a && f > +a.max + 1e-10 ? (p = a.unitFactor || C.unitFactors[s] || 1,
                    (h = c > a.max && a.min !== a.max || l * p > -15 && l * p < 45 ? r + .1 * (n - r) : U(c, a.max, l)) + i < m && (m = h + i)) : "min"in a && f < +a.min - 1e-10 && (p = a.unitFactor || C.unitFactors[s] || 1,
                    (h = c < a.min && a.min !== a.max || l * p > -45 && l * p < 15 ? r + .1 * (n - r) : U(c, a.min, l)) + i < m && (m = h + i)),
                    h > v && (v = h)),
                    u > v && (v = u));
                return v > m && (v = m),
                v > n ? n : v < r ? r : v
            }(t, e, y && m.max || 10, y && m.min || .2, y && "overshoot"in m ? +m.overshoot : x ? 0 : 1, !0);
            for (s in e = D,
            D = 0,
            p = V(t, e, v, b),
            e)
                $[s] || (a = e[s],
                j(a) && (a = a(r, t, i)),
                q(a) ? c = a : N(a) && !isNaN(a.velocity) ? c = +a.velocity : o && o.isTracking(s) ? c = o.get(s) : console.warn("ERROR: No velocity was defined for " + t + " property: " + s),
                f = W(c, _),
                d = 0,
                u = v(t, s),
                l = E(u),
                u = parseFloat(u),
                N(a) && (h = u + f,
                "end"in a && (a = z(a, p && s in p ? p : h, a.max, a.min, s, e.radius)),
                "max"in a && +a.max < h ? x || a.preventOvershoot ? f = a.max - u : d = a.max - u - f : "min"in a && +a.min > h && (x || a.preventOvershoot ? f = a.min - u : d = a.min - u - f)),
                this._props.push(s),
                this._pt = new S(this._pt,t,s,u,0,I,0,g.set(t, s, this)),
                this._pt.u = l || 0,
                this._pt.c1 = f,
                this._pt.c2 = d);
            return n.duration(_),
            1
        },
        render: function(t, e) {
            var n, r = e._pt;
            for (t = k(e.tween._time / e.tween._dur); r; )
                r.set(r.t, r.p, (n = r.s + r.c1 * t + r.c2 * t * t,
                Math.round(1e4 * n) / 1e4 + r.u), r.d, t),
                r = r._next
        }
    };
    /*!
 * InertiaPlugin 3.6.0
 * https://greensock.com
 *
 * @license Copyright 2008-2021, GreenSock. All rights reserved.
 * Subject to the terms at https://greensock.com/standard-license or for
 * Club GreenSock members, the agreement issued with that membership.
 * @author: Jack Doyle, jack@greensock.com
*/
    "track,untrack,isTracking,getVelocity,getByTarget".split(",").forEach((function(t) {
        return K[t] = x[t]
    }
    )),
    L() && b.registerPlugin(K)
}
, function(t, e, n) {
    "use strict";
    n.r(e);
    var r = n(0)
      , i = n(13)
      , o = n(10)
      , s = n(3)
      , a = n(2);
    n(28);
    r.a.config({
        nullTargetWarn: !1
    }),
    new i.a,
    o.a.init(),
    o.a.fixMobile(),
    s.a.init(),
    a.a.init(),
    (0,
    n(27).consoleTag)()
}
, function(t, e, n) {
    var r, i;
    r = "undefined" != typeof window ? window : this,
    i = function() {
        "use strict";
        function t() {}
        var e = t.prototype;
        return e.on = function(t, e) {
            if (t && e) {
                var n = this._events = this._events || {}
                  , r = n[t] = n[t] || [];
                return -1 == r.indexOf(e) && r.push(e),
                this
            }
        }
        ,
        e.once = function(t, e) {
            if (t && e) {
                this.on(t, e);
                var n = this._onceEvents = this._onceEvents || {};
                return (n[t] = n[t] || {})[e] = !0,
                this
            }
        }
        ,
        e.off = function(t, e) {
            var n = this._events && this._events[t];
            if (n && n.length) {
                var r = n.indexOf(e);
                return -1 != r && n.splice(r, 1),
                this
            }
        }
        ,
        e.emitEvent = function(t, e) {
            var n = this._events && this._events[t];
            if (n && n.length) {
                n = n.slice(0),
                e = e || [];
                for (var r = this._onceEvents && this._onceEvents[t], i = 0; i < n.length; i++) {
                    var o = n[i];
                    r && r[o] && (this.off(t, o),
                    delete r[o]),
                    o.apply(this, e)
                }
                return this
            }
        }
        ,
        e.allOff = function() {
            delete this._events,
            delete this._onceEvents
        }
        ,
        t
    }
    ,
    t.exports ? t.exports = i() : r.EvEmitter = i()
}
, function(t, e, n) {
    "use strict";
    (function(t) {
        function e(t, e) {
            for (var n = 0; n < e.length; n++) {
                var r = e[n];
                r.enumerable = r.enumerable || !1,
                r.configurable = !0,
                "value"in r && (r.writable = !0),
                Object.defineProperty(t, r.key, r)
            }
        }
        new (function() {
            function n() {
                !function(t, e) {
                    if (!(t instanceof e))
                        throw new TypeError("Cannot call a class as a function")
                }(this, n)
            }
            var r, i, o;
            return r = n,
            (i = [{
                key: "init",
                value: function(t) {
                    var e = this.contentPage;
                    this.qsa = function(t) {
                        var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : e;
                        return n.querySelectorAll(t)
                    }
                    ,
                    this.qs = function(t) {
                        var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : e;
                        return n.querySelector(t)
                    }
                    ,
                    this.onClick(),
                    alert("why")
                }
            }, {
                key: "onClick",
                value: function() {
                    this.btn_forgot = this.qs(".toggle-forgot"),
                    this.form_forgot = this.qs(".forgot-form"),
                    t(this.btn_forgot).click((function() {
                        alert("why clicked"),
                        t(that.form_forgot).toggleClass("js-hidden")
                    }
                    ))
                }
            }]) && e(r.prototype, i),
            o && e(r, o),
            n
        }())
    }
    ).call(this, n(1))
}
, function(t, e) {
    t.exports = {
        consoleTag: function() {
            if (navigator.userAgent.toLowerCase().indexOf("chrome") > -1) {
                window.console.log.apply(console, ["\n %c Made with ❤️ by Victor Work %c https://victor.work/ %c %c 💎 \n\n", "border: 1px solid #000;color: #000; background: #aaa000; padding:5px 0;", "color: #fff; background: #1c1c1c; padding:5px 0;border: 1px solid #000;", "background: red; padding:5px 0;", "color: #b0976d; background: #aaa000; padding:5px 0;"])
            } else
                window.console && window.console.log("Made with love ❤️ Victor Work - https://victor.work/  ❤️");
            return 0
        }
    }
}
, function(t, e) {}
]);

if(window.innerWidth >= 1024){
        $("body").on("click", function(event) {
        if ((!$(event.target).closest(".custom-sortby").length)) {
            $(".custom-sortby .variant-ul").hide();
            $(".custom-sortby").removeClass("active");
        }
        });


        $("body").on("click", ".custom-sortby", function(event) {
            if ($(this).hasClass("unavailable")) {
            event.preventDefault();
            return; // stop function
        }
        event.stopPropagation();

        const $this = $(this);
        const $ul = $this.find(".variant-ul");

        if ($this.hasClass("active")) {
            $ul.hide();
        } else {
            $(".custom-sortby .variant-ul").hide();
            $(".custom-sortby").removeClass("active");
            $ul.show();
        }

        $this.toggleClass("active");
        });
        // $('.product__add-to-cart.desktop-only').click();


        $("body").on("click", ".custom-sortby li", function(event) {
        event.stopPropagation();

        const val = $(this).data("value");
        const valID = $(this).attr("data-id");

        const label = $(this).text().trim();
        console.log(val, label);
        
        $('.custom-sortby').addClass('selected-option');

            if (window.innerWidth >= 1024) {
                if($(this).hasClass("unavailable")){
                    // $(".select-btn-mobile, .add-to-cart-mobile").addClass("disabled");
                    $(".restock-rocket-button-cover").click();


                    const productData = JSON.parse(document.getElementById('product-data').text);
                    const variantId = valID;
                    window._RestockRocket.openModal(productData, variantId);
                    
                    setTimeout(function() {
                        $(".restock-rocket-wrapper #form-Select").val(valID);
                    }, 100);
                //  $('#selectText').text(val);
                }else{
                    $(".custom-sortby .variant-ul").hide();
                    $('#selectText').text(val);
                    $(".custom-sortby").removeClass("active");
                }
            }
            else{
                $('.add-to-cart-mobile').show();
                $('.add-to-cart-mobile').removeClass("disabled");
                $('.select-btn-mobile').hide();
            }
            $(this).siblings().removeClass("active");
            $(this).addClass("active");
        
        });
}
else{
    $("body").on("click", ".active-sort", function(event) {
    event.stopPropagation();

    const $this = $(this).parent();
    const $ul = $this.find(".variant-ul");
    if ($this.hasClass("active")) {
        $ul.hide();
    } else {
        $(".custom-sortby .variant-ul").hide();
        $(".custom-sortby").removeClass("active");
        $ul.show();
    }
    $this.toggleClass("active");
    });
    $("body").on("click", ".custom-sortby li", function(event) {
        event.stopPropagation();

        const val = $(this).attr("data-value");
        const valID = $(this).attr("data-id");

        const label = $(this).text().trim();
        console.log(val, label);
        
        $('.custom-sortby').addClass('selected-option');

            if (window.innerWidth >= 1024) {
                if($(this).hasClass("unavailable")){
                    // $(".select-btn-mobile, .add-to-cart-mobile").addClass("disabled");
                    $(".restock-rocket-button-cover").click();


                    const productData = JSON.parse(document.getElementById('product-data').text);
                    const variantId = valID;
                    window._RestockRocket.openModal(productData, variantId);
                    
                    setTimeout(function() {
                        $(".restock-rocket-wrapper #form-Select").val(valID);
                    }, 100);

                }else{
                    $(".custom-sortby .variant-ul").hide();
                    $('#selectText').text(val);
                    $(".custom-sortby").removeClass("active");
                }
               
            }
            else{
                if($(this).hasClass("unavailable")){
                    $(".select-btn-mobile, .add-to-cart-mobile").addClass("disabled");
                    $(".restock-rocket-button-cover").click();


                    const productData = JSON.parse(document.getElementById('product-data').text);
                    const variantId = valID;
                    window._RestockRocket.openModal(productData, variantId);
                    
                    setTimeout(function() {
                        $(".restock-rocket-wrapper #form-Select").val(valID);
                    }, 100);
                }else{
                    $('.add-to-cart-mobile').show();
                    $('.add-to-cart-mobile').removeClass("disabled");
                    $('.select-btn-mobile').hide();
                }
            }
            $(this).siblings().removeClass("active");
            $(this).addClass("active");
        
        });
        $("body").on("click", ".close-btn", function(event) {
            $(".custom-sortby .variant-ul").hide();
            $(".custom-sortby").removeClass("active");
        });
}


function stoqTrigger(){
    setTimeout(function() {
        if (window.location.pathname.includes("/products/")) {
            function createRestockRocketScript(scriptUrl) {
                const restockRocketScriptElement = document.createElement('script');
                restockRocketScriptElement.setAttribute('defer', 'defer');
                restockRocketScriptElement.src = scriptUrl;
                document.body.appendChild(restockRocketScriptElement);
            }
            createRestockRocketScript(window._RestockRocketConfig.scriptUrlProduct);
            createRestockRocketScript('https://cdn.shopify.com/extensions/07598c53-b7d4-4407-b887-475785086034/stoq-298/assets/restockrocket-preorder.4cc403c24b15f4b7322d.js');
        }
    }, 100);
}
// function kiwiSizeChartTrigger(){
//     setTimeout(function() {
//         console.log("ready");
//         if (window.location.pathname.includes("/products/")) {
//             console.log("%c The URL path contains '/products/'.", "color: white; background: green; padding: 4px; font-size: 14px; font-weight: bold;");
//              const productDataForKiwi = {
//                     productID: $(".header-prod__title").attr("data-product-id"), // Must be a string
//                     tags: $(".header-prod__title").attr("data-product-tags")?.split(",") || [],
//                     brand: $(".header-prod__title").attr("data-product-brands"),
//                     type: $(".header-prod__title").attr("data-product-type"),
//                     title: $(".header-prod__title").text()
//                     // Note: 'categories' and 'sku' may need to be handled separately
//                     // depending on how your theme loads variant data.
//                 };

//                 // 3. Call the function with the correctly formatted object.
//                 window.ks.loadSizing({
//                     productData: productDataForKiwi
//                 });
//                 console.log('productDataForKiwi');
//                 //window.loadKiwiSizingChart(window.KiwiSizing.data.tags);

//         } else {
//             console.log("%c The URL path not contains '/products/'.", "color: white; background: red; padding: 4px; font-size: 14px; font-weight: bold;");
//         }
//     }, 1500);
// }



// if (window.location.pathname.includes("/products/")) {
//     const intervalId = setInterval(() => {
//     const txt = $("._ks_text").text().trim();
//     if (txt === "") {
//         console.log("hi");
//         kiwiSizeChartTrigger();
//     } else {
//         clearInterval(intervalId); // stop when it’s no longer blank
//     }
//     }, 10000);

// }

function getPageScrollTop() {
  let transform = $("#barba-wrapper .page").css("transform");

  if (transform && transform !== "none") {
    let matrix = transform.match(/-?[\d\.]+/g); // extract matrix values
    if (matrix && matrix.length >= 6) {
      let translateY = parseFloat(matrix[5]); // 6th is translateY
      return Math.abs(translateY); // scroll offset
    }
  }

  return 0;
}

$('body').on('click', '.product-details__size-guide-btn', function(e){
    e.stopPropagation();
    e.preventDefault();
    setTimeout(() => {
    $('.size-guide-drawer').addClass('cc-show');
    let scrollTop = getPageScrollTop();
    if (scrollTop > 0) {
    $('#sizeguide-drawer .drawer__content')
      .addClass("scrolled")
      .css("top", scrollTop + "px");
    console.log(scrollTop);
  } else {
    $('#sizeguide-drawer .drawer__content')
      .removeClass("scrolled")
      .css("top", "");
      console.log(scrollTop);
  }
  }, 700);
});

$('body').on('click', '.drawer__close, .drawer__mask', function(){
    $('.size-guide-drawer').removeClass('cc-show');
}); 
// $('body').on('click', '.drawer__mask', function(){
//     $('.size-guide-drawer').removeClass('cc-show');
// }); 
$('body').on('click', '.size-guide__toggler', function(){
   if($('.size-guide__table').length > 1){
    $(".size-guide").toggleClass('cc-show');
   }
}); 

function moveAnnouncementBar() {
  var $announcement = $('.announcment-bar');
  var $miniCart = $('.minicart');
    console.log($announcement);
  if ($announcement.length && $miniCart.length) {
    $announcement.slice(1).remove();
    $announcement.first().insertAfter($miniCart);
    // $announcement.insertAfter($miniCart);
  }
}

// Run on page load
$(document).ready(function() {
  moveAnnouncementBar();
});

